/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

type UtilRequiredKeys<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export interface Link {
  /**
   * An absolute URL linking to a resource.
   * @example "https://..."
   */
  href?: string;
}

export interface Links {
  next?: Link;
  previous?: Link;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

export interface IrDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback","statelessVolumeButtonWithRepetition.volumeUp":4,"statelessVolumeButtonWithRepetition.volumeDown":5}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /** list of child devices */
  childDevices?: IrDevice[];
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
  /**
   * Room that the device is in
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * If this is an Air Conditioner, the minimum temperature allowed
   * @example 0
   */
  minValue?: number;
  /**
   * If this is an Air Conditioner, the maximum temperature allowed
   * @example 30
   */
  maxValue?: number;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrChildDevice {
  /**
   * The identifier for the device instance.
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F-0B01-2002"
   */
  mnId?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId?: string;
  /**
   * The id of the profile that describes the device components and capabilities.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b875r-0213-6479-a0bf-da7aeec3dc0a"
   */
  profileId?: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * List of IR function codes
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: string;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   */
  metadata?: Record<string, any>;
}

/** A paginated array of devices. */
export interface PagedIRDevices {
  items?: IrDevice[];
  _links?: Links;
}

/** A paginated array of devices. */
export interface PagedIRChildDevices {
  items?: IrChildDevice[];
  _links?: Links;
}

/** Creating an IR device. Note - Either (ocfDeviceType) OR (mnId and onboardingId) must be provided. */
export interface CreateIrDevice {
  /**
   * The id of the Parent device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  parentDeviceId?: string;
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The device manufacturer code.
   * @example "010F"
   */
  mnId?: string;
  /**
   * The Onboarding Id, used by mobile phone.
   * @example 100
   */
  onboardingId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * The ID of the Location with which the device is associated.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The OCF Device Type
   * @example "oic.d.tv"
   */
  ocfDeviceType?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * @example {"statelessPowerToggleButton.powerToggle":{"power":"toggle"},"statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored in the conductor for the device.
   * UI Metadata information
   * @example {"mac":"00000110","did":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","pid":"0c0b935d-0616-4441-a0bf-da7aeec3dc0a","cookie":"base64(cookie)"}
   */
  metadata?: Record<string, object>;
  /** The desired state of an Air Conditioner */
  acState?: AcState;
  /**
   * The Room id that the device should be associated with
   * @example "244d9196-fc90-4122-9fe8-2343eede60c2"
   */
  roomId?: string;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export interface IrUpdateRequest {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * The id of the ircode
   * @example "006C"
   */
  irCodeId?: string;
  /**
   * The brand name of the device
   * @example "Samsung"
   */
  brandName?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs.
   * These sholud be comprised of all capabilities of the ir device.
   * All existing values will be overwritten.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * All existing values will be overwritten
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

export type DevTypes = {
  /**
   * The id of the device type
   * @example "15"
   */
  devTypeId?: string;
  /**
   * The name of the device type
   * @example "DVD播放机"
   */
  devTypeName?: string;
}[];

export type Brands = {
  /**
   * The name of the brand
   * @example "长虹电视"
   */
  brand?: string;
  /**
   * Id for the brand
   * @example "6"
   */
  brandId?: string;
  /**
   * English translation of the brand (This appears to be empty in all examples provided)
   * @example ""
   */
  enBrand?: string;
  /**
   * TODO
   * @example "0"
   */
  famousStatus?: string;
}[];

export type Channels = {
  /**
   * Channel name
   * @example "中央一套"
   */
  name?: string;
  /**
   * Channel serial number
   * @example 1
   */
  serialNum?: number;
}[];

/** The function you are executing. Note - either (irCodeId & function) OR (ircode) are required. irCodeId & function are for preset function, irCode for custom function */
export interface Function {
  /**
   * The PID of the device you want to control
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
  /**
   * The IR code ID of a preset function
   * @example "5681"
   */
  irCodeId?: string;
  /**
   * The preset function (object or string)
   * @example {"function":"ok"}
   */
  function?: object;
  /**
   * The learned custom IR code
   * @example "26009...00029"
   */
  irCode?: string;
  /**
   * The ocf device type of the child device
   * @example "oic.d.airconditioner"
   */
  ocfDeviceType?: string;
  /** The initial state of an AC device */
  initialAcState?: {
    /**
     * Power status of the device
     * @example "ON"
     */
    powerState?: string;
    /**
     * Air Conditioner mode
     * @example "heat"
     */
    mode?: string;
    /**
     * Fan speed
     * @example "auto"
     */
    windSpeed?: string;
    /**
     * The temperature the device should be at
     * @example 19
     */
    fixedTargetTemperature?: number;
  };
}

/** The Function you want to update. */
export interface DevicePatch {
  /**
   * The name that a user chooses for the device. This defaults to the same value as name.
   * @example "My light"
   */
  label?: string;
  /**
   * Device capabilities associated with IR functions or function key/value pairs
   * These should be comprised of capabilities that will be added to existing capabilities.
   * @example {"statelessPowerToggleButton.powerToggle":"power","statelessAudioMuteButton.muteToggle":"mute","statelessAudioVolumeButton.volumeUp":"volume_up","statelessAudioVolumeButton.volumeDown":"volume_down","statelessChannelButton.channelUp":"channel_up","statelessChannelButton.channelDown":"channel_down","statelessCustomButton.green":"green","statelessCustomButton.right":"right","statelessCustomButton.3":3,"statelessCustomButton.exit":"exit","statelessCustomButton.playback":"playback"}
   */
  functionCodes?: {
    default?: object;
    [key: string]: any;
  };
  /**
   * Key value pairs stored for the device.
   * @example {"button.color":"blue","button.icon":"button.jpg"}
   */
  metadata?: Record<string, any>;
  /**
   * Unique id for Antenna integration to retrieve user location info
   * @example "244d9196-fc90-4122-9fe8-2343eede60c1"
   */
  headendId?: string;
  /**
   * Location selected for providing channels of TV/Settop
   * @example "경기도#고양시"
   */
  tvLocation?: string;
  /**
   * Name of service provider which manages the channels of TV/Settop
   * @example "ollehTV"
   */
  tvProvider?: string;
}

/** Data pertaining to the device that will be put in a learning state */
export interface IrLearningRequest {
  /**
   * The PID of the device you want to put in a learning state
   * @example "000000000000000000000000c3050100"
   */
  pid: string;
}

/** The desired state of an Air Conditioner */
export interface AcState {
  /**
   * The maximum temperature setting
   * @example 30
   */
  maxTemp?: number;
  /**
   * The minimum temperature setting
   * @example 16
   */
  minTemp?: number;
  /**
   * The temperature unit
   * @example "C"
   */
  unit?: string;
  /**
   * The temperature increment value
   * @example 1
   */
  step?: number;
  /**
   * The temperature value
   * @example 19
   */
  coolingSetpoint?: number;
  /**
   * The power state of the AC device
   * @example "ON"
   */
  powerState?: 'ON' | 'OFF';
  /**
   * The mode of the AC device
   * @example "AUTO"
   */
  mode?: string;
  /**
   * The fan speed of the AC device
   * @example "AUTO"
   */
  windspeed?: string;
}

export type IrCodes = {
  /** List of IR Codes */
  irCode?: {
    /**
     * The IR Code value
     * @example "26009...00029"
     */
    code?: string;
    /**
     * The description of the IR Code function
     * @example "打开空调，制冷，25度，风速2"
     */
    desc?: string;
    /**
     * The function name
     * @example "powerState"
     */
    function?: string;
    /**
     * Appears to have the same info as 'desc'
     * @example "打开空调"
     */
    name?: string;
  }[];
  /**
   * IR Code Id
   * @example "5789"
   */
  irCodeId?: string;
  /**
   * TODO
   * @example "000000000000000000000000c2050100"
   */
  pid?: string;
  /**
   * TODO
   * @example "1535607964"
   */
  timestamp?: string;
  /** The various possible values for an AC device only. Appears to be an empty object for non-AC devices */
  acState?: {
    /**
     * Max temperature for AC in Celsius
     * @example 30
     */
    maxTemp?: number;
    /**
     * Minimum temperature for AC in Celsius
     * @example 16
     */
    minTemp?: number;
    /**
     * Power states available
     * @example ["ON","OFF"]
     */
    powerState?: string[];
    /**
     * The list of modes of the AC
     * @example ["AUTO","COLD","DEHUMI","VENT","HEAT"]
     */
    model?: string[];
    /**
     * The list of fan speeds of the AC
     * @example ["AUTO","LOW","MEDIUM","HIGH"]
     */
    windspeed?: string[];
  };
  /**
   * A list of all functions for the IR code. Appears to only show up on TVs
   * @example ["power","mute","tv_av","menu","back","exit","0","1","2","3","4","5","6","7","8","9","channel_up","channel_down","volume_up","volume_down","up","down","right","left","ok"]
   */
  allFunction?: string[];
}[];

/** List of IR Codes with names (Just for AC) */
export type MatchIRCode = {
  /**
   * Name
   * @example "科龙_5693"
   */
  name?: string;
  /**
   * IR Id
   * @example 5693
   */
  irid?: number;
}[];

/** List of Provider Brands */
export type ProviderBrands = {
  /**
   * Provider brand name
   * @example "四川电信4K机顶盒 (Google Translated as Sichuan Telecom 4K set top box)"
   */
  brand?: string;
  /**
   * Provider brand id
   * @example "1223"
   */
  brandId?: string;
}[];

/** Providers under a location */
export type Providers = {
  /**
   * Provider's id
   * @example 38
   */
  providerId?: number;
  /**
   * Name of the provider
   * @example "杭州华数"
   */
  providerName?: string;
  /**
   * English name of the provider (again, always appears to be blank)
   * @example ""
   */
  providerNameEn?: string;
  /**
   * Location id associated with the provider
   * @example 0
   */
  locateId?: number;
  /**
   * Initials of the provider
   * @example "H"
   */
  initials?: string;
  /**
   * Whether the provider has a brand associated (0 = false, 1 = true)
   * @example 1
   */
  hasBrand?: number;
}[];

/** Sub areas under a location */
export type SubAreaInfo = {
  /**
   * Location id
   * @example 92
   */
  locateId?: number;
  /**
   * The level of the location (Country = 1, Province = 2, City = 3)
   * @example 3
   */
  levelId?: number;
  /**
   * Name of the location
   * @example "丽水市"
   */
  name?: string;
  /**
   * Indication of whether or not there are any sub areas under this location (0 = false, 1 = true)
   * @example 1
   */
  isLeaf?: number;
  /**
   * Status of the location
   * @example "正常"
   */
  status?: string;
  /**
   * Initials of the location
   * @example "N"
   */
  initials?: string;
}[];

/**
 * All of the OTA Versions
 * @example {"3":{"versions":[{"version":"20029","url":"google.com","date":"2017-02-28","changelog":{"en":"update","cn":"更新内"}}]}}
 */
export type OTAVersions = Record<
  string,
  {
    versions?: OTAVersion[];
  }
>;

/** OTA Version */
export interface OTAVersion {
  /**
   * OTA Version
   * @example "41024"
   */
  version?: string;
  /**
   * Url to download firmware update
   * @example "http://fwversions.ibroadlink.com/firmware/download/30014/41027.bin"
   */
  url?: string;
  /**
   * date of firmware version
   * @example "2018-03-09T00:00:00Z"
   */
  date?: string;
  /** @example {"en":"updating"} */
  changelog?: Record<string, string>;
}

/** Ota Version for Device */
export interface DeviceOTAVersion {
  /**
   * Version of the device
   * @example 50
   */
  version?: string;
  serverversion?: {
    /**
     * URL of the version
     * @example "https://broadlinkversion.com/version"
     */
    url?: string;
    /**
     * Device Type number
     * @example 10039
     */
    devtype?: string;
    /**
     * Version of the server
     * @example 55
     */
    version?: string;
  };
}

export type App = EndpointApp[];

export interface UserIdApp {
  /** UserId */
  userId?: string;
  endpointApps?: EndpointApp[];
}

export interface Isa {
  /** Possible values - __requiresLogin__ or __loggedIn__. These two values determine what fields are returned in this response. If value is "requiresLogin", only "oAuthLink" is returned in the response. If value is "loggedIn", only isaId, partnerName, appName, devices and icons are returned. */
  pageType?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** partner or brand name eg LIFX Inc. */
  partnerName?: string;
  /** Connector name. eg Lifx (Connect) */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** location of the installed smart app */
  locationId?: string;
  devices?: DeviceResults[];
  /** generated oAuth link for the user to login to partner server. This will only be returned when the user is not logged in. */
  oAuthLink?: string;
  viperAppLinks?: ViperAppLinks;
  /** connection status between partner and ST platform */
  partnerSTConnection?: 'connected' | 'disconnected';
}

export interface LocationIsa {
  installedSmartApps?: IsaResults[];
}

export interface GetOauthCallback200Resp {
  /** Number of new partner devices added */
  devices_added?: number;
  /** Number of existing partner devices */
  existing_devices?: number;
  /** Number of partner devices which Viper failed to create */
  failed_to_create_devices?: number;
}

export interface GetOauthCallback400Resp {
  /** Error sent by partner */
  error?: string;
  /** Error description sent by partner */
  error_description?: string;
  /** Error URI sent by partner */
  error_uri?: string;
  viper_error?:
    | 'missing_required_query_parameters'
    | 'redirect_expired'
    | 'unexpected_redirect_called'
    | 'oauth_state_verification_failed';
}

export interface GetOauthCallback404Resp {
  viper_error?: 'isa_not_found' | 'endpoint_app_not_found';
}

export interface GetOauthCallback424Resp {
  viper_error?:
    | 'access_token_request_failed'
    | 'discovery_request_failed'
    | 'isa_deleted'
    | 'grant_callback_access_failed';
}

export interface GetOauthCallback500Resp {
  viper_error?: 'server_error';
}

export interface OauthCallbackJson {
  /** isaId */
  isaId?: string;
  /** partner or brand name */
  partnerName?: string;
  /** SmartThings Schema App name */
  appName?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  devices?: DeviceResults[];
}

export interface IsaResults {
  /** isaId installed for the user */
  isaId: string;
  /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
  appName: string;
  /** Parnter name eg Lifx Inc */
  partnerName: string;
  /** url of partner icon */
  icon: string;
  /** url of partner icon in 2x dimensions */
  icon2x: string;
  /** url of partner icon in 3x dimensions */
  icon3x: string;
  /** location of the installed smart app */
  locationId: string;
  /** connection status between partner and ST platform */
  partnerSTConnection: 'connected' | 'disconnected';
  /** endpoint app id of the installed smart app */
  endpointAppId: string;
}

export interface PostEndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface EndpointApp {
  /** The name of the SmartThings Schema App */
  appName?: string;
  /** The name of the partner/brand */
  partnerName?: string;
  /** oAuth authorization url of the partner */
  oAuthAuthorizationUrl?: string;
  /** lambda arn of the partner for US region (default) */
  lambdaArn?: string;
  /** lambda arn of the partner for EU region */
  lambdaArnEU?: string;
  /** lambda arn of the partner for AP region */
  lambdaArnAP?: string;
  /** lambda arn of the partner for CN region */
  lambdaArnCN?: string;
  /** url of partner icon */
  icon?: string;
  /** url of partner icon in 2x dimensions */
  icon2x?: string;
  /** url of partner icon in 3x dimensions */
  icon3x?: string;
  /** endpoint app id for the partner */
  endpointAppId?: string;
  /** Client id for the partner oAuth */
  oAuthClientId?: string;
  /** Client secret for the partner oAuth */
  oAuthClientSecret?: string;
  /** oAuth token refresh url of the partner */
  oAuthTokenUrl?: string;
  /** oAuth scope for the partner. Example "remote_control:all" for Lifx */
  oAuthScope?: string;
  /** user id for the partner */
  userId?: string;
  /** Possible values - "lambda" or "webhook" */
  hostingType?: string;
  /** Possible values - "alexa-schema", "st-schema", "google-schema" */
  schemaType?: string;
  /** webhook url for the partner */
  webhookUrl?: string;
  /** Possible values - "", "cst", "wwst", "review" */
  certificationStatus?: string;
  /** Email for the partner */
  userEmail?: string;
  viperAppLinks?: ViperAppLinks;
}

export interface ViperAppLinks {
  /** app deep linking to partners in android */
  android?: string;
  /** app deep linking to partners in ios */
  ios?: string;
  /** whether deep app linking is enabled */
  isLinkingEnabled?: boolean;
}

export interface DeviceResults {
  /** deviceId created by DM */
  deviceId?: string;
  /** initial device name from the partner */
  name?: string;
}

export interface CommandResponse {
  success?: string;
}

export interface CommandBody {
  /** deviceId of the device */
  deviceId?: string;
  /** command name to be processed on the device */
  commandName?: string;
  /** Arguments for specific command types like setLevel, colorControl etc. */
  arguments?: CommandArguments[];
}

/** @example 30 */
export type CommandArguments = string;

export interface PostReceipt {
  /**
   * @format uuid
   * @example "viper_9121f970-f503-11e8-a7de-7319cef9605d"
   */
  endpointAppId?: string;
  /**
   * @format uuid
   * @example "e3fd04cb-c488-4bbd-9759-8deb512656a8"
   */
  stClientId?: string;
  /**
   * @format uuid
   * @example "02c75d945e69e167233cb635b1f9be76d97ebb0b04f4e6839f3acfad320bed64ab86838dc6312585b037259e7797bf2bb44b3caa7a60539c1f402abe3bbe9256424615fddc48e76823b9c230b15669901becb33711e48192aa54a31e4e287ff47295c61c15e2e046103f13aa250bb561136625b69304cc31ef5004d267d0847184426144c60a74329bb47e2f773469ebb6a1e585175370fda78e03413abbcafe51665e8cbe51adf37dd5a3ff376300ebdbe2a359589951a72867bd3fcc574bd77b9ac85127023f931de3c5bcb213efeab3d94a7ee4a3d20acc6f6e575755b10bceb74290f4182c9bddc407d4361710492611568ebcb0b2ffac09e70d0c977d5f"
   */
  stClientSecret?: string;
}

export interface GenerateStOauthBody {
  /** SmartThings Schema App id for the partner */
  endpointAppId?: string;
}

/** @example {"invokeType":"email","fromAddress":"example@smartthings.com","toAddresses":["example@smartthings.com"],"ccAddresses":["example@smartthings.com"],"bccAddresses":["example@smartthings.com"],"isTemplatedEmail":false,"emailparams":{"subject":"Example subject.","body":{"text":"Hello. This is the email body.","html":"<div>Hello. This is the email body.</div>"}}} */
export interface EmailBody {
  /**
   * What operation the handler is performing.
   * @example "email"
   */
  invokeType: 'email' | 'createTemplate' | 'updateTemplate' | 'deleteTemplate' | 'verifyEmail';
  /**
   * Required if invokeType is email - This is the address your email will be 'from'. Any email not from the @smartthings.com domain must be verified with the verifyEmail invokeType.
   * @example "example@smartthings.com"
   */
  fromAddress?: string;
  /**
   * Required if invokeType is email - The email addresses you want to send your email to.
   * @example ["example@smartthings.com"]
   */
  toAddresses?: string[];
  /**
   * Not required - The email addresses you want to cc on your email.
   * @example ["example@smartthings.com"]
   */
  ccAddresses?: string[];
  /**
   * Not required - The email addresses you want to bcc on your email.
   * @example ["example@smartthings.com"]
   */
  bccAddresses?: string[];
  /**
   * Required if invokeType is email - Designates whether you are sending a regular email or a templated email.
   * @example true
   */
  isTemplatedEmail?: boolean;
  /** Required if invokeType is email - Contains parameters specific for regular or templated emails. */
  emailParams?: {
    /**
     * Required if isTemplatedEmail is false - The subject your regular email will have.
     * @example "Hello World"
     */
    subject?: string;
    /** Required if isTemplatedEmail is false - Contains any text or html that your email body will have. */
    body?: {
      /**
       * Required if html is not provided, but both text and html can be provided - The text format of your email body.
       * @example "Hello. This is the email body."
       */
      text?: string;
      /**
       * Required if text is not provided, but both text and html can be provided - The html format of your email body.
       * @example "<div>Hello. This is the email body.</div>"
       */
      html?: string;
    };
    /**
     * Required if isTemplatedEmail is true - Contains info needed to send a templated email.
     * @example "MyEmailTemplate"
     */
    template?: string;
    /**
     * Not Required - Contains any data to replace variables in your template. For more info: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
     * @example {"name":"John Doe"}
     */
    templateData?: object;
  };
  /**
   * Required if invokeType is createTemplate or updateTemplate - Contains data about the template. For more info, checkout the value of 'Template' here: https://docs.aws.amazon.com/ses/latest/DeveloperGuide/send-personalized-email-api.html
   * @example {"TemplateName":"MyEmailTemplate","SubjectPart":"Hello {{name}}","HtmlPart":"<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>","TextPart":"Dear {{name}},\r\nYour favorite color is {{color}}."}
   */
  templateInfo?: {
    /**
     * Required - The name of the template. When you send the email, you refer to this name.
     * @example "MyEmailTemplate"
     */
    TemplateName?: string;
    /**
     * Required - The subject line of the email. This property may contain replacement tags. These tags use the following format: {{tagname}}. When you send the email, you can specify a value for tagname for each destination.
     * @example "Hello {{name}}"
     */
    SubjectPart?: string;
    /**
     * Required if TextPart is not provided, but both can be provided - The HTML body of the email. This property may contain replacement tags.
     * @example "<h1>Hello {{name}},</h1><p>Your favorite color is {{color}}.</p>"
     */
    HtmlPart?: string;
    /**
     * Required if HtmlPart is not provided, but both can be provided - The text body of the email. Recipients whose email clients don't display HTML email see this version of the email. This property may contain replacement tags.
     * @example "Dear {{name}},
     * Your favorite color is {{color}}."
     */
    TextPart?: string;
  };
  /**
   * Required if invokeType is deleteTemplate - The name of the template to delete.
   * @example "MyEmailTemplate"
   */
  templateName?: string;
  /**
   * Required if invokeType is verifyEmail - The email address to verify. All email addresses from @smartthings.com are already verified. this is for external addresses such as @gmail.com
   * @example "example@gmail.com"
   */
  email?: string;
}

export interface PutIsaBody {
  /** Whether the user is required to sign in through oauth flow */
  needsAttention?: boolean;
}

export interface TriggerDiscoveryBody {
  /** @example {"schema":"st-schema","version":"1.0","interactionType":"triggerDiscovery","requestId":"fe09d40d-a55f-4bc0-8b62-2dea171567a6"} */
  headers?: {
    /** st-schema */
    schema?: string;
    /** version 1.0 */
    version?: string;
    /** triggerDiscovery */
    interactionType?: string;
    /** Matching request ID from request */
    requestId?: string;
  };
}

/** @example {"endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","locationId":"e6c887ac-f293-402a-8335-ee3557a380cd","email":"example@smartthings.com"} */
export interface TriggerPreinstallIsaBody {
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** location id of device location */
  locationId?: string;
  /** user email that is used */
  email?: string;
}

/** @example {"deviceHandlerType":"c2c-rgbw-color-bulb","deviceId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","endpointAppId":"viper_86d99e60-aec2-11ec-a1d1-613f85592d17","isaId":"5e0c20e3-9bb8-4a69-a33e-4c6538cc4143","label":"Color Bulb"} */
export interface PutDeviceBody {
  /** Example-"c2c-rgbw-color-bulb" */
  deviceHandlerType?: string;
  /** deviceId created by ST cloud */
  deviceId?: string;
  /** endpoint app id of the installed smart app */
  endpointAppId?: string;
  /** isaId (Installed App Id) */
  isaId?: string;
  /** Example -"Color Bulb" */
  label?: string;
}

export interface FlatDeviceStatus {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the device
   * @example "main"
   */
  componentId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceStatusPagedResult {
  items?: FlatDeviceStatus[];
  _links?: Links;
}

/** {"status": "success"} */
export interface StandardSuccessResponse {
  /** @default "success" */
  status?: 'success';
}

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]} */
export interface InstalledApp {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus: InstalledAppStatus;
  /**
   * A user defined name for the installed app. May be null.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
  referenceId?: string;
  /**
   * The ID of the location to which the installed app may belong.
   * @format uuid
   */
  locationId?: string;
  /** A typed model which provides information around ownership of a specific domain. */
  owner: Owner;
  notices: Notice[];
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
  /**
   * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
   * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
   */
  ui?: {
    /** @format ^[a-zA-Z._]{1,99}$ */
    pluginId?: string;
    /** @format uri */
    pluginUri?: string;
    dashboardCardsEnabled: boolean;
    preInstallDashboardCardsEnabled: boolean;
  };
  /**
   * A default icon image for the app.
   * @example {"url":"https://smart-home-monitor.com/image"}
   */
  iconImage?: {
    /**
     * A default icon image url for an app. https url required.
     * @format uri
     */
    url?: string;
  };
  /**
   * An App maybe associated to many classifications.  A classification drives how the integration is presented
   * to the user in the SmartThings mobile clients.  These classifications include:
   * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
   * * SERVICE - Denotes an integration that is classified as a "Service".
   * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
   * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
   * * HIDDEN - Denotes an integration that should not display in mobile clients
   */
  classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
  /** Denotes the principal type to be used with the app.  Default is LOCATION. */
  principalType: 'LOCATION' | 'USER_LEVEL';
  /** Restriction tier of the install, if any. */
  restrictionTier?: number;
  /**
   * Inform the installation systems that the associated app can only be installed once within a user's account.
   * @default false
   */
  singleInstance: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   * <ul>
   * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
   * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
   * </ul>
   */
  allowed?: string[];
}

export interface ConnectedService {
  /** The name of the Connected Service */
  name?: string;
  /** The id of the Connected Service */
  id?: string;
  /** The id of the location */
  locationId?: string;
  /** The type of Connected Service */
  serviceType?: 'groovy_app' | 'endpoint_app' | 'viper_app' | 'api_only';
  /** URL to the icon that represents the Connected Service */
  iconUrl?: string;
}

export interface FlatDeviceGroupStatus {
  /**
   * The identifier for the device group.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceGroupId: string;
  /**
   * The ID of the Location with which the device is associated
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  locationId: string;
  /**
   * The identifier for the capability
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The name of the attribute
   * @example "level"
   */
  attributeName: string;
  /**
   * The value of the attribute
   * @example 75
   */
  value: object;
  /** The type of value */
  valueType: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  /** @example "°C" */
  unit?: string;
  /** @example {"method":"manual","codeId":1234,"timeout":"2018-05-09T23:03:31+0000"} */
  data?: Record<string, object>;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp?: string;
}

export interface FlatDeviceGroupStatusPagedResult {
  items?: FlatDeviceGroupStatus[];
  _links?: Links;
}

/**
 * The type of device integration (may be null).
 * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
 * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
 * If the type is IR, the details are in the "ir" field.
 * If the type is IR_OCF, the details are in the "irOcf" field.
 * If the type is OCF, the details are in the "ocf" field.
 * If the type is VIPER, the details are in the "viper" field.
 * @default "DTH"
 */
export enum DeviceIntegrationType {
  BLE = 'BLE',
  BLED2D = 'BLE_D2D',
  DTH = 'DTH',
  ENDPOINT_APP = 'ENDPOINT_APP',
  GROUP = 'GROUP',
  HUB = 'HUB',
  IR = 'IR',
  IR_OCF = 'IR_OCF',
  LAN = 'LAN',
  MATTER = 'MATTER',
  MOBILE = 'MOBILE',
  MQTT = 'MQTT',
  OCF = 'OCF',
  PENGYOU = 'PENGYOU',
  SHP = 'SHP',
  VIDEO = 'VIDEO',
  VIPER = 'VIPER',
  VIRTUAL = 'VIRTUAL',
  WATCH = 'WATCH',
  ZIGBEE = 'ZIGBEE',
  ZWAVE = 'ZWAVE',
  EDGE_CHILD = 'EDGE_CHILD',
}

export interface AppDeviceDetails {
  /**
   * The ID of the installed app that integrates this device.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
   */
  installedAppId?: string;
  /**
   * A field to store an ID from a system external to SmartThings.
   * @maxLength 64
   * @example "Th13390"
   */
  externalId?: string;
  profile?: DeviceProfileReference;
}

export interface DeviceProfileReference {
  /**
   * The device profile Id
   * @example "a7b3c264-2d22-416e-bca1-ca4b59a60aee"
   */
  id?: string;
}

export interface DthDeviceDetails {
  /** True if the device setup has been completed so the device is ready to use. */
  completedSetup: boolean;
  /** The device network type. */
  deviceNetworkType?: DeviceNetworkType;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  deviceTypeId: string;
  /**
   * The name for the device's DeviceType.
   * @example "x.com.samsung.da.fridge"
   */
  deviceTypeName: string;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The ID of a Hub */
  hubId?: HubId;
  /**
   * The ID of the installed groovy application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "8f5ra619-4c05-4a90-a245-cc129b0a8098"
   */
  installedGroovyAppId?: string;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
}

export type BleDeviceDetails = object;

export interface BleD2DDeviceDetails {
  /**
   * Security encryption key.
   * @example "96012869B606355A1F843B1E19DC31B1"
   */
  encryptionKey?: string;
  /**
   * Key for the decrypt.
   * @example "BMO_256-CBS-PKMS1Padding"
   */
  cipher?: string;
  /**
   * BLE Advertising Id.
   * @example "9C0D4219"
   */
  advertisingId?: string;
  /**
   * Unique device identifier.
   * @example "88-57-1d-0e-53-ab"
   */
  identifier?: string;
  configurationVersion?: string;
  /** @example "https://apisa.samsungiots.com/v1/miniature/profile/e524ceba-93b9-499d-a90a-24214f7f01cb" */
  configurationUrl?: string;
  metadata?: object;
}

/**
 * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
 * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
 * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
 * @default "UNKNOWN"
 */
export enum DeviceNetworkSecurityLevel {
  UNKNOWN = 'UNKNOWN',
  ZWAVE_LEGACY_NON_SECURE = 'ZWAVE_LEGACY_NON_SECURE',
  ZWAVES0LEGACY = 'ZWAVE_S0_LEGACY',
  ZWAVES0FALLBACK = 'ZWAVE_S0_FALLBACK',
  ZWAVES2UNAUTHENTICATED = 'ZWAVE_S2_UNAUTHENTICATED',
  ZWAVES2AUTHENTICATED = 'ZWAVE_S2_AUTHENTICATED',
  ZWAVES2ACCESSCONTROL = 'ZWAVE_S2_ACCESS_CONTROL',
  ZWAVES2FAILED = 'ZWAVE_S2_FAILED',
  ZWAVES0FAILED = 'ZWAVE_S0_FAILED',
  ZWAVES2DOWNGRADE = 'ZWAVE_S2_DOWNGRADE',
  ZWAVES0DOWNGRADE = 'ZWAVE_S0_DOWNGRADE',
}

export interface SharedLocation {
  /** @example "1c75f712-2c3e-4e51-970c-a42ae7aedbdc" */
  locationId?: string;
}

/** Device Profile information for Lan devices. This field will be empty if device type is not LAN. */
export interface LanDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The ID of a Hub */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/** Device Profile information for Zigbee devices. This field will be empty if device type is not ZIGBEE. */
export interface ZigbeeDeviceDetails {
  /** The EUID of the Zigbee device */
  eui?: DeviceEui;
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The ID of a Hub */
  hubId?: HubId;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * 16-bit manufacturer identifier assigned by the Z-Wave Specification
 * @min 0
 * @max 65535
 * @example 134
 */
export type ZWaveManufacturerId = number;

/**
 * 16-bit manufacturer defined product type
 * @min 0
 * @max 65535
 * @example 17488
 */
export type ZWaveProductType = number;

/**
 * 16-bit manufacturer defined product identifier
 * @min 0
 * @max 65535
 * @example 12336
 */
export type ZWaveProductId = number;

/** Device Profile information for Z-Wave devices. This field will be empty if device type is not ZWAVE. */
export interface ZwaveDeviceDetails {
  /** The network-specific identifier of the device on the network */
  networkId?: DeviceNetworkId;
  /** The ID of the Sprocket driver */
  driverId?: DriverId;
  /** True if the device is executing locally on the hub */
  executingLocally?: ExecutingLocally;
  /** The ID of a Hub */
  hubId?: HubId;
  /**
   * For hub-connected devices on protocols with multiple security levels, the security level the device was added with.
   * Values ZWAVE_S2_FAILED, ZWAVE_S0_FAILED, ZWAVE_S2_DOWNGRADE, and ZWAVE_S0_DOWNGRADE should be treated as failures
   * and prompt the user to remove and re-add the device. Other Z-Wave values are success cases.
   */
  networkSecurityLevel?: DeviceNetworkSecurityLevel;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
  /** 16-bit manufacturer identifier assigned by the Z-Wave Specification */
  manufacturerId?: ZWaveManufacturerId;
  /** 16-bit manufacturer defined product type */
  productType?: ZWaveProductType;
  /** 16-bit manufacturer defined product identifier */
  productId?: ZWaveProductId;
}

/** True if the device is executing locally on the hub */
export type ExecutingLocally = boolean;

/** The network-specific identifier of the device on the network */
export type DeviceNetworkId = string;

/**
 * The device id associated with the camera device
 * @format uuid
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceId = string;

/**
 * The EUID of the Zigbee device
 * @example "24FD5B000105DB96"
 */
export type DeviceEui = string;

/**
 * The device network type.
 * @example "ZIGBEE"
 */
export type DeviceNetworkType = string;

/**
 * The ID of the Sprocket driver
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "9314a926-528c-403f-ae56-4b0d059381dd"
 */
export type DriverId = string;

/** Listening type for the device. Optional. */
export enum MatterListeningType {
  ALWAYS = 'ALWAYS',
  SLEEPY = 'SLEEPY',
}

/** Hardware and Software version info for matter devices. Optional. */
export interface MatterVersion {
  /**
   * 16-bit hardware version. Optional.
   * @min 0
   * @max 65535
   * @example 771
   */
  hardware?: number;
  /** Label for the hardware version. Optional. */
  hardwareLabel?: string;
  /**
   * 32-bit software version. Optional.
   * @min 0
   * @max 4294967295
   * @example 50529027
   */
  software?: number;
  /** Label for the hardware version. Optional. */
  softwareLabel?: string;
}

/** List of network interfaces. Optional. */
export type MatterNetworkInterfaces = MatterNetworkInterface[];

/** Supported Network Interfaces of the Device */
export enum MatterNetworkInterface {
  THREAD = 'THREAD',
  WIFI = 'WIFI',
  ETHERNET = 'ETHERNET',
}

/**
 * The ID of a Hub
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 * @example "0c0b935d-0616-4441-a0bf-da7aeec3dc0a"
 */
export type HubId = string;

/** Provisioning type for a widget device */
export enum ProvisioningState {
  PROVISIONED = 'PROVISIONED',
  TYPED = 'TYPED',
  DRIVER_SWITCH = 'DRIVER_SWITCH',
  NONFUNCTIONAL = 'NONFUNCTIONAL',
}

export interface Swatch {
  /**
   * Unique Id of a swatch
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId: string;
  /** The type of Swatch to display */
  swatchType: SwatchType;
  /**
   * The Id of the Component represented by this Swatch
   * @example "main"
   */
  componentId: string;
  /**
   * The Id of the Capability represented by this Swatch
   * @example "switchLevel"
   */
  capabilityId: string;
  /**
   * The Attribute represented by this Swatch
   * @example "level"
   */
  attributeName?: string;
  /** The label to display to the user */
  label: string;
  /**
   * A url that points to the Swatch Icon
   * @format uri
   * @example "https://client.smartthings.com/icons/capabilities/switchLevel/level"
   */
  icon: string;
  /** Data specific to SwatchType of color */
  colorData?: SwatchColorData;
  /** Data specific to SwatchType of enum */
  enumData?: SwatchEnumData;
  /** Data specific to SwatchType of value */
  valueData?: SwatchValueData;
  /** Data specific to SwatchType of slider */
  sliderData?: SwatchSliderData;
  /** Data specific to SwatchType of toggle */
  toggleData?: SwatchToggleData;
  /** Data specific to SwatchType of button */
  buttonData?: SwatchButtonData;
}

/** The type of Swatch to display */
export enum SwatchType {
  Color = 'color',
  Enum = 'enum',
  Value = 'value',
  Slider = 'slider',
  Toggle = 'toggle',
  Button = 'button',
}

/** Data specific to SwatchType of color */
export interface SwatchColorData {
  /** The method to call to set the color after user interaction */
  command?: string;
  /** A list of arguments to be included in the request to set the color */
  arguments?: {
    /** The name of the argument which coincides with a capability attribute value */
    name?: string;
    /** The type of value the argument should be */
    type?: 'number';
    /** The minimum value allowed */
    min?: number;
    /** The maximum value allowed */
    max?: number;
    /** Whether or not this argument is required when calling the setter */
    required?: boolean;
  }[];
}

/** Data specific to SwatchType of enum */
export interface SwatchEnumData {
  /** A list of possible values that can be displayed on the swatch */
  possibleValues?: {
    /** The value matching the device status value */
    name: string;
    /** A full url pointing to the icon that can and should be cached */
    icon: string;
    /** The command to call (if present) when the user interacts with this swatch */
    command: string;
    /** The label to display to the user */
    label: string;
  }[];
}

/** Data specific to SwatchType of value */
export interface SwatchValueData {
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status */
  unit: string;
  /** The type of data this slider represents (typically string, number, or integer, but could be JSON_OBJECT) */
  type: 'NUMBER' | 'INTEGER' | 'STRING' | 'OBJECT' | 'ARRAY';
}

/** Data specific to SwatchType of slider */
export interface SwatchSliderData {
  /** The minimum value allowed */
  min: number;
  /** The maximum value allowed */
  max: number;
  /** The Command to call to set the value after user interaction */
  command: string;
  /** A unit associated with the value to be displayed to the user. The value to be displayed is the actual value of the device status */
  unit: string;
  /** The number to be added or subtracted to the current setting when incrementing or decrementing the value */
  step: number;
  /** The type of data this slider represents */
  type: 'NUMBER' | 'INTEGER';
}

/** Data specific to SwatchType of toggle */
export interface SwatchToggleData {
  /** Data specific to the on or off state of a toggle control */
  onState: SwatchToggleState;
  /** Data specific to the on or off state of a toggle control */
  offState: SwatchToggleState;
}

/** Data specific to the on or off state of a toggle control */
export interface SwatchToggleState {
  /** The Command to call when the toggle is flipped to this state */
  command: string;
  /** The value of the Device status that indicates whether the toggle is in this state */
  status: string;
  /** A url to the icon that represents the toggle when it is in this state */
  icon: string;
}

/** Data specific to SwatchType of button */
export interface SwatchButtonData {
  /** The command to call when the button is pushed */
  command: string;
}

/** Swatch data required to render the main controls on the details page */
export interface HeroSwatch {
  /** List of swatchIds to display as the main control of the HeroSwatch */
  mainSwatchIds: string[];
  /** List of swatchIds to display in the top row of the HeroSwatch */
  topSwatchIds?: string[];
  /** List of swatchIds to display in the bottom row of the HeroSwatch */
  bottomSwatchIds?: string[];
}

export interface DeviceSwatch {
  /**
   * The id of the Device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /** The label or name of this Device */
  deviceName: string;
  /**
   * The Location that the Device is in
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The Room that the Device is in
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /**
   * Id of the swatch to use in the list view
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  listSwatchId: string;
  /** Swatch data required to render the main controls on the details page */
  heroSwatch: HeroSwatch;
  /** Ordered list of swatchIds to display on the details view */
  detailSwatchIds?: string[];
  swatches: Swatch[];
}

export interface PartialDeviceSwatchResponse {
  /** A list of DeviceSwatches that have been added or modified */
  modified: DeviceSwatch[];
  /** A list of deviceIds that have been deleted */
  deleted: string[];
}

export type SwatchStatus = FlatDeviceStatus & {
  /**
   * Unique Id of a swatch
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  swatchId?: string;
};

export interface SwatchStatusPagedResult {
  items?: SwatchStatus[];
  _links?: Links;
}

export interface OcfRouteRequest {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /**
   * Observe option
   * @default "NOTHING"
   */
  observeOption: 'SUBSCRIBE' | 'UNSUBSCRIBE' | 'NOTHING';
  /** Request method */
  method: 'GET' | 'PUT' | 'POST';
  /** Path to the resource */
  path: string;
  /** OCF interface */
  query?: string;
  /** The OCF message body in JSON */
  message?: Record<string, object>;
}

export interface OcfRouteResponse {
  /** Device ID of the sender */
  senderDi: string;
  /** Device ID of the receiver */
  receiverDi: string;
  /**
   * A resource identifier of the sender device. Max length of the token is 8 bytes. String presentation in hexadecimal will be 16 characters.
   * @maxLength 16
   * @pattern [0-9a-fA-F]+
   */
  coapToken: string;
  /** Observe option */
  observeOption?: 'SUBSCRIBE' | 'UNSUBSCRIBE';
  /** The OCF message body in JSON */
  message: object;
  /** Response code from resource server */
  responseCode: string;
  /** Path to the resource */
  path: string;
}

/** something */
export interface DeviceGroupLinks {
  /** @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0" */
  href?: string;
  /** @example "oic.r.switch.binary" */
  rt?: string;
}

/** A group */
export interface DeviceGroupCreateRequest {
  /** Name of the group created */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType?: 'UNDETERMINED' | 'GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING';
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group. Defaults to main if not supplied. */
    components?: {
      id?: string;
    }[];
  }[];
  /** Room containing this device group */
  roomId?: RoomId;
}

/** A group */
export interface DeviceGroupUpdateRequest {
  /** Name of the group created */
  groupName: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId: string;
    /** Components to add to the group. Defaults to main if not supplied. */
    components?: {
      id?: string;
    }[];
  }[];
  /** Room containing this device group */
  roomId?: RoomId;
}

/** A group */
export interface DeviceGroupResponse {
  /** Name of the group */
  groupName: string;
  /**
   * The type of the group in question
   *
   * "UNDETERMINED" is a default value and is not used during normal operation. Passing "UNDETERMINED" into the API is the same as not passing a group type.
   */
  groupType: 'UNDETERMINED' | 'GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING';
  /**
   * Location where this group is
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "30d3691f-2416-4cbc-b193-2329581f29d1"
   */
  locationId?: string;
  /** An array of devices in the group */
  devices: {
    /**
     * GUID representing the device
     * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
     */
    deviceId?: string;
    /** Components to add to the group */
    components?: Record<string, any>[];
  }[];
  /**
   * a GUID that identifies a group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /** Room containing this device group */
  roomId?: RoomId;
  /** Lowest common denominator capability of all the devices in the group */
  links: DeviceGroupLinks[];
}

/**
 * Room containing this device group
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type RoomId = string;

export interface OcfDeviceGroupsCommandRequest {
  /**
   * Path to the resource
   * @example " /st/devicegroups/6ada44d8-966a-4b7c-9f1c-c028bcde45ee/capability/switch/0"
   */
  path: string;
  /**
   * The OCF message body in JSON
   * @example {"payload":{"value":true}}
   */
  message?: object;
  /**
   * Request menthod
   * @example "POST"
   */
  method: 'GET' | 'POST';
}

/** @example {"rt":["oic.r.switch.binary"],"id":"0","if":["oic.if.baseline","oic.if.r"],"value":true,"dimmingSetting":23} */
export interface OcfDeviceGroupsCommandResponse {
  rt?: string[];
  id?: string;
  if?: string[];
  value?: boolean;
  dimmingSetting?: number;
}

/** A paginated array of device groups */
export interface PagedDeviceGroups {
  items?: DeviceGroupResponse[];
  _links?: Links;
}

export type DeviceGroupDeleteResponse = Record<string, any>;

export type UserSettingsResponse = LastUsedLocationResponse & LocationsOrderResponse;

export interface LastUsedLocationResponse {
  /** The users last used location. This can be null when there is no lastUsedLocation saved. */
  lastUsedLocationId?: LastUsedLocation;
}

/**
 * The users last used location. This can be null when there is no lastUsedLocation saved.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type LastUsedLocation = string;

/** An ordered list of rooms in a location */
export interface RoomsOrderResponse {
  rooms?: UserRoom[];
}

/** An ordered list of devices in a rooms */
export interface RoomsDevicesOrderResponse {
  devices?: RoomDevice[];
}

/** All rooms in a location together with ordered device list. */
export interface LocationDevicesOrderResponse {
  roomDevices?: RoomDevices[];
}

/** Room with devices in order */
export interface RoomDevices {
  /**
   * The unique id for the room
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  devices?: RoomDevice[];
}

export interface UserRoom {
  /**
   * The unique id for the room
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
}

/** An ordered list of locations for a user */
export interface LocationsOrderResponse {
  locations?: UserLocation[];
}

/** An ordered list of automations for a user */
export interface AutomationsOrderResponse {
  automations?: UserAutomation[];
}

/** An ordered list of life services for a user */
export interface LifeServicesOrderResponse {
  lifeServices?: UserLifeService[];
}

/** An ordered list of smartApps for a user location */
export interface SmartAppsOrderResponse {
  apps?: UserLocationSmartApp[];
}

export interface UserLocation {
  /**
   * The unique id for the location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

/** An ordered list of static summary settings for a users location */
export interface StaticSummaryOrderResponse {
  settings?: UserStaticSettings[];
}

export interface UserStaticSettings {
  /**
   * The static setting type
   * @example "LIGHTS"
   */
  staticType?: 'LIGHTS' | 'INDOOR_TEMPERATURE' | 'INDOOR_HUMIDITY' | 'WEATHER' | 'OUTDOOR_AIR_QUALITY' | 'BLINDS';
}

/** An ordered list of location summary cards order */
export interface LocationSummaryCardsSortOrderResponse {
  summaryCards?: LocationSummaryDeviceType[];
}

/** A list of summary settings for a users location */
export interface LocationSummarySettingsResponse {
  summary: SummarySettingItem[];
  /** An ISO Alpha-3 country code.  (i.e. GBR, USA) */
  countryCode?: string;
}

export interface SummarySettingItem {
  /** Flag that represents the active/inactive statis for the summary setting */
  active: boolean;
  /** The location summary settings type of: `MASTER`, `LIGHTS`, `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `WEATHER`, `OUTDOOR_QUALITY`, `INTRUSION`, `SMOKE`, `MOISTURE`, `BLINDS`, `OFFLINE`, `LOW_BATTERY`, `OPEN`, `WASHER`, `DRYER`, `AIR_DRESSER`, `DISHWASHER` */
  id: LocationSummarySettingType;
}

/** A list of unselected devices by type */
export interface UserUnselectedDevices {
  unselectedDevices?: UnselectedDeviceType[];
}

export interface UnselectedDeviceType {
  /** The location summary settings type of: `LIGHTS`, `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `WEATHER`, `OUTDOOR_QUALITY`, `INTRUSION`, `SMOKE`, `MOISTURE`, `BLINDS`, `OFFLINE`, `LOW_BATTERY`, `OPEN`, `WASHER`, `DRYER`, `AIR_DRESSER`, `DISHWASHER` */
  id: LocationSummaryDeviceType;
  devices: string[];
}

/** The location summary settings type of: `MASTER`, `LIGHTS`, `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `WEATHER`, `OUTDOOR_QUALITY`, `INTRUSION`, `SMOKE`, `MOISTURE`, `BLINDS`, `OFFLINE`, `LOW_BATTERY`, `OPEN`, `WASHER`, `DRYER`, `AIR_DRESSER`, `DISHWASHER` */
export enum LocationSummarySettingType {
  MASTER = 'MASTER',
  LIGHTS = 'LIGHTS',
  INDOOR_TEMPERATURE = 'INDOOR_TEMPERATURE',
  INDOOR_HUMIDITY = 'INDOOR_HUMIDITY',
  WEATHER = 'WEATHER',
  OUTDOOR_AIR_QUALITY = 'OUTDOOR_AIR_QUALITY',
  INTRUSION = 'INTRUSION',
  SMOKE = 'SMOKE',
  MOISTURE = 'MOISTURE',
  BLINDS = 'BLINDS',
  OFFLINE = 'OFFLINE',
  LOW_BATTERY = 'LOW_BATTERY',
  OPEN = 'OPEN',
  WASHER = 'WASHER',
  DRYER = 'DRYER',
  AIR_DRESSER = 'AIR_DRESSER',
  DISHWASHER = 'DISHWASHER',
}

/** The location summary settings type of: `LIGHTS`, `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `WEATHER`, `OUTDOOR_QUALITY`, `INTRUSION`, `SMOKE`, `MOISTURE`, `BLINDS`, `OFFLINE`, `LOW_BATTERY`, `OPEN`, `WASHER`, `DRYER`, `AIR_DRESSER`, `DISHWASHER` */
export enum LocationSummaryDeviceType {
  LIGHTS = 'LIGHTS',
  INDOOR_TEMPERATURE = 'INDOOR_TEMPERATURE',
  INDOOR_HUMIDITY = 'INDOOR_HUMIDITY',
  WEATHER = 'WEATHER',
  OUTDOOR_AIR_QUALITY = 'OUTDOOR_AIR_QUALITY',
  INTRUSION = 'INTRUSION',
  SMOKE = 'SMOKE',
  MOISTURE = 'MOISTURE',
  BLINDS = 'BLINDS',
  OFFLINE = 'OFFLINE',
  LOW_BATTERY = 'LOW_BATTERY',
  OPEN = 'OPEN',
  WASHER = 'WASHER',
  DRYER = 'DRYER',
  AIR_DRESSER = 'AIR_DRESSER',
  DISHWASHER = 'DISHWASHER',
}

export interface UserAutomation {
  /**
   * The unique id for the automation
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  automationId?: string;
}

export interface UserLifeService {
  /**
   * The unique id for the life service
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  lifeServiceId?: string;
}

export interface UserLocationSmartApp {
  /**
   * The unique id for the smartApp
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
}

export interface RoomDevice {
  /**
   * The unique id for the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
}

export interface LastUsedLocationRequest {
  /**
   * The users last used location
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  lastUsedLocationId: string;
}

/** An ordered list of scenes in a location */
export interface ScenesOrderResponse {
  scenes?: UserScene[];
}

export interface UserScene {
  /**
   * The unique id for the scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
}

/**
 * The id of the favorite.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteId = string;

/**
 * The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type FavoriteLocationId = string;

/** The id of a Thing the favorite represents. */
export type FavoriteMemberId = string;

/** The type of favorite. */
export enum FavoriteMemberType {
  DEVICE = 'DEVICE',
  DEVICE_GROUP = 'DEVICE_GROUP',
  SCENE = 'SCENE',
  SERVICE = 'SERVICE',
  D2D = 'D2D',
}

/** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
export type FavoriteSortOrder = number;

/** Additional Id used for SERVICE favorites. */
export type FavoriteAdditionalId = string;

/** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
export type FavoriteBucket = string;

/** The model of device that created the favorite. Used for debugging purposes. */
export type FavoriteDeviceModel = string;

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","locationId":"811ba20b-9c6f-4064-851e-53e6fd3985ff","memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1,"additionalId":null,"bucket":null} */
export interface Favorite {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The id of the location to which the favorite belongs. Must match the location the entity belongs to if it's assigned to a location. */
  locationId: FavoriteLocationId;
  /** The id of a Thing the favorite represents. */
  memberId: FavoriteMemberId;
  /** The type of favorite. */
  memberType: FavoriteMemberType;
  /** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
  sortOrder: FavoriteSortOrder;
  /** Additional Id used for SERVICE favorites. */
  additionalId?: FavoriteAdditionalId;
  /** The bucket you are requesting favorites for. If present then manipulate the data corresponding to that bucket of favorites, otherwise uses location based favorites. [Max length = 50] */
  bucket?: FavoriteBucket;
  /** The model of device that created the favorite. Used for debugging purposes. */
  deviceModel: FavoriteDeviceModel;
  /**
   * The date the favorite was created.
   * @format date-time
   */
  createdDate: string;
  /**
   * The date the favorite was updated.
   * @format date-time
   */
  lastUpdatedDate: string;
}

/**
 * Thing to be added to favorites. Requires a locationId, memberId, memberType, and sortOrder.
 * @example {"memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1,"additionalId":null}
 */
export interface FavoriteCreateObject {
  /** The id of a Thing the favorite represents. */
  memberId: FavoriteMemberId;
  /** The type of favorite. */
  memberType: FavoriteMemberType;
  /** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
  sortOrder: FavoriteSortOrder;
  /** Additional Id used for SERVICE favorites. */
  additionalId?: FavoriteAdditionalId;
}

/**
 * Favorite to Update or Create. If favoriteId is null a new favorite is created, ortherwise the existing favorite is updated.
 * @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"SERVICE","sortOrder":1,"additionalId":"vodafone_MAS"}
 */
export interface FavoriteUpdateObject {
  /** The id of the favorite. */
  favoriteId?: FavoriteId;
  /** The id of a Thing the favorite represents. */
  memberId: FavoriteMemberId;
  /** The type of favorite. */
  memberType: FavoriteMemberType;
  /** The sort order of the favorite. Duplicate numbers are allowed to allow clients to group favorites by MemberType. */
  sortOrder: FavoriteSortOrder;
  /** Additional Id used for SERVICE favorites. */
  additionalId?: FavoriteAdditionalId;
}

/**
 * Object containing the favorites migration status for the location.
 * @example {"isMigrated":false}
 */
export interface FavoriteMigrationStatus {
  /** The favorites migration status for the location. */
  isMigrated: boolean;
  /**
   * The date the favorite was updated.
   * @format date-time
   */
  lastUpdatedDate?: string;
  /** The model of device that created the favorite. Used for debugging purposes. */
  deviceModel?: FavoriteDeviceModel;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","sceneName":"Test Scene","sceneIcon":"st.scenes.wand","ocfIconId":"200","locationId":"ece68254-ad83-4c49-9b96-5a723098a118","locationName":"Test Location"}
 */
export interface SceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The name of the Scene. Not nullable. */
  sceneName?: string;
  /** The name for the Scene Icon. Nullable. */
  sceneIcon?: string;
  /** The id for the OCF Icon. Not nullable. */
  ocfIconId?: string;
  /**
   * The location id of the Scene. Not nullable.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The name for the location of the Scene. Not nullable. */
  locationName?: string;
}

/**
 * An object that represents a favorites scene widget
 * @example {"sceneId":"bc2cee1e-60cf-4e3f-813d-1fe836f9e554","locationId":"ece68254-ad83-4c49-9b96-5a723098a118"}
 */
export interface CreateSceneWidgetFavoriteRepresentation {
  /**
   * The id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
  /**
   * The location id of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  sortOrder?: number;
}

/** The single item for Android Auto to use in the app */
export interface AndroidAutoItem {
  /** The id of a Thing the Android Auto represents. */
  memberId: AndroidAutoMemberId;
  /** The type of the Thing. */
  memberType: AndroidAutoMemberType;
  /** Additional Id used for SERVICE types. */
  additionalId?: AndroidAutoAdditionalId;
  /** The sort order of the item. Duplicate numbers are allowed to allow clients to group items by MemberType. */
  sortOrder: AndroidAutoSortOrder;
}

/** Single location for Android Auto to use in the app */
export interface AndroidAutoLocation {
  /** The id of the location. Must match the location the entity belongs to if it's assigned to a location. */
  locationId: AndroidAutoLocationId;
  items: AndroidAutoItem[];
}

/** All locations for Android Auto to use in the app */
export type AndroidAutoLocations = AndroidAutoLocation[];

/** Last connection time from Android Auto */
export interface AndroidAutoConnectionStatus {
  /**
   * The last time an API with path /androidauto/car/* was called
   * @format date-time
   * @example "2021-04-14T12:34:56Z"
   */
  latestConnectionTimestamp?: string;
}

/** Settings to use in the car */
export interface AndroidAutoSettings {
  getGeneralNotificationInCar: boolean;
  getSecurityNotificationInCar: boolean;
  /** The id of the location. Must match the location the entity belongs to if it's assigned to a location. */
  selectedLocation?: AndroidAutoLocationId;
}

/**
 * The id of a Thing the Android Auto represents.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 * @example "c8eb8b78-9e16-11eb-a8b3-0242ac130003"
 */
export type AndroidAutoMemberId = string;

/**
 * The type of the Thing.
 * @example "DEVICE"
 */
export enum AndroidAutoMemberType {
  DEVICE = 'DEVICE',
  DEVICE_GROUP = 'DEVICE_GROUP',
  SCENE = 'SCENE',
  SERVICE = 'SERVICE',
  D2D = 'D2D',
}

/**
 * Additional Id used for SERVICE types.
 * @maxLength 36
 * @example "vodafone_MAS"
 */
export type AndroidAutoAdditionalId = string;

/**
 * The id of the location. Must match the location the entity belongs to if it's assigned to a location.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 * @example "e7edcce8-9e16-11eb-a8b3-0242ac130003"
 */
export type AndroidAutoLocationId = string;

/**
 * The sort order of the item. Duplicate numbers are allowed to allow clients to group items by MemberType.
 * @min 1
 * @example 4
 */
export type AndroidAutoSortOrder = number;

/** room wallpaper info */
export interface RoomWallpaper {
  /** Id of the location */
  locationId: string;
  /** Id of the room */
  roomId: string;
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

/** location wallpaper info */
export interface LocationWallpaper {
  /** Id of the location */
  locationId: string;
  /** Id of the wallpaper. null if the wallpaper hasn't been set */
  wallpaperId?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate: string;
}

export interface UpdateWallpaperBodyObject {
  /** Id of the wallpaper */
  wallpaperId: string;
}

export interface MigrateWallpapersBodyObject {
  /** Id of the location wallpaper */
  wallpaperId: string;
  /** List of rooms with wallpaperIds */
  roomWallpapers?: {
    /** Id of the wallpaper */
    wallpaperId: string;
    /** Id of the room */
    roomId: string;
  }[];
}

/** Provide any settings that have changed */
export interface UpdateLocationSummarySettingsBodyObject {
  summary?: SummarySettingItem[];
}

/** Provide any categories that have unselected devices.  All unselected devices for a category should be provided. */
export interface UpdateLocationSummaryUnselectedDevicesBodyObject {
  unselectedDevices?: UnselectedDeviceType[];
}

export interface UpdateHiddenDevicesRequest {
  /** List of Device IDs to hide. */
  hide?: string[];
  show?: string[];
}

/**
 * The id of the location to which the favorite belongs.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type LocationId = string;

/**
 * The id of a Thing the favorite represents.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */
export type MemberId = string;

/** The type of favorite. */
export enum MemberType {
  DEVICE = 'DEVICE',
  SCENE = 'SCENE',
  DEVICE_GROUP = 'DEVICE_GROUP',
}

/**
 * The id of room which this favorite belongs. Nullable.
 * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
 */

// removed this line because it is a duplicate definition
// export type RoomId = string;

/** The sort order of the favorite. */
export type SortOrder = number;

/** @example {"favoriteId":"6c6eeb4b-ec78-4b54-b057-5d5f79982abc","sortOrder":1} */
export interface FavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

export interface WidgetFavoritePagedResult {
  items?: WidgetFavorite[];
  links?: Links;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","locationId":"020c9fe5-98e2-4919-9603-a20781df25d0","memberId":"f0353f80-64dd-4e03-98be-95f98f0b0a08","memberType":"SCENE","sortOrder":1} */
export interface WidgetFavorite {
  /** The id of the favorite. */
  favoriteId?: FavoriteId;
  /** The id of the location to which the favorite belongs. */
  locationId?: LocationId;
  /** The id of a Thing the favorite represents. */
  memberId?: MemberId;
  /** The type of favorite. */
  memberType?: MemberType;
  /** The sort order of the favorite. */
  sortOrder?: SortOrder;
}

/** @example {"favoriteId":"c2dda15c-bcc7-4711-a945-f1378bd1ce70","sortOrder":1} */
export interface WidgetFavoriteSortOrderObject {
  /** The id of the favorite. */
  favoriteId: FavoriteId;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

/**
 * Thing to be added to widget favorites. Requires a memberId, memberType, and sortOrder.
 * @example {"memberId":"7ffb873c-a155-4c7c-acb3-88c7589bd456","memberType":"DEVICE","sortOrder":1}
 */
export interface WidgetFavoriteBodyObject {
  /** The id of a Thing the favorite represents. */
  memberId: MemberId;
  /** The type of favorite. */
  memberType: MemberType;
  /** The sort order of the favorite. */
  sortOrder: SortOrder;
}

export interface InstalledAppSummary {
  /** The developer-defined name of the app */
  name?: string;
  /** The user-defined label of the installedapp */
  label?: string;
  /** The id of the app. This will be null when appType is SMARTAPP */
  appId?: string;
  /** The id of the installed app */
  installedAppId?: string;
  /**
   * The id of the location the app is installed
   * @format uuid
   */
  locationId?: string;
  /** A simplified verion of installedAppStatus for legacy purposes. installedAppStatus is preffered. */
  state?: 'COMPLETE' | 'INCOMPLETE';
  /**
   * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
   * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
   * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
   * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
   * 'AUTHORIZED' Installed App will not execute.
   */
  installedAppStatus?: 'PENDING' | 'AUTHORIZED' | 'REVOKED' | 'DISABLED';
  /**
   * An icon image url for the app
   * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
   */
  iconUrl?: string;
  /** The type of app. SMARTAPP is a legacy SmartApp, ENDPOINTAPP and WEBHOOK are SmartApps from the public API. */
  appType?: 'SMARTAPP' | 'ENDPOINTAPP' | 'WEBHOOK';
  /**
   * This will always be "automationApp" for ENDPOINT and WEBHOOK types.
   * @default "NONE"
   */
  samsungCategory?: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
  /**
   * Whether or not the automation can be paused
   * @default false
   */
  pausable?: boolean;
  /**
   * Whether or not the automation is paused
   * @default false
   */
  paused?: boolean;
  /**
   * Whether or not the automation is maintained by SmartThings or a third party
   * @default false
   */
  usesThirdPartyAuthentication?: boolean;
  /** A collection of settings to drive user interface in SmartThings clients. This will always be null for SMARTAPP types */
  ui?: {
    /** @format ^[a-zA-Z._]{1,99}$ */
    pluginId?: string;
    /** @format uri */
    pluginUri?: string;
    dashboardCardsEnabled: boolean;
    preInstallDashboardCardsEnabled: boolean;
  };
  classifications?: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
}

/**
 * A typed model which provides information around ownership of a specific domain.
 * @example {"ownerType":"USER","ownerId":"72fd3b54-d243-4bf7-a845-92eb7956b982"}
 */
export interface Owner {
  /**
   * The type of owner that owns this entity. "Account" refers specifically to a coterie account ID.
   * @default "USER"
   */
  ownerType: 'USER' | 'SYSTEM' | 'IMPLICIT' | 'ACCOUNT';
  /** A global identifier for owner. */
  ownerId: string;
}

/**
 * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
 * useful for filtering.
 *
 * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
 * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
 * * Case sensitive
 * * Maximum number of tags per resource: 25
 * * Reserved prefix — `st:`
 * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
 * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
 * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
 * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
 * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
 * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
 */
export type Tags = Record<string, string>;

/** A request object used to update a resource's tags. */
export interface UpdateTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the updated tags. */
export interface UpdateTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A request object used to update a resource's tags. */
export interface PatchTagsRequest {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  upserts?: Tags;
  removals?: string[];
}

/** A response object containing the updated tags. */
export interface PatchTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** A response object containing the resource's tags. */
export interface GetTagsResponse {
  /**
   * A map of user-defined tags which can be used to associate arbitrary metadata to a resource, and can be
   * useful for filtering.
   *
   * * Key length must be between 1 and 64 (inclusive) Unicode characters in UTF-8
   * * Value length must be between 1 and 256 (inclusive) Unicode characters in UTF-8
   * * Case sensitive
   * * Maximum number of tags per resource: 25
   * * Reserved prefix — `st:`
   * * ST-generated tag names and values are automatically assigned the `st:` prefix, which you cannot assign.
   * * Use each key only once for each resource. If you attempt to use the same key twice on the same resource the last key wins.
   * * You cannot tag a resource at the same time you create it. Tagging requires a separate action after the resource is created.
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding to your tag.
   */
  tags?: Tags;
}

/** Entity that created the event. */
export enum DeviceEventSource {
  OCFDEVICE = 'OCFDEVICE',
  HUBDEVICE = 'HUBDEVICE',
  HUB = 'HUB',
  CLOUD = 'CLOUD',
}

/** Represents a single page of Locations available in a user account. */
export interface PagedLocations {
  items: PagedLocation[];
  _links?: Links;
}

/**
 * A slimmed-down representation of the Location model.
 * @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"}}
 */
export interface PagedLocation {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent: LocationParent;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface Location {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:locations - the user can change the name of the location
   *   <li> d:locations - the user can delete the location
   *   <li> w:grants:locationshare - the user can share the location with other users
   *   <li> w:devices - the user can create devices on the location
   *   <li> w:locations:geo - the user can edit the geo-coordinates of the location
   *   <li> r:installedapps - the user can view or list installed apps on the location
   *   <li> w:installedapps - the user can create installed apps on the location
   *   <li> r:modes - the user can view or list Modes on the location
   *   <li> r:rooms - the user can view or list rooms on the location
   *   <li> w:rooms - the user can create rooms on the location
   *   <li> r:locations:currentmode - the user can view the current Mode on the location
   *   <li> w:locations:currentmode - the user can change the current Mode on the location
   *   <li> r:scenes - the user can view or list scenes on the location
   *   <li> w:scenes - the user can create scenes on the location
   *   <li> r:rules - the user can view or list rules on the location
   *   <li> w:rules - the user can create rules on the location
   *   <li> r:linkedplaces - the user can view or list linked places on the location
   *   <li> w:linkedplaces - the user can create linked places on the location
   *   </ul>
   */
  allowed?: string[];
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

export interface CreateLocationRequest {
  /** Group name(title) for the created group */
  gname: string;
  /** Group latitude [Max length = 20] */
  latitude: string;
  /** Group longitude [Max length = 20] */
  longitude: string;
  /** Group radius [Max length = 20] */
  radius: string;
}

export interface CreateLocationResponse {
  /** The ID of the location. */
  gid?: string;
}

/** @example {"latitude":{"toNull":true},"longitude":{"value":50}} */
export interface PatchLocationRequest {
  /** Settings for the geographic latitude. */
  latitude?: {
    /**
     * the new value
     * @min -90
     * @max 90
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the geographic longitude. */
  longitude?: {
    /**
     * the new value
     * @min -180
     * @max 180
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
  /** Settings for the radius in meters around the latitude and longitude defining the location. */
  regionRadius?: {
    /**
     * the new value
     * @min 20
     * @max 500000
     */
    value?: number;
    /**
     * if true, value will be cleared (unset)
     * @default false
     */
    toNull?: boolean;
  };
}

export interface UpdateLocationRequest {
  /** Group's name to be replaced [Only replace available] */
  gname: string;
  /** Masters to be added or deleted or replaced */
  masters: string[];
  /** Members to be added or deleted or replaced */
  members: string[];
  /** Devices to be added or deleted or replaced */
  devices: string[];
  /** Resources to be replaced [Only replace available] */
  resources: LocationResource[];
  /** Group latitude  [Max length = 20] */
  latitude: string;
  /** Group latitude  [Max length = 20] */
  longitude: string;
  /** Group radius [Max length = 20] */
  radius: string;
  /** Group backgroundImage [Max length = 128] */
  backgroundImage: string;
  /** Temperaturescale ["C","F"] */
  temperaturescale: string;
}

/** @example {"locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Home","countryCode":"USA","latitude":45.00708112,"longitude":-93.11223629,"regionRadius":150,"temperatureScale":"F","timeZoneId":"America/Chicago","locale":"en_US","parent":{"type":"LOCATIONGROUP","id":"6ecb6c06-7319-49b1-8ebd-f97660efdd06"},"created":1547920800,"lastModified":1548007200} */
export interface UpdateLocationResponse {
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
  /** A name given for the location (eg. Home) */
  name: string;
  /**
   * An ISO Alpha-3 country code.  (i.e. GBR, USA)
   * @example "USA"
   */
  countryCode: string;
  /** A geographical latitude. */
  latitude?: number;
  /** A geographical longitude. */
  longitude?: number;
  /**
   * The radius in meters around latitude and longitude which defines this location.
   * @format int32
   */
  regionRadius?: number;
  /** The desired temperature scale used within location. Value can be F or C. */
  temperatureScale?: string;
  /**
   * An ID matching the Java Time Zone ID of the location. Automatically generated if latitude and longitude have been
   * provided.
   */
  timeZoneId?: string;
  /**
   * We expect a POSIX locale but we also accept an IETF BCP 47 language tag.
   * @example "en_US"
   */
  locale?: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /** Additional information about the location that allows SmartThings to further define your location. */
  additionalProperties?: Record<string, string>;
  /** The parent of a Location */
  parent?: LocationParent;
  /**
   * The timestamp of when a location was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a location was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteLocationResponse = object;

/** The parent of a Location */
export interface LocationParent {
  /** The type of the Location's parent. */
  type?: LocationParentTypes;
  /**
   * The ID of the parent
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @minLength 36
   * @maxLength 36
   */
  id?: string;
}

/**
 * The type of the Location's parent.
 * @minLength 7
 * @maxLength 14
 */
export enum LocationParentTypes {
  LOCATIONGROUP = 'LOCATIONGROUP',
  ACCOUNT = 'ACCOUNT',
}

/** Represents a single page of Rooms available in a Location. */
export interface PagedRooms {
  items: Room[];
  _links?: Links;
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface Room {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:rooms - the user can delete the room
   *   <li> w:rooms - the user can edit the room
   *   </ul>
   */
  allowed?: string[];
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

export interface CreateRoomResponse {
  gid?: string;
}

/** @example {"roomId":"bdd8a15f-33d4-41fc-b33c-75ce85e99d24","locationId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","name":"Living Room","created":1547920800,"lastModified":1548007200,"indoorMap":{"mapRoomId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf8","color":"some color code"}} */
export interface UpdateRoomResponse {
  /**
   * The ID of the room.
   * @format uuid
   */
  roomId: string;
  /**
   * The ID of the parent Location.
   * @format uuid
   */
  locationId: string;
  /** A name for the room (e.g. Living Room) */
  name: string;
  /**
   * Not currently in use.
   * @example null
   */
  backgroundImage?: string;
  /**
   * The timestamp of when a room was created in UTC.
   * @format date-time
   */
  created?: string;
  /**
   * The timestamp of when a room was last updated in UTC.
   * @format date-time
   */
  lastModified?: string;
  /** Data used for indoor map */
  indoorMap?: {
    /**
     * The reference id for the room map
     * @minLength 1
     * @maxLength 40
     */
    mapRoomId?: string;
    /**
     * Map Room Color
     * @minLength 1
     * @maxLength 255
     */
    color?: string;
  };
}

export interface CreateRoomRequest {
  /** The name of location. */
  gname: string;
  /** Group backgroundImage. */
  backgroundImage: string;
}

export interface UpdateRoomRequest {
  /** Group's name to be replaced [Only replace available] */
  gname: string;
  /** Devices to be added or deleted or replaced */
  devices: string[];
  /** Group backgroundImage [Max length = 128] */
  backgroundImage: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteRoomResponse = object;

/** @example {"displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","installedAppType":"WEBHOOK_SMART_APP","configurationStatus":"STAGED","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface CreateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
  /** The ID of the app. */
  appId: string;
  /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. */
  referenceId?: string;
  /**
   * The ID of the location.  A locationId may or may not be required based on the type of install.
   * @format uuid
   */
  locationId: string;
  /** Denotes the type of installed app. */
  installedAppType: InstalledAppType;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

/** @example {"displayName":"Color App"} */
export interface UpdateInstalledAppRequest {
  /**
   * A user defined name for the installed app.
   * @maxLength 100
   */
  displayName?: string;
}

/** @example {"removals":["temperature_controls","some_other_developer_defined_key"],"upserts":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"paint","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface PatchInstalledAppRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  upserts?: ConfigMap;
  /** An array of config name's to delete. */
  removals?: string[];
}

/**
 * An empty object request.
 * @example {}
 */
export type InitializeUpdateFlowRequest = object;

/** Initialize update flow response. */
export interface InitializeUpdateFlowResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

/**
 * An configuration instance of an Installed App.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"DONE","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z"}
 */
export interface InstallConfiguration {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/**
 * Encompasses both a configuration value, and any required permissions that maybe needed.
 * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","configurationStatus":"AUTHORIZED","createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61","componentId":"main","permissions":["r:devices:5ccbf4ba-7b5f-4eb3-85b8-ab8705ff8d61"]}}]}}
 */
export interface InstallConfigurationDetail {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /**
   * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
   * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
   * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
   * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
   * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
   */
  configurationStatus?: InstallConfigurationStatus;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  createdDate?: string;
  /**
   * A UTC ISO-8601 Date-Time String
   * @format date-time
   */
  lastUpdatedDate?: string;
}

/** @example {"config":{"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}],"color_controls":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"379572d6-20ef-4f02-af84-86131600b048","componentId":"marker","permissions":["r:devices:379572d6-20ef-4f02-af84-86131600b048"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"34afdafc-f272-4d1d-ac1c-cbf6e0c62049","componentId":"crayon","permissions":["r:devices:34afdafc-f272-4d1d-ac1c-cbf6e0c62049"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}],"other":[{"valueType":"PERMISSION","permissionConfig":{"permissions":["w:notifications","w:schedules"]}}]}} */
export interface UpdateInstallConfigurationRequest {
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config: ConfigMap;
}

/**
 * Initialize request.
 * @example {"appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a"}
 */
export interface InitializeRequest {
  /** The ID of the app. */
  appId: string;
  /**
   * A user defined name for the installed app. Only used for a new installed app.
   * @maxLength 100
   */
  displayName?: string;
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID of the location.
   * @format uuid
   */
  locationId: string;
}

/** Initialize response. */
export interface InitializeResponse {
  /** A composite model to provide both the details of an InstalledApp and the current configuration. */
  installedAppComposite?: InstalledAppComposite;
}

export interface CancelRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type CancelResponse = object;

/**
 * A simple string configuration.
 * @example {"value":"31192dc9-eb45-4d90-b606-21e9b66d8c2b"}
 */
export interface StringConfig {
  /**
   * A config value
   * @maxLength 2048
   */
  value?: string;
}

/**
 * A device and component configuration with any required permissions.
 * @example {"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}
 */
export interface DeviceConfig {
  /**
   * The ID of the device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * The component ID on the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * Required permissions for the installed app.
 * @example {"permissions":["w:notifications","r:devices:*"]}
 */
export interface PermissionConfig {
  /**
   * @maxItems 25
   * @minItems 1
   */
  permissions?: string[];
}

/**
 * A mode configuration.
 * @example {"modeId":"9206ea57-2e2e-414c-a792-9087117ca3d8"}
 */
export interface ModeConfig {
  /**
   * The ID of the mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
}

/**
 * A scene configuration.
 * @example {"sceneId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["x:scences:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface SceneConfig {
  /**
   * The ID of the scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A message configuration.
 * @example {"messageGroupKey":"leaks"}
 */
export interface MessageConfig {
  /**
   * The key value of the message group.
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A room configuration.
 * @example {"roomId":"9206ea57-2e2e-414c-a792-9087117ca3d8","permissions":["r:locations:9206ea57-2e2e-414c-a792-9087117ca3d8"]}
 */
export interface RoomConfig {
  /**
   * The ID of the room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId?: string;
  /** @maxItems 25 */
  permissions?: string[];
}

/**
 * A configuration value type and the correspodning configuration.
 * @example {"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}}
 */
export interface ConfigEntry {
  /** The value type. */
  valueType?: 'STRING' | 'DEVICE' | 'PERMISSION' | 'MODE' | 'SCENE' | 'MESSAGE' | 'ROOM';
  /** The config if valueType is STRING, meaningless otherwise */
  stringConfig?: StringConfig;
  /** The config if valueType is DEVICE, meaningless otherwise */
  deviceConfig?: DeviceConfig;
  /** The config if valueType is PERMISSION, meaningless otherwise */
  permissionConfig?: PermissionConfig;
  /** The config if valueType is MODE, meaningless otherwise */
  modeConfig?: ModeConfig;
  /** The config if valueType is SCENE, meaningless otherwise */
  sceneConfig?: SceneConfig;
  /** The config if valueType is MESSAGE, meaningless otherwise */
  messageConfig?: MessageConfig;
  /** The config if valueType is ROOM, meaningless otherwise */
  roomConfig?: RoomConfig;
}

/** A list of available configuration values. */
export type ConfigEntries = ConfigEntry[];

/**
 * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
 * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
 * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
 * @example {"switches":[{"valueType":"DEVICE","deviceConfig":{"deviceId":"31192dc9-eb45-4d90-b606-21e9b66d8c2b","componentId":"main","permissions":["r:devices:31192dc9-eb45-4d90-b606-21e9b66d8c2b"]}},{"valueType":"DEVICE","deviceConfig":{"deviceId":"bea6074d-7dde-4936-ab79-373fa13250d4","componentId":"main","permissions":["r:devices:bea6074d-7dde-4936-ab79-373fa13250d4"]}}],"color":[{"valueType":"STRING","stringConfig":{"value":null}}]}
 */
export type ConfigMap = Record<string, ConfigEntries>;

/** Denotes the type of installed app. */
export enum InstalledAppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
  BEHAVIOR = 'BEHAVIOR',
  API_ONLY = 'API_ONLY',
}

/**
 * Denotes the current state of a configuration instance.  'STAGED' configuration is used during active
 * modification to config.  A configuration is marked 'DONE' once it is deemed finished.  At this point it
 * is immutable, meaning it can't be changed.  A status of 'AUTHORIZED' means the apps permissions have been
 * authorized by the consumer.  Installed Apps in 'AUTHORIZED' state are fully installed and used by the
 * SmartThings platform.  A status of 'REVOKED' means the apps permissions have been revoked.
 */
export enum InstallConfigurationStatus {
  STAGED = 'STAGED',
  DONE = 'DONE',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
}

/**
 * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
 * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
 * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
 * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
 * 'AUTHORIZED' Installed App will not execute.
 */
export enum InstalledAppStatus {
  PENDING = 'PENDING',
  AUTHORIZED = 'AUTHORIZED',
  REVOKED = 'REVOKED',
  DISABLED = 'DISABLED',
}

/** A composite model to provide both the details of an InstalledApp and the current configuration. */
export interface InstalledAppComposite {
  installedApp?: InstalledApp;
  /** Encompasses both a configuration value, and any required permissions that maybe needed. */
  configurationDetail?: InstallConfigurationDetail;
}

/** Represents a single page of InstalledApps available in a user account. */
export interface PagedInstalledApps {
  items?: InstalledApp[];
  _links?: Links;
}

/** @example {"installable":true} */
export interface CanInstallAppResponse {
  /**
   * Will be set to true if the provided App can be installed.
   * @default false
   */
  installable?: boolean;
}

/** A response containing details about the bearer token. */
export interface InstalledAppMeResponse {
  /**
   * The installedapp identifier.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The location identifier.
   * @format uuid
   */
  locationId?: string;
  /** A unique set of the OAuth scope associated with the bearer token. */
  scope?: string[];
}

/** Represents a single page of InstallConfiguration models available for an InstalledApp. */
export interface PagedInstallConfigurations {
  items?: InstallConfiguration[];
  _links?: Links;
}

/** The number of deleted installed apps. */
export interface DeleteInstalledAppResponse {
  /** @format int32 */
  count?: number;
}

/** @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","configurationId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","permissions":["r:devices:416747c2-ac57-4f49-8d01-aff1094dee61","r:devices:656382bd-b125-4ade-a429-193fb3e7900d","w:devices:656382bd-b125-4ade-a429-193fb3e7900d","l:devices"]} */
export interface InstallConfigurationPermissionResponse {
  /**
   * The ID of the installed app.
   * @format uuid
   */
  installedAppId?: string;
  /**
   * The ID to this configration instance.
   * @format uuid
   */
  configurationId?: string;
  /** A unique set of the OAuth scope required for a specific install configuration. */
  permissions?: string[];
}

export interface Notice {
  /**
   * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
   * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
   * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
   */
  code?: NoticeCode;
  /** The url of the badge icon for the notice card */
  badgeUrl?: string;
  /** The localized message to be displayed */
  message?: string;
  /** The action(s) a user can take to resolve this notice */
  actions?: NoticeAction[];
}

/**
 * An action the user can take to resolve a notice
 * @default "none"
 */
export enum NoticeAction {
  DISMISS = 'DISMISS',
  EDIT = 'EDIT',
  NONE = 'NONE',
}

/**
 * * USER_PAUSE - Denotes installed app is paused by the user and user action is required to unpause it.
 * * REVISIT - Denotes installed app is still running and user action may be required to reconcile a configuration.
 * * RECONFIGURE - Denotes installed app is no longer running and user action is required to resolve a configuration issue.
 */
export enum NoticeCode {
  USER_PAUSE = 'USER_PAUSE',
  REVISIT = 'REVISIT',
  RECONFIGURE = 'RECONFIGURE',
}

export interface Event {
  /**
   * Unique ID of the event.
   * @format uuid
   */
  id?: string;
  /** UNIX timestamp of the server. */
  serverTime?: string;
  /** ID of the location that this event relates to. */
  locationId: string;
  /** Name of the event. */
  name?: string;
  /** Whether the state is changed. */
  stateChange?: boolean;
  /** Whether this event is intended for mobile app UI display */
  displayed?: boolean;
  /**
   * UNIX timestamp of the provider when the event was created
   * @format int64
   */
  providerTime?: number;
  /** Internal event ID from provider */
  providerEventId?: string;
  /** Raw message as debugging reference */
  rawMessage?: string;
  /** Tracking IDs used to track relationship between events */
  trackingIds?: string[];
  /** Body of the legacy event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  legacyEvent?: LegacyEvent;
  /** Body of the device event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  deviceEvent?: DeviceEvent;
  /** Body of the timer event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
  timerEvent?: TimerEvent;
  modeEvent?: ModeEvent;
  /**
   * If status is not `OFFLINE` or if the reason is `SERVICE_UNAVAILABLE` then `hubId` is optional, otherwise a `hubId` must
   * be provided. Further, if the `status` is `OFFLINE` then `reason` is required. If the `status` is not `OFFLINE` a `reason` must
   * not be provided.
   */
  deviceHealthEvent?: DeviceHealthEvent;
  /** If status is offline, reason can't be `NONE`. For any other status, reason has to be `NONE` */
  hubHealthEvent?: HubHealthEvent;
  hubDeviceDiscoveryEvent?: HubDeviceDiscoveryEvent;
  deviceCommandsEvent?: DeviceCommandsEvent;
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  deviceLogEvent?: DeviceLogEvent;
  installedAppLifecycleEvent?: InstalledAppLifecycleEvent;
  /** A capability lifecycle event. At least one of `create`, `update`, `delete`, `localizationChange` and `statusChange` must be set and value should not be null. */
  capabilityLifecycleEvent?: CapabilityLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
  /** An event which can be used to broadcast custom triggers from SmartApps. */
  smartAppEvent?: SmartAppEvent;
  /** An event used to trigger a client action on a SmartApp dashboard card. */
  smartAppDashboardCardEvent?: SmartAppDashboardCardEvent;
  /** An event that represents a change in the arm state of a security system. */
  securityArmStateEvent?: SecurityArmStateEvent;
  /** An event that represents a failure to change the arm state of a security system. */
  securityArmFailureEvent?: SecurityArmFailureEvent;
  /** An event that represents a SOS event has occured for a security system. */
  securitySosEvent?: SecuritySosEvent;
  /** An event that represents a quarantine state change for an entity. */
  quarantineEvent?: QuarantineEvent;
  /** An event representing the current weather forecast. */
  weatherEvent?: WeatherEvent;
  /** A GeoPlace lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. There must also be either a user or service value set and not null. A GeoPlaceLifecycleEvent should typically not have a locationId in the event wrapper object. */
  geoPlaceLifecycleEvent?: GeoPlaceLifecycleEvent;
  /** A rule lifecycle event. */
  ruleLifecycleEvent?: RuleLifecycleEvent;
  /** Schema that is registered in the system */
  schemaUri?: string;
}

/** Body of the device event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface DeviceEvent {
  /** Unique ID of a registered device in the cloud. The device must have already been registered with the system and assigned this ID. */
  deviceId?: string;
  /** ID of the device type. The service that registers the device must have looked up that device type ID prior to registration. */
  deviceTypeId?: string;
  /**
   * ID for what owns the device event. Works in tandem with `ownerType` as a composite identifier.
   * A DeviceEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** ID (componentName) of the component. Default component is 'main'. */
  component?: string;
  /** Localizable human readable title for the event. */
  linkText?: string;
  /** (TBD) Capability that this event relates to. */
  capability?: string;
  /** The capabilities for attributes that are related to multiple capabilities. */
  capabilities?: string[];
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Value associated with the event. */
  value?: string;
  /** any JSON type wrapped in a single element array to allow for top level primitives. */
  valueJson?: string;
  /** Unit of the value field. Must be defined in the capability model. */
  unit?: string;
  /** ID of the hub that the device is connected to. Hub must have already been registered with the system. */
  hubId?: string;
  /** Localizable human readable description of the event. */
  descriptionText?: string;
  /** Serial number, IMEI, MAC address or other unique identifier of the device. */
  providerDeviceId?: string;
  /** Entity that created the event. */
  source?: DeviceEventSource;
  /**
   * When user-level devices have been shared to multiple locations, this will be `true` when the event is on the
   * user's "primary" shard.
   * @default false
   */
  primaryEvent?: boolean;
  /**
   * Identifier to ensure uniquness of events across multiple shards, when used by global services that consume
   * those events. Required if `sharedLocations` or `globalSharedLocations` are provided.
   * @format uuid
   */
  sourceEventId?: string;
  /**
   * Locations that the event was created in for the current shard.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard. If used, `sourceEventId` is required.
   */
  sharedLocations?: EventSharedLocation[];
  /**
   * Locations that the event was created in for all other shards.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard. If used, `sourceEventId` is required.
   */
  globalSharedLocations?: EventSharedLocation[];
}

/**
 * User-level DeviceEvents and DeviceLifecycleEvents can be shared into multiple locations. Each location is
 * defined by the shard it lives within plus its actual identifier.
 */
export interface EventSharedLocation {
  /**
   * Identifier of containing shard. Example: `na01`
   * @pattern ^\w{2}\d{2}\w*$
   * @example "na01"
   */
  shardId?: string;
  /**
   * Identifier of location being shared.
   * @format uuid
   */
  locationId?: string;
}

/** Body of the legacy event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface LegacyEvent {
  /** Entity that created the event */
  source?: LegacyEventSource;
  /** Localizable human readable title for the event. */
  linkText?: string;
  /** (TBD) Capability that this event relates to. */
  capability?: string;
  /** Name of the capability attribute that this event relates to. */
  attribute?: string;
  /** Name of the component that this event relates to. */
  component?: string;
  /** Value associated with the event. */
  value?: string;
  /** Unit of the value field. Must be defined in the capability model. */
  unit?: string;
  /** True if the event should NOT be archived, defaults to false. */
  nonArchivable?: boolean;
  /** (TBD) */
  type?: string;
  /** (TBD) Event type. */
  eventType?: string;
  /** (TBD) Event data. */
  data?: string;
  /**
   * ID of command sent from a mobile app.
   * @format int32
   */
  commandId?: number;
  /** ID of the hub that the device is connected to. Hub must have already been registered with the system. */
  hubId?: string;
  /** (TBD) ID of the group that the device is related to. */
  groupId?: string;
  /** Unique ID of a registered device in the cloud. The device must have already been registered with the system and assigned this ID. */
  deviceId?: string;
  /** If this is a component event, then set the id of the parent device that kicked off the event. */
  parentDeviceId?: string;
  /** ID of the device type. The service that registers the device must have looked up that device type ID prior to registration. */
  deviceTypeId?: string;
  /** GUID for Object instance of SmartApp install unique to location installation. */
  installedDeviceId?: string;
  /** GUID for SmartApp class/code. */
  smartAppId?: string;
  /** Version of the smart app "class". */
  smartAppVersionId?: string;
  /** GUID for Object instance of SmartApp install unique to location installation. */
  installedSmartAppId?: string;
  /** Two-tiered hierarchy for Smartapps (allows parent/child). References parent installed app instance. */
  installedSmartAppParentId?: string;
  /** (TBD) */
  userID?: string;
  /** (TBD) */
  description?: string;
  /** Localizable human readable description of the event. */
  descriptionText?: string;
  /** The name of the legacy handler associated with the event. */
  handlerName?: string;
  /** (TBD) */
  triggeredBy?: string;
  /** Flag to indicate whether the descriptionText should be translated or not. */
  translatable?: boolean;
  /** Templateable message arguments for localization service. */
  messageArgs?: string;
  /** Event ID that triggered the generation of this event */
  triggerEventId?: string;
  /** (TBD) */
  virtualHub?: boolean;
  /** ID of the account that this event relates to. */
  accountId?: string;
}

/** Body of the timer event message. Due to limitation of swagger api, only one of the event messages can be used per event. */
export interface TimerEvent {
  /** (TBD) */
  type?: TimerEventType;
  /** ID of the installed app that created and is the target of the schedule. */
  installedAppId?: string;
  /**
   * ID for what owns the timer event. Works in tandem with `ownerType` as a composite identifier.
   * A TimerEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /**
   * UNIX timestamp of the time the event was triggered.
   * @format int64
   */
  time?: number;
  /** Cron expression that was in effect at time of event creation. */
  expression?: string;
}

/** (TBD) */
export enum TimerEventType {
  NONE = 'NONE',
  CRON = 'CRON',
  ONCE = 'ONCE',
}

/**
 * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
 * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
 * * `USER` A user-level event, where the user can be found in `ownerId`.
 * @default "LOCATION"
 */
export enum EventOwnerType {
  LOCATION = 'LOCATION',
  USER = 'USER',
}

/** Entity that created the event */
export enum LegacyEventSource {
  NONE = 'NONE',
  HUB = 'HUB',
  DEVICE = 'DEVICE',
  DEVICE_COMMAND = 'DEVICE_COMMAND',
  LOCATION = 'LOCATION',
  COMMAND = 'COMMAND',
  APP = 'APP',
  APP_COMMAND = 'APP_COMMAND',
  USER = 'USER',
  ROOM = 'ROOM',
}

export interface ModeEvent {
  /** The ID of the event. */
  eventId?: string;
  /** The name of the MODE_EVENT. */
  name?: string;
  /** The ID of the mode associated with a MODE_EVENT. */
  modeId?: string;
}

/**
 * If status is not `OFFLINE` or if the reason is `SERVICE_UNAVAILABLE` then `hubId` is optional, otherwise a `hubId` must
 * be provided. Further, if the `status` is `OFFLINE` then `reason` is required. If the `status` is not `OFFLINE` a `reason` must
 * not be provided.
 */
export interface DeviceHealthEvent {
  deviceId: string;
  hubId?: string;
  /** ID for what owns the device health event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  status?: DeviceHealthStatus;
  reason?: DeviceHealthOfflineReason;
  /** Entity that created the event. */
  eventSource?: DeviceEventSource;
}

export enum DeviceHealthStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNHEALTHY = 'UNHEALTHY',
}

export enum DeviceHealthOfflineReason {
  NONE = 'NONE',
  SERVICE_UNAVAILABLE = 'SERVICE_UNAVAILABLE',
  HUB_OFFLINE = 'HUB_OFFLINE',
  ZWAVE_OFFLINE = 'ZWAVE_OFFLINE',
  ZIGBEE_OFFLINE = 'ZIGBEE_OFFLINE',
  BLUETOOTH_OFFLINE = 'BLUETOOTH_OFFLINE',
}

/** If status is offline, reason can't be `NONE`. For any other status, reason has to be `NONE` */
export interface HubHealthEvent {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  hubId: string;
  status?: HubHealthStatus;
  reason: HubHealthOfflineReason;
}

export enum HubHealthStatus {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  ZWAVE_OFFLINE = 'ZWAVE_OFFLINE',
  ZWAVE_ONLINE = 'ZWAVE_ONLINE',
  ZIGBEE_OFFLINE = 'ZIGBEE_OFFLINE',
  ZIGBEE_ONLINE = 'ZIGBEE_ONLINE',
  BLUETOOTH_OFFLINE = 'BLUETOOTH_OFFLINE',
  BLUETOOTH_ONLINE = 'BLUETOOTH_ONLINE',
}

export enum HubHealthOfflineReason {
  NONE = 'NONE',
  DISCONNECTED = 'DISCONNECTED',
  INACTIVE = 'INACTIVE',
}

export interface HubDeviceDiscoveryEvent {
  hubId?: string;
  mac?: string;
  networkAddress?: string;
  deviceAddress?: string;
  ssdp?: SsdpDiscovery;
  mndns?: MdnsDiscovery;
}

export interface SsdpDiscovery {
  path?: string;
  USN?: string;
  ST?: string;
  NTS?: string;
}

export interface MdnsDiscovery {
  path?: string;
}

export interface DeviceCommandsEvent {
  /** The guid of the device that the cammands are for. */
  deviceId?: string;
  /** The guid of the installed app that will process the commands for endpoint app managed devices. */
  installedAppId?: string;
  commands?: DeviceCommandsEventCommand[];
}

export interface DeviceCommandsEventCommand {
  component?: string;
  capability?: string;
  command?: string;
  arguments?: object[];
}

/** A rule lifecycle event. */
export interface RuleLifecycleEvent {
  /**
   * The rule lifecycle. The lifecycle will be one of:
   * * CREATE - Invoked when a rule is created.
   * * UPDATE - Invoked when a rule is updated.
   * * DELETE - Invoked when a rule is deleted.
   * * EXECUTE - Invoked when a rule is executed.
   * * CREATE_FOR_BIXBY - Invoked when a rule is created for Bixby.
   * * UPDATE_FOR_BIXBY - Invoked when a rule is updated for Bixby.
   * * DELETE_FOR_BIXBY - Invoked when a rule is deleted for Bixby.
   */
  lifecycle?: RuleLifecycle;
  /** The id of the event. */
  eventId?: string;
  /**
   * The id of the location in which the event was triggered.
   *
   * This field is not used or populated for user-level events.
   *
   * Location id may also be sent in `ownerId` with `ownerType` = `LOCATION`.
   */
  locationId?: string;
  /** ID for what owns the rule lifecyle event. Works in tandem with `ownerType` as a composite identifier. */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  /** The id of the rule. */
  ruleId?: string;
  /** The version of the rule. */
  version?: string;
  /** Create rule lifecycle. */
  create?: RuleLifecycleCreate;
  /** Update rule lifecycle. */
  update?: RuleLifecycleUpdate;
  /** Delete rule lifecycle. */
  delete?: RuleLifecycleDelete;
  /** Execute rule lifecycle. */
  execute?: RuleLifecycleExecute;
  /** Create rule lifecycle for bixby. */
  createForBixby?: RuleLifecycleCreateForBixby;
  /** Update rule lifecycle for bixby. */
  updateForBixby?: RuleLifecycleUpdateForBixby;
  /** Delete rule lifecycle for bixby. */
  deleteForBixby?: RuleLifecycleDeleteForBixby;
}

/**
 * The rule lifecycle. The lifecycle will be one of:
 * * CREATE - Invoked when a rule is created.
 * * UPDATE - Invoked when a rule is updated.
 * * DELETE - Invoked when a rule is deleted.
 * * EXECUTE - Invoked when a rule is executed.
 * * CREATE_FOR_BIXBY - Invoked when a rule is created for Bixby.
 * * UPDATE_FOR_BIXBY - Invoked when a rule is updated for Bixby.
 * * DELETE_FOR_BIXBY - Invoked when a rule is deleted for Bixby.
 */
export enum RuleLifecycle {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  EXECUTE = 'EXECUTE',
  CREATE_FOR_BIXBY = 'CREATE_FOR_BIXBY',
  UPDATE_FOR_BIXBY = 'UPDATE_FOR_BIXBY',
  DELETE_FOR_BIXBY = 'DELETE_FOR_BIXBY',
}

/** Create rule lifecycle. */
export interface RuleLifecycleCreate {
  /** The entities that trigger rule execution. */
  triggers?: Triggers;
}

/** Update rule lifecycle. */
export interface RuleLifecycleUpdate {
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  /** A Location Lifecycle Event. */
  locationLifecycleEvent?: LocationLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
  /** The entities that trigger rule execution. */
  triggers?: Triggers;
}

/** Delete rule lifecycle. */
export interface RuleLifecycleDelete {
  /** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
  deviceLifecycleEvent?: DeviceLifecycleEvent;
  /** A Location Lifecycle Event. */
  locationLifecycleEvent?: LocationLifecycleEvent;
  /** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
  sceneLifecycleEvent?: SceneLifecycleEvent;
}

/** Create rule lifecycle for bixby. */
export type RuleLifecycleCreateForBixby = object;

/** Update rule lifecycle for bixby. */
export type RuleLifecycleUpdateForBixby = object;

/** Delete rule lifecycle for bixby. */
export type RuleLifecycleDeleteForBixby = object;

/** Execute rule lifecycle. */
export type RuleLifecycleExecute = object;

/** The entities that trigger rule execution. */
export interface Triggers {
  /** The devices that trigger rule execution. */
  devices?: Devices;
}

/** The devices that trigger rule execution. */
export type Devices = DeviceTrigger[];

/** One of the devices that trigger a rule execution. */
export interface DeviceTrigger {
  /**
   * Device ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /** Device component */
  component?: string;
  /** Device capability */
  capability?: string;
  /** Device attribute */
  attribute?: string;
}

/** A Location Lifecycle Event. */
export interface LocationLifecycleEvent {
  /** The id of the event. */
  eventId?: string;
  /**
   * The ID of the location in which the event was triggered.
   * @example "499e28ba-b33b-49c9-a5a1-cce40e41f8a6"
   */
  locationId?: string;
  lifecycle?: LocationLifecycle;
  modeCreate?: LocationLifecycleModeCreate;
  modeUpdate?: LocationLifecycleModeUpdate;
  modeDelete?: LocationLifecycleModeDelete;
  create?: LocationLifecycleCreate;
  update?: LocationLifecycleUpdate;
  delete?: LocationLifecycleDelete;
}

export enum LocationLifecycle {
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  UPDATE = 'UPDATE',
  MODE_CREATE = 'MODE_CREATE',
  MODE_UPDATE = 'MODE_UPDATE',
  MODE_DELETE = 'MODE_DELETE',
}

export interface LocationLifecycleModeCreate {
  modeId?: string;
}

export interface LocationLifecycleModeUpdate {
  modeId?: string;
}

export interface LocationLifecycleModeDelete {
  modeId?: string;
}

export type LocationLifecycleCreate = object;

export type LocationLifecycleUpdate = object;

export type LocationLifecycleDelete = object;

/** One of `create`, `update`, `delete`, `moveTo`, `moveFrom` must be provided and the value should not be null. */
export interface DeviceLifecycleEvent {
  deviceId: string;
  /**
   * ID for what owns the device lifecycle event. Works in tandem with `ownerType` as a composite identifier.
   * A DeviceLifecycleEvent will not have a `locationId` in the event wrapper object if a value is specified here.
   */
  ownerId?: string;
  /**
   * Type of owner for the Event. `ownerType` and `ownerId` work in tandem as a composite identifier. Possible values include:
   * * `LOCATION` A location-level event, where the location can be found in `ownerId`.
   * * `USER` A user-level event, where the user can be found in `ownerId`.
   */
  ownerType?: EventOwnerType;
  principal?: string;
  name?: string;
  /**
   * When user-level devices have been shared to multiple locations, this will be `true` when the event is on the
   * user's "primary" shard.
   * @default false
   */
  primaryEvent?: boolean;
  /**
   * Identifier to ensure uniquness of events across multiple shards, when used by global services that consume
   * those events. Required if `sharedLocations` or `globalSharedLocations` are provided.
   * @format uuid
   */
  sourceEventId?: string;
  /**
   * Locations that the event was created in for the current shard.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard.
   */
  sharedLocations?: EventSharedLocation[];
  /**
   * Locations that the event was created in for all other shards.
   * The union of `sharedLocations` and `globalSharedLocationds` will contain all relevant shared locations for
   * the event, regardless of the current shard.
   */
  globalSharedLocations?: EventSharedLocation[];
  /** Create device lifecycle. */
  create?: DeviceLifecycleCreate;
  /** Delete device lifecycle. */
  delete?: DeviceLifecycleDelete;
  /** Update device lifecycle. */
  update?: DeviceLifecycleUpdate;
  /** Move device lifecycle. */
  moveFrom?: DeviceLifecycleMove;
  /** Move device lifecycle. */
  moveTo?: DeviceLifecycleMove;
  /** Room move device lifecycle. */
  roomMove?: DeviceLifecycleRoomMove;
}

/** Create device lifecycle. */
export type DeviceLifecycleCreate = object;

/** Delete device lifecycle. */
export type DeviceLifecycleDelete = object;

/** Update device lifecycle. */
export type DeviceLifecycleUpdate = object;

/** Move device lifecycle. */
export interface DeviceLifecycleMove {
  locationId: string;
}

/** Room move device lifecycle. */
export interface DeviceLifecycleRoomMove {
  roomIdFrom?: string;
  roomIdTo?: string;
}

export interface DeviceLogEvent {
  deviceId?: string;
  /** Base 64 encoded message. */
  message?: string;
}

export interface InstalledAppLifecycleEvent {
  installedAppId?: string;
  create?: object;
  delete?: object;
  update?: object;
}

/** A capability lifecycle event. At least one of `create`, `update`, `delete`, `localizationChange` and `statusChange` must be set and value should not be null. */
export interface CapabilityLifecycleEvent {
  /** The unique identifier of the capability. In the format of `<<namespace>>.<<capabilityId>>`. */
  capabilityId?: string;
  /** The version of the capability */
  version?: number;
  create?: object;
  delete?: object;
  update?: object;
  /** A set of capability localization changes. */
  localizationChange?: CapabilityLocalizationChange;
  /** The capability status change information. */
  statusChange?: CapabilityStatusChange;
}

/** A set of capability localization changes. */
export interface CapabilityLocalizationChange {
  localizations?: CapabilityLocalizationItem[];
}

/** A capability localization change Item. */
export interface CapabilityLocalizationItem {
  locale?: string;
  manufacturerName?: string;
  presentationId?: string;
}

/** The capability status change information. */
export interface CapabilityStatusChange {
  /** The status of the capability. */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
}

/** A scene lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. */
export interface SceneLifecycleEvent {
  /** The id of the scene. */
  sceneId: string;
  /** Create scene lifecycle. */
  create?: SceneLifecycleCreate;
  /** Update scene lifecycle. */
  update?: SceneLifecycleUpdate;
  /** Delete scene lifecycle. */
  delete?: SceneLifecycleDelete;
}

/** Create scene lifecycle. */
export type SceneLifecycleCreate = object;

/** Update scene lifecycle. */
export type SceneLifecycleUpdate = object;

/** Delete scene lifecycle. */
export type SceneLifecycleDelete = object;

/** An event used to trigger a client action on a SmartApp dashboard card. */
export interface SmartAppDashboardCardEvent {
  /**
   * The ID of the installed application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  installedAppId?: string;
  /**
   * A developer defined dashboard card ID.
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "my_dashboard_card"
   */
  cardId?: string;
  /** An update action will trigger client to fully refresh card state. */
  update?: object;
  /** A delete action will trigger client to delete a card. */
  delete?: object;
}

/** An event which can be used to broadcast custom triggers from SmartApps. */
export interface SmartAppEvent {
  /**
   * An arbitrary name for the custom SmartApp event.  Typically useful as a hook for in-app routing.
   * @format ^[a-zA-Z_]{1,36}$
   */
  name?: string;
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 256 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
  /**
   * The ID of the installed application
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  installedAppId?: string;
}

/** An event that represents a change in the arm state of a security system. */
export interface SecurityArmStateEvent {
  /** The arm state of a security system. */
  armState: 'ARMED_AWAY' | 'ARMED_STAY' | 'DISARMED';
  /**
   * A set of key / value pairs useful for passing any optional arguments.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum string value length: 128 Unicode characters in UTF-8
   * * Allowed values for *keys* are JSON strings
   * * Allowed values for *values* are null, JSON strings, numbers, booleans
   * @example {"intArgument":17,"doubleArgument":17.9,"stringArgument":"foo","booleanArgument":true}
   */
  optionalArguments?: Record<string, any>;
}

/** An event that represents a failure to change the arm state of a security system. */
export interface SecurityArmFailureEvent {
  /** The reason that the security system failed to change arm state. */
  failureReason?: 'SERVER_ERROR' | 'TIMEOUT';
}

/** An event that represents a SOS event has occured for a security system. */
export type SecuritySosEvent = object;

/** An event that represents a quarantine state change for an entity. */
export interface QuarantineEvent {
  entityId?: string;
  /** The type of entity that the quarantine applies to. */
  entityType?: QuarantineEventEntityType;
  /** The state of the quarantine. */
  state?: QuarantineEventState;
}

/** The type of entity that the quarantine applies to. */
export enum QuarantineEventEntityType {
  APP = 'APP',
  INSTALLED_APP = 'INSTALLED_APP',
}

/** The state of the quarantine. */
export enum QuarantineEventState {
  LIFTED = 'LIFTED',
  ENFORCED = 'ENFORCED',
}

/** Weather data */
export interface WeatherData {
  /** Cloud ceiling in meters */
  cloudCeilingInM?: number;
  /** The phrase of the cloud cover */
  cloudCoverPhrase?: string;
  /** Relative Humidity Percentage */
  relativeHumidityInPercent?: number;
  sunriseDate?: string;
  sunsetDate?: string;
  /**
   * Temperature in degrees celsius
   * @format double
   */
  temperatureInC?: number;
  /**
   * Feels-like temperature in degrees celsius
   * @format double
   */
  temperatureFeelsLikeInC?: number;
  uvDescription?: string;
  uvIndex?: number;
  /** @format double */
  visibilityInKm?: number;
  windDirectionInDegrees?: number;
  windDirectionCardinal?: string;
  windGustInKmph?: number;
  windSpeedInKmph?: number;
  conditionPhraseLong?: string;
  conditionState?: 'UNKNOWN' | 'CLEAR' | 'SNOW' | 'RAIN' | 'CLOUDY' | 'STORM' | 'DUSTY' | 'FOGGY';
}

/** Air quality data */
export interface AirQualityData {
  airQualityIndex?: number;
  /** @format double */
  o3AmountInUgm3?: number;
  o3Index?: number;
  /** @format double */
  no2AmountInUgm3?: number;
  no2Index?: number;
  /** @format double */
  so2AmountInUgm3?: number;
  so2Index?: number;
  /** @format double */
  coAmountInUgm3?: number;
  coIndex?: number;
  /** @format double */
  pm10AmountInUgm3?: number;
  pm10Index?: number;
  /** @format double */
  pm25AmountInUgm3?: number;
  pm25Index?: number;
}

/** Severe Weather Alert data */
export interface SevereAlertData {
  headlineText?: string;
  detailUrl?: string;
  startTime?: string;
  endTime?: string;
  severity?: 'UNKNOWN_SEVERITY' | 'EXTREME' | 'SEVERE' | 'MODERATE';
  state?: 'NONE' | 'NEW' | 'UPDATE' | 'CANCEL';
}

/** An event representing the current weather forecast. */
export interface WeatherEvent {
  /** Weather data */
  weatherData?: WeatherData;
  /** Air quality data */
  airQualityData?: AirQualityData;
  /** Severe Weather Alert data */
  severeAlertData?: SevereAlertData;
  /** The id of the GeoPlace. */
  geoPlaceId?: string;
  /** The postal code of the weather event. */
  postalCode?: string;
}

/** A GeoPlace lifecycle event. At least one of `create`, `update`, and `delete` must be set and value should not be null. There must also be either a user or service value set and not null. A GeoPlaceLifecycleEvent should typically not have a locationId in the event wrapper object. */
export interface GeoPlaceLifecycleEvent {
  /** The id of the GeoPlace. */
  geoPlaceId: string;
  /** The id of the GeoPlace's owner (e.g. Location ID). */
  ownerId: string;
  /** Type of owner that this GeoPlace has. 0 represents a GeoPlace owned by a location. */
  ownerType: GeoPlaceOwnerType;
  user?: User;
  /** A service in the system. */
  service?: Service;
  /** Create GeoPlace lifecycle. */
  create?: GeoPlaceLifecycleCreate;
  /** Update GeoPlace lifecycle. */
  update?: GeoPlaceLifecycleUpdate;
  /** Delete GeoPlace lifecycle. */
  delete?: GeoPlaceLifecycleDelete;
}

/** Create GeoPlace lifecycle. */
export type GeoPlaceLifecycleCreate = object;

/** Update GeoPlace lifecycle. */
export interface GeoPlaceLifecycleUpdate {
  /** The changes that occurred on this GeoPlace to trigger this event. */
  changes?: string[];
}

/** Delete GeoPlace lifecycle. */
export type GeoPlaceLifecycleDelete = object;

/** Type of owner that this GeoPlace has. 0 represents a GeoPlace owned by a location. */
export enum GeoPlaceOwnerType {
  Value0 = 0,
}

export interface User {
  id?: string;
  name?: string;
  linkedAt?: string;
}

/** A service in the system. */
export interface Service {
  clientId?: string;
}

/** The type of execution allows the app to exhibit different behavior based on the type. */
export enum ExecutionType {
  INSTALL = 'INSTALL',
  UPDATE = 'UPDATE',
  UNINSTALL = 'UNINSTALL',
  EVENT = 'EVENT',
  PING = 'PING',
  CONFIGURATION = 'CONFIGURATION',
  OAUTH_CALLBACK = 'OAUTH_CALLBACK',
  EXECUTE_BEHAVIOR = 'EXECUTE_BEHAVIOR',
  EXECUTE = 'EXECUTE',
  DASHBOARD = 'DASHBOARD',
  CONFIRMATION = 'CONFIRMATION',
}

/** Dictates how Execution should process the request. */
export enum InvocationType {
  SYNCHRONOUS = 'SYNCHRONOUS',
  ASYNCHRONOUS = 'ASYNCHRONOUS',
}

export interface AppExecutionRequest {
  /** The type of execution allows the app to exhibit different behavior based on the type. */
  executionType: ExecutionType;
  /** Dictates how Execution should process the request. */
  invocationType?: InvocationType;
  /**
   * An IETF BCP 47 language tag representing the chosen locale for this account.  If not provided will attempt to
   * resolve locale from location, and lastly default to english.
   * @example "en"
   */
  locale?: string;
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
  eventData?: EventData;
  installData?: InstallData;
  updateData?: UpdateData;
  uninstallData?: UninstallData;
  pingData?: PingData;
  confirmData?: ConfirmData;
  configData?: ConfigData;
  executeBehaviorData?: ExecuteBehaviorData;
  /** Provides intergration with the result of a third party oauth attempt.  This will only be available for executions of type "OAUTH_CALLBACK". */
  oAuthCallbackData?: OAuthCallbackData;
  /**
   * Provides the ability to execute the SmartApp with custom parameters, and receive a custom response.  This lifecycle allows
   * a developer to expose a fully custom API to a client.  This will only be available for executions of type "EXECUTE".
   */
  executeData?: ExecuteData;
  /**
   * Provides the ability to execute the SmartApp to render cards on the user's dashboard. This will only be available
   * for executions of type "DASHBOARD".
   */
  dashboardData?: DashboardData;
}

/**
 * Known details about the client application from which the request was initiated.  This information is provided
 * on best effort basis.  All properties maybe null or empty.
 */
export interface ClientDetails {
  /**
   * The operating system of the client application initiating the request.
   * @maxLength 16
   */
  os?: string;
  /**
   * The version of the client application initiating the request.
   * @maxLength 16
   */
  version?: string;
  /**
   * Language header representing the client's preferred language. The format of the `Accept-Language` header follows what is defined in [RFC 7231, section 5.3.5](https://tools.ietf.org/html/rfc7231#section-5.3.5)
   * @maxLength 1024
   */
  language?: string;
  /** The display mode of the operating system of the client. */
  displayMode?: 'DARK' | 'LIGHT';
  /** A time zone [UTC offset](https://en.wikipedia.org/wiki/ISO_8601#Time_offsets_from_UTC). Note that a leading zero is required. (e.g. "UTC-06:00", "UTC+09:00" or "UTC-00:00") */
  timeZoneOffset?: string;
  /** Templates that could be renderable in the client */
  supportedTemplates?: ('BASIC_V1' | 'BASIC_V2' | 'BASIC_V3' | 'BASIC_V4' | 'BASIC_V5' | 'BASIC_V6' | 'BASIC_V7')[];
  /**
   * ID for acting user in Samsung Account. Will be null for smartthings only accounts.
   * @example "pcg38apioc"
   */
  samsungAccountId?: string;
  /**
   * ID for acting user's mobile device.
   * @example "d4e53f5c-7eb1-4f7e-a9ff-b908b2a36bf0"
   */
  mobileDeviceId?: string;
}

export interface EventData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  event: Event;
}

export interface InstallData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** An OAuth token to use when calling into SmartThings API's. */
  authToken: string;
  /**
   * A refresh token which maybe used to obtain authorization to SmartThings API after expiration of the authToken.
   * An integration will need to use this refreshToken to support calling the SmartThings API outside the context
   * of an event.
   */
  refreshToken: string;
}

export interface UpdateData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** An OAuth token to use when calling into SmartThings API's. */
  authToken: string;
  /**
   * A refresh token which maybe used to obtain authorization to SmartThings API after expiration of the authToken.
   * An integration will need to use this refreshToken to support calling the SmartThings API outside the context
   * of an event.
   */
  refreshToken: string;
}

export interface UninstallData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  event?: Event;
}

/** @example {"appType":"WEBHOOK_SMART_APP","targets":["https://smartthings.com/webhook"]} */
export interface PingData {
  /** Denotes the type of app. */
  appType: AppType;
  /**
   * A list of targets which should be executed to test connectivity.  For a LAMBDA_SMART_APP, targets would
   * be a list of AWS Lambda ARNs.  For a WEBHOOK_SMART_APP, targets would contain a single URL.
   */
  targets?: string[];
}

/** @example {"appType":"WEBHOOK_SMART_APP","targets":["https://smartthings.com/webhook"],"appId":"40110c5e-e064-4549-a366-89dab9d55f0a","principal":"user_uuid:40110c5e-e064-4549-a366-89dab9d55f0a"} */
export interface ConfirmData {
  /** Denotes the type of app. */
  appType: AppType;
  /**
   * A list of targets which should be executed to test connectivity. For WEBHOOK_SMART_APP and API_ONLY, targets
   * will contain a single URL.
   */
  targets?: string[];
  /**
   * The unique identifier of the App.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  appId?: string;
  /** The principal that created the app. */
  principal?: string;
}

/** Denotes the type of app. */
export enum AppType {
  LAMBDA_SMART_APP = 'LAMBDA_SMART_APP',
  WEBHOOK_SMART_APP = 'WEBHOOK_SMART_APP',
  BEHAVIOR = 'BEHAVIOR',
  API_ONLY = 'API_ONLY',
}

export interface ConfigData {
  /**
   * The unique identifier of the App.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "64d1d1ab-afb9-4a75-9cd8-f1ced9430518"
   */
  appId: string;
  /**
   * The current installedAppId if available.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /** Denotes the current installation phase. */
  phase: 'INITIALIZE' | 'PAGE';
  /**
   * The specific page being requested if available.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   * @example "second-page"
   */
  pageId?: string;
  /**
   * The previous page the user completed if available.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   * @example "first-page"
   */
  previousPageId?: string;
}

/** Provides intergration with the result of a third party oauth attempt.  This will only be available for executions of type "OAUTH_CALLBACK". */
export interface OAuthCallbackData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
  /**
   * A relative URL containing all of the query string parameters as returned by the third party oauth system. An endpoint app can
   * parse the `urlPath` property to extract any senstive auth codes/tokens which can then be used to access the third party system.
   */
  urlPath: string;
}

/**
 * Provides the ability to execute the SmartApp with custom parameters, and receive a custom response.  This lifecycle allows
 * a developer to expose a fully custom API to a client.  This will only be available for executions of type "EXECUTE".
 */
export interface ExecuteData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId?: string;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

export interface ExecuteBehaviorData {
  /**
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "40110c5e-e064-4549-a366-89dab9d55f0a"
   */
  installedAppId: string;
}

/**
 * Provides the ability to execute the SmartApp to render cards on the user's dashboard. This will only be available
 * for executions of type "DASHBOARD".
 */
export interface DashboardData {
  /** @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$ */
  installedAppId: string;
}

export interface AppExecutionResponse {
  /**
   * A unique identifier for this execution.
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  executionId?: string;
  /**
   * A base64 encoded JSON representation of the value returned from the execution.
   * @format byte
   */
  payload?: string;
}

export interface InstalledAppExecuteRequest {
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

export interface InstalledAppDashboardRequest {
  /**
   * Known details about the client application from which the request was initiated.  This information is provided
   * on best effort basis.  All properties maybe null or empty.
   */
  client?: ClientDetails;
}

/** Expected response for a Dashboard lifecycle execution. */
export interface DashboardResponseData {
  /**
   * A unique identifier for a card of service
   * @format some service name
   */
  serviceName?: string;
  /**
   * list of card object
   * @maxItems 5
   * @minItems 1
   */
  cards?: DashboardCard[];
}

/** payload of dashboard card */
export interface DashboardCard {
  /**
   * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
   * Each card template may have a different set requirement for data needs.
   *
   * * BASIC_V1 - The basic / default template.
   * * BASIC_V2 - default template + HTML and body items support.
   * * BASIC_V3 - V2 template + bar graph support.
   * * BASIC_V4 - Template to support Pet care and Kitchen services
   * * BASIC_V5 - Template to support UX2.5 changes
   * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
   * * BASIC_V7 - Template to support body image + bg Image + icon.
   * * FREE_FORM - A free form template with minimal constraints.
   */
  templateId: DashboardCardTemplate;
  /**
   * A unique identifier for a card of service
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "some-card-id"
   */
  cardId: string;
  /** card size */
  size?: number;
  /** Data requirements for a Basic V1 card template. */
  basicV1?: BasicCard;
  /** Data requirements for a Basic V2 card template. */
  basicV2?: BasicV2Card;
  /** Data requirements for a Basic V3 card template. */
  basicV3?: BasicV3Card;
  /** Data requirements for a Basic V4 card template. */
  basicV4?: BasicV4Card;
  /** Data requirements for a Basic V5 card template. */
  basicV5?: BasicV5Card;
  /** Data requirements for a Basic V6 card template. */
  basicV6?: BasicV6Card;
  /** Data requirements to support BasicV7 */
  basicV7?: BasicV7Card;
  freeForm?: FreeFormCard;
}

/**
 * A directive to the SmartThings client to use a specific template for rendering the dashboard card.
 * Each card template may have a different set requirement for data needs.
 *
 * * BASIC_V1 - The basic / default template.
 * * BASIC_V2 - default template + HTML and body items support.
 * * BASIC_V3 - V2 template + bar graph support.
 * * BASIC_V4 - Template to support Pet care and Kitchen services
 * * BASIC_V5 - Template to support UX2.5 changes
 * * BASIC_V6 - Template to remove dependency on webViews, add talkback fields.
 * * BASIC_V7 - Template to support body image + bg Image + icon.
 * * FREE_FORM - A free form template with minimal constraints.
 */
export enum DashboardCardTemplate {
  BASICV1 = 'BASIC_V1',
  BASICV2 = 'BASIC_V2',
  BASICV3 = 'BASIC_V3',
  BASICV4 = 'BASIC_V4',
  BASICV5 = 'BASIC_V5',
  BASICV6 = 'BASIC_V6',
  BASICV7 = 'BASIC_V7',
  FREE_FORM = 'FREE_FORM',
}

/** Data requirements for a Basic V1 card template. */
export interface BasicCard {
  /**
   * name of the card
   * @maxLength 100
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * A title icon url for card. Angit  HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image"
   */
  iconUrl?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V1 template. */
  body?: BasicBody;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicButton[];
}

/** Data requirements for a Basic V2 card template. */
export interface BasicV2Card {
  /**
   * An title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** Body definition for a Basic V2 template. */
  body?: BasicV2Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

export interface FreeFormCard {
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 5 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 1000 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

/** A background image. */
export interface BasicBackgroundImage {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-1]{1}$
   */
  alpha?: number;
}

/** Body definition for a Basic V1 template. */
export interface BasicBody {
  image?: BasicImage;
  /** A text object. */
  text?: BasicText;
}

/** A button definition for a Basic V1 template. */
export interface BasicButton {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic template. */
  textButton?: BasicTextButton;
  /** A text button definition for a basic template. */
  iconButton?: BasicIconButton;
}

export interface BasicImage {
  /**
   * An icon name.
   * @maxLength 100
   */
  name?: string;
  /** Position of where the image should be rendered within card. */
  position?: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
}

/** A text object. */
export interface BasicText {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
}

/**
 * The type of buttons to render.
 *
 * * TEXT - A colored button with a text overrlay.
 * * ICON - A button with an image backgroup and text overrlay.
 */
export enum BasicButtonType {
  TEXT = 'TEXT',
  ICON = 'ICON',
}

/** Position of where the image should be rendered within card. */
export enum BasicImagePosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A text button definition for a basic template. */
export interface BasicTextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic template. */
export interface BasicIconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** Position of where the button should be rendered within card. */
  position?: BasicButtonPosition;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /**
   * A default icon image url. HTTPS url required.
   * @format uri
   * @maxLength 250
   */
  iconUrl?: string;
}

/** Position of where the button should be rendered within card. */
export enum BasicButtonPosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

/** A definition of the action to be taken when button is activated. */
export interface ServiceCardAction {
  type?: ActionType;
  /** Launch a backing UI plugin in SmartThings Client. */
  launchPlugin?: LaunchPluginAction;
  /** Call the EXECUTE lifecycle on the backing SmartApp. */
  execute?: ExecuteAction;
  /** Launch the SmartApp's configuration page in Strongman */
  launchConfiguration?: LaunchConfiguration;
  /** Launch a service plugin in background. */
  launchPluginService?: LaunchPluginService;
}

export enum ActionType {
  Command = 'command',
  Every = 'every',
  If = 'if',
  Location = 'location',
  Scene = 'scene',
  Sleep = 'sleep',
  Notification = 'notification',
  Toggle = 'toggle',
  Group = 'group',
}

/** Launch a backing UI plugin in SmartThings Client. */
export interface LaunchPluginAction {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId?: string;
  /** parameter to be passed to plugin */
  uri?: string;
}

/** Call the EXECUTE lifecycle on the backing SmartApp. */
export interface ExecuteAction {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch the SmartApp's configuration page in Strongman */
export interface LaunchConfiguration {
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Launch a service plugin in background. */
export interface LaunchPluginService {
  /**
   * The ID of the plugin to launch.
   * @format ^[a-zA-Z._]{1,99}$
   */
  pluginId: string;
  /**
   * service component to be launched.
   * @format ^[a-zA-Z._]{1,99}$
   */
  componentId: string;
  /** parameter to be passed to plugin */
  uri?: string;
  /** An arbitrary map of input parameters which the SmartApp can use to build a custom response. */
  parameters?: Record<string, string>;
}

/** Body definition for a Basic V2 template. */
export interface BasicV2Body {
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
}

export interface BasicV2Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/**
 * Body item array definition for a Basic V2 template
 * @maxItems 4
 */
export type BasicV2Items = BasicV2Item[];

/** Item in Basic V2 items */
export interface BasicV2Item {
  /** Body item image height */
  height?: number;
  /** Body item object definition for a Basic V2 template */
  item?: BasicV2ImageItem;
}

/** Body item object definition for a Basic V2 template */
export interface BasicV2ImageItem {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url?: string;
  /**
   * The text that would be shown under image
   * @maxLength 250
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text object. */
export interface BasicV2Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A button definition for a Basic V2 template. */
export interface BasicV2Button {
  /**
   * The type of buttons to render.
   *
   * * TEXT - A colored button with a text overrlay.
   * * ICON - A button with an image backgroup and text overrlay.
   */
  type?: BasicButtonType;
  /** A text button definition for a basic V2 template. */
  textButton?: BasicV2TextButton;
  /** A text button definition for a basic V2 template. */
  iconButton?: BasicV2IconButton;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2TextButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** A text button definition for a basic V2 template. */
export interface BasicV2IconButton {
  /**
   * The name of the button
   * @maxLength 100
   */
  name?: string;
  /**
   * An icon image url on button-released. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  releasedIconUrl?: string;
  /**
   * An icon image url on button-pressed. HTTPS url required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  pressedIconUrl?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V3 card template. */
export interface BasicV3Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V3 template. */
  body?: BasicV3Body;
  /**
   * A list of buttons to render and buttons must be of the same type.
   * @maxItems 3
   */
  buttons?: BasicV2Button[];
}

/** Body definition for a Basic V3 template. */
export interface BasicV3Body {
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  image?: BasicV2Image;
  /** Body item array definition for a Basic V2 template */
  items?: BasicV2Items;
  /** A text object. */
  text?: BasicV2Text;
}

/**
 * A horizontal comparision bar graph to compare two values.
 * @maxItems 2
 * @minItems 2
 */
export type ServiceCardBarGraph = ServiceCardBar[];

export interface ServiceCardBar {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value: number;
  /** color with alpha */
  color: BasicCardColor;
  /** units of the field. */
  units: string;
}

/** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
export interface ServiceCardBarGraphV2 {
  /** VALUE_UNIT_GRAPH requires value and unit fields, PERCENT_COST_GRAPH and SAME_BASE_GRAPH requires percent and cost fields. */
  type: 'VALUE_UNIT_GRAPH' | 'PERCENT_COST_GRAPH' | 'SAME_BASE_GRAPH';
  /** @minItems 1 */
  list: ServiceCardBarV2[];
}

export interface ServiceCardBarV2 {
  /**
   * Bar header.
   * @maxLength 100
   */
  header: string;
  /** Value of the field. */
  value?: number;
  /** percent of the bar to occupy. */
  percent?: number;
  /** color with alpha */
  color: BasicCardColor;
  /** color with alpha */
  maxBarColor?: BasicCardColor;
  /** units of the field. */
  units?: string;
  /** Bar information. */
  cost?: string;
}

/** Data requirements for a Basic V4 card template. */
export interface BasicV4Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V4 template. */
  body?: BasicV4Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Header icon for Basic V4 template */
export interface BasicV4HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Body definition for a Basic V4 template. */
export interface BasicV4Body {
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV2Text;
  /** A text object. */
  text?: BasicV2Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Background spacing to show image in the Card's bgImage */
export interface BasicV4BackgroundSpacing {
  /** Spacing position */
  position: 'LEFT' | 'RIGHT';
  /** width of spacing in px */
  width: number;
}

/** item in BasicV4, BasicV5, BasicV6 items list. */
export interface BasicV4Item {
  /**
   * Text 1 in the body/header item
   * @maxLength 250
   */
  name?: string;
  /**
   * Text 2 in the body item
   * @maxLength 250
   */
  description?: string;
  /** icon of the body/header item */
  icon?: BasicV4Icon;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** icon of the body/header item */
export interface BasicV4Icon {
  /**
   * icon url for the item. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** Item alignment */
  align: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Item position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Item icon height */
  height?: number;
  /** A background image. */
  bgImage?: BasicBackgroundImage;
}

/** Switch button in BasicV4 body */
export interface BasicV4SwitchButton {
  /** Switch enabled status */
  status: boolean;
  /** color with alpha */
  color: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action: ServiceCardAction;
}

/** BasicV4 icon button */
export interface BasicV4IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** BasicV4 text button */
export interface BasicV4TextButton {
  /**
   * text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V5 card template. */
export interface BasicV5Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV4HeaderIcon[];
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V5 template. */
  body?: BasicV5Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV4IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV4TextButton[];
  };
}

/** Body definition for a Basic V5 template. */
export interface BasicV5Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  image?: BasicV2Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** WebView for service card body */
  webView?: ServiceCardWebView;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** A text object. */
export interface BasicV5Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content?: string;
  /** text vertical alignment. Default CENTER */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** text horizontal alignment */
  position?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements for a Basic V6 card template. */
export interface BasicV6Card {
  /**
   * A title icon url for card. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  iconUrl?: string;
  /**
   * name of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  name?: string;
  /**
   * sublined text of the card
   * @maxLength 250
   * @example "Smart Home Monitor"
   */
  description?: string;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  headerIcons?: BasicV6HeaderIcon[];
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  headerItems?: ServiceCardItemsV2;
  /** header alignment */
  headerAlignment?: 'LEFT' | 'CENTER' | 'RIGHT';
  /** A background image. */
  bgImage?: BasicBackgroundImage;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Body definition for a Basic V6 template. */
  body?: BasicV6Body;
  /** buttons to render. */
  buttons?: {
    /**
     * A list of icon buttons.
     * @maxItems 5
     */
    iconButtons?: BasicV6IconButton[];
    /**
     * A list of text buttons.
     * @maxItems 3
     */
    textButtons?: BasicV6TextButton[];
  };
}

/** Body definition for a Basic V6 template. */
export interface BasicV6Body {
  /** Body item alignment */
  align?: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Background spacing to show image in the Card's bgImage */
  bgSpacing?: BasicV4BackgroundSpacing;
  /** A text object. */
  description?: BasicV5Text;
  /** A text object. */
  text?: BasicV5Text;
  /** Image definition for Basic V6. */
  image?: BasicV6Image;
  /** Switch button in BasicV4 body */
  switch?: BasicV4SwitchButton;
  /** A horizontal comparision bar graph to compare two values. */
  barGraph?: ServiceCardBarGraph;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraphV2?: ServiceCardBarGraphV2;
  /** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
  items?: ServiceCardItemsV2;
}

/** Header icon for Basic V6 template */
export interface BasicV6HeaderIcon {
  /**
   * header icon url. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for icon.
   * @maxLength 250
   * @example "Barcode Scanner"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 icon button */
export interface BasicV6IconButton {
  /**
   * icon url for button. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  url: string;
  /**
   * Talkback text for Button.
   * @maxLength 250
   * @example "off device"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Image definition for Basic V6. */
export interface BasicV6Image {
  /** Position of where the image should be rendered within card. */
  position: BasicImagePosition;
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /** describes how image should be scaled. */
  scaleType?: 'CENTER_CROP' | 'FIT_CENTER' | 'CENTER_INSIDE' | 'FIT_XY';
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Basic V6 text button */
export interface BasicV6TextButton {
  /**
   * 1st line of text in button
   * @maxLength 250
   * @example "Lock All"
   */
  name: string;
  /**
   * 2nd line of text in button
   * @maxLength 250
   * @example "Locks all devices"
   */
  description?: string;
  /** color with alpha */
  color?: BasicCardColor;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Data requirements to support BasicV7 */
export interface BasicV7Card {
  /** Common properties that shared by entire card in Basic V7. */
  card?: BasicV7CardProperties;
  /** Data requirement to support Basic V7 header types. */
  header?: BasicV7Header;
  /** Data requirement to support Basic V7 body types. */
  body: BasicV7Body;
}

/** Common properties that shared by entire card in Basic V7. */
export interface BasicV7CardProperties {
  /** Background for the entire card. */
  bgImage?: BasicV7Image;
  /** Default action of the card. */
  action: ServiceCardAction;
}

/** Data requirement to support Basic V7 header types. */
export interface BasicV7Header {
  /** Type of header as per GUI naming. */
  headerType: 'STYLE_1' | 'STYLE_2' | 'STYLE_3' | 'STYLE_4';
  /** A title icon url for card. */
  titleIcon?: BasicV7Image;
  /** Text to be shown on header */
  text: BasicV7Text;
  /**
   * A list of icons to be displayed in header.
   * @maxItems 2
   */
  iconsList?: BasicV7Image[];
  /** header items for small device icon and a single line of text. */
  headerItems?: BasicV7ItemGroup;
}

/** Data requirement to support Basic V7 body types. */
export interface BasicV7Body {
  /** Type of body as per GUI naming. */
  bodyType: 'TYPE_1' | 'TYPE_2' | 'TYPE_3' | 'TYPE_4' | 'TYPE_5' | 'TYPE_6';
  /** Data requirements for name for Basic V7. */
  nameGroup?: BasicV7NameGroup;
  /** Text for UI components of Basic V7. */
  name?: BasicV7Text;
  /** Text for UI components of Basic V7. */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  image?: BasicV7Image;
  /** A horizontal comparison bar graph to compare two or more values, or just shows one value in case of percentage graph. */
  barGraph?: ServiceCardBarGraphV2;
  /** Data requirements for header/body items for Basic V7. */
  items?: BasicV7ItemGroup;
  /** Text to be displayed on button. */
  buttonText?: BasicV7Text;
  /** Image definition for Basic V7. */
  bgImage?: BasicV7Image;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
}

/** Text for UI components of Basic V7. */
export interface BasicV7Text {
  /**
   * Text to display.
   * @maxLength 500
   */
  content: string;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Image definition for Basic V7. */
export interface BasicV7Image {
  /**
   * URL of image.  HTTPS url is required.
   * @format uri
   * @maxLength 250
   */
  url: string;
  /**
   * Talkback text for body image.
   * @maxLength 250
   * @example "Tutorial Image"
   */
  talkback?: string;
  /**
   * some color code
   * @format ^[a-fA-F0-9]{6}$
   */
  color?: string;
  /**
   * transparency of the color/image
   * @format ^[0-9]{1,2}$
   */
  alpha?: number;
  /** Position/Padding of any UI entity. */
  position?: BasicV7Position;
  /** Align/Padding of any UI entity. */
  align?: BasicV7Align;
  /** Defines scale type of the image. */
  scaleType?: BasicV7ImageScaleType;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
  /** Defines the dimension of the UI entity. */
  dimension?: BasicV7Dimension;
}

/** Defines scale type of the image. */
export enum BasicV7ImageScaleType {
  CENTER_CROP = 'CENTER_CROP',
  FIT_CENTER = 'FIT_CENTER',
  CENTER_INSIDE = 'CENTER_INSIDE',
  FIT_XY = 'FIT_XY',
}

/** Position/Padding of any UI entity. */
export interface BasicV7Position {
  /** General Position */
  position: 'LEFT' | 'CENTER' | 'RIGHT';
  /** Defines left Padding. */
  paddingLeft?: number;
  /** Defines right Padding. */
  paddingRight?: number;
}

/** Align/Padding of any UI entity. */
export interface BasicV7Align {
  /** General Position */
  position: 'TOP' | 'CENTER' | 'BOTTOM';
  /** Defines Top Padding. */
  paddingTop?: number;
  /** Defines Bottom Padding. */
  paddingBottom?: number;
}

/** Defines the dimension of the UI entity. */
export interface BasicV7Dimension {
  width: number;
  height: number;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7ItemGroup {
  /** Image definition for Basic V7. */
  dividerUrl?: BasicV7Image;
  /**
   * @maxItems 3
   * @minItems 1
   */
  items: BasicV7Item[];
}

/** Data requirements for name for Basic V7. */
export interface BasicV7NameGroup {
  /** Text for UI components of Basic V7. */
  mainName: BasicV7Text;
  /** Text for UI components of Basic V7. */
  subName?: BasicV7Text;
  /** Image definition for Basic V7. */
  dividerImage?: BasicV7Image;
}

/** Data requirements for header/body items for Basic V7. */
export interface BasicV7Item {
  /** Type of body as per GUI naming. */
  itemType: 'BODY_TYPE_1' | 'BODY_TYPE_2' | 'HEADER_STYLE_4';
  /** Text for line 1 in the item */
  name?: BasicV7Text;
  /** Text for line 2 in the item */
  description?: BasicV7Text;
  /** Image definition for Basic V7. */
  icon?: BasicV7Image;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** WebView for service card body */
export interface ServiceCardWebView {
  /**
   * HTML content for the web view
   * @maxLength 10000
   */
  content: string;
  /**
   * CSS styles for the web view
   * @maxLength 5000
   */
  styles?: string;
  /** A definition of the action to be taken when button is activated. */
  action?: ServiceCardAction;
}

/** Service card body/header items for BASIC_V4, BASIC_V5, BASIC_V6 */
export interface ServiceCardItemsV2 {
  /** divider width in dp */
  dividerWidth?: number;
  /**
   * URL of the divider for the items. A HTTPS URL is required.
   * @format uri
   * @maxLength 250
   * @example "https://smart-home-monitor.com/image.png"
   */
  dividerUrl?: string;
  /**
   * A list of items.
   * @maxItems 4
   */
  list: BasicV4Item[];
}

/**
 * color with alpha
 * @format ^[a-fA-F0-9]{8}$
 */
export type BasicCardColor = string;

/** The behavior */
export type Behavior = BehaviorRequest & {
  /**
   * Unique id for the behavior
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
};

/**
 * Input object to create a Behavior
 * @example {"parentId":"g2a6ce48-5geb-4287-bb34-8bc0xa241j59","parentType":"SCENE","actions":[{"action":"send","target":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d","cmd":"off","capability":"Switch","component":"main"}],"triggers":[{"type":"subscription","pattern":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d.contact.open"},{"type":"","pattern":"f1a6ce48-4ce8-4267-bf34-83c05f241e5d.contact.open"}],"guard":[{"LI":{"I64":0}},{"LI":{"I64":0}},{"CE":{"time":"isDay"}}],"default":[]}
 */
export interface BehaviorRequest {
  /** Unique name for the behavior */
  name?: string;
  /** ID of the parent. */
  parentId?: string;
  /** The source of the Behavior */
  parentType: ParentType;
  /** Execution strategy for the behavior */
  executionStrategy?: 'interrupt' | 'ignore';
  actions: Action[];
  triggers?: Trigger[];
  /** Guard condition that must be true before a behavior is executed. The array represents a RPN expression. */
  guard?: Element[];
  /** Follows IANA(Internet Assigned Numbers Authority) time zone database notion. If provided, this will dictate the timezone in which the schedule is created. If not provided, the location timezone will be used, or, if not available, UTC will be assumed. */
  timezone?: string;
  /** If this automation should executed once per a day or once per N hours. Only for "RULE" and can be null. */
  oncePer?: {
    /** Limit execution to once per interval, ex. once every 24 hours */
    interval?: {
      seconds?: number;
    };
    /** Limit execution to once per unit on the calendar, ex. once per day */
    calendar?: {
      value?: number;
      unit?: 'day' | 'hour' | 'min';
    };
  };
  /** Default set of actions executed in case of Guard evaluates to false. */
  default?: Action[];
  /** The status of the Behavior */
  status?: BehaviorEnabledEnum;
  /** Defines expiration, or scheduled deletion of Behaviors. */
  expiration?: Expiration;
}

/**
 * Defines a behavior set in the smartthings system.
 * @example {"id":"2baf54f0-7d3a-4ee1-a68a-d59a035e6060","behaviorIds":["5n6f54f0-7d3a-4ee1-a68a-d59a035e6061","b9mf54f0-7d3a-4ee1-a68a-d59a035e6062"]}
 */
export interface BehaviorSet {
  /**
   * Unique id for the behavior set
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** List of behaviors' IDs in this set */
  behaviorIds?: string[];
  /** List of behaviors in this set */
  behaviors?: Behavior[];
}

/**
 * Input object to create a BehaviorSet
 * @example {"behaviorIds":["5n6f54f0-7d3a-4ee1-a68a-d59a035e6061","b9mf54f0-7d3a-4ee1-a68a-d59a035e6062"]}
 */
export interface BehaviorSetRequest {
  /**
   * Parent ID for behaviors
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  parentId?: string;
  /** List of behaviors in this set */
  behaviorIds?: string[];
  /** List of BehaviorRequests to be included in this set */
  behaviorRequests?: BehaviorRequest[];
}

export type Action = ActionBase & {
  scene?: SceneAction;
  notification?: NotificationAction;
  toggle?: ToggleAction;
  /** Defines any combination of actions. */
  group?: GroupAction;
  limit?: LimitAction;
  type?: ActionType;
};

/** Action used to send a command to a device */
export interface SendAction {
  /** Device GUID */
  device?: string;
  /** The capability id, i.e. switch, switchLevel */
  capability?: string;
  /** Command name */
  command?: string;
  /**
   * Device component
   * @default "main"
   */
  component?: string;
  /** Arguments for device command */
  arguments?: object;
}

/** Action used to call various APIs */
export interface CallAction {
  scheduler?:
    | 'runIn'
    | 'runOnce'
    | 'schedule'
    | 'runEveryMinute'
    | 'runEvery5Minutes'
    | 'runEvery10Minutes'
    | 'runEvery15Minutes'
    | 'runEvery30Minutes'
    | 'runEvery1Hour'
    | 'runEvery3Hours'
    | 'unschedule'
    | 'canSchedule';
  time?: 'now' | 'isDay' | 'isNight' | 'todaysSunrise' | 'todaysSunset';
  notification?: 'sendPush' | 'sendPlugin' | 'sendImage';
  location?: 'setMode';
  security?: 'setArmStay' | 'setArmAway' | 'disarm';
  /** List of args */
  arguments?: Element[];
}

/** Action used to immediately trigger another behavior */
export type RaiseAction = object;

/** Action used to set state variable */
export interface SetAction {
  /** The name of the variable */
  name?: string;
  /** Value of the variable represented as string */
  value?: {
    /** Literal value, only one of the properties should be specified */
    LI?: Literal;
    /** Member expression */
    ME?: MemberExpression;
    /** Call expression */
    CE?: CallExpression;
  };
}

export type SleepAction = SleepActionBase & {
  strategy?: Strategy;
};

/** Action used to cycle through a list of actions */
export interface CycleAction {
  /** Target device to run cycle actions on */
  device?: string;
  /** List of Send Actions */
  action?: SendAction[];
}

/** Action used to send a command to a device group */
export interface SendDeviceGroupAction {
  /** Device Group GUID */
  deviceGroup?: string;
  /** The capability id, i.e. switch, switchLevel */
  capability?: string;
  /** Command name */
  command?: string;
  /** Arguments for device command */
  arguments?: object;
}

/** Action used to send an SMS to a list of phone numbers */
export interface SmsAction {
  recipients?: string[];
  /** SMS content */
  message: string;
  /** The type of message group entity. */
  entityType?: MessageGroupEntityType;
  /**
   * SMS Message Group Entity ID (usually the ISA or USER ID)
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  entityId?: string;
  /**
   * SMS Message Group Set ID - usually the config ID of an ISA
   * @format ^[-._a-zA-Z0-9]{1,36}$
   */
  messageGroupSet?: string;
  /**
   * SMS Message Group ID - unique identifier for the group
   * @format ^[a-zA-Z0-9._]{1,36}$
   */
  messageGroupKey?: string;
}

/**
 * A Trigger represents a
 * @example {"type":"subscription","pattern":"31192dc9-eb45-4d90-b606-21e9b66d8c2b.main.switch.switch.on"}
 */
export interface Trigger {
  /**
   * Unique id for the trigger
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** Trigger type */
  type: 'subscription' | 'cron' | 'sunevent' | 'init' | 'update';
  /** The pattern of the trigger */
  pattern: string;
  /** Modify trigger criteria */
  modifiers?: {
    /** Lead time between two events */
    leadTime?: LeadTimeModifier;
    /** Delay execution after triggered */
    delay?: DelayModifier;
    filters?: TriggerFilter[];
  };
  /** Trigger subscription values */
  subscription?: TriggerSubscription;
}

/**
 * Lead time between two events
 * @example {"seconds":300,"begin":{"STR":"not_present"},"end":{"STR":"present"}}
 */
export interface LeadTimeModifier {
  /** Number of seconds between events */
  seconds?: number;
  /** Literal value, only one of the properties should be specified */
  begin?: Literal;
  /** Literal value, only one of the properties should be specified */
  end?: Literal;
}

/** Delay execution after triggered */
export interface DelayModifier {
  /** Number of seconds to delay */
  seconds?: number;
}

/** A trigger filter */
export interface TriggerFilter {
  /**
   * Unique id for the base action
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  type: string;
  expression: Element[];
}

/** A filter that expects the expression to equal the value */
export type EqualsTriggerFilter = TriggerFilter & {
  /** Literal value, only one of the properties should be specified */
  value?: Literal;
};

/** A filter that expects the expression to change to value */
export type ChangesToTriggerFilter = TriggerFilter & {
  /** Literal value, only one of the properties should be specified */
  value?: Literal;
};

/** A filter that expects the expression to increase since its last evaluation */
export type IncreasesTriggerFilter = TriggerFilter;

/** A filter that expects the expression to decrease since its last evaluation */
export type DecreasesTriggerFilter = TriggerFilter;

/** Trigger subscription values */
export interface TriggerSubscription {
  /** Trigger subscription type */
  type?: 'DEVICE' | 'MODE' | 'SECURITY_ARM_STATE' | 'WEATHER';
  /**
   * Location id for MODE & SECURITY_ARM_STATE subscriptions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * Device id for the DEVICE subscriptions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /** Device component for the DEVICE subscriptions */
  componentId?: string;
  /** Component capability for DEVICE subscriptions */
  capabilityId?: string;
  /** Capability attribute for DEVICE and WEATHER subscriptions */
  attribute?: string;
  /** Attribute value for DEVICE subscriptions */
  value?: string;
}

/** LEGACY - Map containing a key-value that describes a call */
export type CallNode = any;

/** Only one of these elements should be present. */
export interface Element {
  /** Binary operator */
  BO?:
    | 'ADD'
    | 'SUB'
    | 'MUL'
    | 'DIV'
    | 'POW'
    | 'MOD'
    | 'AND'
    | 'OR'
    | 'XOR'
    | 'SHL'
    | 'SHR'
    | 'EQ'
    | 'NE'
    | 'LT'
    | 'GT'
    | 'LE'
    | 'GE';
  /** Unary operator */
  UO?: 'NEG' | 'POS' | 'NOT';
  /** Logical operator */
  LO?: 'AND' | 'OR';
  /** Literal value, only one of the properties should be specified */
  LI?: Literal;
  /** Member expression */
  ME?: MemberExpression;
  /** Call expression */
  CE?: CallExpression;
}

/** Literal value, only one of the properties should be specified */
export interface Literal {
  Number?: number;
  I64?: number;
  U64?: number;
  F64?: number;
  BOOL?: boolean;
  STR?: string;
}

/** An array of behaviors */
export interface PagedBehaviors {
  items?: Behavior[];
  _links?: Links;
}

/** The source of the Behavior */
export enum ParentType {
  RULE = 'RULE',
  SCENE = 'SCENE',
  SMARTAPP = 'SMARTAPP',
  NONE = 'NONE',
}

/**
 * The status of the Behavior
 * @default "ENABLED"
 */
export enum BehaviorEnabledEnum {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

/** Call expression */
export interface CallExpression {
  /** The name of the call */
  time?:
    | 'now'
    | 'isDay'
    | 'isNight'
    | 'todaysSunrise'
    | 'todaysSunset'
    | 'todaysSolarNoon'
    | 'hourOfDay'
    | 'minuteOfHour'
    | 'dayOfWeek'
    | 'dayOfMonth'
    | 'dayOfYear'
    | 'monthOfYear'
    | 'minuteOfDay'
    | 'nowMatches';
  /** The name of the weather property to use */
  weather?:
    | 'absoluteFineDust'
    | 'absoluteUltraFineDust'
    | 'fineDust'
    | 'humidity'
    | 'temperature'
    | 'ultraFineDust'
    | 'weather';
}

/** Member expression */
export type MemberExpression = string;

export type ActionExecutionResult = ActionExecutionResultBase & {
  type: ActionType;
  /** The result of a limit action execution */
  limit?: LimitActionExecutionResult;
  scene?: SceneActionExecutionResult[];
  /** The result of a notification action execution */
  notification?: NotificationActionExecutionResult;
};

/** The result of a behavior execution */
export interface BehaviorExecutionResult {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** ID of the parent. */
  parentId?: string;
  /** The source of the Behavior */
  parentType?: ParentType;
  actions?: ActionExecutionResult[];
  /** @default false */
  filtered?: boolean;
  /**
   * The owner of the rule is either a location or user
   * @default "Location"
   */
  ownerType: 'Location' | 'User';
  /** The UUID of the rule owner for a User rule */
  userUuid?: string;
  /** The location ids that are effected by actions in a User rule */
  actionLocationIds?: string[];
}

/**
 * Defines expiration, or scheduled deletion of Behaviors.
 * @example {"pattern":"1","type":"MAXEXECUTIONS","strategy":"DELETE"}
 */
export interface Expiration {
  /** The pattern for the expiration type, e.g. the number of allowed executions */
  pattern?: string;
  /** Expiration type or condition, e.g. expire after maximum number of exections */
  type: 'MAXEXECUTIONS';
  /** Behavior handling after expiration, e.g. delete behavior */
  strategy: 'DELETE';
}

export interface ModesResponse {
  /** @maxItems 10 */
  items: Mode[];
}

export interface Mode {
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:modes - the user can edit the Mode
   *   <li> d:modes - the user can delete the Mode
   *   </ul>
   */
  allowed?: string[];
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * If the user has not set a label and the name of the mode is one of "Home", "Away", or "Night",
   * then the returned label will be translated from the name based on the `Accept-Language` header.
   * If the user has not set a label and the name of the mode is anything else, then the label will be the same as the name.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * Unique per Location.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface CreateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface UpdateModeResponse {
  /**
   * Globally unique id for the Mode.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  id: string;
  /**
   * A user-readable label used to identify the mode in the app.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
  /**
   * An internal name for the Mode.
   * @format ^[a-zA-Z0-9.-_]+$
   * @example "Home"
   */
  name: string;
}

export interface CreateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface UpdateModeRequest {
  /**
   * A user-readable label used to identify the mode in the app.
   * Unique per Location.
   * @minLength 1
   * @maxLength 25
   * @example "Vacation"
   */
  label: string;
}

export interface ChangeModeRequest {
  /**
   * Update the current Mode for this Location to the given Mode ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "9206ea57-2e2e-414c-a792-9087117ca3d8"
   */
  modeId: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type DeleteModeResponse = object;

export interface CreateInstalledAppEventsRequest {
  /**
   * An array of smartapp events used to trigger client behavior in loaded web plugin detail pages.  Events will
   * be delivered to JavaScript event handler of all active client processes related to parameterized installed app.
   * @maxItems 8
   * @minItems 1
   */
  smartAppEvents?: SmartAppEventRequest[];
  /**
   * An array of smartapp dashboard card events used to trigger client behavior for dashboard cards.
   * Dashboard card events are directives to a SmartThings client to take actions in relation to lifecycle changes
   * to a specific dashboard card.  These events are not delivered to the web plugin event handler.
   * @maxItems 8
   * @minItems 1
   */
  smartAppDashboardCardEvents?: SmartAppDashboardCardEventRequest[];
}

/** An event used to trigger a client action on a SmartApp dashboard card. */
export interface SmartAppDashboardCardEventRequest {
  /**
   * A developer defined dashboard card ID.
   * @format ^[a-z0-9.-_]{1,36}$
   * @example "my_dashboard_card"
   */
  cardId?: string;
  lifecycle?: DashboardCardLifecycle;
}

export enum DashboardCardLifecycle {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

export interface SmartAppEventRequest {
  /**
   * An arbitrary name for the custom SmartApp event.  Typically useful as a hook for in-app routing.
   * @format ^[a-zA-Z_]{1,36}$
   */
  name?: string;
  /**
   * An arbitrary set of key / value pairs useful for passing any custom metadata.
   *
   * * Supports a maximum of 10 entries.
   * * Maximum key length: 36 Unicode characters in UTF-8
   * * Maximum value length: 256 Unicode characters in UTF-8
   * * Allowed characters for *keys* are letters, plus the following special characters: `:`, `_`
   * * Allowed characters for *values* are letters, whitespace, and numbers, plus the following special characters: `+`, `-`, `=`, `.`, `_`, `:`, `/`
   * * If you need characters outside this allowed set, you can apply standard base-64 encoding.
   */
  attributes?: Record<string, string>;
}

export type CreateInstalledAppEventsResponse = object;

export interface SceneSummary {
  /**
   * The unique identifier of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId?: string;
  /** The user-defined name of the Scene */
  sceneName?: string;
  /** The name of the icon */
  sceneIcon?: string;
  /** The color of the icon */
  sceneColor?: string;
  /**
   * Location of the Scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The unique identifier of the user that created the scene
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  createdBy?: string;
  /**
   * The date the scene was created
   * @format date-time
   */
  createdDate?: string;
  /**
   * The date the scene was last updated
   * @format date-time
   */
  lastUpdatedDate?: string;
  /**
   * The date the scene was last executed
   * @format date-time
   */
  lastExecutedDate?: string;
  /** Whether or not this scene can be edited by the logged in user using the version of the app that made the request */
  editable?: boolean;
  apiVersion?: string;
}

export type Scene = SceneSummary & {
  /** device configuration objects */
  devices?: SceneDevice[];
  /** The mode activated by the Scene */
  mode?: SceneMode;
  /** device group action */
  devicegroups?: SceneDeviceGroup[];
  /** Whether or not this scene's behavior is locally executed */
  executingLocally?: boolean;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:scenes - the user can edit the scene
   *   <li> x:scenes - the user can execute the scene
   *   <li> d:scenes - the user can delete scene
   *   </ul>
   */
  allowed?: 'w:scenes' | 'x:scenes' | 'd:scenes';
};

export interface SceneDevice {
  /** the id of the device */
  deviceId?: string;
  /** the label of the device */
  deviceLabel?: string;
  /** the name of the device */
  deviceName?: string;
  /**
   * The identifier for the device's DeviceType.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceTypeId?: string;
  components?: SceneComponent[];
  /**
   * Location of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface SceneDeviceGroup {
  /** the id of the device */
  deviceGroupId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode activated by the Scene */
export interface SceneMode {
  /**
   * the id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId?: string;
  /** the name of the mode */
  modeName?: string;
}

/** JSON body for creating or updating a Scene */
export interface SceneRequest {
  /** The user-defined name of the Scene */
  sceneName: string;
  /** The name of the icon */
  sceneIcon?: string;
  /**
   * The color of the icon
   * @format ^\#[0-9A-F]{6}$
   */
  sceneColor?: string;
  /** Non-sequential list of device actions */
  devices: SceneDeviceRequest[];
  /** List of parallel action sequences */
  sequences?: SceneActionSequence[];
  /** The mode to be activated by the Scene */
  mode?: SceneModeRequest;
  /** The security mode to be activated by the Scene */
  securityMode?: SceneSecurityModeRequest;
  /** List of device group actions */
  devicegroups?: SceneDeviceGroupRequest[];
}

export type SceneActionSequence = SceneAction[];

export interface SceneAction {
  scenes: string[];
  sequence?: SceneSequence;
}

/** JSON structure for a device when creating a Scene */
export interface SceneDeviceRequest {
  /**
   * the id of the device
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  components?: SceneComponent[];
}

/** JSON structure for a device group when creating a Scene */
export interface SceneDeviceGroupRequest {
  /**
   * the id of the device group
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceGroupId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** A device component capability */
  capability?: SceneCapability;
}

/** The mode to be activated by the Scene */
export interface SceneModeRequest {
  /**
   * The id of the mode
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  modeId: string;
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The name of the mode */
  modeName?: string;
}

/** The security mode to be activated by the Scene */
export interface SceneSecurityModeRequest {
  /**
   * the id of the action to be created. Optional, sent by Reaver only
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  actionId?: string;
  /** The id of the security mode */
  security: 'setArmStay' | 'setArmAway' | 'disarm';
  /** Additional query param */
  arguments?: string;
}

/** Sleep a particular sequence */
export interface SceneSleepRequest {
  /** Number of seconds to sleep the sequence */
  seconds: number;
}

/** A component of the scene device */
export interface SceneComponent {
  /** the id of the component */
  componentId?: string;
  capabilities?: SceneCapability[];
}

/** A device component capability */
export interface SceneCapability {
  /** The id of the capability */
  capabilityId?: string;
  /** The status of the capability */
  status?: 'proposed' | 'live' | 'deprecated' | 'dead';
  /** Capability commands */
  commands?: Record<string, SceneCommand>;
}

/** A component capability command */
export interface SceneCommand {
  /** the command arguments */
  arguments?: SceneArgument[];
}

/** A capability command argument */
export interface SceneArgument {
  /** the name of the command */
  name?: string;
  /** the schema of the command */
  schema?: object;
  /** The value being set for the capability command */
  value?: object;
}

export interface ScenePagedResult {
  items?: SceneSummary[];
  _links?: Links;
}

export interface SceneDevicePagedResult {
  items?: SceneDevice[];
  _links?: Links;
}

export type RegistrationRequest = Registration;

export type RegistrationResponse = Registration;

export interface Registration {
  /** Type of registration */
  type?: RegistrationType;
  armAway?: RegistrationTargetConfig;
  armStay?: RegistrationTargetConfig;
  disarm?: RegistrationTargetConfig;
  armState?: {
    url?: string;
    supportedOptionalReturnValues?: string[];
  };
}

export interface RegistrationTargetConfig {
  url?: string;
  supportedOptionalArguments?: string[];
}

/** Type of registration */
export enum RegistrationType {
  APP = 'APP',
  DEVICE = 'DEVICE',
}

export type RegistrationDeletionResponse = object;

/** Security system arm state */
export enum SecurityArmState {
  ARMED_AWAY = 'ARMED_AWAY',
  ARMED_STAY = 'ARMED_STAY',
  DISARMED = 'DISARMED',
}

export interface SecurityArmStateResponse {
  /** Security system arm state */
  armState: SecurityArmState;
  /** If Home monitoring service is installed, default is 'true' */
  vssEnabled: boolean;
  /** Return only when VA(Voice Assistant) is set. */
  vaEnabled?: boolean;
}

export type ArmAwayRequest = object;

export type ArmAwayResponse = object;

export type ArmStayRequest = object;

export type ArmStayResponse = object;

export type DisarmRequest = object;

export type DisarmResponse = object;

export interface NotificationRequest {
  /** The target location of sending push message. */
  locationId: string;
  /** The notification indicator type. The type determines the type of alerts the user sees on the device. */
  type: 'ALERT' | 'SUGGESTED_ACTION' | 'EVENT_LOGGING' | 'AUTOMATION_INFO';
  /**
   * It means the category of devices on which the client is installed to receive notifications (separated by dots).
   * The categories are divided into three parts. The 1st parts is the product category, the 2nd part is the operating system and the last part is the manufacturer.
   * The default ("empty") is to send the push notification to all of categories, and you can send push notification by selecting multiple categories as needed.
   * @example ["phone","pc.windows.samsung"]
   */
  categories?: PushCategory[];
  /** Notification title. */
  title?: string;
  /** The content that you want to display with the push notification. To use this value, pre-defined code and localized message map should be registered. */
  code?: string;
  /** Supports the ability to replace the custom variable in a title or body. The format of 'key' must be of the form ${...}. If you want to show the location nickname that the platform has, put it as the form of ${System.locationNickname} in the title or body. */
  replacements?: ReplacementsObject[];
  /**
   * The notification method.
   * 'CREATE':default, Create a new notification.
   * 'UPDATE':Notification is just updated instead of inserting new one.
   * 'DELETE':Clear the notifications displayed on the quick panel.
   */
  method?: 'CREATE' | 'UPDATE' | 'DELETE';
  /** It is used as the key value of update and delete notification. The key is generated by a combination of 'locationId' and 'code' and 'condition' value. */
  condition?: string;
  /** Notification target users. Users must belong to the location. The format must be saguid or uuid. */
  users?: string[];
  /** Notification target device ids. Device must belong to the location. */
  deviceIds?: string[];
  /**
   * Supports the ability to launch the specific plugin on your SmartThings app.
   * @example {"type":"device","id":"b968e0f3-c542-4256-acfa-e7690dac7ef9"}
   */
  deepLink?: {
    /** The plugin type where the push message will be delivered. */
    type?: 'device' | 'installedapp' | 'location' | 'recommendation';
    /** The specific plugin id. */
    id?: string;
  };
  /** Notification image url. */
  imageUrl?: string;
}

export interface MessagesObject {
  localeCode?: {
    title?: string;
    body?: string;
  };
}

/** @example {"key":"${progress}","value":"50"} */
export interface ReplacementsObject {
  key?: string;
  value?: string;
}

/** Represents a single page of Hub information. */
export interface PagedHubList {
  items?: Hub[];
  _links?: Links;
}

export interface Hub {
  /**
   * @format uuid
   * @example "6496be9a-aa23-4320-b60f-904e472db962"
   */
  id?: string;
  /** @example "Happy Hub" */
  name?: string;
  /** @example "D052A82674C90001" */
  eui?: string;
  /** @example "john.doe@smartthings.com" */
  owner?: string;
  /** @example "asdfasdf" */
  serialNumber?: string;
  /** @example "000.020.00203" */
  firmwareVersion?: string;
}

export interface HubUpdateRequest {
  /** @example "Happy hub" */
  name?: string;
  /** @example "1234abcd-eaff-47b3-80d6-a4cbe14e3344" */
  locationId?: string;
}

/** The type of message group entity. */
export enum MessageGroupEntityType {
  INSTALLED_APP = 'INSTALLED_APP',
  USER = 'USER',
}

export interface InstallRequest {
  installType: 'LAMBDA' | 'WEBHOOK';
  lambda: {
    /**
     * The id of the app to start installing.
     * @format uuid
     */
    appId?: string;
    /**
     * The location id of where the app is to be installed for.
     * @format uuid
     */
    locationId?: string;
  };
  webhook: {
    /**
     * The id of the app to start installing.
     * @format uuid
     */
    appId?: string;
    /**
     * The location id of where the app is to be installed for.
     * @format uuid
     */
    locationId?: string;
  };
}

export interface MigrationInstallRequest {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
  /** SMS message groups for the App.  This is optional. */
  smsMessageGroups?: MessageGroup[];
}

export interface MessageGroup {
  /**
   * The message group key for the migrated SHM app
   * @example "message_group_key_leak"
   */
  messageGroupKey?: string;
  /**
   * A channel is a compound identifier which combines both the message protocal and destination to which a
   * message should be delivered.  A channel value follows the following format: `<protocol>:<target-destination>`.
   *
   * ## Supported Protocols
   * | Protocol | Channel Format | Restrictions |
   * | -------- | -------------- | ------------ |
   * | SMS      | sms:+19999999999 | Phone Number in E.164 format. Messaging API is only supported for US based phone numbers. |
   */
  recipients?: string[];
}

export interface NextPageRequest {
  installInformation?: InstallInformation;
  /** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
  configurationData?: ConfigurationData;
}

export interface InstallInformation {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface InstallSummary {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface StartInstallResponse {
  installSummary?: InstallSummary;
  appSummary?: AppSummary;
  /** The first page for the install. */
  page?: Page;
}

export interface InstallResponse {
  /** The initial setting to be returned when starting a new configuration install. */
  app?: Setting & {
    /**
     * A developer defined page ID of the first page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    firstPageId?: string;
    /**
     * A developer defined page ID of any page to display. Must be URL safe characters.
     * @format ^[a-zA-Z0-9.-_]{1,36}$
     */
    customDisplayNamePageId?: string;
    /**
     * Disable the ability for the user to customize the display name.
     * @default false
     */
    disableCustomDisplayName?: boolean;
    /**
     * Disable the ability to remove the app from the configuration flow.
     * @default false
     */
    disableRemoveApp?: boolean;
    permissions?: string[];
  };
  installSummary?: InstallSummary;
  /** The first page for the install. */
  page?: Page;
  /** If the app is preauthorized or not. */
  preauthorized?: boolean;
}

export interface NextPageResponse {
  installSummary?: InstallSummary;
  page?: Page;
}

export interface UpdateInstallRequest {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface UpdateInstallResponse {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The new display name. */
  displayName?: string;
}

export interface AppSummary {
  /**
   * Name of the app to be configured.
   * @maxLength 256
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
  /**
   * A developer defined page ID of the first page to display. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  firstPageId?: string;
  requirements?: Requirement[];
}

export interface Requirement {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Value chosen for this configuration setting.
   * @maxLength 2048
   */
  value?: string;
  permissions?: string[];
}

export interface Section {
  /**
   * Name of the section.
   * @maxLength 128
   */
  name?: string;
  /** The user defined settings for configuration. */
  settings?: Setting[];
}

export interface Setting {
  /**
   * A developer defined configuration ID.
   * @format ^[a-zA-Z0-9.-_]+$
   * @maxLength 128
   */
  id?: string;
  /**
   * Name of the setting to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * Description of the app to be configured.
   * @maxLength 2048
   */
  description?: string;
  /** Indicates if this setting is required for configuration. */
  required?: boolean;
  /** The type of configuration setting. */
  type: 'DEVICE' | 'TEXT' | 'BOOLEAN' | 'ENUM' | 'MODE';
}

/** Device Setting */
export type DeviceSetting = Setting & {
  /** Indicates if this device setting can have multiple values. */
  multiple?: boolean;
  /** The required capabilities for the device(s) options. */
  capabilities?: string[];
  /** The required permissions for the selected device(s). */
  permissions?: ('READ' | 'EXECUTE' | 'WRITE')[];
  /** The device options for this setting that meet the required cababilities. */
  options?: Device[];
};

export interface Device {
  id?: string;
  name?: string;
  type?: string;
}

/** Enum Setting */
export type EnumSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** Display the enum options as groups. */
  groupedOptions?: GroupedOption[];
  /** The enum options. */
  options?: Option[];
};

/** Mode Setting */
export type ModeSetting = Setting & {
  /** Indicates if this enum setting can have multiple values. */
  multiple?: boolean;
  /** The mode options. */
  options?: Option[];
};

export interface GroupedOption {
  /**
   * The display name of this group of enum options.
   * @maxLength 128
   */
  name?: string;
  /** The enum options. */
  options?: Option[];
}

export interface Option {
  /**
   * The unique ID for this option.
   * @maxLength 128
   */
  id?: string;
  /**
   * The display name for this option.
   * @maxLength 128
   */
  name?: string;
}

export interface Page {
  /**
   * Name of the page to be configured.
   * @maxLength 128
   */
  name?: string;
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * A developer defined page ID for the next page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  nextPageId?: string;
  /**
   * A developer defined page ID for the previous page in the configuration process. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /**
   * Indicates if this is the last page in the configuration process.
   * @default false
   */
  complete?: boolean;
  /**
   * Change how the page is presented
   * @default "NORMAL"
   */
  style?: 'NORMAL' | 'SPLASH';
  /**
   * The text for the next button. Only applies if style is `SPLASH`
   * @maxLength 128
   */
  nextText?: string;
  /** The display sections for user defined settings. */
  sections?: Section[];
}

/** A request for a pages flow to drive app installation.  This will only be available for executions of type "CONFIGURATION". */
export interface ConfigurationData {
  /** Denotes the current installation phase. */
  phase: 'INITIALIZE' | 'PAGE';
  /**
   * A developer defined page ID. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  pageId?: string;
  /**
   * The previous page the user completed. Must be URL safe characters.
   * @format ^[a-zA-Z0-9.-_]{1,36}$
   */
  previousPageId?: string;
  /** Settings currently configured by user. */
  config?: ConfigMap;
  /** Global settings as defined on the App. */
  settings?: Record<string, string>;
}

export interface ServiceAppCompleteRequest {
  installInformation?: ServiceInstallInformation;
  /**
   * A multi-map of configurations for an Installed App.  The map 'key' is the configuration name
   * and the 'value' is an array of ConfigEntry models each containing a value and associated permissions.  The config
   * key is alpha-numeric, may contain dashes, underscores, periods, and must be less then 50 characters long.
   */
  config?: ConfigMap;
}

export interface ServiceInstallInformation {
  /**
   * The ID of the app.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  appId?: string;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId?: string;
  /** The id of the install configuration. */
  configurationId?: string;
}

export interface ServiceAppCompleteResponse {
  /**
   * Url that is used to allow/deny permissions and redirect to install/finalize endpoint.
   * @example "https://consigliere-regionald.smartthingsgdev.com/oauth/authorize?response_type=code&principal=installedapp:{{installedAppId}}:{{locationId}}&client_id={{clientId}}&state={{encrypted_state}}&installedAppId={{installedAppId}}&installedAppConfigId={{configurationId}}&language=en&redirect_uri=https://strongman-regionald.smartthingsgdev.com/install/finalize"
   */
  url?: string;
}

export interface PaginationRequest {
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond).
   * Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   * Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond).
   * Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   * Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return.
   * @default 20
   */
  limit?: number;
}

export type ActivitiesRequest = PaginationRequest & {
  /** location IDs */
  location: string[];
  /** device IDs */
  device?: string[];
  /** Parameter to filter by activities type, defaults to include everything. */
  include?: ('device' | 'execution' | 'mode')[];
  /** This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
};

/** @example {"saguid":"docUserGuid","title":"Right to access","region":"us-east-2","gdpr_id":"1234-11b5-4271-8b23-456789","callback_url":"http://gdpr","file_path":"/v1/gdpr/data/accio/docUserGuid/1234-11b5-4271-8b23-456789","file_name":"docUserGuid-c2ad77359b22","bucket_name":"samsung-gdpr"} */
export interface GdprRequest {
  callback_url: string;
  file_path: string;
  saguid: string;
  event_type: string;
  file_name: string;
  bucket_name: string;
  channel: string;
  title: string;
  region: string;
  gdpr_id: string;
}

export interface GdprResponse {
  /**
   * The request ID originally sent by GDPR server in the request.
   * @example "request-uuid-1"
   */
  gdpr_id: string;
  /**
   * The service ID of historian.
   * @example "historian"
   */
  service_id: string;
  /** The original request type. "portability" or "delete". */
  event: 'portability' | 'delete';
  /** Request processing status. "accepted", "ok" or "error". */
  event_status: 'accepted' | 'ok' | 'error';
  /** Error message if event_status is "error" */
  error?: string;
  /** Set if user has no PII data. Apply to "portability" response only. */
  noData?: boolean;
}

export interface ActivityHistory {
  /**
   * Deprecated. Translated human readable string (localized)
   * @example "battery of Button is: 89%"
   */
  text?: string;
  /**
   * this event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp: string;
  /** The type of activity. "execution", "device", "locationMode", "nativeApp". */
  activityType: 'EXECUTION' | 'DEVICE' | 'LOCATION_MODE' | 'NATIVE';
  deviceActivity?: DeviceActivity;
  executionActivity?: ExecutionActivity;
  modeActivity?: ModeActivity;
  nativeActivity?: NativeActivity;
}

export interface ThanosEvent {
  /**
   * Event ID (smartthings.event.Event.id)
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6bfb0047-9985-4102-8ecc-ada38ce9a3c5"
   */
  eventId: string;
  /**
   * timestamp in UTC time (smartthings.event.Event.serverTime)
   * @format date-time
   * @example "2020-07-13T22:14:52.714Z"
   */
  timeStamp?: string;
  /**
   * internal field for event ordering
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Location ID (gid) (smartthings.event.Event.locationId)
   * @example "location-uuid-1"
   */
  locationId: string;
  /** smartthings.event.Event.name */
  name?: string;
  /** smartthings.event.Event.stateChange */
  isStateChanged?: boolean;
  /** smartthings.event.Event.displayed */
  isDisplayed?: boolean;
  /**
   * smartthings.event.Event.providerTime
   * @format date-time
   * @example "2020-07-13T22:14:52.714Z"
   */
  providerTimeStamp?: string;
  /**
   * smartthings.event.Event.providerEventId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "3ce9c056-9fa8-4534-989f-13f5796356b1"
   */
  providerEventId?: string;
  /** smartthings.event.Event.rawMessage */
  rawMessage?: string;
  /** smartthings.event.Event.schemaUri */
  schemaUri?: string;
  /**
   * smartthings.event.LegacyEvent.deviceId or smartthings.event.DeviceEvent.deviceId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "dbfb7eb0-1b7f-4d83-b90b-15dccaeb0ac3"
   */
  deviceId: string;
  /**
   * Device nick name (only present in device activity event)
   * @example "TV"
   */
  deviceName?: string;
  /** Device type, e.g. device, child, resource_client, mobile, samsungconnect, legacy_da_device, cellrouter, smartthings_device, smartthing_hub, smartwatch, smartphone (only present in device activity event) */
  deviceType?: string;
  /**
   * Location name (only present in device activity event)
   * @example "Home"
   */
  locationName?: string;
  /** Room Id (only present in device activity event) */
  roomId?: string;
  /** Room Name (only present in device activity event) */
  roomName?: string;
  /**
   * smartthings.event.DeviceEvent.component or smartthings.event.LegacyEvent.component
   * @example "main"
   */
  component?: string;
  /**
   * smartthings.event.DeviceEvent.capability or smartthings.event.LegacyEvent.capability
   * @example "battery"
   */
  capability?: string;
  /**
   * smartthings.event.DeviceEvent.attribute or smartthings.event.LegacyEvent.attribute
   * @example "battery"
   */
  attributeName?: string;
  /**
   * smartthings.event.DeviceEvent.value or smartthings.event.LegacyEvent.value
   * @example 89
   */
  attributeValue?: string;
  /** smartthings.event.DeviceEvent.valueJson */
  attributeValueJson?: string;
  /** attribute unit (smartthings.event.DeviceEvent.unit) */
  unit?: string;
  /** default English text for the event (smartthings.event.DeviceEvent.linkText or smartthings.event.LegacyEvent.linkText) */
  text?: string;
  /** smartthings.event.LegacyEvent.source */
  source?: number;
  /** smartthings.event.legacyEvent.type */
  type?: string;
  /** smartthings.event.legacyEvent.data */
  data?: string;
  /** smartthings.event.LegacyEvent.commandId */
  commandId?: number;
  /** smartthings.event.LegacyEvent.hubId */
  hubId?: string;
  /** smartthings.event.LegacyEvent.groupId */
  groupId?: string;
  /** smartthings.event.LegacyEvent.parentDeviceId */
  parentDeviceId?: string;
  /** smartthings.event.LegacyEvent.deviceTypeId */
  deviceTypeId?: string;
  /** smartthings.event.LegacyEvent.installedDeviceId */
  installedDeviceId?: string;
  /** smartthings.event.LegacyEvent.smartAppId */
  smartAppId?: string;
  /** smartthings.event.LegacyEvent.smartAppVersionId */
  smartAppVersionId?: string;
  /** smartthings.event.LegacyEvent.installedSmartAppId */
  installedSmartAppId?: string;
  /** smartthings.event.LegacyEvent.installedSmartAppParentId */
  installedSmartAppParentId?: string;
  /** smartthings.event.LegacyEvent.userId */
  userId?: string;
  /** smartthings.event.LegacyEvent.descriptionText */
  descriptionText?: string;
  /** smartthings.event.LegacyEvent.handlerName */
  handlerName?: string;
  /** smartthings.event.LegacyEvent.triggeredBy */
  triggeredBy?: string;
  /** smartthings.event.LegacyEvent.translatable */
  isTranslatable?: boolean;
  /** smartthings.event.LegacyEvent.messageArgs */
  messageArgs?: string;
  /** smartthings.event.LegacyEvent.triggerEventId */
  triggerEventId?: string;
  /** smartthings.event.LegacyEvent.virtualHub */
  isVirtualHub?: boolean;
  /** smartthings.event.LegacyEvent.accountId */
  accountId?: string;
  /** smartthings.event.LegacyEvent.ephemeral */
  isEphemeral?: boolean;
}

export interface DeviceActivity {
  /**
   * Device ID (did)
   * @example "device-uuid-1"
   */
  deviceId: string;
  /**
   * Device nick name
   * @example "TV"
   */
  deviceName?: string;
  /** Device type, e.g. device, child, resource_client, mobile, samsungconnect, legacy_da_device, cellrouter, smartthings_device, smartthing_hub, smartwatch, smartphone */
  deviceType?: string;
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /** Room Id */
  roomId?: string;
  /** Room Name */
  roomName?: string;
  /** Event Name, closely related to attribute name. DEPRECATED, please use capability instead. */
  eventText?: string;
  /**
   * device component ID. Not nullable.
   * @example "main"
   */
  component: string;
  /**
   * device component label. Nullable.
   * @example "left button"
   */
  componentLabel?: string;
  /**
   * capability name
   * @example "battery"
   */
  capability: string;
  /**
   * attribute name
   * @example "battery"
   */
  attributeName?: string;
  /**
   * attribute value
   * @example 89
   */
  attributeValue?: string;
  /** attribute unit */
  unit?: string;
  /**
   * translated attribute name based on 'Accept-Language' requested in header
   * @example "스위치"
   */
  translatedAttributeName?: string;
  /**
   * translated attribute value based on 'Accept-Language' requested in header
   * @example "켜짐"
   */
  translatedAttributeValue?: string;
}

export interface ExecutionActivity {
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * Execution ID
   * @example "execution-uuid-1"
   */
  executionId: string;
  ruleType: 'BEHAVIOR' | 'SCENE' | 'WEBHOOK' | 'LAMBDA' | 'SMARTAPP' | 'OCF_RULE';
  /**
   * ID or the rule. Depending on rule type, the ID could you syndicate scene ID, alliance behavior ID, bookie installedAppId, or ocf rule ID
   * @example "behavior-uuid-1"
   */
  ruleId: string;
  /** Display name of the rule. */
  displayName?: string;
  /** Execution success or not */
  success?: boolean;
  /**
   * *DEPRECATED* - URL of the actions associated with the execution
   * @example "https://historian.samsung.com/v2/activities/location-uuid-1/executions/exec-uuid-1/actions"
   */
  actionsLink?: string;
}

export interface ExecutionActionsResponse {
  actions?: ExecutionAction[];
  _links?: Links;
}

export interface ExecutionAction {
  /** Action type. */
  actionType: 'DEVICE_COMMAND';
  /**
   * This is Execution action ID. Device command action can be multiple per one Execution Action ID.
   * @example "uuid"
   */
  id: string;
  /**
   * this event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  deviceAction?: DeviceAction;
}

export interface DeviceAction {
  /**
   * Device ID (did)
   * @example "device-uuid-1"
   */
  deviceId: string;
  /**
   * Device nick name
   * @example "TV"
   */
  deviceName?: string;
  /**
   * Capability
   * @example "Switch"
   */
  capability: string;
  /**
   * Device command
   * @example true
   */
  command: string;
  /** Device command argument */
  arguments?: string[];
  /**
   * The text to display to user when device command is failure or offline
   * @example "Device disconnected."
   */
  text?: string;
  /**
   * Deprecated - Result code of the action
   * @example 200
   */
  resultCode?: number;
  /** Result of action */
  result: 'Success' | 'Failure' | 'Offline';
}

export interface ModeActivity {
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * Mode ID
   * @example "location-uuid-1"
   */
  modeId: string;
  /**
   * Mode name (eg. Away, Home, Night)
   * @example "Away"
   */
  modeName?: string;
}

export interface NativeActivity {
  /**
   * event ID (eid)
   * @example "b48e24ae-c144-11ec-9d64-0242ac120002"
   */
  eventId: string;
  /**
   * Location ID (gid)
   * @example "abcde07a-1234-5ab6-9d76-e07a16fbfabd"
   */
  locationId: string;
  /**
   * Location Name
   * @example "Living Room"
   */
  locationName: string;
  /**
   * Source Application Name
   * @example "Calendar"
   */
  appName: string;
  /**
   * Optional. Device Status
   * @example "connected"
   */
  deviceStatus?: string;
  /**
   * Mobile Device Name
   * @example "Galaxy S21"
   */
  mobileDeviceName: string;
  /**
   * translated source app name based on 'Accept-Language' requested in header
   * @example "캘린더"
   */
  translatedAppName: string;
  /**
   * translated app name and device status based on 'Accept-Language' requested in header
   * @example "캘린더 has been activated."
   */
  translatedText: string;
}

export interface ActivityHistoryPage {
  items?: ActivityHistory[];
  _links?: Links;
}

export interface ThanosHistoryPage {
  items?: ThanosEvent[];
  _links?: Links;
}

export interface Notification {
  /**
   * unique Id that identifies the notification message.
   * @example "2d542d1d-ede9-4c9a-94c8-9ecd80e16322"
   */
  id: string;
  /**
   * Device ID (did). Optional. The IoT device Id associated with the notification.
   * @example "device-uuid-1"
   */
  deviceId?: string;
  /**
   * The IoT device nick name as defined by the user. Optional.
   * @example "Nick's Air conditioner"
   */
  deviceName?: string;
  /**
   * Device Type, e.g. "samsungconnect", "oic.d.camera", "x.com.st.d.sensor.multifunction"
   * @example "oic.d.airconditioner"
   */
  deviceType?: string;
  /**
   * Location ID (gid)
   * @example "location-uuid-1"
   */
  locationId?: string;
  /**
   * Location name
   * @example "Home"
   */
  locationName?: string;
  /**
   * notification type, 1 to 9. <br/> 1 = alert, <br/> 2 = system level <br/> 3 = event logging <br/> 4 = automation notifications <br/> 5 = warning <br/> 6 = low importance <br/> 7 = hidden api call <br/> 8 = force client refresh to remove warning (not visible to customer) <br/> 9 = suggested action
   * @example "1"
   */
  type: string;
  /**
   * Notification message code. Optional. This might not be there if the notification contains a custom message.
   * @example "VHM_0001"
   */
  code?: string;
  /** Notification message title. Optional. Note: this is not localized. */
  title?: string;
  /**
   * Localized message text associated with code or custom message (not localized).
   * @example "Auto cleaning is completed. Start returning to the charge."
   */
  message?: string;
  /**
   * deep link of push notification, <br/> format: {targetResource}:{targetResourceId} <br/> targetResource - installedappid, deviceid and locationid
   * @example "deviceid:b968e0f3-c542-4256-acfa-e7690dac7ef9"
   */
  deepLink?: string;
  /**
   * The raw push notification payload
   * @example "{"x.org.iotivity.ns.messageid":0,"x.org.iotivity.ns.providerid":"0f5bdefb-bf32-4673-924f-f1650be140b8","x.org.iotivity.ns.type":1,"x.org.iotivity.ns.source":"/oic/acl/group/0f5bdefb-bf32-4673-924f-f1650be140b8","x.org.iotivity.ns.title":"the notification title","x.com.samsung.code":"MO_PHONE_V_0001","x.com.samsung.deeplink":"locationid:0f5bdefb-bf32-4673-924f-f1650be140b8","x.com.samsung.params":[{"n":"%1$s","value":"John"},{"n":"%2$s","value":"Office"}],"x.com.samsung.data":{"et":"external","rep":{"gid":"0f5bdefb-bf32-4673-924f-f1650be140b8"},"dname":null},"x.org.iotivity.ns.contenttext":"John invited you to Office."}"
   */
  rawPayload: string;
  /**
   * When the message was received by the system. This will always be 0 timezone offset
   * @format date-time
   * @example "2017-12-18T22:14:52.714Z"
   */
  timestamp: string;
  /**
   * This event history timestamp in epoch (millisecond). Note: type is a long
   * @format int64
   * @example 1511913638679
   */
  epoch: number;
  /**
   * Hash value of this record. Note: type is a long
   * @format int64
   * @example 4080908847
   */
  hash: number;
  /**
   * Installed App Id associated with the SMS message
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "0550c6a2-cf39-49fd-a011-a800c50f3ecf"
   */
  installedAppId?: string;
  /**
   * Template used to generate SMS history, for support use.
   * @example "{"recipients":["sms:+123456789"],"message":{"fallbackLocale":"en","templates":[{"locale":"en","variables":{},"template":"The front door is open "}],"defaultVariables":{}}}"
   */
  smsMessageTemplate?: string;
}

export interface NotificationPage {
  items?: Notification[];
  _links?: Links;
}

export interface TokenSignUpRequest {
  /** himei - Hashed IMEI of device allowed.<br>hsn - Hashed Serial Number of device allowed.<br>imei - IMEI of device<br>mnId -MN-ID of device<br>pid - partnerId if device is a partner device.<br>sn - Serial number of the device<br>jwt - JWT token<br> */
  aaf?: object;
  /** Provide either authcode or accesstoken for sign-up. */
  accesstoken?: string;
  /** Provide either authcode or accesstoken for sign-up. */
  authprovider?: string;
  /** Samsung account app ID foreach service client. */
  clientId?: string;
  /** Device Type Client should use one of these values */
  devicetype:
    | 'device'
    | 'dadevice'
    | 'tvdevice'
    | 'avdevice'
    | 'ocfcommondevice'
    | 'ocf_hub'
    | 'child'
    | 'mobile'
    | 'multirole'
    | 'wifidevice'
    | 'pnpdevice'
    | 'resource_server'
    | 'resource_client'
    | 'oneapp'
    | 'samsungconnect'
    | 'smartthings_device'
    | 'smartthings_hub'
    | 'legacy_da_device';
  /** Unique device identifier. Format shall be UUID */
  di: string;
  /** Major version of OCF protocol. (OCF1.1) */
  dmv: string;
  /**
   * Has additional auth field.
   * @example false
   */
  haaf?: boolean;
  /** Minor version of OCF protocol. (IoTivity1.2) */
  icv: string;
  /** Push application id, related to push provider. */
  pushappid?: string;
  /** Name of push provider for notification. */
  pushprovider?: 'SPP' | 'GCM' | 'APNS' | 'INAPP' | 'none';
  /** Push registration id, related to push provider. */
  pushregid?: string;
  /** Samsung account unique user ID. */
  uid?: string;
}

export interface SignUpResponse {
  /** Access token used for communication with cloud after account creation. */
  accesstoken: string;
  /** Default location ID of account */
  defaultgroup?: string;
  /** Unique device identifier. Format shall be UUID */
  di: string;
  /**
   * Access token life time in seconds.
   * @format int64
   */
  expiresin: number;
  /** Redirect URL */
  redirecturi?: string;
  /** Refresh token used to refresh the access token in cloud before getting expired. */
  refreshtoken: string;
  /**
   * Refresh token life time in seconds.
   * @format int64
   */
  refreshtoken_expiresin?: number;
  /** Access token type. */
  tokentype: string;
  /** Samsung account unique user ID. */
  uid: string;
}

export interface SignInRequest {
  /** himei - Hashed IMEI of device allowed.<br>hsn - Hashed Serial Number of device allowed.<br>imei - IMEI of device<br>mnId -MN-ID of device<br>pid - partnerId if device is a partner device.<br>sn - Serial number of the device<br>jwt - JWT token<br> */
  aaf?: object;
  /** Access token used for communication with cloud. */
  accesstoken: string;
  /** Unique device identifier. Format shall be UUID */
  di: string;
  /**
   * Has additional auth field.
   * @example false
   */
  haaf?: boolean;
  /**
   * Login Status
   * @example false
   */
  login: boolean;
  /** Samsung account unique user ID. */
  uid: string;
}

export interface SignInResponse {
  /**
   * Remaining access token lifetime in seconds.
   * @format int64
   */
  expiresin: number;
  /**
   * Remaining refresh token lifetime in seconds.
   * @format int64
   */
  refreshtoken_expiresin?: number;
  /** Scope of token. */
  scope: string[];
}

export interface AddGroupInvitationListRequest {
  /** The Uid of the inviter. */
  from: string;
  invite: AddGroupInvitationRequest[];
}

export interface SendGroupInvitationRequest {
  /** The ID of the location. */
  gid?: string;
  /** Group name to be set for invitee's device */
  groupName?: string;
  /** Group role to be set ["member", "master(default)""] */
  groupRole?: string;
  /** Samsung account unique user ID. */
  uid?: string;
}

export interface SendGroupInvitationResponse {
  /** The ID of the location. */
  gid?: string;
  /** Group role to be set ["member", "master"] */
  groupRole?: string;
  /** The uid of inviter */
  inviterUid?: string;
  /** SC App download url */
  signedUrl?: string;
  /** Token to use assign invitation */
  token?: string;
}

export interface AddJoinGroupRequest {
  /** Unique device identifier. Format shall be UUID */
  di: string;
  /** Samsung account unique user ID. */
  uid: string;
}

export interface GetLocationListResponse {
  groups?: GetLocationResponse[];
}

export interface GetLocationProfileResponse {
  groups?: LocationProfile[];
}

export interface LocationProfile {
  /** The ID of the location. */
  gid?: string;
  /** The location nick name. */
  nick?: string;
}

export interface GetLocationResponse {
  /** Group backgroundImage [Max length = 128] */
  backgroundImage?: string;
  /** Device ID list */
  devices?: string[];
  /** Group gacl */
  gacl?: string;
  /** The ID of the location. */
  gid?: string;
  /** The name of location. */
  gname?: string;
  /** Group latitude */
  latitude?: string;
  /** Group longitude */
  longitude?: string;
  /** Groupradius */
  radius?: string;
  /** Master uid list */
  masters?: string[];
  /** Member uid list */
  members?: string[];
  /** The onwer's uid of the location. */
  owner?: string;
  /** Parent group id. */
  parent?: string;
  /** Group resources */
  resources?: LocationResource[];
  /** Subgroup list */
  subGroups?: string[];
  /** Temperaturescale ["C","F"] */
  temperaturescale?: string;
  /** Group type ["private", "public", "personal", "all"] */
  type?: string;
}

export interface AddGroupInvitationRequest {
  /** The ID of the location. */
  gid: string;
  /** Invitee id (email is not specified) */
  to: string;
  /** Invitee email address (to parameter is not specified) */
  email: string;
  /** invitee's group role to be set ["master", "member"] */
  groupRole: string;
  /** Group name to be displayed in invite push message */
  groupName: string;
}

export interface AssignGroupInvitationResponse {
  /** The ID of the location. */
  gid?: string;
  /** Group name */
  groupName?: string;
}

export interface GetJoinGroupResponse {
  /** The ID of the location. */
  gid?: string;
  /** Invitee's group role */
  groupRole?: 'OWNER' | 'MASTER' | 'MEMBER';
  /** The name of guest. */
  guestName?: string;
  /** The uid of guest. */
  guestUid?: string;
  /** The uid of owner. */
  ownerUid?: string;
}

export interface BookmarkLocation {
  /**
   * TTL for bookmarking. [default = 600000(ms) but max ttl is about 1 month.]
   * @format int64
   */
  expiresIn?: number;
  /** The ID of the location. */
  locationId: string;
  /** The ID of the room. (subgroup) */
  roomId?: string;
}

export interface GetInvitationResponse {
  /** The uid of inviter. */
  from?: string;
  /** The ID of the location. */
  gid?: string;
  /** The name of location. */
  gname?: string;
  /** The name of inviter. */
  name?: string;
}

export interface SendGroupInvitationListResponse {
  invitations?: SendGroupInvitationResponse[];
}

export interface AssignGroupInvitationRequest {
  /** Samsung account unique user ID. */
  uid: string;
  /** Token value from send invitation API for QR code */
  token: string;
}

export interface LocationResource {
  /** Resource href */
  href?: string;
  /** Resoure if */
  if?: string;
  /** resource rt */
  rt?: string;
}

export interface GetJoinGroupListResponse {
  joinRequests?: GetJoinGroupResponse[];
}

export interface GetInvitationListResponse {
  invited?: GetInvitationResponse[];
}

export interface SendGroupInvitationListRequest {
  invitations: SendGroupInvitationRequest[];
}

export interface InvitationTokenValidateResponse {
  /**
   * Token expire time.
   * @format int64
   */
  expiresin?: number;
}

export interface UpdateLocationProfileRequest {
  groups: LocationProfile[];
}

export interface GetUserInfoResponse {
  /** Email Address */
  email: string;
  /** User Name */
  name: string;
  /** User Nick Name */
  nick: string;
  /** Phone Number */
  phone: string;
}

export interface UpdateUserInfoRequest {
  /** Email Address */
  email?: string;
  /** User Nick Name */
  nick?: string;
  /** Phone Number */
  phone?: string;
}

export interface GetDeviceInfoListResponse {
  devices?: GetDeviceInfoResponse[];
}

export interface GetDeviceInfoResponse {
  /** OCF Card Color in Samsung Connect */
  color?: string;
  /** OCF Device Created time */
  createTime?: string;
  /** Unique device identifier. Format shall be UUID */
  di: string;
  /** OCF Vertical Domain Spec. Version */
  dmv?: string;
  /** OCF Spec. Version */
  icv?: string;
  /**
   * Device status is anormaly
   * @example false
   */
  isabnormal?: boolean;
  /** Language Code */
  locale: string;
  /** OCF Firmware Version */
  mnfv?: string;
  /** OCF Platform HW Version */
  mnhw?: string;
  /** OCF Manufacturer Name */
  mnmn?: string;
  /** OCF Model Number */
  mnmo?: string;
  /** OCF Platform OS */
  mnos?: string;
  /** OCF Platform Version */
  mnpv?: string;
  /** Device Name */
  n?: string;
  /** Device Nick Name */
  nick: string;
  /** Push Application Id */
  pushappid: string;
  /** Push Provider */
  pushprovider: 'SPP' | 'GCM' | 'APNS' | 'INAPP' | 'FCM' | 'none';
  /** Push Registration Id */
  pushregid: string;
  /** OCF Device Type */
  rt?: string;
  /** OCF Device Updated time */
  updateTime?: string;
  /** OCF Vendor ID */
  vid?: string;
  /** Serial Number for devices. */
  sn?: string;
  /**
   * Device Visibility
   * @example false
   */
  visible?: boolean;
  /** OCF Vendor Resource Client/Server Version */
  vrv?: string;
}

export interface UpdateDeviceInfoListRequest {
  devices: UpdateDeviceInfoRequest[];
}

export interface UpdateDeviceInfoRequest {
  /** OCF Card Color in Samsung Connect */
  color?: string;
  /** Device ID. */
  di: string;
  /** OCF Vertical Domain Spec. Version */
  dmv?: string;
  /** OCF Spec. Version */
  icv?: string;
  /** Language Code */
  locale?: string;
  /** OCF Firmware Version */
  mnfv?: string;
  /** OCF Platform HW Version */
  mnhw?: string;
  /** OCF Manufacturer Name */
  mnmn?: string;
  /** OCF Model Number */
  mnmo?: string;
  /** OCF Platform OS */
  mnos?: string;
  /** OCF Platform Version */
  mnpv?: string;
  /** Device Name */
  n?: string;
  /** Device Nick Name */
  nick?: string;
  /** Push application id, related to push provider. */
  pushappid?: string;
  /** Name of push provider for notification. */
  pushprovider?: 'SPP' | 'GCM' | 'APNS' | 'INAPP' | 'none';
  /** Push registration id, related to push provider. */
  pushregid?: string;
  /** OCF Device Type */
  rt?: string;
  /** OCF Vendor ID */
  vid?: string;
  /** Serial Number for devices. */
  sn?: string;
  /**
   * Device Visibility
   * @example false
   */
  visible?: boolean;
  /** OCF Vendor Resource Client/Server Version */
  vrv?: string;
}

export interface GetShpDeviceExistenceResponse {
  data?: boolean;
}

export interface ShpDeviceListResponse {
  /** Samsung account unique user ID */
  uid?: string;
  shpdevices?: ShpDeviceInfo[];
}

export interface ShpDeviceInfo {
  /** Device ID */
  di?: string;
  /** The owned of SHP devices */
  owned?: boolean;
}

export interface UpdateShpDeviceTokenRequest {
  /** Device ID */
  di: string;
  /** SHP device token */
  token?: string;
  /** The setup state of SHP devices */
  issetup?: boolean;
}

export interface UpdateShpDeviceTokenResponse {
  data?: boolean;
}

export interface GetShpDeviceTokenResponse {
  /** Device ID */
  di?: string;
  /** SHP device token */
  token?: string;
  /** The setup state of SHP devices */
  issetup?: boolean;
}

export interface ShpOwnerShipTransferRequest {
  /** Device ID */
  di: string;
  /** Samsung account unique user ID */
  uid: string;
}

export interface OnboardingInfoRequest {
  /** One-Time password */
  otp: string;
  roomId: string;
  locationId: string;
  nickname: string;
  'x.com.samsung.uid': string;
  'x.com.samsung.clientid'?: string;
  apn: string;
  cis: string;
  'x.com.samsung.iatt'?: number;
  'x.com.samsung.deployenv'?: string;
  'x.com.samsung.aac'?: string;
  'x.com.samsung.saauthserver'?: string;
  'x.com.samsung.saapiserver'?: string;
  'x.com.samsung.sadsc'?: string;
  'x.com.samsung.account'?: string;
}

export interface OnboardingInfoResponse {
  accesstoken?: string;
  roomId?: string;
  locationId?: string;
  nickname?: string;
  'x.com.samsung.uid'?: string;
  'x.com.samsung.clientid'?: string;
  apn?: string;
  cis?: string;
  'x.com.samsung.iatt'?: number;
  'x.com.samsung.deployenv'?: string;
  'x.com.samsung.aac'?: string;
  'x.com.samsung.saauthserver'?: string;
  'x.com.samsung.saapiserver'?: string;
  'x.com.samsung.sadsc'?: string;
  'x.com.samsung.account'?: string;
}

export interface CommonResponse {
  /** @format int32 */
  code?: number;
  data?: boolean;
  /** @example "SUCCESS" */
  message?: string;
}

export interface CasperNotificationConfig {
  installedApp?: DenyListObject;
  device?: DenyListObject;
  recommendation?: RecommendationConfig;
}

export interface DenyListObject {
  /** Denylist */
  denylist?: string[];
}

export interface RecommendationConfig {
  enabled?: boolean;
}

export interface InternalValidateRequest {
  certificate: string;
}

export interface InternalNonceRequest {
  noparameter: string;
}

export interface NonceRequest {
  deviceId: string;
}

export interface DeviceRequest {
  deviceId: string;
  nonce: string;
  signature: string;
  certificate: string;
  keyChanged?: boolean;
}

export interface ValidateRequest {
  deviceId: string;
  nonce: string;
  signature: string;
  certificate: string;
}

export interface SharedKeyRequest {
  deviceId: string;
  sharedDeviceId: string;
  nonce: string;
  key: string;
  signature: string;
  certificate: string;
}

export interface EncryptionKeyRequest {
  deviceId: string;
  nonce: string;
  key: string;
  signature: string;
  certificate: string;
}

export interface EncryptionKeyResponse {
  nonce?: string;
  key?: string;
  signature?: string;
  certificate?: string;
}

export interface SharedKeyResponse {
  nonce?: string;
  key?: string;
  signature?: string;
}

export interface NonceResponse {
  nonce?: string;
}

export interface StD2DDeviceCreateRequest {
  userguid?: string;
  country?: string;
  userId?: string;
  parentDevice?: SmartthingsDeviceInfo;
  devices?: SmartthingsDeviceInfo[];
}

export interface RestResponse {
  code?: number;
  data?: any;
  message?: string;
}

export interface SmartthingsDeviceInfo {
  sn?: string;
  imei?: string;
  wifiMac?: string;
  btMac?: string;
  bleMac?: string;
  type?: string;
  modelNumber?: string;
  modelSkuCode?: string;
  nickName?: string;
  marketingName?: string;
  manufacturerName?: string;
  manufacturerCode?: string;
  btName?: string;
  netType?: string;
  smartThingsDid?: string;
  registeredDatetime?: number;
  updateDatetime?: number;
}

/** SuccessRestResponse */
export interface SuccessRestResponse {
  /** @example 2000000 */
  code?: number;
  /** @example "SUCCESS" */
  message?: string;
}

/**
 * routeSuccessResponse
 * @example "{x.com.samsung.da.supportedModes=[Cool, Dry, Wind, CoolClean, DryClean, Auto], x.com.samsung.da.options=[Comode_Off], x.com.samsung.da.modes=[Auto]}"
 */
export type RouteSuccessResponse = object;

/** errorInBridgeRestResponse */
export interface ErrorInBridgeRestResponse {
  /** @example 4000000 */
  code?: number;
  /** @example "BRIDGE_CALL_FAILURE" */
  message?: string;
}

/** deviceNotFoundRestResponse */
export interface DeviceNotFoundRestResponse {
  /** @example 4040000 */
  code?: number;
  /** @example "DEVICE_NOT_FOUND" */
  message?: string;
}

/** userInvalidParamRestResponse */
export interface UserInvalidParamRestResponse {
  /** @example 4000000 */
  code?: number;
  /** @example "USER_INVALID_PARAM" */
  message?: string;
}

export interface PostResource {
  /**
   * resource property value ({x.com.samsung.da.power=On})
   * @example "{x.com.samsung.da.power=On}"
   */
  payload?: object;
}

export interface ChangeNotification {
  Notification?: {
    /**
     * Indicates the timestamp when event occurs
     * @example 1423523538
     */
    timestamp?: string;
    /**
     * Device List change type
     * @example "created, deleted, changeDeviceName"
     */
    event?: string;
    /** user id whose device list was changed */
    userIds?: string[];
  };
}

export interface Notification {
  Notification?: {
    /** Occurred in the device events list */
    Events?: NotiElements[];
  };
}

export interface NotiElements {
  /** device id */
  id?: string;
  /** device sub id */
  subId?: string;
  /** indicates the resource name */
  resource?: string;
  /**
   * Indicates time when event occurs
   * @example "2016-05-10T23:06:53"
   */
  eventTime?: string;
  /**
   * Indicates time when event occurs
   * @example "2016-05-10T23:06:53+00:00"
   */
  eventTimeUTC?: string;
  /**
   * Indicates event type
   * @example "created, Notified, deleted"
   */
  event?: string;
  /**
   * Indicates the resource attribute
   * @example [{"current":"123","id":"0"}]
   */
  resourceName?: object;
}

/**
 * The node identifier for the default administrator(s) on a fabric.  Typically, this embeds a CASE Authenticated Tag that administrators carry as an additional Relative Distinguished Name within their Node Operational Certificates.
 * @format ^(((?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16})|(F{7}D[0-9A-F]{8}))$
 */
export type AdminSubject = string;

/**
 * An X.509v3 certificate in PEM format
 * @example "-----BEGIN CERTIFICATE-----\nMIIB4TCCAYagAwIBAgIIGOlpug4IniMwCgYIKoZIzj0EAwIwIjEgMB4GCisGAQQB\ngqJ8AQMMEENBQ0FDQUNBMDAwMDAwMDMwHhcNMjAxMDE1MTQyMzQzWhcNNDAxMDE1\nMTQyMzQyWjBEMSAwHgYKKwYBBAGConwBAQwQREVERURFREUwMDAxMDAwMTEgMB4G\nCisGAQQBgqJ8AQUMEEZBQjAwMDAwMDAwMDAwMUQwWTATBgcqhkjOPQIBBggqhkjO\nPQMBBwNCAAS89lgNLXHhRBZlH3wxG178+a7AqMEK+AknhEwkD1Go6yP6B0QTiIes\nHnPLcqBUtqDbBiKqgHBxAWMTsVlshVLPo4GDMIGAMAwGA1UdEwEB/wQCMAAwDgYD\nVR0PAQH/BAQDAgeAMCAGA1UdJQEB/wQWMBQGCCsGAQUFBwMCBggrBgEFBQcDATAd\nBgNVHQ4EFgQUaWfJEvij5olVb4mbZddvU/plx7YwHwYDVR0jBBgwFoAURAzGkjHE\ny1s3lCQm+Bu+JLfvNFwwCgYIKoZIzj0EAwIDSQAwRgIhAM5u85PLvJT4DuKQyzw9\nNzM1urlZB3NNmdOEpio3O4SEAiEA4dQaBMMUD6oZ6KK5mwxh4zwn6pE5c+RbW8bj\nnCcNrFM=\n-----END CERTIFICATE-----\n"
 */
export type Certificate = string;

/**
 * A PKCS#10 Certificate Signing Request in PEM format.
 * @example "-----BEGIN CERTIFICATE REQUEST-----\nMIIBADCBpwIBADBFMQswCQYDVQQGEwJVUzETMBEGA1UECAwKU29tZS1TdGF0ZTEh\nMB8GA1UECgwYSW50ZXJuZXQgV2lkZ2l0cyBQdHkgTHRkMFkwEwYHKoZIzj0CAQYI\nKoZIzj0DAQcDQgAEvPZYDS1x4UQWZR98MRte/PmuwKjBCvgJJ4RMJA9RqOsj+gdE\nE4iHrB5zy3KgVLag2wYiqoBwcQFjE7FZbIVSz6AAMAoGCCqGSM49BAMCA0gAMEUC\nIDrLfK17+sA13XHWPfBx5sNrPueinoaju2F0cTea8fBvAiEA5+Vij6HcVjZCs78o\nU1w5n0kGTkwyCjOvN/IRUFOezTg=\n-----END CERTIFICATE REQUEST-----\n"
 */
export type CertificateSigningRequest = string;

/**
 * 64-bit fabric ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved value 0
 * @pattern ^(?!0{16})[0-9A-F]{16}$
 * @example "DBBD152AC71F134D"
 */
export type FabricId = string;

/**
 * A symmetric key used to obfuscate Matter node identities during CASE handshake.
 * @format ^[0-9A-F]{32}$
 */
export type IdentityProtectionKey = string;

/**
 * An array of Identity Protection Keys (IPKs) used within a fabric, which when fully populated represent
 * (previous, current, future) epoch keys.  To enable key rotation, nodes initiate CASE with the current key
 * and accept CASE with any of the previous, current, or future keys.  If two keys are presented, these are
 * (current, future).  If one key is presented, this is the (current) epoch key.  All APIs currently return
 * only a single (current) epoch key.
 * @maxItems 1
 * @minItems 1
 */
export type IdentityProtectionEpochKeys = IdentityProtectionKey[];

/**
 * 64-bit operational node ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved values
 * @pattern ^(?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16}$
 * @example "E24BD96D4F235823"
 */
export type NodeId = string;

export interface CreateFabricRequest {
  /** A PKCS#10 Certificate Signing Request in PEM format. */
  csr: CertificateSigningRequest;
}

export interface UpdateFabricRequest {
  /** A PKCS#10 Certificate Signing Request in PEM format. */
  csr: CertificateSigningRequest;
  /** The ID of a Hub */
  newHubId: HubId;
}

export interface CreateNodeRequest {
  /** A PKCS#10 Certificate Signing Request in PEM format. */
  csr: CertificateSigningRequest;
}

export interface NodeCreatedResponse {
  /** 64-bit fabric ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved value 0 */
  fabricId: FabricId;
  /** 64-bit operational node ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved values */
  nodeId: NodeId;
  /** An X.509v3 certificate in PEM format */
  nodeCertificate: Certificate;
  /** An X.509v3 certificate in PEM format */
  rootCA: Certificate;
  /**
   * A list of all intermediates certificate between the root and the node certificate.
   * @minItems 0
   */
  intermediateCA: Certificate[];
  /**
   * An array of Identity Protection Keys (IPKs) used within a fabric, which when fully populated represent
   * (previous, current, future) epoch keys.  To enable key rotation, nodes initiate CASE with the current key
   * and accept CASE with any of the previous, current, or future keys.  If two keys are presented, these are
   * (current, future).  If one key is presented, this is the (current) epoch key.  All APIs currently return
   * only a single (current) epoch key.
   */
  ipk: IdentityProtectionEpochKeys;
  /** The node identifier for the default administrator(s) on a fabric.  Typically, this embeds a CASE Authenticated Tag that administrators carry as an additional Relative Distinguished Name within their Node Operational Certificates. */
  adminSubject: AdminSubject;
}

export interface GetRootCertificatesResponse {
  /** An X.509v3 certificate in PEM format */
  current: Certificate;
  compromised?: {
    /** An X.509v3 certificate in PEM format */
    certificate?: Certificate;
    /**
     * When the certificate have been revoked
     * @format date-time
     */
    on?: string;
  }[];
  retired: {
    /** An X.509v3 certificate in PEM format */
    certificate?: Certificate;
    /**
     * When the certificate have been retired
     * @format date-time
     */
    on?: string;
  }[];
}

/** Address information. */
export interface AddressesResults {
  addresses: Address[];
}

export interface Address {
  /** Country code in ISO Alpha-2 format */
  country: string;
  /** Name of state */
  state: string;
  /** List of city name */
  cities: string[];
}

/** Headend information. */
export interface HeadendResults {
  headends: Headend[];
  /** Postal code */
  postalCode?: string;
  /** State name */
  state?: string;
  /** City name */
  city?: string;
}

export interface Headend {
  /** Country code in ISO Alpha-2 format */
  country: string;
  /** Unique key of headend */
  headendId: number;
  /**
   * Device type code
   * @format P|X|Y
   */
  deviceType: string;
  /** Name of headend */
  name: string;
  /** Name of mbr */
  mbrName: string;
  /**
   * Type of service provider
   * @format CATV|DBS|MATV|MH|OTA|TL
   */
  serviceType: string;
}

/** Channel information. */
export interface ChannelsResults {
  channels: Channel[];
}

/** Channel information */
export interface Channel {
  /** Country code in ISO Alpha-2 format */
  country: string;
  /** Number of channel */
  channelNumber: string;
  /** Number of major channel */
  majorNumber: string;
  /** Number of minor channel */
  minorNumber: string;
  /** Name of source(Channel) */
  name: string;
  /** Name of alias source(Channel) */
  aliasName: string;
  /** Unique key of headend */
  headendId: number;
}

export interface ProxyDeviceRequest {
  id?: string;
  type?: string;
}

export interface DeviceIdentityPeripheralInfo {
  modelName?: string;
  sn?: string;
}

export interface PlansResponse {
  code?: Int;
  message?: PlanMessageResponse;
}

export interface KitsMessageResponse {
  id?: Int;
}

export interface TariffResponse {
  country?: string;
  updatedTime?: number;
  devices?: DevicesResponse[];
  services?: object[];
  type?: string;
  expiredTime?: number;
  userCentric?: boolean;
  partner?: PartnerResponse;
  activatedTime?: number;
  kit?: KitResponse;
  name?: string;
  id?: number;
  status?: string;
  purchasedTime?: number;
}

/** @example {"name":"OPEN_GLOBAL_HOME_PLAN","peripherals":[{"sn":"kitSn","type":"HUB","model":"F-CAM-VF-1"}]} */
export interface PlanKit {
  peripherals: PeripheralsModel[];
  name: string;
}

export interface PartnerInfo {
  regions?: string;
  code?: string;
  name?: string;
}

/** @example {"name":"OPEN_GLOBAL_HOME_PLAN","userId":"docSaguid","country":"US","status":"ACTIVE","activatedTime":1573458043541,"updatedTime":1573458043541,"services":{"HMVS_OPEN":{"status":"ACTIVE","maxNumCamera":1,"maxStorageMB":10240,"maxRetentionDays":30,"maxRecodingSeconds":60,"maxNumPermClip":100},"SHM":{"status":"ACTIVE"}}} */
export interface PlansRequest {
  country: string;
  updatedTime?: number;
  activatedTime?: number;
  devices?: SingleDeviceInfo[];
  name: string;
  services?: object;
  activationUrl?: string;
  type?: string;
  userId?: string;
  expiredTime?: number;
  status?: string;
  purchasedTime?: number;
}

export interface PeripheralsModel {
  model?: string;
  sn: string;
  type: string;
}

/** @example {"status":"ACTIVE"} */
export interface UpdatePlanStatusRequest {
  status: string;
}

export interface GetTariffInfo {
  devices?: string[];
  id?: number;
  services?: object[];
}

export interface GetLocationTariffResponse {
  locationId?: string;
  tariffs?: GetTariffInfo[];
}

export interface AppReference {
  schema?: string;
  method?: string;
  packageName?: string;
  url?: string;
}

export interface PabalReplacement {
  value?: string;
  key?: string;
}

export interface PartnerStatusV2Response {
  deviceList?: STPartnerStatusInfo[];
}

export interface DevicesResponse {
  iccid?: string;
  mnc?: string;
  partnerDeviceId?: string;
  imei?: string;
  id?: string;
  sn?: string;
  partOfTariff?: boolean;
  type?: string;
  mcc?: string;
  parentId?: number;
  manufacturer?: string;
}

/** @example {"type":"ALERT","hubSn":"testHubSn","userId":"testUser","device":{"type":"TAG","id":"testDi"},"messages":[{"es_US":{"title":"Smart Home Monitor+","body":"Smart Home Monitor+"}},{"default":{"title":"Smart Home Monitor+","body":"Smart Home Monitor+"}}]} */
export interface ProxyRequest {
  hubSn?: string;
  imageUrl?: string;
  messages: object[];
  replacements?: PabalReplacement[];
  type: string;
  userId?: string;
  device?: ProxyDeviceRequest;
}

export interface PolicyResponse {
  tariffNeeded?: boolean;
  userCentric?: boolean;
  message?: string;
}

export interface PlanMessageResponse {
  id?: Int;
}

export type CSVParams = object;

export interface ActivationUrlResponse {
  app?: AppReference;
  appDeepLink?: string;
  requestHeaders?: object;
  web?: WebReference;
  href?: string;
}

export interface ProxyResponse {
  code?: Int;
  message?: string;
}

export interface KitResponse {
  peripherals?: PeripheralsModel[];
  type?: string;
}

export interface DeleteDeviceInfo {
  iccid?: string;
  mnc?: string;
  partnerDeviceId?: string;
  imei?: string;
  id?: string;
  sn?: string;
  type?: string;
  mcc?: string;
  manufacturer?: string;
}

export interface GetSercommDeviceResponse {
  code?: number;
  data?: DeviceIdentityDataField;
  message?: string;
}

export interface DeleteTariffDeviceResponse {
  devices?: DeleteDeviceInfo[];
  href?: string;
}

/** @example {"id":"1234568-4110-268f-a1b4-123456","type":"CAMERA","sn":"testSn"} */
export interface RegisterDeviceRequest {
  deviceType?: string;
  mnc?: string;
  deviceCode?: string;
  type: string;
  mcc?: string;
  parentId?: string;
  manufacturer?: string;
  iccid?: string;
  partnerDeviceId?: string;
  imei?: string;
  model?: string;
  id: string;
  sn?: string;
}

export interface GetNewPlansResponse {
  country?: string;
  activatedTime?: number;
  devices?: SingleDeviceInfo[];
  name?: string;
  id?: number;
  services?: object;
  userId?: string;
  status?: string;
}

export type Int = object;

export interface KitsResponse {
  code?: Int;
  message?: KitsMessageResponse;
}

export interface PartnerResponse {
  regions?: string;
  code?: string;
  name?: string;
}

export interface WebReference {
  clientType?: string;
  method?: string;
  accessibleUrls?: string[];
  requiredPayload?: object;
  url?: string;
}

export interface SearchTariffResponse {
  country?: string;
  updatedTime?: number;
  partner?: PartnerInfo;
  activatedTime?: number;
  name?: string;
  id?: number;
  type?: string;
  expiredTime?: number;
  status?: string;
  purchasedTime?: number;
}

/** @example {"deviceType":"TAG","deviceCode":"1","imei":"testImei","sn":"testSn","os":"android","deviceId":"test-device-id","nickName":"SmartThings Tracker"} */
export interface ActivationUrlRequest {
  deviceType?: string;
  country?: string;
  mnc?: string;
  partnerCode?: string;
  os?: string;
  partnerName?: string;
  nickName?: string;
  deviceCode?: string;
  mcc?: string;
  deviceId?: string;
  deviceStatus?: string;
  iccid?: string;
  imei?: string;
  guid?: string;
  id?: string;
  sn?: string;
}

export interface SingleDeviceInfo {
  partnerDi: string;
  kit?: PlanKit;
  imei?: string;
  sn?: string;
  type?: string;
  manufacturer?: string;
}

/** @example {"diList":["testSn"],"type":"CAMERA"} */
export interface DeleteDeviceRequest {
  diList?: string[];
  type?: string;
}

/** @example {"status":"ACTIVE"} */
export type Map = object;

export interface GetKitsResponse {
  kitId: number;
  peripherals?: PeripheralsModel[];
  name: string;
}

export interface STPartnerStatusInfo {
  update_time?: string;
  service_type?: string[];
  create_time?: string;
  di?: string;
  partner_di?: string;
}

export interface DeviceIdentityDataField {
  partner?: string;
  devices?: DeviceIdentityPeripheralInfo[];
  kitName?: string;
}

export interface LocationSettingRequest {
  /**
   * milliseconds (default: 10 minutes)
   * @format int64
   */
  expiresIn?: number;
  /** The location id */
  locationId: string;
  /** The room id */
  roomId?: string;
}

export interface DeviceMode {
  /** @example "f2188102-1d74-0402-e585-xxxxxx" */
  di: string;
  /** @example "suspend" */
  mode: string;
  /** @example "dot" */
  devicetype: string;
}

export interface ServiceBlacklistRequest {
  installedApp?: ServiceBlackListObject;
  device?: ServiceBlackListObject;
  /** Enable recommended notification */
  enableRecommendation?: boolean;
}

export interface ServiceBlackListObject {
  /** Blacklist */
  blacklist?: string[];
}

/**
 * Push category
 * @example ["phone","pc.windows.samsung"]
 */
export enum PushCategory {
  Phone = 'phone',
  PhoneAndroid = 'phone.android',
  PhoneAndroidSamsung = 'phone.android.samsung',
  PhoneAndroidOthers = 'phone.android.others',
  PhoneIos = 'phone.ios',
  Tablet = 'tablet',
  Tv = 'tv',
  Refrigerator = 'refrigerator',
  Speaker = 'speaker',
  Pc = 'pc',
  PcWindows = 'pc.windows',
  PcWindowsSamsung = 'pc.windows.samsung',
  PcWindowsOthers = 'pc.windows.others',
}

export interface NotificationProfileRequest {
  /** Device ID. */
  di?: string;
  /** Push application id, related to push provider. */
  pushAppId?: string;
  /** Name of push provider for notification. */
  pushProvider?: 'SPP' | 'GCM' | 'APNS' | 'INAPP' | 'none';
  /** Push registration id, related to push provider. */
  pushRegId?: string;
  /** on/off notification */
  enable?: boolean;
  /** device locale */
  locale?: string;
}

export interface IncidentPostBody {
  /** The location ID the app was set to on the mobile device at the time of the incident. */
  locationId?: string;
  /**
   * Country code that is used for the catalog service. If no country is provided, server will
   * default to US
   */
  country?: string;
  /**
   * Language code that is used for the catalog service. If no language is provided, server will
   * default to en-US
   */
  language?: string;
  /**
   * JSON blob that will contain all the configuration settings of the mobile devices. Data provided in this field
   * will be posted on the JIRA ticket when created. Must be a valid JSON.
   */
  additionalData?: object;
}

export interface IncidentIdResponse {
  /**
   * ID of the incident
   * @format uuid
   */
  incidentId?: string;
}

export interface CreateJwtTokenRequest {
  /**
   * The location id
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  locationId: string;
  /**
   * The room id
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  roomId?: string;
  /** first 4 char of (base64urlsafe(sha256(di)) */
  deviceVerify?: string;
  /**
   * The scope of auth using the JWT
   * @example ["iot.client","iot.device"]
   */
  scope: string[];
  /** The saguid of device's owner */
  uid?: string;
}

export interface CreateJwtResponse {
  /** created jwt token */
  jwt?: string;
  /** authProvider */
  authprovider?: string;
  /** url for onboarding */
  redirecturi?: string;
}

export type CertificateUuidResponse = string[];

export type PublisherDetailsResponse = Publisher[];

export interface Publisher {
  mnId: string;
  groupId: string;
  saguid: string;
  role: string;
}

export interface EasySetupBlobRes {
  blob?: string;
  cloudPubKey?: string;
  meta?: EasySetupBlobMetadata;
  sn?: string;
  type?: string;
}

export interface EasySetupBlobMetadata {
  mfgr?: string;
  mnId?: string;
  modelName?: string;
  onboardingId?: string;
  partner?: string;
  sku?: string[];
}

export interface RestResponseListEasySetupBlobRes {
  /** @format int32 */
  code?: number;
  data?: EasySetupBlobRes[];
  message?: string;
}

export interface EasySetupBlobReq {
  keyid: EasySetupBlobKeyId;
  rand: string;
  modelName: string;
  mnId?: string;
  setupId?: string;
}

export interface EasySetupBlobKeyId {
  type: 'sn' | 'hashed_sn' | 'hybrid_sn';
  value: string;
}

export interface LuxFileLinkResult {
  /** uuid file id */
  file_id: string;
  /** file link url */
  url: string;
}

export interface UsersSigninRequest {
  /** Product ID */
  productId: string;
  /**
   * Platform type value in admin system
   * @example "01: Android, 02: Gear, 03: iOS"
   */
  platformType: string;
  /** Device ID */
  deviceId: string;
  /** Samsung account device ID */
  saDeviceId: string;
  /** Service device ID */
  serviceDeviceId: string;
  /** Samsung account app ID */
  saAppId?: string;
  /** Device master ID */
  deviceMasterId?: string;
  /**
   * Device model name
   * @example "SM-G950"
   */
  deviceModelName?: string;
  /** Sales code */
  salesCode?: string;
  /** Version name */
  versionName?: string;
  /** POC ID in partner portal */
  pocId?: string;
  /**
   * Service join date
   * @example 1598019349
   */
  serviceJoinDate?: number;
  /** Samsung account URL */
  saUrl?: string;
  /** Samsung account physical address text */
  saDevicePhysicalAddressText?: string;
  /** Phone number */
  phoneNo?: string;
  /** Samsung push registration ID */
  pushRegId?: string;
  /** GCM push registration ID */
  gcmRegId?: string;
  /** APNS push registration ID */
  apnRegId?: string;
  /**
   * APNS type
   * @example "01: inhouse_dev, 02: inhouse_dis, 03: prd_dis"
   */
  apnsType?: string;
  /** Representative name check Y/N Flag (KOR only) - Default N */
  nameCheckYn?: 'Y' | 'N';
}

export interface UsersSigninResponse {
  /** User's master ID */
  masterId?: string;
  /** User’s device master id */
  deviceMasterId?: string;
  pubKeys?: {
    push: string;
  }[];
  /** Access token */
  accessToken?: string;
  /** Remaining SA expire token time in seconds. */
  saRemainExpireTimeSec?: number;
  /** Partner access token */
  partnerAccessToken?: string;
  /** Base MCS URL */
  mcsUrl?: string;
}

export interface BixbyApiResponseObjectValue {
  /** @format int32 */
  code?: number;
  data?: object;
  message?: string;
}

export interface GetDeliveryOrderResponse {
  /** Delivery Quantity */
  quantity?: string;
  /** Serial number. */
  serialNumber?: string;
  /** CE H.P */
  phoneNumber?: string;
  /** Delivery Number */
  documentNumber?: string;
  /** Model Code */
  modelCode?: string;
  /** Delivery Item Number */
  deliveryItem?: string;
  /** Delivery Item Number */
  numOfItems?: string;
  /** Installation Date */
  installationDate?: string;
  /** sales order number */
  soNumber?: string;
  saGuids?: string[];
}

export interface PlcmDeviceItem {
  serialNumber: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  partialSerialNumber?: string;
  visibility: boolean;
  /** FOA | UPI | SCV | PRS | PDD | PLCM | SNC */
  sourceType: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  createTime: string;
  modelCode?: string;
  setupId: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  updateTime?: string;
  discovererDevice?: DiscovererDeviceItem;
  ssid?: string;
  mnId: string;
}

/** @example {"mnId":"testMnId","setupId":"testSetupId","serialNumber":"testSerial","visibility":false} */
export interface PlcmDevicePutRequest {
  serialNumber?: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  partialSerialNumber?: string;
  visibility: boolean;
  setupId: string;
  mnId: string;
}

/** @example {"mnId":"testMnId","setupId":"testSetupId","serialNumber":"testSerial","sourceType":"PDD","discovererDevice":{"deviceId":"testDeviceId","deviceType":"TV"}} */
export interface PlcmDevicePostRequest {
  serialNumber?: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  partialSerialNumber?: string;
  /** FOA | UPI | SCV | PRS | PDD | PLCM | SNC */
  sourceType: string;
  modelCode?: string;
  setupId?: string;
  /** DiscovererDevice cannot be null in case of pdd */
  discovererDevice?: DiscovererDeviceItem;
  ssid?: string;
  mnId?: string;
}

export interface GetPlcmDevicesResponse {
  devices?: GetPlcmDeviceResponse[];
}

export interface DiscovererDeviceItem {
  /** MP | HS | FH | TV | HC */
  deviceType: string;
  deviceId?: string;
}

export interface PostPlcmDeviceResponse {
  serialNumber: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  partialSerialNumber?: string;
  visibility: boolean;
  /** FOA | UPI | SCV | PRS | PDD | PLCM | SNC */
  sourceType: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  createTime: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  updateTime?: string;
  modelCode?: string;
  setupId: string;
  mnId: string;
}

export interface GetPlcmDeviceResponse {
  serialNumber: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  partialSerialNumber?: string;
  visibility: boolean;
  /** FOA | UPI | SCV | PRS | PDD | PLCM | SNC */
  sourceType: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  createTime: string;
  modelCode?: string;
  setupId: string;
  /** @format yyyy-MM-dd'T'HH:mm:ss.SSS'Z' */
  updateTime: string;
  discovererDevices?: DiscovererDeviceItem[];
  ssid?: string;
  mnId: string;
}

export interface GeolocationResponse {
  items: GeolocationResponseItem[];
}

export interface Key {
  /** @format uuid */
  deviceId: string;
  pubKey: string;
  encPrivKey: string;
}

export interface GeolocationInput {
  encryption?: EncryptionInput;
  /**
   * Geographic coordinate (-90, 90)
   * @format may be encrypted
   */
  latitude: string;
  /**
   * Geographic coordinate (-180, 180)
   * @format may be encrypted
   */
  longitude: string;
  /** The method used to produce location data */
  method?: 'GPS' | 'WI_FI';
  /**
   * Radius of a circle around given coordinates (meter)
   * @format may be encrypted
   */
  accuracy?: string;
  /**
   * Degree measured between the latest location and the second latest location (-180, 180)
   * @format may be encrypted
   */
  heading?: string;
  /**
   * Travel speed (Km/H)
   * @format may be encrypted
   */
  speed?: string;
  /**
   * RSSI of BLE signal (dBM)
   * @format may be encrypted
   */
  rssi?: string;
  /**
   * Battery percentage of (%)
   * @format may be encrypted
   */
  battery?: string;
}

export interface EncryptionInput {
  /**
   * List of objects that are encrypted in given geolocation item
   * @example ["latitude","longitude"]
   */
  encObjs: string[];
  /** Public key of the tracker as an encryption key. */
  pubKey: string;
}

export interface GeolocationOutput {
  encryption?: EncryptionOutput;
  /**
   * Geographic coordinate (-90, 90)
   * @format may be encrypted
   */
  latitude: string;
  /**
   * Geographic coordinate (-180, 180)
   * @format may be encrypted
   */
  longitude: string;
  /** The method used to produce location data */
  method?: 'GPS' | 'WI_FI';
  /**
   * Radius of a circle around given coordinates (meter)
   * @format may be encrypted
   */
  accuracy?: string;
  /**
   * Degree measured between the latest location and the second latest location (-180, 180)
   * @format may be encrypted
   */
  heading?: string;
  /**
   * Travel speed (Km/H)
   * @format may be encrypted
   */
  speed?: string;
  /**
   * RSSI of BLE signal (dBM)
   * @format may be encrypted
   */
  rssi?: string;
  /**
   * Battery percentage of (%)
   * @format may be encrypted
   */
  battery?: string;
  /** epoch time */
  lastUpdatedTime: number;
}

export interface EncryptionOutput {
  /**
   * List of objects that are encrypted in given geolocation item
   * @example ["latitude","longitude"]
   */
  encObjs: string[];
}

/**
 * Has tracker's state and scanners ID
 * @example {"state":"connected","connectedDeviceId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","connectedUserId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","geolocations":[{"encryption":{"encObjs":["latitude","longitude"]},"latitude":"wJMcXFwazt4n7uHQ3ZKi9g==","longitude":"Uko5CMFXNmmTfWfPU+D+zQ==","method":"method","accuracy":"accuracy","heading":"heading","speed":"speed"}]}
 */
export interface TrackerStateItemInput {
  state: 'undefined' | 'connected' | 'disconnected' | 'lost' | 'found';
  /** connectedDeviceId is only defined when the state is "connected", "disconnected", otherwise it's null. */
  connectedDeviceId?: string;
  /** connectedUserId is only defined when the state is "connected", "disconnected", "lost", otherwise it's null. */
  connectedUserId?: string;
  /** geolocations is only defined when the state is "connected", "disconnected", otherwise it's null. */
  geolocations?: GeolocationInput[];
}

/**
 * Has tracker's state and scanners ID
 * @example {"state":"connected","connectedDeviceId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","connectedUserId":"1a03f60a-0e56-45a4-a3fd-19a91800fd01","geolocations":[{"encryption":{"encObjs":["latitude","longitude"],"encPrivKey":"Ek3SJxM7etLnUsDEKbofI789uML6XwE7eTZrbj0WAeQ="},"latitude":"wJMcXFwazt4n7uHQ3ZKi9g==","longitude":"Uko5CMFXNmmTfWfPU+D+zQ==","method":"method","accuracy":"accuracy","heading":"heading","speed":"speed"}]}
 */
export interface TrackerStateItemOutput {
  state: 'undefined' | 'connected' | 'disconnected' | 'lost' | 'found';
  /** connectedDeviceId is only defined when the state is "connected", "disconnected", otherwise it's null. */
  connectedDeviceId?: string;
  /** connectedUserId is only defined when the state is "connected", "disconnected", "lost", otherwise it's null. */
  connectedUserId?: string;
  /** geolocations is only defined when the state is "connected", "disconnected", otherwise it's null. */
  geolocations?: GeolocationOutput[];
}

/** @example {"tagTime":1594359205} */
export interface TrackerTimerItemInput {
  /** synced date time by seconds */
  tagTime: number;
}

/**
 * Tracker timer object
 * @example {"receivedServerTime":1594359210,"tagTime":1594359205,"timeGap":5}
 */
export interface TrackerTimerItemOutput {
  /** epoch time when server processed the call */
  receivedServerTime: number;
  /** the same value in request payload */
  tagTime: number;
  /** time gap between what tag has and when server received */
  timeGap: number;
}

export interface GeolocationResponseItem {
  /** @format uuid */
  deviceId?: string;
  geolocations: GeolocationOutput[];
  /**
   * The key of the item where the operation stopped, inclusive of the previous result.
   * Use this value to fetch next result.
   */
  offset?: string;
}

/** devices response */
export type HintsForDevicesResponse = ApiSuccessResponse & {
  /** response data */
  data?: {
    targets?: HintsForDevices;
  };
};

/** device response */
export type HintsForDeviceResponse = ApiSuccessResponse & {
  data?: HintsForDevice;
};

/** capability response */
export type HintsForCapabilityResponse = ApiSuccessResponse & {
  /** SmartThings capabilities with component */
  data?: HintsForCapability;
};

/** voice intents response */
export type HintsForVoiceIntentsResponse = ApiSuccessResponse & {
  data?: HintsForVoiceIntents;
  _links?: {
    next?: {
      /** @example "https://{url}/hints/voiceintents?page=3" */
      href?: string;
    };
    previous?: {
      /** @example "https://{url}/hints/voiceintents?page=1" */
      href?: string;
    };
  };
};

/** voice intent response */
export type HintsForVoiceIntentResponse = ApiSuccessResponse & {
  data?: HintsForVoiceIntent;
};

export type HintsForDevices = HintsForDevice[];

export interface HintsForDevice {
  /**
   * The device ID
   * @example "376fe8cb-4556-432e-9187-ac5d35e150f0"
   */
  id: string;
  /**
   * The device name
   * @example "Ceiling Light"
   */
  name: string;
  /**
   * The device nickname
   * @example "Living room light"
   */
  alias?: string;
  /**
   * The device type
   * @example "oic.d.light"
   */
  type: string;
  /**
   * The device type's representative name
   * @example "light"
   */
  typeName: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /**
   * The room name
   * @example "Living room"
   */
  roomName?: string;
  /** SmartThings capabilities */
  capabilities?: HintsForCapability[];
  /** OCF resources */
  ocfResources?: HintsForOcfResources[];
}

/** SmartThings capabilities with component */
export interface HintsForCapability {
  /**
   * SmartThings capability
   * @example "colorcontrol"
   */
  capability?: string;
  /**
   * Component of the device
   * @example "main"
   */
  component?: string;
  voiceIntents?: HintsForVoiceIntent[];
}

/** OCF resource */
export interface HintsForOcfResources {
  /**
   * resource
   * @example "/color/vs/0"
   */
  href?: string;
  voiceIntents?: HintsForVoiceIntent[];
}

export interface HintsForVoiceIntents {
  voiceIntents?: HintsForVoiceIntent[];
  /** @example 3 */
  pageIdNext?: number;
  /** @example 2 */
  pageIdCurr?: number;
  /** @example 1 */
  pageIdPrev?: number;
  /** @example 5 */
  totalPages?: number;
}

export type HintsForVoiceIntent = VoiceIntentInfo & {
  /** Hint array */
  hints?: string[];
};

/** voice intents and hints for them */
export interface VoiceIntentInfo {
  /**
   * Voice capability
   * @example "color control"
   */
  capability?: string;
  /**
   * Voice capability action
   * @example "setcolor"
   */
  action?: string;
  /**
   * Voice capability enumeration
   * @example "blue"
   */
  enumeration?: string;
  /**
   * Voice capability method type
   * @example "post"
   */
  method?: string;
  /** Voice capability parameter information */
  parameters?: Parameter[];
  /** Voice capability description */
  description?: string;
  /**
   * Voice capability type
   * @example "VOICE_INTENT"
   */
  capabilityType?: string;
  /**
   * The hint weight value
   * @format float
   * @min 0
   * @max 1
   * @example 0.5
   */
  score?: number;
}

/** voice capability parameter */
export interface Parameter {
  /**
   * parameter key name
   * @example "number"
   */
  name?: string;
  /**
   * parameter value type
   * @example "integer"
   */
  type?: string;
  /**
   * whether the value is optional or not
   * @example true
   */
  optional?: boolean;
}

/** vocab response */
export type VocabsDataResponse = ApiSuccessResponse & {
  /** Bixby vocabulary concepts */
  data?: VocabsTypesResponse;
};

/** Bixby vocabulary concepts */
export interface VocabsTypesResponse {
  /** List of Bixby vocabulary concepts */
  types?: VocabsResponse;
}

/** List of Bixby vocabulary concepts */
export type VocabsResponse = Concept[];

export interface Concept {
  /**
   * Name of Bixby vocabulary concept
   * @example "CapabilityName"
   */
  type?: string;
  /** List of Bixby vocabulary symbol */
  vocabs?: {
    /**
     * Name of Bixby vocabulary symbol
     * @example "CP_COLOR"
     */
    value?: string;
    /**
     * Vocabulary
     * @example "color"
     */
    vocab?: string;
  }[];
}

export type DialoguesForVoiceIntent = VoiceIntentInfo & {
  /** dialogues for the voice intent */
  dialogues?: {
    handsFree?: ListenerDialogue[];
    handsOn?: ListenerDialogue[];
  };
};

/** dialogue response */
export type DialoguesForVoiceIntentResponse = ApiSuccessResponse & {
  data?: DialoguesForVoiceIntent;
};

/** dialogue item */
export interface ListenerDialogue {
  /**
   * Dialog (NLG) ID used for smartThingsApp capsule
   * @example "Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes"
   */
  dialogueId?: string;
  /**
   * Dialog (NLG) defined for used in smartThingsApp capsule
   * @example "I'm setting the #{Capability} for #{Keyword} to #{Value}."
   */
  template?: string;
  /** The information of parameters used in template string */
  parameters?: {
    '<paramKey>'?: {
      /** Name of Bixby concept */
      type?: string;
      /** additional data for vocab type */
      vocabData?: {
        /** candidated vocabulary types for vocab type */
        supportedTypes?: string[];
        /** specific vocabulary type */
        type?: string;
        /** Name of Bixby symbol */
        value?: string;
        /** vocabulary text */
        vocab?: string;
      };
      /** additional data for system type */
      systemData?: {
        /** specific system vocabulary type */
        type?: string;
      };
      /** additional data for number type */
      numberData?: {
        /** specific number unit vocabulary type */
        unitType?: string;
      };
      /** additional data for any type */
      anyData?: {
        /** candidated vocabulary types for vocab type */
        supportedTypes?: string[];
        /** specific number unit vocabulary type */
        unitType?: string;
      };
    };
  };
}

/** success response */
export interface ApiSuccessResponse {
  /**
   * detailed success code
   * @example 2000000
   */
  code?: number;
  /**
   * success title
   * @example "SUCCESS"
   */
  message?: string;
}

/** error response */
export interface ApiErrorResponse {
  /** detailed error code */
  code: number;
  /** error title */
  message: string;
  /** detailed error message */
  data?: string;
}

/**
 * request body to generate NLG
 * @example {"handsFree":[{"dialogueId":"Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes","parameters":{"Keyword":[{"type":"system","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null}],"Capability":[{"type":"vocab","vocabData":{"type":"CapabilityName","value":"CP_TEMPERATURE"},"systemData":null,"numberData":null,"anyData":null}],"Value":[{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"24","unitType":"UNIT_TEMP_DEGREES"},"anyData":null},{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"30","unitType":"UNIT_TEMP_DEGREES"},"anyData":null}]}}],"handsOn":[{"dialogueId":"Rev_SamsungIoT_13_5_SetValue_GoalSuccessful_YesOrNo_Yes","parameters":{}}]}
 */
export interface DialogueNLGRequest {
  handsFree: DialogueWithParameterList[];
  handsOn: DialogueWithParameterList[];
}

/**
 * generated NLG
 * @example {"code":"2000000,","message":"SUCCESS","data":{"handsFree":[{"dialogueId":"Rev_SamsungIoT_SPK_13_11_SetValue_GoalSuccessful_YesOrNo_Yes","templates":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"parameters":{"Keyword":{"type":"system","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Capability":{"type":"vocab","vocabData":{"value":"temperature"},"systemData":null,"numberData":null,"anyData":null},"Value":{"type":"number","vocabData":null,"systemData":null,"numberData":{"value":"24 degrees and 30 degrees"},"anyData":null}}}],"handsOn":[{"dialogueId":"Rev_SamsungIoT_13_5_SetValue_GoalSuccessful_YesOrNo_Yes","templates":["Okay"],"parameters":{}}]}}
 */
export type DialogueNLGResponse = ApiSuccessResponse & {
  data?: {
    handsFree: Dialogue[];
    handsOn: Dialogue[];
  };
};

/** The information of parameters used in template string */
export interface DialogueParameter {
  '<paramKey>'?: ParameterObject;
}

export interface ParameterObject {
  /** parameter type */
  type: string;
  /** description */
  description?: string;
  /** additional data for vocab type */
  vocabData?: {
    /** candidated vocabulary types for vocab type */
    supportedTypes?: string[];
    /** specific vocabulary type */
    type?: string;
    /** Name of Bixby symbol */
    value?: string;
    /** vocabulary text */
    vocab?: string;
  };
  /** additional data for system type */
  systemData?: {
    /** specific system vocabulary type */
    type?: string;
  };
  /** additional data for number type */
  numberData?: {
    /** specific number unit vocabulary type */
    unitType?: string;
  };
  /** additional data for any type */
  anyData?: {
    /** candidated vocabulary types for vocab type */
    supportedTypes?: string[];
    /** specific number unit vocabulary type */
    unitType?: string;
  };
}

/** dialogue item */
export type Dialogue = DialogueRequest & {
  /** Dialogue (NLG) ID used for smartThingsApp capsule */
  dialogueId: string;
};

/** dialogue item */
export interface DialogueWithParameterList {
  /** Dialogue (NLG) ID used for smartThingsApp capsule */
  dialogueId: string;
  /** The information of parameters used in template string */
  parameters: {
    '<paramKey>'?: ParameterObject[];
  };
}

/**
 * dialogue item
 * @example {"origin":"custom","mnmn":"Samsung Electronics","mode":null,"goalId":null,"voiceintents":["color control-setColor-blue"],"description":"custom dialogue for color control","templates":null,"templatesByLocale":{"en":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"ko-KR":["#{Keyword} #{Capability}(을)를 #{Value}(으)로 설정할게요."]},"defaultDialogueId":"Rev_SamsungIoT_SPK_0_125_CommonCheck_TargetAction_Match_DeviceControl","defaultDialogue":{"de-DE":["Ok, gut."],"en":["Okay."],"es-ES":["¡Hecho!"],"fr-FR":["D’accord, c’est noté."],"it-IT":["Ok, capito."],"ko-KR":["네, 알겠어요."],"pt-BR":["Ok!"],"zh-CN\"":["没问题。"]},"parameters":{"Keyword":{"type":"system","description":"device parameter","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Capability":{"type":"vocab","description":"capability parameter","vocabData":{"supportedTypes":["CapabilityName"]},"systemData":null,"numberData":null,"anyData":null},"Value":{"type":"number","description":"result value parameter","vocabData":null,"systemData":null,"numberData":{"unitType":"UNIT_TEMP_DEGREES"},"anyData":null}}}
 */
export interface DialogueRequest {
  /**
   * origin for dialogue template
   * @example "custom"
   */
  origin: string;
  /**
   * manufacturer name
   * @example "Samsung Electonics"
   */
  mnmn: string;
  /**
   * bixby invoke mode
   * @example "handsFree"
   */
  mode?: 'handsOn' | 'handsFree';
  /**
   * dialogue MWUC goal ID. defined only in system dialogues
   * @example "SamsungIoT_0"
   */
  goalId?: string;
  /** description */
  description?: string;
  /**
   * Voice Intent :(voice capability)-(voice action)-(voice enumeration)
   * @example ["color control-setColor-blue"]
   */
  voiceintents?: string[];
  /** Dialogue for requested language (filled when Accept-Langauge is not null) */
  templates?: string[];
  /** Dialogues for all supported languages (filled when Accept-Language is * or null) */
  templatesByLocale?: {
    /** Dialogue (NLG) defined for used in smartThingsApp capsule by locale */
    '<locale>'?: string[];
  };
  /** Default dialogue ID. Used when language is not supported in the current dialogue ID (filled when Accept-Language is * or null) */
  defaultDialogueId?: string;
  /** Default dialogues for all supported languages (filled when Accept-Language is * or null) */
  defaultDialogue?: {
    /** default dialogue (NLG) defined for used in smartThingsApp capsule by locale */
    '<locale>'?: string[];
  };
  /** The information of parameters used in template string */
  parameters: DialogueParameter;
}

/** dialogue list */
export type DialogueListResponse = ApiSuccessResponse & {
  data?: {
    /**
     * response data
     * @example [{"dialogueId":"custom_Samsung_Electronics_abcd","origin":"custom","mnmn":"Samsung Electronics","mode":null,"goalId":null,"voiceintents":["color control-setColor-blue"],"description":"custom dialogue for color control","templates":null,"templatesByLocale":{"en":["I'm setting the #{Capability} for #{Keyword} to #{Value}."],"ko-KR":["#{Keyword} #{Capability}(을)를 #{Value}(으)로 설정할게요."]},"defaultDialogueId":"Rev_SamsungIoT_SPK_0_125_CommonCheck_TargetAction_Match_DeviceControl","defaultDialogue":{"de-DE":["Ok, gut."],"en":["Okay."],"es-ES":["¡Hecho!"],"fr-FR":["D’accord, c’est noté."],"it-IT":["Ok, capito."],"ko-KR":["네, 알겠어요."],"pt-BR":["Ok!"],"zh-CN\"":["没问题。"]},"parameters":{"Capability":{"type":"any","description":"capability parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}},"Keyword":{"type":"system","description":"device parameter","vocabData":null,"systemData":{"type":"Device"},"numberData":null,"anyData":null},"Value":{"type":"any","description":"result value parameter","vocabData":null,"systemData":null,"numberData":null,"anyData":{"unitType":"Unit","supportedTypes":["AppName","CapabilityName","CapabilityValue","Compartment","RVCLocation","RVCObject"]}}}}]
     */
    dialogues?: Dialogue[];
  };
};

/** scenes response */
export type HintsForScenesResponse = ApiSuccessResponse & {
  /** Hints for all scenes */
  data?: HintsForScenes;
};

/** Hints for all scenes */
export interface HintsForScenes {
  targets?: HintsForScenesTarget[];
}

/** scene response */
export type HintsForSceneResponse = ApiSuccessResponse & {
  /** hints for each scene */
  data?: HintsForScenesTarget;
};

/** hints for each scene */
export interface HintsForScenesTarget {
  /**
   * The scene ID
   * @example "22fd3dea-3724-4915-b9ab-d6c3fe275245"
   */
  id: string;
  /**
   * The scene name
   * @example "Good morning"
   */
  name: string;
  /**
   * The location ID
   * @example "3872090a-bf3c-4fad-896a-8b8090f15a7c"
   */
  locationId: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /** Hint array */
  hints?: string[];
}

/** locations response */
export type HintsForLocationsResponse = ApiSuccessResponse & {
  /** Locations resonse data */
  data?: HintsForLocations;
};

/** Locations resonse data */
export interface HintsForLocations {
  locations?: HintsForLocation[];
}

/** locations response */
export type HintsForLocationResponse = ApiSuccessResponse & {
  /** app and grouupintents for all locations */
  data?: HintsForLocation;
};

/** app and grouupintents for all locations */
export interface HintsForLocation {
  /**
   * The Location ID
   * @example "b11688ef-54f4-49da-8854-13dd27140b43"
   */
  locationId: string;
  /**
   * The Location name
   * @example "My home"
   */
  locationName: string;
  /** Array of the hints for the ST app related commands */
  apps: HintsForLocationApp[];
  /** Array of the hints for the location or room related commands */
  groupIntents?: HintsForLocationGroupIntent[];
}

/** Array of the hints for the location or room related commands */
export interface HintsForLocationGroupIntent {
  /**
   * The room ID. If these roomID and roomName are null, the hints in this object are for the location
   * @example "2adff38d-d457-433e-ada9-1a0fd49cbc36"
   */
  roomId: string;
  /**
   * The room name
   * @example "Hall"
   */
  roomName: string;
  voiceIntents?: HintsForVoiceIntent[];
}

/** Array of the hints for the ST app related commands */
export interface HintsForLocationApp {
  /** Goal names for hint */
  goal: 'AddDevice' | 'ShowLists' | 'ShowAutomations' | 'ShowSupportedDeviceList';
  /** Voice capability parameter information */
  parameters?: Parameter[];
  /** Voice capability description */
  description?: string;
  /** Voice capability type */
  capabilityType: 'DEEP_LINK';
  /** Hint array */
  hints?: string[];
}

/** automation creation response */
export type HintsForAutomationCreationResponse = ApiSuccessResponse & {
  /** automation hints for all target devices */
  data?: HintsForAutomationCreation;
};

/** automation hints for all target devices */
export interface HintsForAutomationCreation {
  targets?: HintsForAutomationCreationTarget[];
}

/** Array of the hints to create automation for each device */
export interface HintsForAutomationCreationTarget {
  /**
   * The Device ID
   * @example "376fe8cb-4556-432e-9187-ac5d35e150f0"
   */
  id: string;
  /**
   * The Device name
   * @example "Ceiling Light"
   */
  name: string;
  /**
   * Recommended name for calling this device
   * @example "Living room light"
   */
  alias?: string;
  /**
   * OCF device type
   * @example "oic.d.light"
   */
  type?: string;
  /**
   * Device type in natural language. It is translated to the selected language
   * @example "light"
   */
  typeName?: string;
  /**
   * The location name
   * @example "My home"
   */
  locationName: string;
  /**
   * The location ID
   * @example "a7973ba6-0743-45ba-b777-aca216cbd780"
   */
  locationId: string;
  /** the automation hints */
  voiceIntents?: HintsForAutomationCreationVoiceIntents[];
}

/** hints for each capability action */
export type HintsForAutomationCreationVoiceIntents = AutomationCreationVoiceIntent & {
  /** Hint array */
  hints?: string[];
};

/** capability action details */
export interface AutomationCreationVoiceIntent {
  /**
   * Currently supported powerSwitch-on-, powerSwitch-off-, cleaningmode-auto-
   * @example "powerswitch"
   */
  capability: string;
  /**
   * Voice cap-ability action
   * @example "on"
   */
  action: string;
  /**
   * Voice capability enumeration
   * @example "powerswitch-on-"
   */
  enumeration?: string;
  /** Voice capability description */
  automationType?: 'Time' | 'TimeAndDate' | 'TimeRepetition' | 'GeoLocation' | 'Weather';
  /** Voice capability method type */
  method: 'POST' | 'GET';
}

export interface RestResponseUserPIIGetRequest {
  /** @format int32 */
  code: number;
  data?: GDPRTransactionRes;
  message: string;
}

export interface RestResponseUserPIIDeleteRequest {
  /** @format int32 */
  code: number;
  message: string;
}

export interface RestResponseUserPIIGetDeleteStatusRequest {
  /** @format int32 */
  code: number;
  data?: GDPRDeleteStatusRes;
  message: string;
}

export interface GDPRTransactionRes {
  /** Transaction id corresponding to the request made for future status check */
  transactionId: string;
  /** Request time of the request made to GDPR service */
  requestTime: string;
  /** Status of the Request made */
  status: 'PROCESSING' | 'FAIL' | 'COMPLETED' | 'NOTIFIED' | 'IGNORED' | 'DISABLED';
  /** Prre-signed url for the output user pii data file for "A" eventType */
  preSignedUrl?: string;
  /** Location for the output user pii data file for "A" eventType */
  data?: string;
  /** Type of event - access("A")/erasure("E") */
  eventType: string;
  /** Type of Compliance law */
  channel: string;
  /**
   * Size of the output user pii data file for "A" eventType
   * @format int32
   */
  fileSize?: number;
}

export interface GDPRDeleteStatusRes {
  /** Saguid of the used who requested the pii data DELETE */
  saguid: string;
  /** Status of previous pii data DELETE request made by user */
  status: 'COMPLETED' | 'NOT_REQUESTED' | 'FAILED' | 'PROCESSING';
}

/** howtouselist response body */
export type ListHowToUseResponse = HowToUse[];

/**
 * HowToUse object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"howtouse example","title":"HowToUse Example","description":"HowToUse description.","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","countryCodeId":"US","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/article/ffffd976ffb727001abc7eed?t=1582196980463","serveIfReqLngNotFound":false,"serviceProviderId":"none","updatedAt":1582196980463,"deepLink":"none","weight":9,"author":"","location":"","date":"2018-06-07"}
 */
export interface HowToUse {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  image: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /**
   * `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc).
   */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other service providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  deepLink:
    | 'none'
    | 'automation'
    | 'scene'
    | 'invitation'
    | 'video'
    | 'fme'
    | 'galaxyx'
    | 'androidauto'
    | 'galaxywatch4'
    | 'findlba'
    | 'seuk_find'
    | 'seuk_voice'
    | 'seuk_personalisation'
    | 'offline_diagnostics';
  /**
   * @min 0
   * @max 100
   */
  weight: number;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  author?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  howToUseLink?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  howToUseLinkType?: string;
  /** `deprecated` - not supported in the latest GSE Admin Console, might be exists in older contents. */
  location?: string;
  /** start date : "2021-06-07" */
  date?: string;
}

/** notificationslist response body */
export type GSListNotificationResponse = GSNotification[];

/**
 * Notification object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"notification example","title":"Notification Example","description":"Notification description.","countryCodeId":"US","date":"2019-07-22","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/notification/ffffd976ffb727001abc7eed?t=1564378172835","serveIfReqLngNotFound":true,"serviceProviderId":"none","updatedAt":1564378172835,"weight":39}
 */
export interface GSNotification {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  date: string;
  /** `othersp`: For other sevice providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  /**
   * @min 0
   * @max 100
   */
  weight: number;
}

/**
 * Video object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"video example","title":"Video Example","description":"Video description.","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","countryCodeId":"US","languageCodeId":"en","link":"https://samsung-connect.samsungiotcloud.com/webview/article/ffffd976ffb727001abc7eed?t=1582196980463","serveIfReqLngNotFound":false,"serviceProviderId":"none","updatedAt":1582196980463,"deepLink":"none","weight":9}
 */
export interface Video {
  document_id: string;
  adminTitle: string;
  title: string;
  description?: string;
  image: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  link: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other sevice providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  deepLink: 'none' | 'automation' | 'scene' | 'invitation' | 'video' | 'fme';
  /**
   * @min 0
   * @max 100
   */
  weight: number;
}

/** videolist response body */
export type ListVideoResponse = Video[];

/**
 * HeroBanner object structure
 * @example {"document_id":"ffffd976ffb727001abc7eed","adminTitle":"herobanner example","title":"HeroBanner Example","titleColor":"#FFFFFF","subTitle":"HeroBanner Subtitle","subTitleColor":"#FFFFFF","description":"HeroBanner description.","descriptionColor":"#FFFFFF","countryCodeId":"US","languageCodeId":"en","serveIfReqLngNotFound":true,"serviceProviderId":"none","periodToDisplayStartDate":"2018-06-11","periodToDisplayEndDate":"2023-06-11","image":"https://samsung-connect.samsungiotcloud.com/bucket/example/image.png","tabletImage":"https://samsung-connect.samsungiotcloud.com/bucket/example/tabletImage.png","weight":10,"updatedAt":1529010550549,"link":"https://librarian-regionals.smartthingsgdev.com/api","linkType":"web"}
 */
export interface HeroBanner {
  document_id: string;
  adminTitle: string;
  title: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  titleColor?: string;
  subTitle?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  subTitleColor?: string;
  description?: string;
  /**
   * `not included` in the response when the value is empty string `""`.
   * @pattern /^#[a-f0-9]+$/i
   */
  descriptionColor?: string;
  /** `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc). */
  countryCodeId?: string;
  /** `ISO 639-1` Language Code (example: en, ko, zh, etc). */
  languageCodeId?: string;
  serveIfReqLngNotFound: boolean;
  /** `othersp`: For other sevice providers that is not listed */
  serviceProviderId: 'none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp';
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayStartDate: string;
  /**
   * `ISO 8601` date with format `YYYY-MM-DD`.
   * @format date
   */
  periodToDisplayEndDate: string;
  image: string;
  tabletImage?: string;
  /**
   * @min 1
   * @max 100
   */
  weight: number;
  /** `Unix Time Stamp` for last update in milliseconds. */
  updatedAt: number;
  link: string;
  linkType: 'web' | 'app' | 'deepLink' | 'appIntent';
}

/** herobannerlist response body */
export type ListHeroBannerResponse = HeroBanner[];

export interface IndoormapPUT {
  building: MapBuilding;
  floors: {
    /** @example "1" */
    name: string;
    /** @minItems 1 */
    rooms: MapRoom[];
    openings?: MapOpening[];
    objects?: MapObject[];
  }[];
}

export type Indoormap = {
  /** @example "4604c328-8040-405a-ad69-0b9cd7416ea3" */
  id: string;
} & IndoormapPUT;

/**
 * Full address
 * @example "경기도 화성시 능동 1066-2"
 */
export type FullAddress = string;

/**
 * Road name based address
 * @example "경기도 화성시 동탄원천로 354-14"
 */
export type RoadAddress = string;

/**
 * type of this object
 * @example "SMARTAPARTMENT"
 */
export enum BuildingType {
  APARTMENT = 'APARTMENT',
  HOUSESTORECOMPLEX = 'HOUSESTORECOMPLEX',
  OFFICETEL = 'OFFICETEL',
  SMARTAPARTMENT = 'SMARTAPARTMENT',
}

export interface MapBuilding {
  /**
   * id of a building
   * @example "4604c328-8040-405a-ad69-0b9cd7416ea3"
   */
  id: string;
  /** @example "동탄아르젠2차" */
  name: string;
  /** type of this object */
  buildingType?: BuildingType;
  /**
   * type of the indoormap
   * @example "61.41A"
   */
  type?: string;
  address?: {
    /** Full address */
    fullAddress: FullAddress;
    /** Road name based address */
    roadAddress?: RoadAddress;
  };
  geolocation?: Geolocation;
  /** Real Area Information of the Physical Space of the House */
  size?: MapSize;
  floors: MapFloors;
  images?: MapImage[];
}

/**
 * Real Area Information of the Physical Space of the House
 * @example 61.41
 */
export type MapSize = number;

/** Size of an indoormap image in pixel */
export interface MapImage {
  url?: string;
  /** @example "1" */
  floor: string;
  /** @example 897 */
  width: number;
  /** @example 672 */
  height: number;
}

/**
 * @default "1"
 * @example "1"
 */
export type MapFloor = string;

export interface MapRoom {
  /**
   * Id of a room
   * @example "room_00001"
   */
  id: string;
  plane: {
    /** @example "plane_00001" */
    id: string;
    coordinates: MapCoordinates;
  };
  walls?: MapWall[];
  properties: {
    /** @example "LIVINGROOM" */
    category:
      | 'DUCT'
      | 'LIVINGROOM'
      | 'CLOSET'
      | 'BATHROOM'
      | 'BEDROOM'
      | 'KITCHEN'
      | 'TERRACE'
      | 'BALCONY'
      | 'ENTRANCE'
      | 'UNKNOWN';
    /**
     * @default true
     * @example true
     */
    visible: boolean;
  };
}

export interface MapWall {
  /** @example "wall_00001" */
  id: string;
  coordinates: MapCoordinates;
}

export interface MapOpening {
  /**
   * id of opening
   * @example "opening_00001"
   */
  id: string;
  coordinates: MapCoordinates;
  properties: {
    /** @example "WINDOW" */
    category: 'WINDOW' | 'DOOR';
    /** @example ["wall_00001","wall_00011"] */
    groups: string[];
    /**
     * @default true
     * @example true
     */
    visible: boolean;
  };
}

/** @example [[208,0,588],[208,0,654],[99,0,654],[99,0,588]] */
export type MapCoordinates = MapCoordinate[];

/**
 * @maxItems 3
 * @minItems 3
 */
export type MapCoordinate = number[];

export interface PagedAddresses {
  items?: BlueprintAddress[];
  _links?: Links;
}

export interface BlueprintAddress {
  /**
   * id of the address
   * @example "04c3f971-fbef-4faf-b4ee-a8b3b37adba0"
   */
  id: string;
  /** @example "동탄아르젠2차" */
  name: string;
  /** type of this object */
  buildingType?: BuildingType;
  /** Full address */
  fullAddress: FullAddress;
  /** Road name based address */
  roadAddress?: RoadAddress;
  geolocation?: Geolocation;
}

export interface AddressTypes {
  items?: AddressType[];
}

/**
 * type of the indoormap
 * @example "32A"
 */
export type IndoormapType = string;

/**
 * @minItems 1
 * @example ["B2","B1","1","2"]
 */
export type MapFloors = MapFloor[];

export interface AddressType {
  /**
   * id of the address
   * @example "04c3f971-fbef-4faf-b4ee-a8b3b37adba0"
   */
  addressId: string;
  /** type of the indoormap */
  type: IndoormapType;
  floors: MapFloors;
  /** Real Area Information of the Physical Space of the House */
  size?: MapSize;
  images?: MapImage[];
  /**
   * id of an indoormap
   * @example "4604c328-8040-405a-ad69-0b9cd7416ea3"
   */
  indoormapId: string;
}

export interface MapObject {
  /**
   * id of opening
   * @example "object_00001"
   */
  id: string;
  coordinates: {
    position?: MapCoordinate;
    size?: MapObjectSize;
    rotation?: MapRotation;
  };
  properties: {
    /** @example "furniture_00001" */
    resourceId: string;
    /**
     * @default true
     * @example true
     */
    visible?: boolean;
  };
}

/**
 * @maxItems 3
 * @minItems 3
 */
export type MapRotation = number[];

/**
 * @maxItems 3
 * @minItems 3
 */
export type MapObjectSize = number[];

export interface Geolocation {
  /**
   * latitude of geographical location of the building
   * @example 37
   */
  latitude?: number;
  /**
   * longitude of geographical location of the building
   * @example 127
   */
  longitude?: number;
}

export interface PagedIndoormapIds {
  items?: IndoormapId[];
}

export interface IndoormapId {
  /** @example "4604c328-8040-405a-ad69-0b9cd7416ea3" */
  id?: string;
}

export interface GetAPDetailResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Available response data */
  data?: APDetailResponse[];
  /** Response result message */
  message?: string;
}

export interface GetConsentResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  data?: ConsentObject;
  /** Response result message */
  message?: string;
}

export interface GetUserSettingResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  data?: UserSettingObject;
}

export interface PostAPDetailResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Any failure data during request execution */
  data?: APDetailErrorResponse[];
  /** Response result message */
  message?: string;
}

export interface PostDeviceAPErrorResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Any failure data during request execution */
  data?: DeviceAPErrorObject[];
}

export interface GeneralPostResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
}

export interface GeneralPostResponseWithData {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Response related message */
  data?: string;
}

export interface GetAllAPDetailsResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Available response data */
  data?: APDetailResponse[];
  /** Response result message */
  message?: string;
}

export interface GetAllDeviceAPDetailsResponse {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response result message */
  message?: string;
  /** Available response data */
  data?: DeviceAPRequest[];
}

export interface APDetail {
  /** ssid associated with the AP. */
  ssid?: string;
  /** MAC address of the AP. */
  bssid?: string;
  /** SHA512 MAC address of the AP. */
  hashedBssid?: string;
  /** probable location id for AP. */
  locationId?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency?: number;
  /** List of device ids connected to the AP. */
  deviceIds?: string[];
  /** List of DeviceIdWithTimestamp objects having device ids and onboarding timestamp connected to the AP. */
  deviceIdWithTimestampList?: DeviceIdWithTimestamp[];
  /** Capability of the AP separated by space or other separator. */
  capabilities?: string;
  /** Password of the AP. */
  passphrase?: string;
  /**
   * Created time (epoch time in milliseconds) for ap details at client.
   * @format int64
   */
  timestamp?: number;
  /** Hidden AP recognition. */
  hiddenStatus?: boolean;
}

export interface OcfDeviceAPRequest {
  /** List of Device AP objects */
  deviceAPRequests?: DeviceAPRequest[];
}

export interface DeviceAPRequest {
  /** deviceId associated with the AP. It can only be a uuid string. */
  deviceId: string;
  /** ssid associated with the AP. */
  ssid: string;
  /** MAC address of the AP. */
  bssid?: string;
  /** SHA512 MAC address of the AP. */
  hashedBssid?: string;
  /**
   * Integer code of raw security.
   * @format int32
   */
  securityCode: number;
  /** raw security type. */
  security?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency: number;
  /**
   * Last updated timestamp (epoch time in milliseconds) for device ap details at client.
   * @format int64
   */
  timestamp: number;
  /** Password of the AP. */
  passphrase?: string;
  /** Hidden AP recognition. */
  hiddenStatus: boolean;
  /**
   * Number of times the AP has been used by devices.
   * @format int32
   */
  noOfDevices?: number;
}

export type KeyList = string[];

export type DeviceKeyList = string[];

export interface OcfDeviceKeyList {
  deviceIds?: string[];
}

/** ssids for which AP filtering is done for a user in Wifilocker. */
export type APDetailsFilterRequest = string;

export interface ConsentObject {
  /** Wifi Locker enable/disable setting for a user */
  enabled?: boolean;
}

export interface UserSettingObject {
  /** Wifi Locker setting value for a user. Currently, 0 - unknown, 1 - allow, 2 - deny. */
  enabled: number;
}

export interface APDetailResponse {
  /** ssid associated with the AP */
  ssid?: string;
  /** MAC address of the AP */
  bssid?: string;
  /** SHA512 MAC address of the AP */
  hashedBssid?: string;
  /** probable location id for AP */
  locationId?: string;
  /** List of device ids connected to the AP. */
  deviceIds?: string[];
  /** List of DeviceIdWithTimestamp objects having device ids and onboarding timestamp connected to the AP. */
  deviceIdWithTimestampList?: DeviceIdWithTimestamp[];
  /** Capability of the AP separated by space or other separator */
  capabilities?: string;
  /** Password of the AP. */
  passphrase?: string;
  /**
   * Frequency of the AP. Frequency unit is MHz.
   * @format int32
   */
  frequency?: number;
  /** Hidden AP recognition. */
  hiddenStatus?: boolean;
  /**
   * Timestamp (epoch time in milliseconds) for ap detail at client when any client is plaaning to make a server data update.
   * @format int64
   */
  timestamp?: number;
  /**
   * Updated time for ap detail. This time indicates that when for the last time (epoch time in milliseconds) AP detail has been updated at server.
   * @format int64
   */
  updateTime?: number;
}

export interface APDetailErrorResponse {
  /** ssid associated with the requested AP. */
  ssid?: string;
  /** SHA512 MAC address of the requested AP. */
  bssid?: string;
  /**
   * Timestamp (epoch time in milliseconds) for ap detail at client when any client is plaaning to make a server data update.
   * @format int64
   */
  timestamp?: number;
  /** Details about the error because of which add/update of AP details didn't work. */
  errorMessage?: string;
}

export interface DeviceAPErrorObject {
  /** ssid associated with the requested AP. */
  ssid: string;
  /** SHA512 MAC address of the requested AP. */
  bssid: string;
  /** device id of the requested AP. */
  deviceId: string;
  /** Details about the error because of which add/update of AP details didn't work. */
  errorMessage: string;
}

export interface DeviceIdWithTimestamp {
  /** device id connected to AP. */
  deviceId?: string;
  /**
   * Onboarding timestamp of device in milliseconds.
   * @format int64
   */
  onboardingTimestamp?: number;
}

export interface Application {
  deviceID?: string;
  publicKey?: string;
  userID?: string;
}

export interface Auth {
  authorizationURL?: string;
  clientID?: string;
  redirectURL?: string;
  responseType?: string;
  scopes?: string[];
}

export interface AvailableDevice {
  id?: string;
  providers?: AvailableProvider[];
}

export interface AvailableValidateDevice {
  id?: string;
  providerIds?: string[];
}

export interface ValidateDeviceBody {
  deviceIds?: string[];
  country?: string;
  providerIds?: string[];
}

export interface ValidateMetricBody {
  sessionType: 'created' | 'existing' | 'removed';
  providerId: string;
  /** @example "tv" */
  device?: string;
  result: 'success' | 'failure';
}

export interface AvailableValidateDeviceResponse {
  devices?: AvailableValidateDevice[];
}

export interface AvailablePlayersResponse {
  devices?: AvailableDevice[];
}

export interface AvailableProvider {
  id?: string;
}

export interface Content {
  context?: string;
  cursor?: string;
  items?: Item[];
  /** @format int64 */
  limit?: number;
  /** @format int64 */
  offset?: number;
  operation?: string;
  /** @format int64 */
  progress?: number;
  /** @format int64 */
  total?: number;
}

export interface ContentProvider {
  applications?: ProviderApplication[];
  auth?: Auth;
  companyName?: string;
  country?: string[];
  description?: string;
  /** @format int64 */
  displayOrder?: number;
  icon?: {
    /** @format int64 */
    height?: number;
    url?: string;
    /** @format int64 */
    width?: number;
  }[];
  id?: string;
  isLocal?: boolean;
  /** @format int64 */
  lastUpdateTime?: number;
  name?: string;
  supportedContentTypes?: string[];
  type?: string;
  url?: string;
  version?: string;
}

export interface ContentProviderList {
  providers?: ContentProvider[];
}

export interface Session {
  sessionId?: string;
  deviceId?: string;
  providerId?: string;
  contents?: string;
  /** @format date-time */
  timestamp?: string;
}

export interface SessionList {
  sessions?: Session[];
}

export type ContentProviderMap = Record<string, ContentProvider>;

export type Contents = object;

export interface Credentials {
  authUrl?: string;
  blob?: string;
  clientID?: string;
  linkedUserID?: string;
  userID?: string;
  userName?: string;
}

export interface CurrentlyPlayingTrack {
  context?: object;
  is_playing?: boolean;
  item?: object;
  /** @format int64 */
  progress_ms?: number;
}

export interface Description {
  albumArtist?: string[];
  albumTitle?: string;
  artist?: string[];
  /** @format int64 */
  duration?: number;
  images?: Image[];
  releaseDate?: string;
  title?: string;
  /** @format int64 */
  trackNumber?: number;
  type?: string;
}

export interface DeviceBody {
  action?: string;
  contents?: Contents;
  credentials?: Credentials;
  sessionID?: string;
}

export interface DeviceResponse {
  'x.com.samsung.ccv'?: string;
  'x.com.samsung.currentRenderer'?: string;
  'x.com.samsung.renderers'?: Renderer[];
  'x.com.samsung.uid'?: string;
}

export interface ErrorMessage {
  code?: string;
  details?: ErrorMessage[];
  message?: string;
  target?: string;
}

export interface Image {
  /** @format int64 */
  height?: number;
  url?: string;
  /** @format int64 */
  width?: number;
}

export interface Item {
  description?: Description;
  id?: string;
  item?: string;
}

export interface PlaybackInfo {
  device?: Device;
  is_Playing?: boolean;
  playedAt?: string;
}

export interface Player {
  Cp_di?: string;
  Cpid?: string;
  Data?: string;
  Id?: string;
}

export interface PlayingTrack {
  context?: object;
  item?: object;
}

export interface ProviderApplication {
  appURI?: string;
  deviceType?: string;
  fingerprint?: string;
  id?: string;
  installable?: boolean;
  manufacturerName?: string;
  modelName?: string[];
  name?: string;
  os?: string;
  osVersion?: string[];
  packageName?: string;
  platformVersion?: string[];
}

export interface ProviderData {
  Data?: string;
  /** @format date-time */
  UpdateTime?: string;
}

export interface ProviderVO {
  Data?: string;
  Enabled?: string;
  Id?: string;
}

export interface RecentlyPlayingTrack {
  context?: object;
  played_at?: string;
  track?: object;
}

export interface RecentlyPlayingTracks {
  items?: RecentlyPlayingTrack[];
}

export interface Renderer {
  action?: string;
  appURI?: string;
  application?: Application;
  contents?: Contents;
  credentials?: Credentials;
  fingerprint?: string;
  id?: string;
  name?: string;
  packageName?: string;
  /** @format int64 */
  result?: number;
  sessionID?: string;
  state?: string;
  /** @format int64 */
  timestamp?: number;
  type?: string[];
}

export interface ServiceError {
  Details?: ServiceError[];
  Syserror?: string;
  Target?: string;
}

export interface SpotifyTrackInfo {
  album?: {
    artists?: {
      name?: string;
    }[];
    images?: Image[];
    name?: string;
    release_date?: string;
  };
  artists?: {
    name?: string;
  }[];
  /** @format int64 */
  duration_ms?: number;
  id?: string;
  name?: string;
  /** @format int64 */
  track_number?: number;
}

export interface SpotifyUserProfile {
  /**
   * Country     string `json:"country,omitempty"`
   * DisplayName string `json:"display_name,omitempty"`
   * Email       string `json:"email,omitempty"`
   */
  id?: string;
}

/**
 * The status of the Rule
 * @default "Enabled"
 */
export enum Status {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

export interface TrackIndexItem {
  /** @format int64 */
  Index?: number;
  /** @format int64 */
  Total?: number;
}

export interface Tracks {
  MakeContentsBody?: Content;
}

export interface UserDelProvider {
  callback_url?: string;
  gdpr_id?: string;
  service_id?: string;
}

export interface UserEvent {
  result?: {
    events?: string[];
    serviceId?: string;
  };
  subscriptionId?: string;
  userId?: string;
}

export interface UserToken {
  company?: string;
  refreshToken?: string;
}

export interface UserFeedback {
  providerId?: string;
  devices?: DeviceFeedback[];
  action?: string;
  devicePlayed?: DeviceFeedback;
  timestampStart?: string;
  timestampEnd?: string;
}

export interface DeviceFeedback {
  locationId?: string;
  roomId?: string;
  id?: string;
  type?: string;
}

export interface UserBehaviorModel {
  modelPath?: string;
  mappingPath?: string;
  version?: string;
}

export interface RuleRequestBase {
  /** The name for the Rule. Limit 100 characters. */
  name: string;
  actions: Action[];
  /** The sequence in which the actions are to be executed (i.e. Serial (default) or Parallel). */
  sequence?: ActionSequence;
  /** The time zone ID for this Rule. This overrides the Location time zone ID, but is overridden by time zone ID provided by each operand individually. */
  timeZoneId?: string;
}

export type RuleRequest = RuleRequestBase & {
  /** Unstructured object for client to store additional data */
  meta?: object;
  /** The status of the Rule */
  status?: Status;
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: ExecutionLocation;
};

export interface RuleAdhocRequest {
  /** The user-defined name of the Rule */
  name?: string;
  /** List of actions to be executed */
  actions: AdhocAction[];
  /** The sequence in which the actions are to be executed i.e. Serial or Parallel (default) */
  sequence?: ActionSequence;
  /** Unstructured object for client to store additional data */
  meta?: object;
}

export type RuleBase = RuleRequest & {
  /**
   * Unique id for the Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /**
   * The status of the Rule
   * @default "Enabled"
   */
  status?: 'Enabled' | 'Disabled';
  /** The location where the rule is executing, either local or cloud */
  executionLocation?: 'Cloud' | 'Local';
  /** Owner id */
  ownerId: string;
  /**
   * The owner of the rule is either a location or user
   * @default "Location"
   */
  ownerType: 'Location' | 'User';
  /** The creator name who create the behavior */
  creator?: Creator;
  /** Created date time */
  dateCreated: string;
  /** Last updated date time */
  dateUpdated: string;
  /**
   * List of client-facing action identifiers that are currently permitted for the user.
   * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> w:rules - the user can edit the rule
   *   <li> x:rules - the user can execute the rule
   *   <li> d:rules - the user can delete the rule
   *   </ul>
   */
  allowed?: 'w:rules' | 'x:rules' | 'd:rules';
};

export type Rule = RuleBase & {
  /** url to the scene icon */
  iconUrl?: string;
};

export interface ActionBase {
  if?: IfAction;
  sleep?: SleepAction;
  command?: CommandAction;
  every?: EveryAction;
  location?: LocationAction;
}

export interface SleepActionBase {
  duration: Interval;
}

export type AdhocAction = {
  command?: CommandAction;
  location?: LocationAction;
  scene?: SceneAction;
  notification?: NotificationAction;
  toggle?: ToggleAction;
  type?: 'command' | 'location' | 'scene' | 'notification' | 'toggle';
};

export type IfAction = Condition & {
  then?: Action[];
  else?: Action[];
  /** The sequence in which the actions are to be executed */
  sequence?: IfActionSequence;
};

export interface CommandAction {
  devices: string[];
  commands: DeviceCommand[];
  /** The sequence in which the commands are to be executed i.e. Serial or Parallel (default) */
  sequence?: CommandSequence;
}

export interface EveryAction {
  interval?: Interval;
  specific?: DateTimeOperand;
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial (default) or Parallel */
  sequence?: ActionSequence;
}

export interface LocationAction {
  /**
   * locationId is required for "User level rule". (It's optional for "Location level rule")
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  mode?: string;
  security?: SecurityState;
}

export interface LimitAction {
  /**
   * Unique id for the action
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
  /** Number of times the action can execute within the period */
  count: number;
  /** The period of time */
  period: 'Minute' | 'Hour' | 'Day' | 'Week' | 'Month' | 'Lifetime';
  /**
   * Number of period interval. Must be greater than or equal to 1. \n\n
   * If period == Minute then periodInterval can be 1 ~ 1440 \n\n
   * If period == Hour then periodInterval can be 1 ~ 8760 \n\n
   * If period == Day then periodInterval can be 1 ~ 4380 \n\n
   * If period == Week then periodInterval can be 1 ~ 624 \n\n
   * If period == Month then periodInterval can be 1 ~ 144 \n\n
   * @min 1
   */
  periodInterval?: number;
  actions: Action[];
  sequence?: ActionSequence;
}

export interface NotificationAction {
  push?: PushNotification;
  audio?: AudioNotification;
  custom?: CustomNotification;
  sms?: SmsNotification;
  image?: ImageNotification;
  type?: NotificationType;
}

export interface ToggleAction {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
}

/** Defines any combination of actions. */
export interface GroupAction {
  actions: Action[];
  /** The sequence in which the actions are to be executed i.e. Serial (default) or Parallel */
  sequence?: ActionSequence;
}

export enum NotificationType {
  Push = 'push',
  Audio = 'audio',
  Custom = 'custom',
  Sms = 'sms',
  Image = 'image',
}

export interface PushNotification {
  /** Push notification title */
  title?: string;
  /** Push notification message */
  message: string;
  target?: NotificationTarget;
}

export interface AudioNotification {
  /** Audio notification title */
  title?: string;
  /** Audio notification message */
  message: string;
  /** Device list where audio to be played */
  devices: string[];
  /**
   * Number of times to repeat the message, default is one
   * @format int64
   * @min 1
   * @max 10
   */
  repeat?: number;
  /**
   * Volume level
   * @format int64
   * @min 1
   * @max 100
   */
  level?: number;
  ttsProvider?: TtsProvider;
}

export interface TtsProvider {
  /** Voice provider name, Bixby (default), Polly */
  provider?: string;
  /** Language code, “en-us” (default), “ko-kr” */
  locale?: string;
  /** Voice code, “M01”, “M02” (default), “F05” */
  profile?: string;
  /** Audio encoding properties that will be used by TTS service to prepare the audio */
  output?: Output;
}

export interface Output {
  /** Encoding type. Default “PCM” */
  format?: string;
  /** Bitrate of the audio. Default 24 */
  bitrate?: number;
  /** Channel supported. Default “Mono” */
  channel?: string;
  /** Frequency supported. Default 24000 */
  freq?: number;
}

export interface CustomNotification {
  /** Default(when recipientType is not filled out or 'DEVICE' ),Device ids that would receive this noti(mobile client id) or that is used at 'Rule'(mobile presence id). If recipientType is 'LOCATION', recipients should be location id. If recipientType is 'USER' recipients should be user uuid. */
  recipients: string[];
  /** Custom notification message in pabal request format */
  message: object;
  /** DEVICE - recipients must be 'deviceId' LOCATION - recipients must be 'locationId' / USER - recipients must be 'userUuid' */
  recipientType?: RecipientType;
}

/** @example {"recipients":["sms:+19999999999"]} */
export interface SmsNotification {
  /** Sms notification message */
  message: string;
  /** List of recipients phone number. Format - ['sms:<Phone Number>'] */
  recipients: string[];
  /** Installed App Id to be added in the response */
  entityId?: string;
  /** Installed app config ID to be added in the response */
  messageGroupSet?: string;
  /** Response from Hermes API Client, To be included in the Response */
  messageGroupKey?: string;
}

/** @example {"device":{"devices":["device1"],"component":"main","capability":"imageCapture","attribute":"image","subscriptionMode":"Never"}} */
export interface ImageNotification {
  /** Image notification title */
  title?: string;
  /** Image notification message. Would be sent when image capture fails. */
  message: string;
  /** Camera list that would capture and produce event. Event musth be mentioned and triggerMode must be "NEVER" */
  device: DeviceOperand;
  /** Mention that this action is for only sending image notification or sending image take device command together. Default false. */
  onlyNoti?: boolean;
  target?: NotificationTarget;
}

export interface NotificationTarget {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  locationId?: string;
  userUuids?: string[];
}

export enum RecipientType {
  DEVICE = 'DEVICE',
  LOCATION = 'LOCATION',
  USER = 'USER',
}

export interface ConditionBase {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
  changes?: ChangesCondition;
  remains?: RemainsCondition;
  /** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
  was?: WasCondition;
}

export interface BasicCondition {
  and?: Condition[];
  or?: Condition[];
  not?: Condition;
  equals?: EqualsCondition;
  greaterThan?: GreaterThanCondition;
  greaterThanOrEquals?: GreaterThanOrEqualsCondition;
  lessThan?: LessThanCondition;
  lessThanOrEquals?: LessThanOrEqualsCondition;
  between?: BetweenCondition;
}

export enum BasicConditionType {
  And = 'and',
  Between = 'between',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  Not = 'not',
  Or = 'or',
}

export enum ConditionType {
  And = 'and',
  Between = 'between',
  Changes = 'changes',
  DropsBelow = 'dropsBelow',
  DropsToOrBelow = 'dropsToOrBelow',
  Equals = 'equals',
  GreaterThan = 'greaterThan',
  GreaterThanOrEquals = 'greaterThanOrEquals',
  LessThan = 'lessThan',
  LessThanOrEquals = 'lessThanOrEquals',
  Not = 'not',
  Or = 'or',
  Remains = 'remains',
  RemainsEqual = 'remainsEqual',
  RisesAbove = 'risesAbove',
  RisesToOrAbove = 'risesToOrAbove',
  Was = 'was',
  WasEqual = 'wasEqual',
  OneAppLeadTime = 'oneAppLeadTime',
}

export type Condition = ConditionBase & {
  /** `Deprecated` */
  dropsBelow?: DropsBelowCondition;
  /** `Deprecated` */
  dropsToOrBelow?: DropsToOrBelowCondition;
  /** `Deprecated` */
  risesAbove?: RisesAboveCondition;
  /** `Deprecated` */
  risesToOrAbove?: RisesToOrAboveCondition;
  remains?: RemainsCondition;
  /** `Deprecated` */
  remainsEqual?: RemainsEqualCondition;
  /** `Deprecated` */
  wasEqual?: WasEqualCondition;
  /** `Deprecated` */
  oneAppLeadTime?: OneAppLeadTimeCondition;
  type?: ConditionType;
};

export interface SingleOperandCondition {
  left: Operand;
  aggregation?: ConditionAggregationMode;
}

export interface SimpleCondition {
  left: Operand;
  right: Operand;
  aggregation?: ConditionAggregationMode;
}

export type StandardCondition = SimpleCondition & {
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
};

export type TimedSimpleCondition = SimpleCondition & {
  interval: Interval;
};

export type EqualsCondition = StandardCondition;

export type GreaterThanCondition = StandardCondition;

export type GreaterThanOrEqualsCondition = StandardCondition;

export type LessThanCondition = StandardCondition;

export type LessThanOrEqualsCondition = StandardCondition;

export interface BetweenCondition {
  value: Operand;
  start: Operand;
  end: Operand;
  aggregation?: ConditionAggregationMode;
  /** Determines whether or not to track the evaluation state of the operation it contains, trigger the condition when the state of the inner operation transitions from false to true. Default is false. */
  changesOnly?: boolean;
}

/** `Deprecated` */
export type DropsBelowCondition = SimpleCondition;

/** `Deprecated` */
export type DropsToOrBelowCondition = SimpleCondition;

/** `Deprecated` */
export type RisesAboveCondition = SimpleCondition;

/** `Deprecated` */
export type RisesToOrAboveCondition = SimpleCondition;

/** `Deprecated` */
export type RemainsEqualCondition = TimedSimpleCondition;

/** `Deprecated` */
export type WasEqualCondition = TimedSimpleCondition;

/** `Deprecated` */
export type OneAppLeadTimeCondition = TimedSimpleCondition;

/** A condition that returns true when its evaluation resolves to true and the previous evaluation resolved to false. */
export type ChangesConditionBase = (BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
}) & {
  type?: BasicConditionType;
};

export type ChangesCondition = ChangesConditionBase;

/** A condition that returns true if its evaluation is true after the specified duration. */
export type RemainsConditionBase = (BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  operand?: Operand;
  duration: Interval;
  /** Determines whether the condition should return true in subsequent executions after initially satisfied. Default is false. */
  latching?: boolean;
}) & {
  type?: BasicConditionType;
};

export type RemainsCondition = RemainsConditionBase;

/** `Deprecated` A condition that returns true if its evaluation would return true within the specified duration. */
export type WasCondition = BasicCondition & {
  /**
   * Unique id for the condition
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  duration: Interval;
  operand?: Operand;
};

export interface OperandBase {
  boolean?: boolean;
  /** @format double */
  decimal?: number;
  /** @format int64 */
  integer?: number;
  string?: string;
  array?: ArrayOperand;
  map?: MapOperand;
  device?: DeviceOperand;
  location?: LocationOperand;
  date?: DateOperand;
  /** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
  time?: TimeOperand;
  datetime?: DateTimeOperand;
}

export enum OperandType {
  Array = 'array',
  Boolean = 'boolean',
  Date = 'date',
  Datetime = 'datetime',
  Decimal = 'decimal',
  Device = 'device',
  Integer = 'integer',
  Location = 'location',
  Map = 'map',
  String = 'string',
  IndexedString = 'indexedString',
  Time = 'time',
}

export type Operand = OperandBase & {
  indexedString?: IndexedStringOperand;
  type?: OperandType;
};

export interface ArrayOperand {
  operands: Operand[];
  aggregation?: OperandAggregationMode;
}

export interface DateOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  reference?: DateReference;
}

export interface DateTimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @format int32 */
  year?: number;
  /**
   * @format int32
   * @min 1
   * @max 12
   */
  month?: number;
  /**
   * @format int32
   * @min 1
   * @max 31
   */
  day?: number;
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface DeviceOperand {
  devices: string[];
  component: string;
  capability: string;
  attribute: string;
  path?: string;
  aggregation?: OperandAggregationMode;
  trigger?: TriggerMode;
}

export interface LocationOperand {
  /**
   * Required for User level rule, optional for Location level in request. Will always be present in response for both.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** Only valid for the attribute 'WeatherAlertSeverity' */
  postalCode?: string;
  attribute: LocationAttribute;
  trigger?: TriggerMode;
}

export type MapOperand = Record<string, Operand>;

/** TimeOperand is restricted to returning a value between 0 and 86399 seconds. This means that adding an offset that potentially drives the integer value outside the range of [0..86399] will cause an adjustment to bring the value back in that range */
export interface TimeOperand {
  /** A java time zone ID reference */
  timeZoneId?: string;
  daysOfWeek?: DayOfWeek[];
  /** @default "Midnight" */
  reference: TimeReference;
  offset?: Interval;
}

export interface IndexedStringOperand {
  value: Operand;
  indices: string[];
}

export enum Sequence {
  Serial = 'Serial',
  Parallel = 'Parallel',
}

export interface ActionSequence {
  actions?: Sequence;
}

export interface CommandSequence {
  commands?: Sequence;
  devices?: Sequence;
}

export interface IfActionSequence {
  then?: Sequence;
  else?: Sequence;
}

export interface SceneSequence {
  scenes?: Sequence;
}

export enum ExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Ignored = 'Ignored',
}

export enum IfExecutionResult {
  True = 'True',
  False = 'False',
}

export enum CommandExecutionResult {
  Success = 'Success',
  Failure = 'Failure',
  Offline = 'Offline',
}

/** The result of a if action execution */
export interface IfActionExecutionResult {
  result: IfExecutionResult;
}

/** The result of a command action execution */
export interface CommandActionExecutionResult {
  result: CommandExecutionResult;
  /**
   * Device ID for device actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
}

/** The result of a location action execution */
export interface LocationActionExecutionResult {
  result: ExecutionResult;
  /**
   * Location ID for location actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** The result of a sleep action execution */
export interface SleepActionExecutionResult {
  result: ExecutionResult;
}

/** The result of a limit action execution */
export interface LimitActionExecutionResult {
  result: ExecutionResult;
}

/** The result of an action execution */
export interface ActionExecutionResultBase {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  actionId: string;
  /** The result of a if action execution */
  if?: IfActionExecutionResult;
  /** The result of a location action execution */
  location?: LocationActionExecutionResult;
  command?: CommandActionExecutionResult[];
  /** The result of a sleep action execution */
  sleep?: SleepActionExecutionResult;
}

/** The result of a scene action execution */
export interface SceneActionExecutionResult {
  result: ExecutionResult;
  /**
   * Scene ID for scene actions
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

/** The result of a notification action execution */
export interface NotificationActionExecutionResult {
  result: ExecutionResult;
  type: NotificationType;
}

/** LightEffectExecutionStatus */
export interface LightEffectExecutionStatus {
  /** Light effect execution status */
  status: 'Running' | 'NotRunning';
  /** Light effect type */
  type?: 'WakeUp' | 'WindDown' | 'Circadian';
}

/** The result of a Rule execution */
export interface RuleExecutionResponse {
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  executionId: string;
  /** @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$ */
  id: string;
  result: ExecutionResult;
  actions?: ActionExecutionResult[];
}

export interface DeviceCommand {
  component: string;
  capability: string;
  command: string;
  arguments?: Operand[];
}

/** @default "Any" */
export enum ConditionAggregationMode {
  Any = 'Any',
  All = 'All',
}

/** @default "None" */
export enum OperandAggregationMode {
  None = 'None',
}

/** @default "Auto" */
export enum TriggerMode {
  Auto = 'Auto',
  Always = 'Always',
  Never = 'Never',
}

export enum LocationAttribute {
  FineDust = 'FineDust',
  FineDustIndex = 'FineDustIndex',
  Humidity = 'Humidity',
  Mode = 'Mode',
  Security = 'Security',
  Temperature = 'Temperature',
  TemperatureC = 'TemperatureC',
  TemperatureF = 'TemperatureF',
  UltraFineDust = 'UltraFineDust',
  UltraFineDustIndex = 'UltraFineDustIndex',
  Weather = 'Weather',
  WeatherAlertSeverity = 'WeatherAlertSeverity',
}

export enum ArmState {
  ArmedStay = 'ArmedStay',
  ArmedAway = 'ArmedAway',
  Disarmed = 'Disarmed',
}

export interface SecurityState {
  armState: ArmState;
  monitoring?: boolean;
}

export enum DateReference {
  Today = 'Today',
}

export enum TimeReference {
  Now = 'Now',
  Midnight = 'Midnight',
  Sunrise = 'Sunrise',
  Noon = 'Noon',
  Sunset = 'Sunset',
}

export enum DayOfWeek {
  Sun = 'Sun',
  Mon = 'Mon',
  Tue = 'Tue',
  Wed = 'Wed',
  Thu = 'Thu',
  Fri = 'Fri',
  Sat = 'Sat',
}

export interface Interval {
  value: Operand;
  unit: IntervalUnit;
}

export enum IntervalUnit {
  Second = 'Second',
  Minute = 'Minute',
  Hour = 'Hour',
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Year = 'Year',
}

/** @default "Interrupt" */
export enum Strategy {
  Ignore = 'Ignore',
  Interrupt = 'Interrupt',
}

/** An array of Rules */
export interface PagedRules {
  items?: Rule[];
  _links?: Links;
}

/** The location where the rule is executing, either local or cloud */
export enum ExecutionLocation {
  Cloud = 'Cloud',
  Local = 'Local',
}

/**
 * The type of owner that the Geoplace is associated to, including user permissioning.
 * @default "LOCATION"
 */
export enum OwnerType {
  LOCATION = 'LOCATION',
}

/** The creator name who create the behavior */
export enum Creator {
  SMARTTHINGS = 'SMARTTHINGS',
  ARB = 'ARB',
  RECIPE = 'RECIPE',
  UNDEFINED = 'UNDEFINED',
}

export interface SupportedFeatures {
  /** Possible Values for Hub Characteristic "Availability" flags */
  zigbeeAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  zwaveAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  threadAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  lanAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  edgeDriversAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  matterAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  localVirtualDeviceAvailability?: AvailabilityCharacteristic;
  /** Possible Values for Hub Characteristic "Availability" flags */
  childDeviceAvailability?: AvailabilityCharacteristic;
}

export interface BackupComponent {
  name: string;
  version: number;
}

export interface DeliveryStatus {
  deliveryStatus?: string;
}

export interface DeviceOTA {
  supported?: boolean;
  enabled?: boolean;
  lightsEnabled?: boolean;
}

/** Response from requesting hub logs */
export type FetchLogsResponse = InternalHubCommandResponse & {
  /** The S3 bucket holding the hub logs requested */
  bucket?: string;
  /** The requesting hubId */
  objectName?: string;
};

export interface InternalHubCommandResponse {
  /**
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  correlationId?: string;
  /** The ID of the hub */
  hubId?: HubIdFieldSchema;
  /** The command to execute on the hub */
  commandName?: HubCommandFieldSchema;
}

/**
 * The ID of the hub
 * @example "D052A900003100FB"
 */
export type HubIdFieldSchema = string;

/**
 * The command to execute on the hub
 * @example "ping"
 */
export type HubCommandFieldSchema = string;

export type InternalHub = (Hub & {
  claimCode?: string;
  /** @example "UNCLAIMED" */
  claimStatus?: string;
  dateClaimed?: string;
  /** @example "V2_HUB" */
  hardwareType?: string;
}) & {
  /**
   * @format uuid
   * @example "6496be9a-aa23-4320-b60f-904e472db962"
   */
  id?: string;
  /** @example "Happy Hub" */
  name?: string;
  /** @example "D052A82674C90001" */
  eui?: string;
  /** @example "john.doe@smartthings.com" */
  owner?: string;
  /** @example "asdfasdf" */
  serialNumber?: string;
  /** @example "000.020.00203" */
  firmwareVersion?: string;
};

/**
 * A JSON object of Hub Characteristics. Values could be of any type. There are no required keys.
 * More information is available [here](https://smartthings.atlassian.net/wiki/spaces/HUBPLT/pages/2348782106/Hub+Characteristics+Guidelines+and+Schema)
 * @example {"key1":"value1","key2":"value2","key3":["a","b","c"]}
 */
export type HubCharacteristics = Record<string, object>;

export interface SupportHub {
  /** @example "Online" */
  status?: string;
  /** @example "2020-01-01" */
  lastCommunication?: string;
  /** @example "UNCLAIMED" */
  claimStatus?: string;
  devices?: SupportDevice[];
}

export interface SupportDevice {
  /** @example "Online" */
  status?: string;
  /** @example "my device" */
  name?: string;
  /** @example "Zwave" */
  deviceType?: string;
  /** @example "someManufacturer" */
  manufacturerCode?: string;
  /** @example "ZWave" */
  protocol?: string;
  /** @example "1.0.1" */
  firmwareVersion?: string;
  /** @example "2020-01-01" */
  lastCommunication?: string;
}

export interface UnsecureRejoinResponse {
  euid?: string;
  unsecureRejoinEnabled?: boolean;
}

export interface MeshGraph {
  devices?: {
    /**
     * @format uuid
     * @example "6496be9a-aa23-4320-b60f-904e472db962"
     */
    deviceId?: string;
    /** @example true */
    repeater?: boolean;
    route?: '[object Object]'[];
    /**
     * @min 0
     * @max 5
     */
    connectionQuality?: number;
    /** @example "2020-02-05T17:28:26.1234Z" */
    updatedTime?: string;
  }[];
}

export interface DiscoveryStartRequest {
  /**
   * Determines the length of time where device discovery will be active. This value should be similar to the poll rate. A value of 0 will stop the discovery instead of letting the hub discover indefinitely
   * @example 15
   */
  timeout: number;
  /**
   * If true, Zigbee devices can only join securely. This does not affect the ability to join non-Zigbee devices. Defaults to false.
   * @example true
   */
  secureJoin?: boolean;
  /**
   * If true then the mobile client supports the Z-Wave S2 onboarding flow, defaults to false
   * @example true
   */
  s2Supported?: boolean;
  /** If set then enable discovery of all of the specified types of devices. If not set then all hub connected device types will be discoverable. */
  discoveryTypes?: ('ZIGBEE' | 'ZWAVE' | 'LAN' | 'BLUETOOTH' | 'BLUETOOTH.MESH')[];
  /** List of strings that specify which drivers to start up during discovery. If field is null or empty, all drivers will start up during discovery. */
  driverIds?: string[];
}

export interface MatterRendezvousRequest {
  /** Generally set to the ${compressedFabricId-nodeID}. */
  operationalId: string;
  /** Time before the rendezvous times out */
  failSafeExpirySeconds: number;
}

/** List of driver channels */
export type HubDriverChannels = HubDriverChannel[];

export interface HubDriverChannel {
  /**
   * Unique Identifier of the channel
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  channelId: string;
  /**
   * User friendly Identifier for Channel
   * @example "Caleb's Fiendly Drivers"
   */
  name: string;
  /**
   * Description of Channel and Contained Drivers
   * @example "Just some friendly Drivers Here"
   */
  description?: string;
  /** ISO-8601 timestamp of creation of channel */
  createdDate?: string;
  /** ISO-8601 timestamp of last modification of channel */
  lastModifiedDate?: string;
  /** Url to web interface to modifiy channel subscriptions */
  subscriptionUrl?: string;
  /** Flag to denote that it works with SmartThings channel */
  isWWST?: boolean;
}

/** List of installed Hub Device drivers */
export type InstalledDrivers = InstalledDriver[];

export interface InstalledDriver {
  /**
   * Unique Identifier of the driver
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  driverId: string;
  /**
   * User friendly Identifier for Driver
   * @example "Caleb's Fiendly Driver"
   */
  name: string;
  /**
   * Description of Driver
   * @example "One friendly driver alright"
   */
  description?: string;
  /** version of the driver currently in use */
  version: string;
  /** identifier for channel this driver is installed from */
  channelId?: string;
  /** developer of the driver */
  developer?: string;
  /**
   * information on how to reach vendor
   * @example "You can find us at JustAFriendlyDriver.com"
   */
  vendorSupportInformation?: string;
  /**
   * map of permissions and attributes used by the driver.
   * In format of {"permissions":{"perm1":{...}, "perm2"{...}}}
   * @example {"lan":{},"lan_internet":{"allowed_hosts":["smartthings.com","samsung.com"]}}
   */
  permissions?: Record<string, object>;
  /** Flag to denote that this driver is part of a works with SmartThings channel */
  isWWST?: boolean;
}

export interface DeviceIntegrationProfileKey {
  /**
   * Unique identifier for integration profile.
   * @format uuid
   */
  id?: string;
  /**
   * Major Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  majorVersion?: number;
  /**
   * Minor Version of the integration profile (major.minor). When creating a minor version, only the major is required.
   * @format int64
   */
  minorVersion?: number;
  /**
   * @format uuid
   * @example "a362ddb6-349b-4650-9911-681b51069a57"
   */
  overrideProfileId?: string;
}

export interface EdgeDeviceUpdateRequest {
  /**
   * Unique Identifier of the driver
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  driverId: string;
  deviceIntegrationProfileKey?: DeviceIntegrationProfileKey;
  /** Provisioning type for a widget device */
  provisioningState?: ProvisioningState;
}

/**
 * Type of discovery code being sent down (NOVA, Zigbee3, ZwaveS2)
 * @example "zigbee3"
 */
export enum DiscoveryCodeType {
  AdtQr = 'adt-qr',
  Zigbee3 = 'zigbee3',
  Zwaves2 = 'zwaves2',
}

/**
 * Possible Values for Hub Characteristic "Availability" flags
 * @example "Available"
 */
export enum AvailabilityCharacteristic {
  Available = 'Available',
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

/**
 * Unavailable = device could work with dongle. Unsupported = device will never work on hub
 * @example "Unavailable"
 */
export enum UnsupportedType {
  Unavailable = 'Unavailable',
  Unsupported = 'Unsupported',
}

export interface DiscoveryCodeRequest {
  /** Type of discovery code being sent down (NOVA, Zigbee3, ZwaveS2) */
  type: DiscoveryCodeType;
  /**
   * The device code that was scanned or manually entered by the user
   * @example "B6E4BB590E374B85828690535526F722BCC0"
   */
  code: string;
  /**
   * The EUID of the Zigbee device, required if type is zigbee3
   * @example "24FD5B000105DB96"
   */
  euid?: string;
}

export interface InstallDriverRequest {
  /**
   * Unique Identifier of the channel the driver is being installed from
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  channelId?: string;
}

export interface CodelessHubClaimRequest {
  /** The hub's EUI */
  hubEui: string;
  /** The hub's hardware ID */
  hardwareId: string;
  /** The location to create the hub device in */
  locationId: string;
  /** The hub's firmware version */
  firmwareVersion?: string;
  /** An optional parameter to name the hub device record. */
  name?: string;
}

export interface LegacyHubClaimRequest {
  /** The hub's EUI */
  zigbeeId: string;
  locationId: string;
  code?: string;
  hardwareId?: string;
  /** Deprecated. */
  channel?: string;
  /** Equivalent to 'name' argument */
  hubName?: string;
  name?: string;
  /** Deprecated. */
  userAgent?: string;
  /** Deprecated. */
  appVersion?: string;
}

export interface LegacyHub {
  id?: string;
  name?: string;
  locationId?: string;
  firmwareVersion?: string;
  zigbeeId?: string;
  hubEui?: string;
  status?: string;
  onlineSince?: string;
  signalStrength?: string;
  batteryLevel?: string;
  data?: object;
  type?: {
    name?: string;
  };
  features?: {
    name?: string;
    enabled?: boolean;
  }[];
  virtual?: boolean;
  role?: string;
  firmwareUpdateAvailable?: boolean;
  hardwareId?: string;
  hardwareDescription?: string;
  hardwareType?: string;
  isZwaveUtilEnabled?: boolean;
  hubId?: string;
  hubStatus?: string;
  onlineSinceDate?: string;
}

export interface LegacyHubChildDevice {
  id?: string;
  name?: string;
  hubId?: string;
  locationId?: string;
  label?: string;
  status?: string;
  currentStates?: object[];
  typeId?: string;
  typeName?: string;
  deviceNetworkId?: string;
  virtual?: boolean;
  primaryTileName?: string;
  completedSetup?: boolean;
  network?: string;
  stateOverrides?: object[];
  role?: string;
  parentSmartAppId?: string;
  parentDeviceId?: string;
  isComponent?: boolean;
  componentName?: string;
  componentLabel?: string;
  isExecutingLocally?: boolean;
  lastActivityTime?: string;
}

export interface LegacyHubResponse {
  hub?: LegacyHub;
  devices?: LegacyHubChildDevice[];
}

/** Contains list of Driver IDs to install on a hub */
export interface InstallDriversRequest {
  /** Driver IDs */
  driverIds: string[];
}

export interface HubRequestLogsAuditData {
  reason?: string;
  user?: string;
}

export interface PostDeviceOTARequest {
  enabled?: boolean;
  lightsEnabled?: boolean;
}

export interface HubCommandsRequest {
  /**
   * The name of the command
   * @example "join, replace, force delete"
   */
  name?: string;
  timeout?: number;
  /** The device ID for the Hub */
  deviceId?: string;
  /**
   * The device code that was scanned or manually entered by the user
   * @example "B6E4BB590E374B85828690535526F722BCC0"
   */
  code?: string;
  /**
   * The EUID of the Zigbee device
   * @example "24FD5B000105DB96"
   */
  euid?: string;
  discoveryTypes?: string[];
}

export interface ToggleFeature {
  enabled?: boolean;
}

export interface OcfDeleteHubCommand {
  samsungAccountId?: string;
  hubs?: string[];
  syncOcf?: boolean;
}

export interface OcfDeleteHubStatus {
  success?: {
    hubId?: string;
  }[];
  failure?: {
    hubId?: string;
    reason?: string;
  }[];
}

/** identifies each of the expected states for a hub replace operation */
export enum ExternalControllerStatus {
  NOT_STARTED = 'NOT_STARTED',
  PREPARED = 'PREPARED',
  BACKUP_UPLOADED = 'BACKUP_UPLOADED',
  FETCHING_BACKUP = 'FETCHING_BACKUP',
  VALIDATING_BACKUP = 'VALIDATING_BACKUP',
  BACKUP_VALIDATED = 'BACKUP_VALIDATED',
  APPLYING_BACKUP = 'APPLYING_BACKUP',
  BACKUP_APPLIED = 'BACKUP_APPLIED',
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}

export enum ExternalControllerType {
  GIZMO = 'GIZMO',
  SOURCE_HUB = 'SOURCE_HUB',
  DESTINATION_HUB = 'DESTINATION_HUB',
}

export interface ExternalControllerStatusReport {
  /** identifies each of the expected states for a hub replace operation */
  status?: ExternalControllerStatus;
  controllerType?: ExternalControllerType;
  failureInfo?: ErrorResponse;
}

export interface HubReplacementProgress {
  /**
   * The identifier used to look up the status of the replacement job
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  jobId: string;
  /** The current overall state of the replacement */
  state?: HubReplacementState;
  isFailure?: boolean;
  failureInfo?: ErrorResponse[];
  destinationHubId?: string;
  sourceHubId?: string;
}

/** The current overall state of the replacement */
export enum HubReplacementState {
  CLOUD_VALIDATION_STARTED = 'CLOUD_VALIDATION_STARTED',
  CLOUD_VALIDATION_COMPLETE = 'CLOUD_VALIDATION_COMPLETE',
  HUB_VALIDATION_STARTED = 'HUB_VALIDATION_STARTED',
  HUB_VALIDATION_COMPLETE = 'HUB_VALIDATION_COMPLETE',
  CLOUD_SETTINGS_MOVED = 'CLOUD_SETTINGS_MOVED',
  DRIVERS_INSTALLED = 'DRIVERS_INSTALLED',
  FABRIC_JOINED = 'FABRIC_JOINED',
  REPARENTING_STARTED = 'REPARENTING_STARTED',
  REPARENTING_COMPLETE = 'REPARENTING_COMPLETE',
  LOCAL_REPLACEMENT_STARTED = 'LOCAL_REPLACEMENT_STARTED',
  REPLACEMENT_COMPLETE = 'REPLACEMENT_COMPLETE',
}

export interface HubBackupMetadata {
  /**
   * Unix timestamp of when backup was generated in milliseconds
   * @format int64
   */
  generationDate?: number;
}

export interface ReplacementRequest {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  sourceHubDeviceId?: string;
}

export interface ReplacementCandidates {
  sourceMeta?: SourceMetadata;
  lastBackupMeta?: HubBackupMetadata;
  candidates?: ReplacementCandidate[];
}

export interface SourceMetadata {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  hubDeviceId: string;
  isReplacementSupported: boolean;
}

export interface CandidateMetadata {
  /**
   * The source hub's device id
   * @example "6d7bf35a-bb57-4b1f-945a-63ff72bfbef3"
   */
  hubDeviceId: string;
  /** Single boolean flag to denote if replacement of source with this candidate should be allowed */
  canReplaceSource: boolean;
  /** denotes if replacement is supported in general on this hub */
  isReplacementSupported: boolean;
  /** does this hub already have child devices */
  hasChildren: boolean;
}

export interface ReplacementCandidate {
  candidateMeta?: CandidateMetadata;
  supportedFeatures?: SupportedFeatures;
  unsupportedDevices?: ReplacementDevice[];
}

export interface ReplacementDevice {
  deviceId: string;
  /** Unavailable = device could work with dongle. Unsupported = device will never work on hub */
  unsupportedType?: UnsupportedType;
  /**
   * The type of device integration (may be null).
   * If the type is DTH, the device implementation is a groovy Device Handler and the details are in the "dth" field.
   * If the type is ENDPOINT_APP, the device implementation is a SmartApp and the details are in the "app" field.
   * If the type is IR, the details are in the "ir" field.
   * If the type is IR_OCF, the details are in the "irOcf" field.
   * If the type is OCF, the details are in the "ocf" field.
   * If the type is VIPER, the details are in the "viper" field.
   */
  deviceType?: DeviceIntegrationType;
}

export interface DevicePresentation {
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName: string;
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** DEPRECATED: Secondary namespacing key for grouping presentations */
  mnmn?: string;
  /** DEPRECATED: System generated identifier that corresponds to a device presentation */
  vid?: string;
  /** The message to display when device is offline */
  offlineMessage: string;
  /**
   * The version of the device configuration.
   * @default "0.0.1"
   * @example "0.0.1"
   */
  version?: string;
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  icons?: Icons;
  dashboard?: Dashboard;
  detailView?: DetailView;
  /** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device's state is met. */
  automation?: Automation;
  /** Information used for obtaining details page plugins on different platforms. Array of Details page link objects. */
  dpInfo: DpInfo;
  /** Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx) */
  language?: Language;
}

export interface CapabilityValue {
  /**
   * This can be either command name or attribute name. For pointing commands without arguments(enumCommands), specify `{{enumCommands}}` then this override values will apply to enumCommands.
   * @example "thermostatMode.value"
   */
  key: string;
  /**
   * A list of values supported among those defined in the capability alternatives. For instance, a device may not support `auto` for supported thermostat fan modes, so this field might be an array containing `on` and `off`.
   * @example ["cooling","heating"]
   */
  enabledValues?: string[];
  label?: string;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** The incremental step that increases or decreases for numeric values. */
  step?: Step;
}

/**
 * Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx)
 * @example "EN, KO, ES, etc."
 */
export type Language = string;

export interface LanguageItem {
  locale: string;
  /** The list of resources that contain translated text */
  poCodes: PoCodes[];
}

export interface PoCodes {
  label: string;
  /**
   * Po code. Should begin with '___PO_CODE'
   * @pattern ^___PO_CODE_[a-zA-Z0-9_]+$
   */
  po: string;
}

/** Information used for obtaining details page plugins on different platforms. Array of Details page link objects. */
export type DpInfo = {
  /** The OS of the UI Client used to show the details page. 'iOS': iOS SmartThings 'android': Android SmartThings */
  os: 'android' | 'ios' | 'tizen' | 'web';
  /**
   * This is linked to obtain the vendor-specific device details page. The device's dashboard card opens the detail view using this link when the user clicks the device card.
   * @example "plugin://example_detail_page_uri"
   */
  dpUri: string;
  /** This describes operating mode after onboarding. `easySetup` will launch the plugin for setting up your device while `deviceControl` will launch the plugin for controlling the device directly after onboarding. */
  operatingMode?: string;
  /** Complex devices can have sub dashboard cards and can pass an argument to the detailView when user clicks each sub dashboard cards. */
  arguments?: {
    /**
     * To specify key of `group` used in `dashboard`
     * @example "{{___PO_CODE_SMARTTHINGS_FLEX_OVEN}}"
     */
    key: string;
    /**
     * To specify group as an argument while launching the detailView.
     * @example "FLEX_UPPER_OVEN"
     */
    value: string;
  }[];
}[];

/** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
export type Alternatives = AlternativeItem[];

export interface AlternativeItem {
  /**
   * The label string to be displayed when the 'key' is evaluated.
   * @example "on"
   */
  key: string;
  /**
   * The alternative string to be displayed when the `key` is selected.
   * @example "Motion detected"
   */
  value: string;
  /**
   * This shows the active or inactive state of the value. `active` is shown in color, while `inactive` value is shown dimmed in the UI view. For example, Motion sensor capability would have `detected` as active and in color and `clear` as inactive and dimmed so that a user can see the `detected` event easily.
   * @default "active"
   */
  type?: 'inactive' | 'active';
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  /** Additional description for each value. This description is shown in detail view or automation under this particular key. */
  description?: string;
}

/**
 * Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category.
 * @example "icon://example_icon_url"
 */
export type IconUrl = string;

export type Icons = {
  /** @default "main" */
  group?: string;
  /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
  iconUrl?: IconUrl;
  /** To specify the condition whether the device is running or not, and a device icon corresponding to running is displayed on the UI. */
  runningConditions?: VisibleCondition[];
  badge?: {
    /** Icon Id used to retrieve icons to be drawn on the UI Client. If iconUrl is omitted, then UI client shows default icon of device's category. */
    iconUrl: IconUrl;
    visibleConditions?: VisibleCondition[];
  }[];
}[];

/**
 * The incremental step that increases or decreases for numeric values.
 * @format double
 * @default 1
 */
export type Step = number;

/**
 * The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to.
 * @maxItems 2
 * @minItems 2
 * @example [0,100]
 */
export type Range = number[];

/** The method to compare */
export enum Operator {
  CONTAINS = 'CONTAINS',
  DOES_NOT_CONTAIN = 'DOES_NOT_CONTAIN',
  EQUALS = 'EQUALS',
  DOES_NOT_EQUAL = 'DOES_NOT_EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS = 'GREATER_THAN_OR_EQUALS',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUALS = 'LESS_THAN_OR_EQUALS',
  ONE_OF = 'ONE_OF',
}

/**
 * The version number of the capability.
 * @default 1
 * @example 1
 */
export type Version = number;

/**
 * The name of the manufacturer
 * @example "SmartThingsCommunity"
 */
export type Mnmn = string;

/**
 * A unique identifier for the presentation of a device. This can be a model number on legacy device integrations, but also may be a system generated UUID based on a device's structure and display configuration.
 * @example "MySmartDevice"
 */
export type Vid = string;

/** @example {"capability":"switch","version":1} */
export interface CapabilityKey {
  capability: string;
  /** The version number of the capability. */
  version?: Version;
}

/**
 * @default "main"
 * @example "main"
 */
export type Component = string;

/**
 * This displays a string. This can be a formatted string with variables.
 * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
 * @example "{{temperatureMeasurement.value}}"
 */
export type FormattedLabel = string;

/** This display type creates a state UI that shows state only. */
export interface State {
  /**
   * This displays a string. This can be a formatted string with variables.
   * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
   */
  label?: FormattedLabel;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
}

/**
 * The attribute name specified in supportedValues is an array that has values supported at runtime.
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "supportedThermostatModes.value"
 */
export type SupportedValues = string;

/**
 * To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges.
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "supportedVolumes.value"
 */
export type SupportedValuesForNumericConstraints = string;

/**
 * Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version.
 * @example {"component":"main","value":"switch.value","operator":"EQUALS","operand":"on"}
 */
export interface VisibleCondition {
  /** The component that controls the visibility of this component. This can be another component or this one. */
  component: Component;
  capability: string;
  /** The version number of the capability. */
  version?: Version;
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The method to compare */
  operator: Operator;
  /** The value that the visible condition evaluates against. */
  operand: string;
}

export type GroupVisibleConditions = {
  /**
   * The group name to control its visibility. Some complex devices can be shown grouped in the dashboard card. This is used for setting visibleCondition of specified non-main group states and actions in the dashboard.
   * @example "cooler"
   */
  group: string;
  /** @maxItems 1 */
  visibleConditions: VisibleCondition[];
}[];

export interface Dashboard {
  states?: StatesArrayItem[];
  actions?: ActionsArrayItem[];
  basicPlus?: BasicPlusItem[];
  groupVisibleConditions?: GroupVisibleConditions;
}

/** The dashboard is the main view in the SmartThings app that shows a list of devices and their state. */
export interface DashboardForCapability {
  states?: StateItem[];
  actions?: ActionItem[];
}

/** @example {"label":"Motion: {{motion.value}}","alternatives":[{"key":"detected","value":"Detected","type":"active"},{"key":"clear","value":"None","type":"inactive"}]} */
export interface StateItem {
  /**
   * This displays a string. This can be a formatted string with variables.
   * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
   */
  label: FormattedLabel;
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
}

export interface CapabilityList {
  component: string;
  capability: string;
  /** The version number of the capability. */
  version?: Version;
  values?: CapabilityValue[];
}

/** @example {"displayType":"switch","switch":{"command":{"name":"setLock","on":"locked","off":"unlocked"},"state":{"value":"lock.value","on":"locked","off":"unlocked"}}} */
export interface ActionItem {
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'pushButton'
    | 'toggleSwitch'
    | 'switch'
    | 'standbyPowerSwitch'
    | 'statelessPowerToggle'
    | 'playPause'
    | 'playStop';
  pushButton?: PushButton;
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitchForDashboard;
  switch?: SwitchForDashboard;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitchForDashboard;
  /** This switch triggers power toggle action without showing any status. */
  statelessPowerToggle?: StatelessPowerToggleForDashboard;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
  group?: Group;
}

/**
 * To specify the function of the device using the extended area of the dashboard card.
 * @example {"displayType":"camera","camera":{"image":{"capability":"imageCapture","component":"main","version":1,"value":"image.value"},"overlayIcons":[{"iconUrl":"example_motion_icon","visibleCondition":{"capability":"motionSensor","component":"main","version":1,"value":"motion.value","operator":"EQUALS","operand":"detected"}},{"iconUrl":"example_object_human_icon","visibleCondition":{"capability":"objectDetection","component":"main","version":1,"value":"detected.value.value","operator":"EQUALS","operand":"human"}},{"iconUrl":"example_object_pet_icon","visibleCondition":{"capability":"objectDetection","component":"main","version":1,"value":"detected.value.value","operator":"EQUALS","operand":"pet"}}]}}
 */
export interface BasicPlusItem {
  /** To specify the type of UI component to display this basicPlus item. The corresponding field must also be included. For example, if you specify "camera" here, you must also include the "camera" key and its object definition for this basicPlus item. */
  displayType: 'camera';
  /** To render the captured image and overlay icon in the dashboard card of a camera device. */
  camera?: Camera;
}

/** To render the captured image and overlay icon in the dashboard card of a camera device. */
export interface Camera {
  /** To specifiy attribute path for a captured image. */
  image: {
    capability: string;
    /** The version number of the capability. */
    version?: Version;
    /** The component that controls the visibility of this component. This can be another component or this one. */
    component: Component;
    /** Notation which indicates the value of an attribute */
    value: Value;
  };
  /** To describe the overlay icon and the conditions under which it will be displayed. */
  overlayIcons?: {
    /** Icon Id used to retrieve a overlay icon to be drawn on the camera card. */
    iconUrl: string;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
  }[];
}

export type DetailView = DetailViewListItem[];

export type DetailViewForCapability = {
  /** @example "Front door" */
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'toggleSwitch'
    | 'standbyPowerSwitch'
    | 'switch'
    | 'slider'
    | 'pushButton'
    | 'textButton'
    | 'playPause'
    | 'playStop'
    | 'list'
    | 'textField'
    | 'numberField'
    | 'stepper'
    | 'state';
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitch;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  switch?: Switch;
  slider?: Slider;
  pushButton?: PushButton;
  /** To specify available values shown in buttons with text label. */
  textButton?: TextButton;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** To specify available values shown in a drop-down UI. User can select one of the value among the list items */
  list?: ListForDetailView;
  /** This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command */
  textField?: TextField;
  /** This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command */
  numberField?: NumberField;
  /** This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument. */
  stepper?: Stepper;
  /** This display type creates a state UI that shows state only. */
  state?: State;
}[];

export type DetailViewItem = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType:
    | 'toggleSwitch'
    | 'standbyPowerSwitch'
    | 'switch'
    | 'slider'
    | 'pushButton'
    | 'textButton'
    | 'playPause'
    | 'playStop'
    | 'list'
    | 'textField'
    | 'numberField'
    | 'stepper'
    | 'state'
    | 'multiArgCommand';
  /** A button style switch element for the UI. */
  toggleSwitch?: ToggleSwitch;
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  switch?: Switch;
  slider?: Slider;
  pushButton?: PushButton;
  /** To specify available values shown in buttons with text label. */
  textButton?: TextButton;
  /** To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  playPause?: PlayPause;
  /** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
  playStop?: PlayStop;
  /** To specify available values shown in a drop-down UI. User can select one of the value among the list items */
  list?: ListForDetailView;
  /** This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command */
  textField?: TextField;
  /** This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command */
  numberField?: NumberField;
  /** This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument. */
  stepper?: Stepper;
  /** This display type creates a state UI that shows state only. */
  state?: State;
  /** To specify multiple arguments command and displayType of each argument. */
  multiArgCommand?: MultiArgCommand;
};

/** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device state is met. */
export interface AutomationForCapability {
  /** To specify the conditions of device state to trigger actions in the automation view of SmartThings app. */
  conditions?: {
    /** @example "Audio volume" */
    label: string;
    /** Specify the type of UI component to use to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'enumSlider';
    slider?: SliderForAutomationCondition;
    list?: ListForAutomationCondition;
    numberField?: NumberFieldForAutomationCondition;
    textField?: TextFieldForAutomationCondition;
    /** This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order. */
    enumSlider?: EnumSliderForAutomationCondition;
    /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
    emphasis?: boolean;
  }[];
  /** To specify the actions of device control based on the device state in the automation view of SmartThings app. */
  actions?: {
    /** @example "Audio volume" */
    label: string;
    /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'multiArgCommand';
    slider?: SliderForAutomationAction;
    list?: ListForAutomationAction;
    textField?: TextFieldForAutomationAction;
    numberField?: NumberFieldForAutomationAction;
    /** To specify multiple arguments command and displayType of each argument. */
    multiArgCommand?: MultiArgCommand;
    /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
    emphasis?: boolean;
  }[];
}

export type AutomationCondition = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType: 'slider' | 'list' | 'numberField' | 'textField' | 'enumSlider';
  slider?: SliderForAutomationCondition;
  list?: ListForAutomationCondition;
  numberField?: NumberFieldForAutomationCondition;
  textField?: TextFieldForAutomationCondition;
  /** This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order. */
  enumSlider?: EnumSliderForAutomationCondition;
  /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
  emphasis?: boolean;
};

export type AutomationAction = CapabilityKey & {
  label: string;
  /** To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state. */
  displayType: 'slider' | 'list' | 'textField' | 'numberField' | 'multiArgCommand';
  slider?: SliderForAutomationAction;
  list?: ListForAutomationAction;
  textField?: TextFieldForAutomationAction;
  numberField?: NumberFieldForAutomationAction;
  /** To specify multiple arguments command and displayType of each argument. */
  multiArgCommand?: MultiArgCommand;
  /** The effect used to emphasize this resource widget. The default value is false. If the emphasis value is true and this object has alternatives, a list will appear without a label */
  emphasis?: boolean;
};

/** In the SmartThings app, you can build custom Automations to automatically trigger actions when certain condition regarding device's state is met. */
export interface Automation {
  /** To specify the conditions of device state to trigger actions in the automation view of SmartThings app. */
  conditions?: AutomationListItem[];
  /** To specify the actions of device control based on the device state in the automation view of SmartThings app. */
  actions?: ActionListItem[];
  /** To specify informative descriptions for condition or action in automation view */
  descriptions?: DescriptionsInAutomation;
}

/**
 * The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard.
 * @default "main"
 * @example "main"
 */
export type Group = string;

/**
 * To specify the type of UI component to display this action or state. The corresponding field must also be included. For example, if you specify "switch" here, you must also include the "switch" key and its object definition for this action or state.
 * @example "switch"
 */
export type DisplayType = string;

/**
 * To specify available values shown in a drop-down UI. User can select one of the value among the list items
 * @example {"command":{"name":"setCleaningMode","alternatives":[{"key":"spot","value":"Spot cleaning mode"},{"key":"auto","value":"Auto cleaning mode"}]},"state":{"value":"cleaningMode.value","alternatives":[{"key":"spot","value":"Spot cleaning mode"},{"key":"auto","value":"Auto cleaning mode"}]}}
 */
export interface ListForDetailView {
  command: {
    /** name refers to command name and key of the alternatives is the argument of the command */
    name?: string;
    /** Additional description of a command. This description is shown in the list. */
    description?: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives: Alternatives;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
    /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
    supportedValues?: SupportedValues;
  };
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives: Alternatives;
  };
}

/**
 * Including a basicPlus item with the "feature" display type adds a shortcut item to the desired detail view.
 * @example [{"key":"cooking","value":"Cooking mode"},{"key":"cleaning","value":"Cleaning mode"}]
 */
export type Feature = {
  /** The name of the feature to be added to the detail view. For example, if the feature is specified as "cooking", then a detail view item will be added called "cooking" */
  key: string;
  /** The alternative string of given 'key' value. */
  value: string;
}[];

/** @example {"alternatives":[{"key":"cooling","value":"Cooling mode"},{"key":"heating","value":"Heating mode"}],"supportedValues":"supportedThermostatModes.value"} */
export interface ListBase {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives: Alternatives;
  /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
  supportedValues?: SupportedValues;
}

export type ListForAutomationAction = ListBase & {
  /** The name of the command that is called when an item is chosen from the list */
  command?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type ListForAutomationCondition = ListBase & {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /**
   * To specify whether to allow multiple selection within a list or not. Default value is false.
   * @default false
   */
  multiSelectable?: boolean;
};

/**
 * This display type creates numberfield that the user enters a new value and that the new value is passed as an argument to the command
 * @example {"value":"volume.value","unit":"volume.unit","command":"setVolume","range":[0,100],"supportedValues":"supportedVolumes.value"}
 */
export interface NumberField {
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** Notation which indicates the unit */
  unit?: Unit;
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/** @example {"command":"setVolume","unit":"volume.unit","range":[0,100],"supportedValues":"supportedVolumes.value"} */
export interface NumberFieldForAutomationAction {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/** @example {"value":"volume.value","unit":"volume.unit","range":[0,100],"supportedValues":"supportedVolumes.value"} */
export interface NumberFieldForAutomationCondition {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

/**
 * To specify separate commands for play and pause, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments.
 * @example {"command":{"name":"setPlaybackState","play":"play","pause":"pause"},"state":{"value":"playbackState.value","play":"playing","pause":"paused","alternatives":[{"key":"playing","value":"Playing","type":"active"},{"key":"paused","value":"Paused","type":"inactive"}]}}
 */
export type PlayPause = UtilRequiredKeys<PlayPauseCommand, 'command'> & {
  state: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The value of "attribute" which indicates playing state. When the attribute value equals to this then UI will show playing state. */
    play: string;
    /** The value of "attribute" which indicates paused state. When the attribute value equals to this then UI will show paused state. */
    pause: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
};

/** @example {"command":"setButton","argument":"push"} */
export interface PushButton {
  command: string;
  argument?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
}

/** To specify separate commands for play and stop, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the " play" and "stop" fields for the arguments. */
export type PlayStop = PlayStopCommand & {
  state: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The value of "attribute" which indicates playing state. When the attribute value equals to this then UI will show playing state. */
    play: string;
    /** The value of "attribute" which indicates stopped state. When the attribute value equals to this then UI will show stopped state. */
    stop: string;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
  };
};

export type Slider = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /**
   * The command which will send the value of the slider as an argument
   * @example "setVolume"
   */
  command?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
};

/**
 * To display slider display type, at least one of the command and value must be specified.
 * @example {"range":[0,100],"step":0.5,"unit":"volume.unit","supportedValues":"supportedVolumes.value"}
 */
export interface SliderBase {
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range: Range;
  /** The incremental step that increases or decreases for numeric values. */
  step?: Step;
  /** Notation which indicates the unit */
  unit?: Unit;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

export type SliderForAutomationAction = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type SliderForAutomationCondition = SliderBase & {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives?: Alternatives;
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
};

/**
 * This display type creates slider composed with enumeration that the user can set an automation to compare between enumeration and device's status. An alternatives array should be `ascending` order.
 * @example {"value":"dustHealthConcern.value","alternatives":[{"key":"hazardous","value":"Hazardous"},{"key":"veryUnhealthy","value":"Very Unhealthy"},{"key":"unhealthy","value":"Unhealthy"},{"key":"moderate","value":"Moderate"},{"key":"good","value":"Good"}],"supportedOperators":[{"operator":"EQUALS","label":"Equals to"},{"operator":"GREATER_THAN_OR_EQUALS","label":"Greater than or equals to"}]}
 */
export interface EnumSliderForAutomationCondition {
  /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
  alternatives: Alternatives;
  /** Notation which indicates the value of an attribute */
  value: Value;
  supportedOperators?: {
    /** The operator to be supported by this display type. */
    operator: 'EQUALS' | 'GREATER_THAN_OR_EQUALS' | 'LESS_THAN_OR_EQUALS';
    /** The alternative string of given operator. */
    label: string;
  }[];
}

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
export type StandbyPowerSwitch = SwitchCommand & SwitchState & object;

/**
 * This display type creates a stepper which can trigger "increase" and "decrease" commands. The user must specify either a "command" field alone or "increase" / "decrease" fields for commands without an argument.
 * @example {"command":{"name":"setVolume"},"value":"volume.value","step":1,"range":[0,100],"supportedValues":"supportedVolumes.value"}
 */
export interface Stepper {
  command: {
    /** To specify a single command like "setValue(number)", use "command" field for the command name. If this field is specified then "increase" and "descrease" fields should not be specified. App will calculate desired value when user clicks "+" and "-" button in the UI based on the current value of "attribute" with specified "step". */
    name?: string;
    /** To specify a command for "increase" without an argument. */
    increase?: string;
    /** To specify a command for "decrease" without an argument. */
    decrease?: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The incremental step that increases or decreases for numeric values. */
  step: Step;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range: Range;
  /** To specify an attribute path that has a dynamic numeric constraint. The constraint can be updated in real-time to reflect changing values and ranges. */
  supportedValues?: SupportedValuesForNumericConstraints;
}

export type Switch = SwitchCommand & SwitchState & object;

/**
 * This display type creates textfield that the user enters a new value and that the new value is passed as an argument to the command
 * @example {"command":"sendNotification","value":"notification.value"}
 */
export interface TextField {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"command":"sendNotification","range":[0,20]} */
export interface TextFieldForAutomationAction {
  command: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"value":"notification.value"} */
export interface TextFieldForAutomationCondition {
  /** Notation which indicates the value of an attribute */
  value: Value;
  /** The data type of the `value`. It's automatically filled from the given capability. */
  valueType?: ValueType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** A button style switch element for the UI. */
export type ToggleSwitch = SwitchCommand & SwitchState & object;

/** To specify multiple arguments command and displayType of each argument. */
export interface MultiArgCommand {
  /**
   * Command name to trigger
   * @example "playTrack"
   */
  command: string;
  arguments: {
    /** @example "Audio volume" */
    label: string;
    /** Specify the type of UI component to use to display this action or state. The corresponding field must also be included. For example, if you specify "list" here, you must also include the "list" key and its object definition for this action or state. */
    displayType: 'slider' | 'list' | 'textField' | 'numberField';
    slider?: SliderForArgument;
    list?: ListForArgument;
    textField?: TextFieldForArgument;
    numberField?: NumberFieldForArgument;
  }[];
}

export type SliderForArgument = SliderBase & {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

export type ListForArgument = ListBase & {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
};

/** @example {"name":"uri","range":[5,50]} */
export interface TextFieldForArgument {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** @example {"name":"level","range":[0,10]} */
export interface NumberFieldForArgument {
  /** Argument name of a command */
  name: ArgumentName;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
  /** The inclusive range of a numeric value or bounds of a string depending on the data type it is applied to. */
  range?: Range;
}

/** Argument name of a command */
export type ArgumentName = string;

/**
 * The tag of the locale as defined in [RFC bcp47](http://www.rfc-editor.org/rfc/bcp/bcp47.txt).
 * @example "en"
 */
export type LocaleTag = string;

export type StatesArrayItem = StateItem &
  CapabilityKey & {
    component: Component;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
    /** To specify composite use of different state items. If composite is true, multiple states items in the same group are combined to a label. */
    composite?: Composite;
    /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
    group?: Group;
    formatInfo?: FormatInfo;
    /**
     * To specify whether the status to be displayed is transient or not
     * @default false
     */
    transient?: boolean;
  };

export type ActionsArrayItem = ActionItem &
  CapabilityKey & {
    component?: Component;
    /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
    visibleCondition?: VisibleCondition;
    /** The group name to which this belongs. Some complex devices can be shown grouped in the dashboard card. This is used for grouping states and actions in the dashboard. */
    group?: Group;
  };

export type DetailViewListItem = DetailViewItem & {
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
};

export type AutomationListItem = AutomationCondition & {
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedConditionItem[];
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
};

export type ActionListItem = AutomationAction & {
  component?: Component;
  /** Use `visibleCondition` to specify under what conditions the resource may be interacted with from the UI. When the specified condition is met, the resource may be interacted with from the UI. If the condition is not met, the resource will appear grayed out and unusable in the UI in the detail view; all other views, including the dashboard, will not display the resource. If `visibleCondition` is omitted, the resource is always displayed and may be interacted with from the UI. The `visibleCondition` object may reference a different component, capability, and version. */
  visibleCondition?: VisibleCondition;
  /** To exclude specified automation in `exclude` when this item is selected by the user. */
  exclusion?: ExcludedActionItem[];
};

/** A button style switch element for the UI. */
export type ToggleSwitchForDashboard = SwitchForDashboard & object;

/** @example {"command":{"name":"setLock","on":"locked","off":"unlocked"}} */
export interface SwitchCommand {
  /** To specify separate commands with no arguments for on and off, use the "on" and "off" fields respectively. To specify a single command, use "name" for the command and the "on" and "off" fields for the arguments. */
  command: {
    name?: string;
    on: string;
    off: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked","label":"Lock: {{lock.value}}","alternatives":[{"key":"locked","value":"Locked","type":"inactive"},{"key":"unlocked","value":"Unlocked","type":"active"}]}} */
export interface SwitchState {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The attribute value that corresponds to the `on` state. */
    on: string;
    /** The attribute value that corresponds to the `off` state. */
    off: string;
    /**
     * This displays a string. This can be a formatted string with variables.
     * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
     */
    label?: FormattedLabel;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked"}} */
export interface SwitchStateForDashboard {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value?: Value;
    on: string;
    off: string;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** A collection of strings that can replace the attribute value in the `label` or `value` or `unit`. Must be human-readable for the UI client to display. */
    alternatives?: Alternatives;
  };
}

export type SwitchForDashboard = SwitchCommand & SwitchStateForDashboard & object;

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
export type StandbyPowerSwitchForDashboard = SwitchCommand & SwitchState & object;

/**
 * This switch triggers power toggle action without showing any status.
 * @example {"command":"setButton","argument":"push"}
 */
export interface StatelessPowerToggleForDashboard {
  command: string;
  argument?: string;
  /** The data type of the `argument`. It's automatically filled from the given capability. */
  argumentType?: ArgumentType;
}

/**
 * Display type for a play/pause button.
 * @example {"command":{"name":"setPlaybackState","play":"playing","pause":"paused"}}
 */
export interface PlayPauseCommand {
  /** To specify separate commands with no arguments for on and off, use the "play" and "pause" fields respectively. To specify a single command, use "name" for the command and the "play" and "pause" fields for the arguments. */
  command: {
    name?: string;
    play: string;
    pause: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/**
 * Display type for a play/stop button.
 * @example {"command":{"name":"setPlaybackState","play":"play","stop":"pause"}}
 */
export interface PlayStopCommand {
  /** To specify separate commands with no arguments for on and off, use the "play" and "stop" fields respectively. To specify a single command, use "name" for the command and the "play" and "stop" fields for the arguments. */
  command: {
    name?: string;
    play: string;
    stop: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** To specify available values shown in buttons with text label. */
export interface TextButton {
  /**
   * To specify command name with argument(s) and key of the buttons is the argument of the command. If this is omitted then keys at `buttons` array are the enumCommands without arguments.
   * @example "setThermostatMode"
   */
  command?: string;
  /** Notation which indicates the value of an attribute */
  value?: Value;
  /** @minItems 2 */
  buttons: {
    /**
     * A command name or an argument name of a command to be mapped with this button.
     * @example "cooling"
     */
    key: string;
    /**
     * The alternative string to be displayed when the `key` is evaluated.
     * @example "Cooling"
     */
    label: string;
    /**
     * To focus this button according to the current status of given attribute which is mapped with this button.
     * @example "Cooling"
     */
    state?: string;
  }[];
  /** The attribute name specified in supportedValues is an array that has values supported at runtime. */
  supportedValues?: SupportedValues;
}

/**
 * Notation which indicates the value of an attribute
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "switch.value"
 */
export type Value = string;

/**
 * Notation which indicates the unit
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.unit)+
 * @example "temperature.unit"
 */
export type Unit = string;

export interface ExcludedConditionItem {
  /**
   * To express that a specific value is selected
   * @example "HDMI"
   */
  value?: object;
  exclude: {
    /** @example "main" */
    component?: string;
    /** @example "pictureMode" */
    capability: string;
    /**
     * @default 1
     * @example 1
     */
    version?: number;
    attributes?: ExcludeItemsAttributes;
  }[];
}

export interface ExcludedActionItem {
  /**
   * To express that a specific value is selected
   * @example "off"
   */
  value?: object;
  exclude: {
    /**
     * To specify target component to exclude, if it's omitted then all components with this capability will be excluded
     * @example "main"
     */
    component?: string;
    /** @example "pictureMode" */
    capability: string;
    /**
     * @default 1
     * @example 1
     */
    version?: number;
    commands?: ExcludeItemsCommands;
  }[];
}

export type ExcludedConditionItemId = {
  /** The index of the array in the given capability to which this exclusion object will be inserted */
  id?: number;
} & ExcludedConditionItem;

export type ExcludedActionItemId = {
  /** The index of the array in the given capability to which this exclusion object will be inserted */
  id?: number;
} & ExcludedActionItem;

export type ExcludeItemsCommands = {
  name: string;
  /** To exclude only some values of the attribute */
  excludedValues?: string[];
}[];

export type ExcludeItemsAttributes = {
  /** Attribute name to be excluded */
  name: string;
  /** To exclude only some values of the attribute */
  excludedValues?: string[];
}[];

/**
 * The data type of the `value`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ValueType = string;

/**
 * The data type of the `argument`. It's automatically filled from the given capability.
 * @example "double"
 */
export type ArgumentType = string;

/**
 * To specify composite use of different state items. If composite is true, multiple states items in the same group are combined to a label.
 * @default false
 */
export type Composite = boolean;

export type FormatInfo = {
  /** Notation which indicates the value of an attribute */
  key: Value;
  /**
   * To specify the type of format to display this attribute value. The corresponding field must also be included. For example, if you specify "remainingTime" here, you must also include the "remainingTime" key and its object definition for formatInfo.
   * @example "remainingTime"
   */
  type: 'remainingTime' | 'time';
  remainingTime?: {
    timeFormat: TimeFormat;
    /**
     * Specify the frequency time(second) so UI client can know how often to update the remaing time.
     * @default 60
     * @example 60
     */
    frequency?: number;
  };
  time?: {
    timeFormat: TimeFormat;
  };
}[];

/**
 * @pattern (MM/dd ){0,1}(HH:|hh:){0,1}mm(:ss){0,1}
 * @example "HH:mm:ss"
 */
export type TimeFormat = string;

/** To specify informative descriptions for condition or action in automation view */
export interface DescriptionsInAutomation {
  conditions?: DescriptionItem[];
  actions?: DescriptionItem[];
}

export interface DescriptionItem {
  /** @default "OR" */
  operator?: 'AND' | 'OR';
  /** @example "Sample description" */
  label: string;
  visibleConditions?: VisibleCondition[];
}

/** Sub graph for the multihub */
export interface MultiHubSubGraph {
  /**
   * id of the location the hub is in
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** primary hub for the requested hub. Will be itself if the requested hub is the primary. Will be null if the requested hub exists, but is incapable of being either primary or secondary */
  primaryHub?: DeviceIdWrapper;
  /** Secondary hubs connected to the primary hub. Will be empty if there are no secondary hubs */
  secondaryHubs?: DeviceIdWrapper[];
  /** Potential primary hubs for the requested hub. Will be empty if the hub can't become a secondary hub or if there are no primary hubs */
  potentialPrimaryHubs?: DeviceIdWrapper[];
  /**
   * will be INFORMATION_UNAVAILABLE if the hub is still in the onboarding state and hasn't had time to report it's characteristics
   * in case of that response try again after waiting the time specified in the delay field
   */
  status: 'INFORMATION_UNAVAILABLE' | 'INFORMATION_AVAILABLE';
  /** time to wait in seconds until retrying the request in case of status being INFORMATION_UNAVAILABLE. Will be 0 otherwise */
  delay: number;
}

/** wrapper around the deviceId so that we can add more properties later without having to do a breaking change */
export interface DeviceIdWrapper {
  /**
   * The identifier for the device instance.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
}

export interface VoiceCatalog {
  /**
   * amazon_alexa | google_assistant
   * @format enum
   * @example "amazon_alexa"
   */
  partnerName?: string;
  /**
   * version number of the catalog
   * @example "v20200223"
   */
  catalogVersion?: string;
  /**
   * language for the requested catalog
   * @format ISO 639-1
   * @example "en"
   */
  language?: string;
  supportedDeviceCategories?: DeviceCategory[];
}

export interface DeviceCategory {
  /**
   * internal name of the device type (not localized)
   * @example "smart-lock"
   */
  internalName?: string;
  /**
   * localized name that will be visible in the app
   * @example "Locks"
   */
  displayName?: string;
  /**
   * any special notes about the category to be displayed (localized)
   * @example "Locks require PIN codes"
   */
  categoryNotes?: string;
  icons?: {
    /**
     * url to the image
     * @format url
     * @example "http://example.com/images/1.png"
     */
    '1x'?: string;
    /**
     * url to the image
     * @format url
     * @example "http://example.com/images/2.png"
     */
    '2x'?: string;
    /**
     * url to the image
     * @format url
     * @example "http://example.com/images/3.png"
     */
    '3x'?: string;
  };
  supportedCommands?: SupportedCommand[];
  supportedDevices?: SupportedDevice[];
}

export interface SupportedCommand {
  /**
   * localized example utterance
   * @example "Turn ON/Off"
   */
  utterance?: string;
}

export interface SupportedDevice {
  /**
   * the id of the user's device. This will only be populated for the owned catalog
   * example: 9121f970-f503-11e8-a7de-7319cef9605d
   * @format uuid
   */
  deviceId?: string;
  /**
   * name of the device
   * @example "zigbee lock"
   */
  deviceName?: string;
  /**
   * display name (label) of the device
   * @example "Front Door"
   */
  deviceLabel?: string;
  /**
   * model number of the device
   * @example "Yale X500"
   */
  deviceModel?: string;
}

/**
 * PEM certifcate
 * @example "-----BEGIN CERTIFICATE-----\nMIIDwjCCAqqgAwIBAgIJAKBHTlxMPhhjMA0GCSqGSIb3DQEBBQUAMHExCzAJBgNV\nBAYTAlVTMQswCQYDVQQIDAJDQTESMBAGA1UEBwwJU2FuIERpZWdvMRAwDgYDVQQK\nDAdTYW1zdW5nMRQwEgYDVQQLDAtTbWFydFRoaW5nczEZMBcGA1UEAwwQU21hcnRU\naGluZ3MsIEluYzAeFw0yMTEwMjYyMzUxMTJaFw0yMjEwMjYyMzUxMTJaMHExCzAJ\nBgNVBAYTAlVTMQswCQYDVQQIDAJDQTESMBAGA1UEBwwJU2FuIERpZWdvMRAwDgYD\nVQQKDAdTYW1zdW5nMRQwEgYDVQQLDAtTbWFydFRoaW5nczEZMBcGA1UEAwwQU21h\ncnRUaGluZ3MsIEluYzCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAOMJ\n+MPNohRYGHZsScpsX6uhRNoP4uuiUuws/PEmYl8IeWiE9AasknXo0J+vb8sr29h5\nbKvxE/BKBkMoIbLgmBtluhctREKuF/baTRk9/N3l7ips5iBMYkuwqYu/n3vvxiRX\n0WqfvjqtdTyl6fdNlltRT3N1ovmeDwZb500C8+Y+cBon5NuL5fRUXFxXduFNjs2S\nTgzLOgB/2hrteuZiFtf3FrTWoKNhCvDN+1E1EDxCsoC6IFpuBNEMxsfxzr0UneQN\n/mlDAkad4+zvB0EhQiIRd9eS0Nd2qzuiJ4AJEh7VWcF7FVY+1LHpYAIRWR3LM5zg\n7jB1IIFM4BtUnDLdCssCAwEAAaNdMFswHQYDVR0OBBYEFD4asm4fRlrIyeNPd8cX\nTgz6vaA0MB8GA1UdIwQYMBaAFD4asm4fRlrIyeNPd8cXTgz6vaA0MAwGA1UdEwQF\nMAMBAf8wCwYDVR0PBAQDAgTwMA0GCSqGSIb3DQEBBQUAA4IBAQAAu35bj4n0mGjt\nKAGM9NsPG/cu5f8Xce5StJKi6ATfdyVVdGdsU1zBS+yQQdqyD4NzvFKhl8ipsQC8\ne4eCirG42/X8FAEzS9W8DtJobEtvvfkPCNX3Tex1OwFiRGkeCHH4BP4jL475Yodl\naLqDuyajpNWLegFrWr67MS3QKlvzgyFmOWMtKctYdc1pe5H2BCSuz7TiRVNtv/ne\nqJxICwlyLdKrsLp1ySVyW6Hn2SAkllux5y2Y1Uo+cd6doqUzRKp8BsTKZ6quHLf2\nxoD0YB7+b8Ky9x3W+KUXvxmOHPU45BXUn1OnRzy+VLFa7tGfCa95TpipNGp46rwb\nnRLPWTiu\n-----END CERTIFICATE-----\n"
 */
export type DclPemCert = string;

/**
 * subject of the PEM certificate
 * @example "CN=SmartThings\\, Inc,OU=SmartThings,O=Samsung,L=San Diego,ST=CA,C=US"
 */
export type DclSubject = string;

/**
 * subject key ID of the PEM certificate
 * @example "3E:1A:B2:6E:1F:46:5A:C8:C9:E3:4F:77:C7:17:4E:C:FA:BD:A0:34"
 */
export type DclSubjectKeyId = string;

/**
 * root subject of the PEM certificate
 * @example "CN=SmartThings\\, Inc,OU=SmartThings,O=Samsung,L=San Diego,ST=CA,C=US"
 */
export type DclRootSubject = string;

/**
 * root subject key ID of the PEM certificate
 * @example "3E:1A:B2:6E:1F:46:5A:C8:C9:E3:4F:77:C7:17:4E:C:FA:BD:A0:34"
 */
export type DclRootSubjectKeyId = string;

/**
 * serial number of the PEM certificate
 * @example "11549285927738021987"
 */
export type DclSerialNumber = string;

/**
 * certifcate authority key ID
 * @example "AA:1A:B2:EE:1F:46:5A:C8:C9:E3:44:77:C7:17:EC:C:FA:BD:A0:34"
 */
export type DclAuthorityKeyId = string;

/**
 * issuer of the PEM certificate
 * @example "Google.com"
 */
export type DclIssuer = string;

/**
 * whether the certificate is root certificate
 * @example true
 */
export type DclIsRoot = boolean;

/**
 * matter or zigbee is the and the only supported values for now
 * @example "matter"
 */
export enum DclCertificationType {
  Matter = 'matter',
  Zigbee = 'zigbee',
}

/**
 * the software compliance status
 * @example "certified"
 */
export enum DclComplianceStatus {
  Revoked = 'revoked',
  Certified = 'certified',
  Provisional = 'provisional',
}

/**
 * the software certification status
 * @example "certified"
 */
export enum DclCertificationStatus {
  Revoked = 'revoked',
  Certified = 'certified',
  Provisional = 'provisional',
  None = 'none',
}

/**
 * address of the ledger account
 * @example "cosmos1rt9fxahte83accc42s8zyvp2jw2t4tvhm9ayq4"
 */
export type DclAddress = string;

/**
 * vendor ID
 * @format int32
 * @min 0
 * @example 33
 */
export type DclVendorId = number;

/**
 * product ID
 * @format int32
 * @min 0
 * @example 100
 */
export type DclProductId = number;

/**
 * software version
 * @format int64
 * @min 0
 * @example 1
 */
export type DclSoftwareVersion = number;

/**
 * minimum software version requested
 * @format int64
 * @min 0
 * @example 1
 */
export type DclMinimumSoftwareVersion = number;

/**
 * software version string
 * @example "1"
 */
export type DclSoftwareVersionString = string;

/**
 * CD version number
 * @format int64
 * @example 1
 */
export type DclCDVersionNumber = number;

/**
 * product name
 * @example "power switch"
 */
export type DclProductName = string;

/**
 * stock keeping unit
 * @example "A5"
 */
export type DclPartNumber = string;

/**
 * test result
 * @example "PASS"
 */
export type DclTestResult = string;

/**
 * RFC3339 section 5.6 date time format
 * @format date-time
 * @example "2017-07-21T17:32:28Z"
 */
export type DclRfc3339Date = string;

/**
 * reason
 * @example "failed compliance test"
 */
export type DclReason = string;

/**
 * URL to the Localized String File of this product.
 * @example "http://smartthings.com/lsf"
 */
export type DclLsfUrl = string;

/**
 * @format int32
 * @example 1
 */
export type DclLsfRevision = number;

/**
 * certified or revoked
 * @example "revoked"
 */
export enum DclCertificationState {
  Certified = 'certified',
  Revoked = 'revoked',
}

/**
 * This is false in two cases: - compliance information not found in the store. - compliance information is found but it is in revoked state.
 * @example true
 */
export type DclCertifiedValue = boolean;

/**
 * This is false in two cases: - compliance information not found in the store. - compliance information is found but it is in certified state.
 * @example true
 */
export type DclRevokedValue = boolean;

/**
 * device type identifier
 * @format int64
 * @min 0
 * @example 10
 */
export type DclDeviceTypeId = number;

/**
 * @format int32
 * @example 5
 */
export type DclCid = number;

/**
 * model description (string or path to file containing data)
 * @example "Light"
 */
export type DclProductLabel = string;

/**
 * @format int64
 * @example 1
 */
export type DclSoftwareVersionCertificationStatus = number;

/**
 * CSA certification’s certificate ID
 * @example "5A43E32B5"
 */
export type DclCDCertificateId = string;

/**
 * certification route
 * @example "route"
 */
export type DclCertificationRoute = string;

/**
 * program type
 * @example "sample program"
 */
export type DclProgramType = string;

/**
 * program type version
 * @example 1
 */
export type DclProgramTypeVersion = string;

/**
 * compliant platform used
 * @example "linux"
 */
export type DclCompliantPlatformUsed = string;

/**
 * compliant platform version
 * @example 2
 */
export type DclCompliantPlatformVersion = string;

/**
 * transport
 * @example "TCP"
 */
export type DclTransport = string;

/**
 * family ID
 * @example 11111
 */
export type DclFamilyId = string;

/**
 * supported clusters
 * @example "thread"
 */
export type DclSupportedClusters = string;

/**
 * OS version
 * @example 11
 */
export type DclOSVersion = string;

/**
 * parent child
 * @example "parent"
 */
export type DclParentChild = string;

/**
 * certification ID of software component
 * @example 222222
 */
export type DclCertificationIdOfSoftwareComponent = string;

/**
 * firmware image digests
 * @example "4A63E52B5"
 */
export type DclFirmwareDigests = string;

/**
 * valid software version
 * @example true
 */
export type DclSoftwareVersionValid = boolean;

/**
 * URL to download firmware image
 * @example "https://smartthings.com/firmware"
 */
export type DclOtaUrl = string;

/**
 * OTA firmware image file size in bytes
 * @format uint64
 * @example 160000
 */
export type DclOtaFileSize = number;

/**
 * OTA firmware image checksum
 * @example "4A63E52B5"
 */
export type DclOtaChecksum = string;

/**
 * @format int32
 * @example 1
 */
export type DclOtaChecksumType = number;

/**
 * @format int64
 * @example 1
 */
export type DclMinApplicableSoftwareVersion = number;

/**
 * @format int64
 * @example 1
 */
export type DclMaxApplicableSoftwareVersion = number;

/**
 * URL to release note
 * @example "https://smartthings.com/release"
 */
export type DclReleaseNotesUrl = string;

/**
 * vendor name
 * @example "SmartThings"
 */
export type DclVendorName = string;

/**
 * company legal name
 * @example "SmartThings, Inc"
 */
export type DclCompanyLegalName = string;

/**
 * preferred name for the company
 * @example "SmartThings"
 */
export type DclCompanyPreferredName = string;

/**
 * URL to vendor landing page
 * @example "https://smartthings.com"
 */
export type DclVendorLandingPageUrl = string;

/**
 * A value of 1 indicates that user interaction with the device (pressing a button, for example) is required before commissioning can take place. When CommissioningCustomflow is set to a value of 2, the commissioner SHOULD attempt to obtain a URL which MAY be used to provide an end-user with the necessary details for how to configure the product for initial commissioning
 * @min 0
 */
export type DclCommissioningCustomFlow = number;

/** commissioningCustomFlowUrl SHALL identify a vendor specific commissioning URL for the device model when the commissioningCustomFlow field is set to '2' */
export type DclCommissioningCustomFlowUrl = string;

/**
 * commissioningModeInitialStepsHint SHALL identify a hint for the steps that can be used to put into commissioning mode a device that has not yet been commissioned. This field is a bitmap with values defined in the Pairing Hint Table. For example, a value of 1 (bit 0 is set) indicates that a device that has not yet been commissioned will enter Commissioning Mode upon a power cycle.
 * @format int64
 * @min 0
 */
export type DclCommissioningModeInitialStepsHint = number;

/** commissioningModeInitialStepsInstruction SHALL contain text which relates to specific values of CommissioningModeInitialStepsHint. Certain values of CommissioningModeInitialStepsHint, as defined in the Pairing Hint Table, indicate a Pairing Instruction (PI) dependency, and for these values the commissioningModeInitialStepsInstruction SHALL be set */
export type DclCommissioningModeInitialStepsInstruction = string;

/**
 * commissioningModeSecondaryStepsHint SHALL identify a hint for steps that can be used to put into commissioning mode a device that has already been commissioned. This field is a bitmap with values defined in the Pairing Hint Table. For example, a value of 4 (bit 2 is set) indicates that a device that has already been commissioned will require the user to visit a current CHIP Administrator to put the device into commissioning mode.
 * @format int64
 * @min 0
 */
export type DclCommissioningModeSecondaryStepsHint = number;

/** commissioningModeSecondaryStepInstruction SHALL contain text which relates to specific values of commissioningModeSecondaryStepsHint. Certain values of commissioningModeSecondaryStepsHint, as defined in the Pairing Hint Table, indicate a Pairing Instruction (PI) dependency, and for these values the commissioningModeSecondaryStepInstruction SHALL be set */
export type DclCommissioningModeSecondaryStepsInstruction = string;

/**
 * URL that contains product specific web page that contains user manual for the device model.
 * @example "http://smartthings.com/manual"
 */
export type DclUserManualUrl = string;

/**
 * URL that contains product specific web page that contains support details for the device model.
 * @example "http://smartthings.com/support"
 */
export type DclSupportUrl = string;

/**
 * URL that contains product specific web page that contains details for the device model.
 * @example "http://smartthings.com/product"
 */
export type DclProductUrl = string;

export interface DclModel {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** device type identifier */
  deviceTypeId: DclDeviceTypeId;
  /** product name */
  productName: DclProductName;
  /** model description (string or path to file containing data) */
  productLabel: DclProductLabel;
  /** stock keeping unit */
  partNumber: DclPartNumber;
  /** A value of 1 indicates that user interaction with the device (pressing a button, for example) is required before commissioning can take place. When CommissioningCustomflow is set to a value of 2, the commissioner SHOULD attempt to obtain a URL which MAY be used to provide an end-user with the necessary details for how to configure the product for initial commissioning */
  commissioningCustomFlow: DclCommissioningCustomFlow;
  /** commissioningCustomFlowUrl SHALL identify a vendor specific commissioning URL for the device model when the commissioningCustomFlow field is set to '2' */
  commissioningCustomFlowUrl: DclCommissioningCustomFlowUrl;
  /** commissioningModeInitialStepsHint SHALL identify a hint for the steps that can be used to put into commissioning mode a device that has not yet been commissioned. This field is a bitmap with values defined in the Pairing Hint Table. For example, a value of 1 (bit 0 is set) indicates that a device that has not yet been commissioned will enter Commissioning Mode upon a power cycle. */
  commissioningModeInitialStepsHint: DclCommissioningModeInitialStepsHint;
  /** commissioningModeInitialStepsInstruction SHALL contain text which relates to specific values of CommissioningModeInitialStepsHint. Certain values of CommissioningModeInitialStepsHint, as defined in the Pairing Hint Table, indicate a Pairing Instruction (PI) dependency, and for these values the commissioningModeInitialStepsInstruction SHALL be set */
  commissioningModeInitialStepsInstruction: DclCommissioningModeInitialStepsInstruction;
  /** commissioningModeSecondaryStepsHint SHALL identify a hint for steps that can be used to put into commissioning mode a device that has already been commissioned. This field is a bitmap with values defined in the Pairing Hint Table. For example, a value of 4 (bit 2 is set) indicates that a device that has already been commissioned will require the user to visit a current CHIP Administrator to put the device into commissioning mode. */
  commissioningModeSecondaryStepsHint: DclCommissioningModeSecondaryStepsHint;
  /** commissioningModeSecondaryStepInstruction SHALL contain text which relates to specific values of commissioningModeSecondaryStepsHint. Certain values of commissioningModeSecondaryStepsHint, as defined in the Pairing Hint Table, indicate a Pairing Instruction (PI) dependency, and for these values the commissioningModeSecondaryStepInstruction SHALL be set */
  commissioningModeSecondaryStepsInstruction: DclCommissioningModeSecondaryStepsInstruction;
  /** URL that contains product specific web page that contains user manual for the device model. */
  userManualUrl: DclUserManualUrl;
  /** URL that contains product specific web page that contains support details for the device model. */
  supportUrl: DclSupportUrl;
  /** URL that contains product specific web page that contains details for the device model. */
  productUrl: DclProductUrl;
  /** URL to the Localized String File of this product. */
  lsfUrl: DclLsfUrl;
  lsfRevision: DclLsfRevision;
  /** address of the ledger account */
  creator: DclAddress;
}

export interface DclTestedModel {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** software version string */
  softwareVersionString: DclSoftwareVersionString;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
}

export interface DclComplianceRecord {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** software version string */
  softwareVersionString: DclSoftwareVersionString;
  /** certified or revoked */
  state: DclCertificationState;
  /** RFC3339 section 5.6 date time format */
  date: DclRfc3339Date;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
  /** reason */
  reason: DclReason;
  /** address of the ledger account */
  owner: DclAddress;
}

export interface DclComplianceHistoryItem {
  softwareVersionCertificationStatus: DclSoftwareVersionCertificationStatus;
  /** RFC3339 section 5.6 date time format */
  date: DclRfc3339Date;
  /** reason */
  reason: DclReason;
  /** CD version number */
  cDVersionNumber: DclCDVersionNumber;
}

export interface DclProposedCertificate {
  /** PEM certifcate */
  pemCert: DclPemCert;
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
  /** serial number of the PEM certificate */
  serialNumber: DclSerialNumber;
  /** address of the ledger account */
  owner: DclAddress;
  approvals: DclAddress[];
}

export interface DclRootCertificateItem {
  /** PEM certifcate */
  pemCert: DclPemCert;
  /** serial number of the PEM certificate */
  serialNumber: DclSerialNumber;
  /** issuer of the PEM certificate */
  issuer: DclIssuer;
  /** certifcate authority key ID */
  authorityKeyId: DclAuthorityKeyId;
  /** root subject of the PEM certificate */
  rootSubject: DclRootSubject;
  /** root subject key ID of the PEM certificate */
  rootSubjectKeyId: DclRootSubjectKeyId;
  /** whether the certificate is root certificate */
  isRoot: DclIsRoot;
  /** address of the ledger account */
  owner: DclAddress;
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
}

export interface DclCertifiedModel {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
  /**
   * certified or not
   * @example true
   */
  value: boolean;
}

export interface DclProvisionalModel {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
  /**
   * provisioned or not
   * @example true
   */
  value: boolean;
}

export interface DclComplianceInfo {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** software version string */
  softwareVersionString: DclSoftwareVersionString;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
  /** CD version number */
  cDVersionNumber: DclCDVersionNumber;
  softwareVersionCertificationStatus: DclSoftwareVersionCertificationStatus;
  /** RFC3339 section 5.6 date time format */
  date: DclRfc3339Date;
  /** reason */
  reason: DclReason;
  /** address of the ledger account */
  owner: DclAddress;
  history: DclComplianceHistoryItem[];
  /** CSA certification’s certificate ID */
  cDCertificateId: DclCDCertificateId;
  /** certification route */
  certificationRoute: DclCertificationRoute;
  /** program type */
  programType: DclProgramType;
  /** program type version */
  programTypeVersion: DclProgramTypeVersion;
  /** compliant platform used */
  compliantPlatformUsed?: DclCompliantPlatformUsed;
  /** compliant platform version */
  compliantPlatformVersion: DclCompliantPlatformVersion;
  /** transport */
  transport: DclTransport;
  /** family ID */
  familyId: DclFamilyId;
  /** supported clusters */
  supportedClusters: DclSupportedClusters;
  /** OS version */
  OSVersion: DclOSVersion;
  /** parent child */
  parentChild: DclParentChild;
  /** certification ID of software component */
  certificationIdOfSoftwareComponent: DclCertificationIdOfSoftwareComponent;
}

export interface DclDeviceSoftwareCompliance {
  /** CSA certification’s certificate ID */
  cDCertificateId: DclCDCertificateId;
  complianceInfo: DclComplianceInfo;
}

export interface DclRevokedModel {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** matter or zigbee is the and the only supported values for now */
  certificationType: DclCertificationType;
  /** @example false */
  value: boolean;
}

export interface DclVendorProducts {
  /** vendor ID */
  vid: DclVendorId;
  products: {
    /** product ID */
    pid: DclProductId;
    /** product name */
    name: DclProductName;
    /** stock keeping unit */
    partNumber: DclPartNumber;
  }[];
}

export interface DclModelVersions {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  softwareVersions: DclSoftwareVersion[];
}

export interface DclModelVersion {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** software version string */
  softwareVersionString: DclSoftwareVersionString;
  /** CD version number */
  cdVersionNumber: DclCDVersionNumber;
  /** firmware image digests */
  firmwareDigests: DclFirmwareDigests;
  /** valid software version */
  softwareVersionValid: DclSoftwareVersionValid;
  /** URL to download firmware image */
  otaUrl: DclOtaUrl;
  /** OTA firmware image file size in bytes */
  otaFileSize: DclOtaFileSize;
  /** OTA firmware image checksum */
  otaChecksum: DclOtaChecksum;
  otaChecksumType: DclOtaChecksumType;
  minApplicableSoftwareVersion: DclMinApplicableSoftwareVersion;
  maxApplicableSoftwareVersion: DclMaxApplicableSoftwareVersion;
  /** URL to release note */
  releaseNotesUrl: DclReleaseNotesUrl;
  /** address of the ledger account */
  creator: DclAddress;
}

export interface DclSoftwareVersionDetails {
  /** vendor ID */
  vid: DclVendorId;
  /** product ID */
  pid: DclProductId;
  softwares: DclSoftwareVersionDetail[];
}

export interface DclSoftwareVersionDetail {
  /** software version */
  softwareVersion: DclSoftwareVersion;
  /** software version string */
  softwareVersionString: DclSoftwareVersionString;
  /** CD version number */
  cdVersionNumber: DclCDVersionNumber;
  /** firmware image digests */
  firmwareDigests: DclFirmwareDigests;
  /** valid software version */
  softwareVersionValid: DclSoftwareVersionValid;
  /** URL to download firmware image */
  otaUrl: DclOtaUrl;
  /** OTA firmware image file size in bytes */
  otaFileSize: DclOtaFileSize;
  /** OTA firmware image checksum */
  otaChecksum: DclOtaChecksum;
  otaChecksumType: DclOtaChecksumType;
  minApplicableSoftwareVersion: DclMinApplicableSoftwareVersion;
  maxApplicableSoftwareVersion: DclMaxApplicableSoftwareVersion;
  /** URL to release note */
  releaseNotesUrl?: DclReleaseNotesUrl;
  /** the software certification status */
  certificationStatus: DclCertificationStatus;
}

export interface DclApprovedCertificates {
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
  certs: DclRootCertificateItem[];
}

export interface DclProposedCertificateRevocation {
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
  approvals: DclAddress[];
}

export interface DclRevokedCertificates {
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
  certs: DclRootCertificateItem[];
}

export interface DclCert {
  /** subject of the PEM certificate */
  subject: DclSubject;
  /** subject key ID of the PEM certificate */
  subjectKeyId: DclSubjectKeyId;
}

export interface DclVendorInfo {
  /** vendor ID */
  vendorId: DclVendorId;
  /** vendor name */
  vendorName: DclVendorName;
  /** company legal name */
  companyLegalName: DclCompanyLegalName;
  /** preferred name for the company */
  companyPreferredName: DclCompanyPreferredName;
  /** URL to vendor landing page */
  vendorLandingPageUrl: DclVendorLandingPageUrl;
  /** address of the ledger account */
  creator: DclAddress;
}

/**
 * PageResponse is to be embedded in gRPC response messages where the
 * corresponding request message has used PageRequest.
 *
 *  message SomeResponse {
 *          repeated Bar results = 1;
 *          PageResponse page = 2;
 *  }
 */
export interface DclPagination {
  /**
   * nextKey is the key to be passed to PageRequest.key to
   * query the next page most efficiently
   * @format byte
   * @example "86F5B7AA"
   */
  nextKey: string;
  /**
   * total is total number of results available if PageRequest.countTotal
   * was set, its value is undefined otherwise
   * @format uint64
   * @example 5
   */
  total: string;
}

/** A DAC valdation post body */
export interface PostDACValidationBody {
  /**
   * PEM representation of the DAC certificate
   * @example "-----BEGIN CERTIFICATE-----\nMIICvDCCAaQ..."
   */
  dac: string;
  /**
   * PEM representation of the PAI certificate
   * @example "-----BEGIN CERTIFICATE-----\nMIICvDCCAaQ..."
   */
  pai: string;
}

/**
 * attestation nonce base64 string
 * @example "8bTcPM/bkfytyqIafTlhzFeMywP2QKddEht6JbhymKs="
 */
export type MatterAttestationNonce = string;

/**
 * ID used to identify requests/workflows
 * @example "2bdfe269-f5a2-48e6-b336-d27ca785147b"
 */
export type MatterAttestationTransactionId = string;

/** Body containing attestation challenge, elements, and signature */
export interface PostAttestationTransactionBody {
  /**
   * base64-encoded attestation challenge
   * @example "O6Y+RTWD3JZL4S7DaEK9ZA=="
   */
  attestation_challenge: string;
  /**
   * base64-encoded attestation elements
   * @example "O6Y+RTWD3JZL4S7DaEK9ZA=="
   */
  attestation_elements: string;
  /**
   * base64-encoded attestation signature
   * @example "O6Y+RTWD3JZL4S7DaEK9ZA=="
   */
  attestation_signature: string;
}

/** Body containing array of vids and pids */
export interface PostSoftwareVersionsBody {
  /**
   * @maxItems 512
   * @minItems 1
   */
  models: {
    modelVersions: {
      /** vendor ID */
      vid: DclVendorId;
      /** product ID */
      pid: DclProductId;
    };
  }[];
}

/** Body containing array of model detail */
export interface PostSoftwareVersionDetailsBody {
  /** "certified" will get both revoked and certified models, "provisional" will get revoked, certified, and provisional models.  If no requirement is specified, revoked, certified, provisional, and none certification status models will return. */
  certificationRequirement?: 'certified' | 'provisional';
  /**
   * @maxItems 512
   * @minItems 1
   */
  models: {
    /** vendor ID */
    vid: DclVendorId;
    /** product ID */
    pid: DclProductId;
    /** minimum software version requested */
    minimumSoftwareVersion?: DclMinimumSoftwareVersion;
  }[];
}

export interface DeviceEssentialRequest {
  /**
   * The identifier for the device instance
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId: string;
  ocf?: BaseDeviceIdentifier;
  mqtt?: BaseDeviceIdentifier;
  video?: BaseDeviceIdentifier;
}

export interface BaseDeviceIdentifier {
  /**
   * Alpha-numeric code associated with an organization. When a user joins an organization, they can submit integrations using this mnId
   * @maxLength 4
   * @example "0AFD"
   */
  mnId?: string;
  /**
   * The Device serial setupId read from QR code
   * @maxLength 3
   * @example "600"
   */
  setupId?: string;
  /**
   * The device serial number
   * @maxLength 15
   * @example "A1B2CD3EFG4H"
   */
  serialNumber?: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA512 algorithm
   * @format ^[a-z0-9]{128}$
   * @maxLength 512
   * @example "669ca8453e8fce6ab564f447362332d4296bd5ecad64ac273d1c21f4bb5b39cf19fe9f00ae44adb1ae4724a8fd45da47856e98e8dc8968a1a3ec4a1be58eeb27"
   */
  hashedSerialNumber?: string;
  /**
   * The last 4 characters of the device's serial number
   * @maxLength 4
   */
  partialSerialNumber?: string;
  /**
   * The unique name that identifies a wireless network (Service Set Identifier)
   * @maxLength 32
   * @example "MyNetwork"
   */
  ssid?: string;
  /**
   * The model code
   * @maxLength 32
   * @example "WF45R6300AV/US"
   */
  modelCode?: string;
  /** Hashed MacAddress */
  macAddressHash?: HashedMacAddress;
}

export interface DeviceEssentialResponse {
  /**
   * The identifier for the device instance
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  deviceId?: string;
  ocf?: BaseDeviceIdentifier;
  mqtt?: BaseDeviceIdentifier;
  video?: BaseDeviceIdentifier;
}

/** Hashed MacAddress */
export interface HashedMacAddress {
  /**
   * Wifi MAC Address
   * @example "hash(2C:54:91:88:C9:E3 or 2c-54-91-88-c9-e3)"
   */
  wifi?: string;
  /**
   * Bluetooth lite MAC Address
   * @example "hash(2C:54:91:88:C9:E3 or 2c-54-91-88-c9-e3)"
   */
  ble?: string;
  /**
   * Peer to peer address
   * @example "hash(2C:54:91:88:C9:E3 or 2c-54-91-88-c9-e3)"
   */
  p2p?: string;
  /**
   * Bluetooth MAC address
   * @example "hash(2C:54:91:88:C9:E3 or 2c-54-91-88-c9-e3)"
   */
  bt?: string;
  /**
   * Universal Plug and Play address
   * @example "hash(2C:54:91:88:C9:E3 or 2c-54-91-88-c9-e3)"
   */
  upnp?: string;
}

export type DeleteDeviceResponse = object;

export interface DeviceEssentialsResponse {
  items?: DeviceEssentialResponse[];
  _links?: Links;
}

export interface ClientSubscription {
  /** The subscription id of the subscription. */
  subscriptionId?: ClientSubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: ClientSubscriptionFilters;
}

/**
 * The subscription id of the subscription.
 * @format uuid
 */
export type ClientSubscriptionId = string;

/** An array of subscription filters */
export type ClientSubscriptionFilters = ClientSubscriptionFilter[];

export interface ClientSubscriptionFilter {
  /** The type of filter */
  type?: ClientSubscriptionFilterTypes;
  /** An array of subscription filter values. */
  value?: ClientSubscriptionFilterValues;
  eventType?: ClientSubscriptionFilterEventTypes;
  attribute?: ClientSubscriptionFilterAttributes;
  capability?: ClientSubscriptionFilterCapabilities;
  component?: ClientSubscriptionFilterComponents;
}

/** The type of filter */
export enum ClientSubscriptionFilterTypes {
  LOCATIONIDS = 'LOCATIONIDS',
  DEVICEIDS = 'DEVICEIDS',
  INSTALLEDSMARTAPPIDS = 'INSTALLEDSMARTAPPIDS',
  SMARTAPPIDS = 'SMARTAPPIDS',
}

/** An array of subscription filter values. */
export type ClientSubscriptionFilterValues = string[];

export type ClientSubscriptionFilterEventTypes = string[];

export type ClientSubscriptionFilterAttributes = string[];

export type ClientSubscriptionFilterCapabilities = string[];

export type ClientSubscriptionFilterComponents = string[];

export interface ClientSubscriptionTarget {
  /** The address to send events to. */
  subscriptionTarget?: ClientSubscriptionTargetValue;
}

/**
 * The address to send events to.
 * @format uri
 */
export type ClientSubscriptionTargetValue = string;

/**
 * The subscription id of the subscription.
 * @format uuid
 */
export type SubscriptionId = string;

/** An array of subscription filters */
export type SubscriptionFilters = SubscriptionFilter[];

export interface SubscriptionFilter {
  /** The type of filter */
  type?: SubscriptionFilterTypes;
  /** An array of subscription filter values. */
  value?: SubscriptionFilterValues;
  eventType?: SubscriptionFilterEventTypes;
  attribute?: SubscriptionFilterAttributes;
  capability?: SubscriptionFilterCapabilities;
  component?: SubscriptionFilterComponents;
}

/** The type of filter */
export enum SubscriptionFilterTypes {
  LOCATIONIDS = 'LOCATIONIDS',
  DEVICEIDS = 'DEVICEIDS',
  INSTALLEDSMARTAPPIDS = 'INSTALLEDSMARTAPPIDS',
  SMARTAPPIDS = 'SMARTAPPIDS',
}

/** An array of subscription filter values. */
export type SubscriptionFilterValues = string[];

export type SubscriptionFilterEventTypes = string[];

export type SubscriptionFilterAttributes = string[];

export type SubscriptionFilterCapabilities = string[];

export type SubscriptionFilterComponents = string[];

export interface SubscriptionTarget {
  /** The address to send events to. */
  url?: SubscriptionTargetValue;
}

/**
 * The address to send events to.
 * @format uri
 */
export type SubscriptionTargetValue = string;

/** @example {"version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionRequest {
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface CreateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface GetSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionRequest {
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface UpdateSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

/** An empty object 200 response. */
export type DeleteSubscriptionResponse = object;

export interface RegisterSubscriptionRequest {
  subscriptionTarget?: SubscriptionTarget;
}

/** @example {"subscriptionId":"33c78a39-9145-4cd9-9b9e-4ae538111e94","registrationUrl":"https://example.smartthings.com/sse","version":1,"name":"my-subscription-name","subscriptionFilters":[{"type":"LOCATIONIDS"}]} */
export interface RegisterSubscriptionResponse {
  /** The subscription id of the subscription. */
  subscriptionId?: SubscriptionId;
  /**
   * The URL used to register a subscription via CES.
   * @format uri
   */
  registrationUrl?: string;
  /** The name of the subscription */
  name?: string;
  /** The version of the event */
  version?: number;
  /** An array of subscription filters */
  subscriptionFilters?: SubscriptionFilters;
}

export interface ConnectedServiceSummary {
  /** The type of Connected Service */
  serviceType: 'ENDPOINTAPP' | 'SMARTAPP' | 'VIPER';
  /**
   * This will only be populated when appType is ENDPOINTAPP
   * @example {"installedAppId":"8885b9c3-a50d-427e-ad07-d7a2f94421af","installedAppType":"WEBHOOK_SMART_APP","installedAppStatus":"PENDING","displayName":"Color App","appId":"fdd21b3e-5880-44c8-9f61-ce474814f587","referenceId":"c71b0a5b-7dab-41fe-b75f-7cf30246468e","locationId":"4ae86cfc-63be-4bcc-8514-836c873b4d7a","owner":{"ownerType":"USER","ownerId":"3f178632-79ed-4358-94de-280dbd7c206c"},"notices":["USER_PAUSE","RECONFIGURE"],"createdDate":"2017-05-19T12:39:37Z","lastUpdatedDate":"2017-05-19T12:39:37Z","allowed":["w:installedapps","d:installedapps"]}
   */
  endpointapp?: {
    /**
     * The ID of the installed app.
     * @format uuid
     */
    installedAppId: string;
    /** Denotes the type of installed app. */
    installedAppType: InstalledAppType;
    /**
     * Denotes the current state of an install.  'PENDING' is used during active modification to the install's config
     * prior to 'AUTHORIZATION'. A status of 'AUTHORIZED' means the install's permissions have been authorized by the
     * consumer. Installed Apps in 'AUTHORIZED' state are fully installed and usable by the SmartThings platform.  A
     * status of 'REVOKED' means the install's permissions have been revoked.  A status of 'DISABLED' means a previously
     * 'AUTHORIZED' Installed App will not execute.
     */
    installedAppStatus: InstalledAppStatus;
    /**
     * A user defined name for the installed app. May be null.
     * @maxLength 100
     */
    displayName?: string;
    /** The ID of the app. */
    appId: string;
    /** A reference to an upstream system.  For example, Behaviors would reference the behaviorId. May be null. */
    referenceId?: string;
    /**
     * The ID of the location to which the installed app may belong.
     * @format uuid
     */
    locationId?: string;
    /** A typed model which provides information around ownership of a specific domain. */
    owner: Owner;
    notices: Notice[];
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    createdDate: string;
    /**
     * A UTC ISO-8601 Date-Time String
     * @format date-time
     */
    lastUpdatedDate: string;
    /**
     * A collection of settings to drive user interface in SmartThings clients.  Currently, only applicable for
     * LAMBDA_SMART_APP and WEBHOOK_SMART_APP app types.
     */
    ui?: {
      /** @format ^[a-zA-Z._]{1,99}$ */
      pluginId?: string;
      /** @format uri */
      pluginUri?: string;
      dashboardCardsEnabled: boolean;
      preInstallDashboardCardsEnabled: boolean;
    };
    /**
     * A default icon image for the app.
     * @example {"url":"https://smart-home-monitor.com/image"}
     */
    iconImage?: {
      /**
       * A default icon image url for an app. https url required.
       * @format uri
       */
      url?: string;
    };
    /**
     * An App maybe associated to many classifications.  A classification drives how the integration is presented
     * to the user in the SmartThings mobile clients.  These classifications include:
     * * AUTOMATION - Denotes an integration that should display under the "Automation" tab in mobile clients.
     * * SERVICE - Denotes an integration that is classified as a "Service".
     * * DEVICE - Denotes an integration that should display under the "Device" tab in mobile clients.
     * * CONNECTED_SERVICE - Denotes an integration that should display under the "Connected Services" menu in mobile clients.
     * * HIDDEN - Denotes an integration that should not display in mobile clients
     */
    classifications: ('AUTOMATION' | 'SERVICE' | 'DEVICE' | 'CONNECTED_SERVICE' | 'HIDDEN' | 'LABS')[];
    /** Denotes the principal type to be used with the app.  Default is LOCATION. */
    principalType: 'LOCATION' | 'USER_LEVEL';
    /** Restriction tier of the install, if any. */
    restrictionTier?: number;
    /**
     * Inform the installation systems that the associated app can only be installed once within a user's account.
     * @default false
     */
    singleInstance: boolean;
    /**
     * List of client-facing action identifiers that are currently permitted for the user.
     * If the value of this property is not null, then any action not included in the list value of the property is currently prohibited for the user.
     * If the value of this property is null (or absent), then no permission-related information is being provided.
     * <ul>
     * <li>`"w:installedapps"` -- the user has update permissions on the installed app</li>
     * <li>`"d:installedapps"` -- the user has delete permissions on the installed app</li>
     * </ul>
     */
    allowed?: string[];
  };
  /** This will only be populated when appType is SMARTAPP */
  smartapp?: {
    /** The developer-defined name of the app */
    name: string;
    /** The user-defined label of the installedapp */
    label?: string;
    /** The id of the installed app */
    installedAppId: string;
    /**
     * The id of the location the app is installed
     * @format uuid
     */
    locationId: string;
    /** Whether or not the SmartApp has been completely installed */
    state: 'COMPLETE' | 'INCOMPLETE';
    /**
     * An icon image url for the app
     * @default "https://s3.amazonaws.com/smartapp-icons/Convenience/Cat-Convenience.png"
     */
    iconUrl: string;
    /** @default "NONE" */
    samsungCategory: 'automationApp' | 'setupApp' | 'serviceApp' | 'NONE';
    /**
     * Whether or not the automation can be paused
     * @default false
     */
    pausable: boolean;
    /**
     * Whether or not the automation is paused
     * @default false
     */
    paused: boolean;
    /**
     * Whether or not the automation is maintained by SmartThings or a third party
     * @default false
     */
    usesThirdPartyAuthentication: boolean;
  };
  /** This will only be populated when appType is VIPER */
  viper?: {
    /** isaId installed for the user */
    isaId: string;
    /** SmartThings Schema connector name given by partner eg Lifx (Connect) */
    appName: string;
    /** Parnter name eg Lifx Inc */
    partnerName: string;
    /** url of partner icon */
    icon: string;
    /** url of partner icon in 2x dimensions */
    icon2x: string;
    /** url of partner icon in 3x dimensions */
    icon3x: string;
    /** location of the installed smart app */
    locationId: string;
    /** connection status between partner and ST platform */
    partnerSTConnection: 'connected' | 'disconnected';
    /** endpoint app id of the installed smart app */
    endpointAppId: string;
  };
}

/** Request body for circadian cancellation. */
export interface CircadianCancelRequest {
  /**
   * The deviceId for which the circadian light effect needs to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

/** Request body for fade cancellation. */
export interface FadeCancelRequest {
  /**
   * The deviceId for which the fade light effects need to cancelled.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId: string;
  /**
   * The name of the component on this device, default is 'main'. The component must be valid for the device.
   * @format ^[-_!.~'()*0-9a-zA-Z]{1,36}$
   */
  componentId: string;
}

export interface CreateConfigurationRequest {
  /** device profile Id published by dossier */
  profileId: string;
  /** vendor id of device */
  vid: string;
  /** manufacture name */
  mnmn: string;
  /** configuration version */
  configurationVersion?: string;
  /** ble d2d configuration information */
  configuration: object;
}

export interface CreateConfigurationResponse {
  /** device profile Id published by dossier */
  profileId: string;
  /** vendor id of device */
  vid: string;
  /** manufacture name */
  mnmn: string;
  /** configuration version */
  configurationVersion?: string;
  /** ble d2d configuration information */
  configuration: object;
}

export type GetConfigurationList = GetConfiguration[];

export interface GetConfiguration {
  /** device profile Id published by dossier */
  profileId?: string;
  /** ble d2d configuration information */
  configuration?: object;
}

export interface BackendDeviceEventsRequest {
  /**
   * An array of attribute state updates.
   * @maxItems 8
   * @minItems 1
   */
  deviceEvents?: DeviceEvent[];
}

export interface CreateBackendEventsResponse {
  /** The list of state changes for each event created in the order in the create request */
  stateChanges?: boolean[];
}

export interface CreateDeviceRequest {
  /** Location Id Unique location identifier. Format shall be UUID */
  locationId: string;
  /** Room Id Unique room identifier. Format shall be UUID */
  roomId: string;
  /** Manufacture Name */
  mnmn: string;
  /** vendor Id */
  vid: string;
  /** device name */
  deviceName: string;
  /** temporary BLE Advertising Id */
  advertisingId?: string;
  /** Unique device identifier. */
  identifier?: string;
  /** one of key for the decrypt */
  cipher: string;
  /** temporary security encryption key */
  encryptionKey: string;
  /** configuration version */
  configurationVersion?: string;
  /** privacy Id Pool size */
  privacyIdPoolSize?: number;
  /** Values used for QR scan */
  tagData?: {
    /** Model name of tag device */
    modelName: string;
    /** Serial number of tag device */
    serialNumber: string;
    /** Setup Id of tag device */
    setupId: string;
    /** MnId of tag device */
    mnId: string;
    firmware?: {
      version?: string;
      specVersion?: string;
    };
  };
}

export interface CreateDeviceResponse {
  /** device UUID issued by gizmo */
  deviceId: string;
  /** ble configuration download url */
  configurationUrl: string;
  /** Metadata required to create privacyId */
  metadata?: {
    /** The number to know environment / region at the device */
    regionCode: number;
    /** The numbers of privacyId */
    privacyIdPoolSize: number;
    /** Seed value to compute privacy ID */
    privacyIdSeed: string;
    /** Privacy Id IV ( Initial Vector ) value */
    privacyIdInitialVector: string;
    /** Current epoch time of the server to sync with tag (in sec) */
    currentServerTime: number;
    /** When Tag onboards initial value must be set */
    numAllowableConnections: string;
    iBeacon: IBeacon;
    /** Lost mode url for NFC TAG */
    lostModeUrl?: string;
  };
}

export interface IBeacon {
  /** Unique Vender ID for iBeacon (16bytes, Base64 encoded) */
  uuid: string;
  /** Unique ID of device within iBeacon UUID (4bytes, Base64 encoded) */
  majorMinorId: string;
}

export interface LastKnownConnection {
  connectedDevice?: ConnectedDevice;
  connectedUser?: ConnectedUser;
  /** When the connected information is uploaded (epoch in sec). */
  updated?: number;
  /**
   * `bleScanned` : ST app is able to scan the tag
   * `gattConnected` : ST app is GATT connected with the tag
   * if omitted, regarded as `bleScanned`
   */
  d2dStatus?: string;
  /**
   * `true` : Tag is nearby or connected
   * `false` : Tag is no longer nearby or connected
   */
  nearby?: boolean;
  /**
   * `true` : Geolocation posted as per on-demand request
   * `false` : Geolocation posted as per ST app’s algorithm
   */
  onDemand?: boolean;
}

/**
 * Searchings status of a tracker
 *
 * | searchingStatus | description                                                                          |
 * | --------------- | ------------------------------------------------------------------------------------ |
 * | stop            | Initial status. it is updated when Onboarding or User action.                        |
 * | searching       | It is updated by User when device is lost.                                           |
 * | spotted         | It is updated when spotted by a nearby Galaxy device in searching status.            |
 * | stopByServer    | It is updated when spotted by a member or owner's Galaxy device in searching status. |
 */
export enum SearchingStatus {
  Stop = 'stop',
  Searching = 'searching',
  Spotted = 'spotted',
  StopByServer = 'stopByServer',
}

export interface TrackerMetaPPRecordResponse {
  /** User guid of Samsung Account */
  saGuid: string;
  /** Privacy policy version */
  version: string;
  /** Updated time */
  updated: number;
}

/**
 * A message to show to the person who acquired my tag when I lost it.
 * @example {"type":"CUSTOM","message":"This is a lost tag, please help me to find it","phoneNumber":"+821011112222"}
 */
export interface TrackerLostmessageOutput {
  /** There are two types. User-defined or not. PREDEFINED(default). CUSTOM */
  type: 'CUSTOM' | 'PREDEFINED';
  /** User-defined message */
  message?: string;
  /** User-defined phone number */
  phoneNumber?: string;
}

/**
 * Values for E2E Encryption
 * @example {"enabled":false}
 */
export interface TrackerE2EEncryptionConfig {
  /** Whether E2E's operation is on */
  enabled?: boolean;
}

/** Whether to save only the latest location information */
export interface GeolocationStorage {
  /**
   * `true`: only most recent ONE data is stored (true by default)
   * `false`: Saves location infromation up to 7 days from now.
   */
  recentDataOnly: boolean;
}

export interface RemoteRingResponse {
  /** Device ID of the remote ring target */
  targetId: string;
  /** true: Ring My Phone enabled. false: Ring My Phone disabled */
  enabled: boolean;
  /** Target Phone's name */
  targetName: string;
}

export interface ConnectedDevice {
  /**
   * Phone’s ST device uuid when the tracker is connected to a phone
   * @format uuid
   */
  id: string;
  /** Phone’s name when the tracker is connected to a phone */
  name: string;
}

export interface ConnectedUser {
  /** User’s Samsung Account Guid when the tracker is connected to a phone */
  id: string;
  /** User’s name when the tracker is connected to a phone */
  name: string;
}

/** Information of Accessories Devices. */
export interface GetPeripheralItemList {
  accessories?: GetPeripheralItem[];
}

export interface GetPeripheralItem {
  /** name */
  name?: string;
  /** mac address information */
  mac: string;
  /** manufacture information */
  manufacturer?: string;
  /** Update time from the database point of view */
  updatetime?: string;
  /** It is the resource updated time from client */
  modifiedtime?: string;
  /** It consists of 23 bits, a value that can distinguish a classic bluetooth device. */
  cod?: number;
  /** This is a value that can distinguish the device type in BLE */
  appearance?: number;
  /** Spare field in preparation for change of bluetooth specification */
  reserved?: string;
}

/** Different for each DeviceType, defined in DTH code */
export interface DevicePreference {
  /**
   * A description of what the preference does
   * @example "Section Title Description"
   */
  description?: string;
  /**
   * Allow multiple instances of this setting, always set to false for Device Preferences
   * @example false
   */
  multiple?: boolean;
  /**
   * An optional header for the preference
   * @example "Section Title"
   */
  title?: string;
  /**
   * Whether this setting is required to be set
   * @example false
   */
  required?: boolean;
  /**
   * The name/id of the preference
   * @example "textInput"
   */
  name: string;
  /**
   * Type of preference
   * @example "password"
   */
  type?: 'bool' | 'boolean' | 'enum' | 'text' | 'number' | 'decimal' | 'password' | 'paragraph';
  /**
   * Default preference value
   * @example "title"
   */
  defaultValue?: object;
  /**
   * Preference value. Can be string, integer, number, boolean or list. Stored in database as varchar(255)
   * @example ""
   */
  value: object;
  /** List of options; either list of strings or map of key/value pairs */
  options?: object;
  /**
   * Display this setting during device setup
   * @example false
   */
  displayDuringSetup?: boolean;
  /**
   * Element name
   * @example "paragraph"
   */
  element?: string;
  /**
   * Value range for the device. Split by ".." with the first value being the minimum and the second the maximum.
   * @format ^[0-9]*\.\.[0-9]*
   * @example "0..1000"
   */
  range?: string;
}

/** A request object to update the device preferences for a specific device, sent as a list of key:value pairs */
export type UpdateDevicePreferencesRequest = {
  /** The name of the device preference */
  name?: string;
  /** The value of the device preference */
  value?: string;
}[];

/** Device additional properties */
export interface DeviceAdditionalProperties {
  /** UI hint indicating that the device can move locations. */
  canMoveToOtherLocation: boolean;
  /** UI hint indicating that the device can move rooms. */
  canMoveToOtherRoom: boolean;
  /** UI hint indicating that the device is a child device. */
  isChildDevice: boolean;
  /** UI hint indicating that the device is able to be deleted. */
  isDeletable: boolean;
  /** UI hint indicating that the device is able to be saved. */
  isSavable: boolean;
}

export interface CasperClient {
  /** The Client ID */
  clientId?: ClientId;
  /** User UUID */
  userId?: UserId;
  /** Casper client type (CLIENT: client, DEVICE: IoT Thing) */
  type?: CasperClientType;
  /** The time when the client was created at (millisecond). */
  createTime?: CreateTime;
  /** The time when the client was modified at (millisecond). */
  updateTime?: UpdateTime;
  /** Client Category (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-17.DeviceType) */
  category?: CasperClientCategory;
  /** SmartThings App Version (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-21.AppVersion) */
  appVersion?: AppVersion;
  /** Manufacturer Name */
  manufacturer?: CasperClientManufacturer;
  /** Model Number */
  model?: CasperClientModel;
  /** To specify the version of the platform in which the client operates. */
  platformVersion?: PlatformVersion;
  /** Platform OS (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-11.OSName) */
  platformOS?: PlatformOS;
  /** Firmware Version */
  firmware?: Firmware;
  /** Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx) */
  language?: Language;
  /** Key value pairs stored in casper for the client */
  metadata?: CasperMetadata;
  /** Push Provider Name */
  pushProvider?: PushProvider;
  /** Push App ID */
  pushAppId?: PushAppId;
  /** Push Registered ID */
  pushRegId?: PushRegId;
}

export interface ClientUpdateRequest {
  /** Client Category (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-17.DeviceType) */
  category?: CasperClientCategory;
  /** SmartThings App Version (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-21.AppVersion) */
  appVersion?: AppVersion;
  /** Manufacturer Name */
  manufacturer?: CasperClientManufacturer;
  /** Model Number */
  model?: CasperClientModel;
  /** To specify the version of the platform in which the client operates. */
  platformVersion?: PlatformVersion;
  /** Platform OS (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-11.OSName) */
  platformOS?: PlatformOS;
  /** Firmware Version */
  firmware?: Firmware;
  /** Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx) */
  language?: Language;
  /** Key value pairs stored in casper for the client */
  metadata?: CasperMetadata;
  /** The OAuth client ID */
  oAuthClientId?: OAuthClientId;
  /** The OAuth provider */
  oAuthProvider?: OAuthProvider;
}

export interface ClientCreateRequest {
  /**
   * The Client ID
   * @format uuid
   */
  clientId: string;
  /** Client Category (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-17.DeviceType) */
  category?: CasperClientCategory;
  /** SmartThings App Version (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-21.AppVersion) */
  appVersion?: AppVersion;
  /** Manufacturer Name */
  manufacturer?: CasperClientManufacturer;
  /** Model Number */
  model?: CasperClientModel;
  /** To specify the version of the platform in which the client operates. */
  platformVersion?: PlatformVersion;
  /** Platform OS (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-11.OSName) */
  platformOS?: PlatformOS;
  /** Firmware Version */
  firmware?: Firmware;
  /** Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx) */
  language?: Language;
  /** Key value pairs stored in casper for the client */
  metadata?: CasperMetadata;
  /** The OAuth client ID */
  oAuthClientId?: OAuthClientId;
  /** The OAuth provider */
  oAuthProvider?: OAuthProvider;
}

/**
 * Client Category (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-17.DeviceType)
 * @example "Phone, Watch, Tablet, PC, Unknown ..."
 */
export type CasperClientCategory = string;

/**
 * SmartThings App Version (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-21.AppVersion)
 * @example "1.7.55.63"
 */
export type AppVersion = string;

/**
 * Manufacturer Name
 * @example "Samsung Electronics, Apple, Unknown ..."
 */
export type CasperClientManufacturer = string;

/**
 * Model Number
 * @example "SM-G988U, UA50RU7400KXXV"
 */
export type CasperClientModel = string;

/**
 * To specify the version of the platform in which the client operates.
 * @example "11, 9 (Android), 14.0.1, 14.2 (iOS), 5.5, 6.0 (Tizen)"
 */
export type PlatformVersion = string;

/**
 * Platform OS (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-11.OSName)
 * @example "Android, Tizen, iOS, Windows, Unknown"
 */
export type PlatformOS = string;

/** Firmware Version */
export type Firmware = string;

/**
 * Key value pairs stored in casper for the client
 * @example {"uiVersion":"In case of MX, one UI version. (e.g. ONEUI1.0, 1.0.1)","smartKitVersion":"e.g. 6.2.0, 7.0.1 (https://smartthings.atlassian.net/wiki/spaces/MOBI/pages/759332875/SmartThingsCore+Versioning)","smartThingsKitVersion":"e.g. 1.3.0, 1.4.0 (https://mobilerndhub.sec.samsung.net/wiki/display/SCONNECT/06.+Feature+set)","marketingName":"e.g. Galaxy S8"}
 */
export type CasperMetadata = Record<string, object>;

/**
 * The Client ID
 * @format uuid
 * @example "2fd72281-a355-43ef-b1c7-ea1d9b6f99f6"
 */
export type ClientId = string;

/**
 * User UUID
 * @format uuid
 */
export type UserId = string;

/**
 * The time when the client was created at (millisecond).
 * @format int64
 * @example 1646636708446
 */
export type CreateTime = number;

/**
 * The time when the client was modified at (millisecond).
 * @format int64
 * @example 1646636708446
 */
export type UpdateTime = number;

/** The OAuth client ID */
export type OAuthClientId = string;

/** The OAuth provider */
export type OAuthProvider = string;

export interface CasperClientResponse {
  /** The Client ID */
  clientId: ClientId;
  /** User UUID */
  userId: UserId;
  /** Casper client type (CLIENT: client, DEVICE: IoT Thing) */
  type: CasperClientType;
  /** The time when the client was created at (millisecond). */
  createTime: CreateTime;
  /** The time when the client was modified at (millisecond). */
  updateTime: UpdateTime;
  /** Client Category (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-17.DeviceType) */
  category?: CasperClientCategory;
  /** SmartThings App Version (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-21.AppVersion) */
  appVersion?: AppVersion;
  /** Manufacturer Name */
  manufacturer?: CasperClientManufacturer;
  /** Model Number */
  model?: CasperClientModel;
  /** To specify the version of the platform in which the client operates. */
  platformVersion?: PlatformVersion;
  /** Platform OS (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=217554790#id-2021%EB%85%84%EC%8B%A0%EA%B7%9C%ED%91%9C%EC%A4%80%EC%A0%95%EC%9D%98%EC%84%9C(24%EC%A2%85)-11.OSName) */
  platformOS?: PlatformOS;
  /** Firmware Version */
  firmware?: Firmware;
  /** Language code (https://code.sec.samsung.net/confluence/pages/viewpage.action?pageId=218347478&preview=/218347478/218363110/Language_Code_v1.0.pptx) */
  language?: Language;
  /** Key value pairs stored in casper for the client */
  metadata?: CasperMetadata;
}

/** Casper client type (CLIENT: client, DEVICE: IoT Thing) */
export enum CasperClientType {
  CLIENT = 'CLIENT',
  DEVICE = 'DEVICE',
}

/** A paginated array of Casper clients */
export interface PagedCasperClients {
  items: CasperClient[];
  _links: Links;
}

/**
 * Push Provider Name
 * @example "FCM_COMMAND_NOTI"
 */
export type PushProvider = string;

/**
 * Push App ID
 * @example "34266"
 */
export type PushAppId = string;

/**
 * Push Registered ID
 * @example "dvVbn0g1QsWKG6e_2TWdO1"
 */
export type PushRegId = string;

/**
 * Country Code
 * @example "ko"
 */
export type Locale = string;

/** Device Icon Data */
export interface DeviceIconData {
  /**
   * Unique Id of a location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * Unique Id of a device.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  deviceId?: string;
  /** The icon url. */
  icon?: string;
}

export interface UiComponent {
  /** Id of the component */
  id: string;
  background?: UiBackground;
  type: UiComponentType;
  action?: UiAction;
  /** jsonpath for which components must be selected for the component to be visible */
  showIf?: string;
}

export enum UiComponentType {
  SECTION = 'SECTION',
  SORTABLE_SECTION = 'SORTABLE_SECTION',
  LABEL = 'LABEL',
  INPUT = 'INPUT',
  SINGLE_SELECT_LIST = 'SINGLE_SELECT_LIST',
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
}

/** A section. */
export type UiSection = UiComponent & {
  label?: string;
  layout: 'VERTICAL' | 'HORIZONTAL';
  items: UiComponent[];
};

/** A sortable section. Items will initially be sorted in accordance to the first sortKey */
export type UiSortableSection = UiComponent & {
  label?: string;
  layout: 'VERTICAL' | 'HORIZONTAL';
  items: UiSortItem[];
  /** @example "name, date(asc), date(desc)" */
  sortKeys: string[];
};

/** an item in a sortable section */
export interface UiSortItem {
  item: UiComponent;
  /** @example "Bob, 1, 9" */
  sortValues: string[];
}

/** A label. */
export type UiLabel = UiComponent & {
  markDownText: string;
};

/** An input. */
export type UiInput = UiComponent & {
  label: string;
  text?: string;
  validation: InputValidation;
  required: boolean;
};

/** A single select list. */
export type UiSingleSelectList = UiComponent & {
  label: string;
  /** id of the selected item */
  selected?: string;
  items: ListSelectItem[];
  required: boolean;
};

/** A multi select list. */
export type UiMultiSelectList = UiComponent & {
  label: string;
  /** ids of the selected items */
  selected: string[];
  items: ListSelectItem[];
  required: boolean;
};

/** object to select */
export interface ListSelectItem {
  /** id of the item */
  id?: string;
  /** markDown to present to the user */
  markDownText?: string;
}

export interface InputValidation {
  type: InputType;
}

export enum InputType {
  TEXT = 'TEXT',
  INT = 'INT',
  FLOAT = 'FLOAT',
}

export type TextValidation = InputValidation & {
  maxLength: number;
};

export type IntValidation = InputValidation & {
  max: number;
  min: number;
};

export type FloatValidation = InputValidation & {
  max: number;
  min: number;
};

export interface UiBackground {
  type: UiBackgroundType;
}

export enum UiBackgroundType {
  IMAGE = 'IMAGE',
  GRADIENT = 'GRADIENT',
}

/** An image background. */
export type UiImageBackground = UiBackground & {
  /** url to the image of the wallpaper */
  image: string;
};

/** A gradient background. */
export type UiGradientBackground = UiBackground & {
  /** hexadecimal value of start colour */
  startHex: string;
  /** hexadecimal value of end colour */
  endHex: string;
};

export interface UiAction {
  type: UiActionType;
}

export enum UiActionType {
  NATIVE_ACTION = 'NATIVE_ACTION',
  HTTP_ACTION = 'HTTP_ACTION',
}

/** A native action. */
export type UiNativeAction = UiAction & {
  /** name of the controller to be invoked */
  controller: string;
  params: UiControllerParams;
};

/** An http action that replaces the entire page. */
export type UiHttpAction = UiAction & {
  /** http method to invoke */
  method: string;
  /** http url to invoke */
  url: string;
  /** body to send with jsonpath expressions to signify where and what to config values to insert. */
  body?: UiHttpBody;
  /**
   * jsonPath to area to replace with the successful response
   * @example "${$.items[?(@.id=='uuid5')]"
   */
  areaToReplace?: string;
};

/** body to send with jsonpath expressions to signify where and what to config values to insert. */
export interface UiHttpBody {
  /**
   * escaped json with placeholders for replacements
   * @example "{"config":{"lightSwitch":${1}, "button":${2}}}"
   */
  content?: string;
  replacements?: string[];
}

export interface UiControllerParams {
  type: UiControllerType;
}

export enum UiControllerType {
  ROOM_DETAIL_CONTROLLER = 'ROOM_DETAIL_CONTROLLER',
}

/** A native action. */
export type UiRoomDetailControllerParams = UiControllerParams & {
  /** id of the room */
  roomId: string;
};

export interface WrappedMainCard {
  /** The icon url */
  icon: string;
  /** The label to display for this card */
  label: string;
  /** The card status */
  status: string;
  details: CardTypeDetails;
}

export interface CardTypeDetails {
  /** The selected card type of object: `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `LIGHTS`, `BLINDS`, `WEATHER` `OUTDOOR_AIR_QUALITY` */
  cardType: CardType;
}

/** The selected card type of object: `INDOOR_TEMPERATURE`, `INDOOR_HUMIDITY`, `LIGHTS`, `BLINDS`, `WEATHER` `OUTDOOR_AIR_QUALITY` */
export enum CardType {
  INDOOR_TEMPERATURE = 'INDOOR_TEMPERATURE',
  INDOOR_HUMIDITY = 'INDOOR_HUMIDITY',
  LIGHTS = 'LIGHTS',
  BLINDS = 'BLINDS',
  WEATHER = 'WEATHER',
  OUTDOOR_AIR_QUALITY = 'OUTDOOR_AIR_QUALITY',
}

export type CardTypeIndoorTemperature = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatus[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeIndoorHumidity = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatus[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeLights = {
  /**
   * The ID for either the deviceGroup or a single device if there is only one.  The `type` will specify which ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  groupId: string;
  /** The identifier for the ID type in `groupId */
  type: 'GROUP' | 'DEVICE';
  /** Flag to identify if card is displayed as active/inactive */
  active: boolean;
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatusIcon[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type SummaryRoomStatusIcon = SummaryRoom & {
  /** The icon url */
  icon: string;
};

export type CardTypeBlinds = {
  /** The rooms that contain devices with the same capabilities */
  rooms: SummaryRoomStatusIcon[];
  /** The capabilities for the summary card */
  capabilities: SummaryCapability[];
};

export type CardTypeWeather = {
  /** A provided url for weather */
  url: string;
  /** Name of the vendor */
  vendor?: string;
  /**
   * An ISO Alpha-3 country code. (i.e. USA, CAN)
   * @format ^[A-Z]{3}$
   */
  countryCode?: string;
  /**
   * Time the data was pulled from the content provider.
   * ISO 8601 in UTC - YYYY-MM-DDTHH:MM:SS.SSSZ
   */
  updatedTime?: string;
};

/** Response object for type INDOOR_TEMPERATURE */
export type INDOORTEMPERATURE = CardTypeDetails & {
  indoorTemperature: CardTypeIndoorTemperature;
};

/** Response object for type LIGHTS */
export type LIGHTS = CardTypeDetails & {
  lights: CardTypeLights;
};

/** Response object for type BLINDS */
export type BLINDS = CardTypeDetails & {
  blinds: CardTypeBlinds;
};

/** Response object for type INDOOR_HUMIDITY */
export type INDOORHUMIDITY = CardTypeDetails & {
  indoorHumidity: CardTypeIndoorHumidity;
};

/** Response object for type WEATHER */
export type WEATHER = CardTypeDetails & {
  weather: CardTypeWeather;
};

/** Response object for type OUTDOOR_AIR_QUALITY */
export type OUTDOORAIRQUALITY = CardTypeDetails & {
  outdoorAirQuality: CardTypeWeather;
};

export interface SummaryRoom {
  /**
   * The roomId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id?: string;
  /** The name of the room */
  name?: string;
  /** A list of devices in the room with the same capability */
  devices?: SummaryDevice[];
  /** The Summary Room status */
  status?: string;
  /** Flag to identify if card is displayed as active/inactive */
  active?: boolean;
}

export type SummaryRoomStatus = SummaryRoom & {
  /** The overall status of the rooms devices (ex - average temperature of room devices) */
  status: string;
};

export interface SummaryDevice {
  /**
   * The deviceId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  id: string;
  /** The device component id */
  componentId: string;
  /** The status of the device */
  status?: string;
}

export interface SummaryCapability {
  /** The ID of the capability */
  capabilityId: string;
  /** The name of the attribute */
  attributeName: string;
  /** The ID of the component */
  componentId: string;
}

/** A key and value used to translate labels with PO Code */
export interface LanguageData {
  /** The PO_CODE key used to determine the value */
  key: string;
  /** The translated value */
  value: string;
}

/** A locale and list of translated strings */
export interface SummaryLanguages {
  /** The locale to translate */
  language: string;
  data: LanguageData[];
}

/** The type and interval for update frequency */
export interface SummaryUpdateFrequency {
  /** The update type (ex - immediately, periodic...) */
  type: 'immediately' | 'periodic';
  /** Optional interval value, will not be populated when type is `immediately` */
  interval?: number;
}

/** The type and interval for update frequency */
export interface SummaryFormat {
  /** The format type (ex - `HH:mm`) */
  type: string;
  /** Interval value (ex - `60`) */
  interval?: number;
}

/** A list of supported platforms (ex - `iOS, Android, ...`) */
export type SummarySupportedPlatforms = string[];

/** Alternative values for the state label */
export interface SummaryStateAlternatives {
  /** The status key (ex - `open`) */
  key: string;
  /** The PO_CODE value to translate for the label */
  value: string;
}

/** When populated, the properties defined to determine when the state should be displayed. */
export interface SummaryStateVisible {
  /** The device component id */
  component: string;
  /** The capability id */
  capability: string;
  /** The attribute value */
  value: string;
  /** The value to match on */
  operand: string;
  /** The operator value to use when matching the operand value (ex - EQUAL) */
  operator:
    | 'CONTAINS'
    | 'DOES_NOT_CONTAIN'
    | 'EQUALS'
    | 'DOES_NOT_EQUAL'
    | 'GREATER_THAN'
    | 'GREATER_THAN_OR_EQUALS'
    | 'LESS_THAN'
    | 'LESS_THAN_OR_EQUALS'
    | 'ONE_OF';
}

/** component/capability/attribute used to subscribe to events */
export interface SummaryObservableDeviceEvent {
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
  /** The name of the attribute */
  attribute: string;
}

export interface SummaryStaticDefinition {
  /** The definition type (ex - `oic.d.airconditioner` */
  type: string;
  observableDeviceEvents?: SummaryObservableDeviceEvent[];
  states: SummaryStaticState[];
  /** A list of supported platforms (ex - `iOS, Android, ...`) */
  supportedPlatforms?: SummarySupportedPlatforms;
}

export interface SummaryDynamicDefinition {
  /** The definition type (ex - `oic.d.airconditioner`) */
  type: string;
  observableDeviceEvents?: SummaryObservableDeviceEvent[];
  states: SummaryDynamicState[];
  /** A list of supported platforms (ex - `iOS, Android, ...`) */
  supportedPlatforms?: SummarySupportedPlatforms;
}

export interface DynamicBatteryDefinition {
  battery?: SummaryDynamicDefinition[];
}

export interface DynamicOpenDefinition {
  open?: SummaryDynamicDefinition[];
}

export interface DynamicRunningDefinition {
  running?: SummaryDynamicDefinition[];
}

export interface StaticBlindDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  blind?: SummaryStaticDefinition[];
}

/** The possible state(s) used for displaying the label */
export interface SummaryStaticState {
  /** Flag to determine if device is displayed as active/inactive */
  active: boolean;
  /** Label displayed to user */
  label?: string;
  /** The name of the device component, or `*` for any component */
  component?: string;
  /** The name of the capability (ex - `temperatureMeasurement`) */
  capability?: string;
  visible?: SummaryStateVisible[];
  alternatives?: SummaryStateAlternatives[];
}

/** The possible state(s) used for displaying the label */
export interface SummaryDynamicState {
  /** Flag to determine if device is displayed as active/inactive */
  active: boolean;
  useDevicePresentation?: boolean;
  /** Label displayed to user */
  label?: string;
  /** The name of the device component, or `*` for any component */
  component?: string;
  /** The name of the capability (ex - `temperatureMeasurement`) */
  capability?: string;
  /** The type and interval for update frequency */
  format?: SummaryFormat;
  visible?: SummaryStateVisible[];
  alternatives?: SummaryStateAlternatives[];
}

export interface StaticHumidityDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  humidity?: SummaryStaticDefinition[];
}

export interface StaticLightDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  light?: SummaryStaticDefinition[];
  group: SummaryGroup;
}

export interface StaticTemperatureDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  temperature?: SummaryStaticDefinition[];
}

export interface StaticWeatherDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  weather?: {
    /** The label to display */
    label: string;
  };
}

export interface StaticOutdoorAirQualityDefinition {
  /** The type and interval for update frequency */
  update: SummaryUpdateFrequency;
  outdoorAirQuality?: {
    /** The label to display */
    label: string;
    alternatives: SummaryStateAlternatives[];
  };
}

export interface SummaryData {
  static: (
    | StaticTemperatureDefinition
    | StaticLightDefinition
    | StaticHumidityDefinition
    | StaticBlindDefinition
    | StaticWeatherDefinition
    | StaticOutdoorAirQualityDefinition
    | (StaticTemperatureDefinition &
        StaticLightDefinition &
        StaticHumidityDefinition &
        StaticBlindDefinition &
        StaticWeatherDefinition &
        StaticOutdoorAirQualityDefinition)
  )[];
  dynamic: (
    | DynamicBatteryDefinition
    | DynamicOpenDefinition
    | DynamicRunningDefinition
    | (DynamicBatteryDefinition & DynamicOpenDefinition & DynamicRunningDefinition)
  )[];
}

export interface SummaryPresentation {
  data: SummaryData;
  languages: SummaryLanguages[];
}

export interface SummaryGroup {
  states?: SummaryGroupState[];
  actions?: SummaryGroupAction[];
}

/** State definition for group control */
export interface SummaryGroupState {
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
  /** The value to check `switch.value` */
  value: string;
}

/** Action definition for group control */
export interface SummaryGroupAction {
  /** The action button display type `standbyPowerSwitch` */
  displayType: 'standbyPowerSwitch';
  /** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */
  standbyPowerSwitch?: StandbyPowerSwitch;
  /** The name of the device component, or `*` for any component */
  component: string;
  /** The name of the capability */
  capability: string;
}

/** A button switch in the UI. Similar to the `toggleSwitch` displayType except for the `off` state is replaced by `standby`. */

// removed this line because it is a duplicate definition
// export type StandbyPowerSwitch = SwitchCommand & SwitchState & object;

/** @example {"command":{"name":"setLock","on":"locked","off":"unlocked"}} */
export interface SwitchCommand {
  /** To specify separate commands with no arguments for on and off, use the "on" and "off" fields respectively. To specify a single command, use "name" for the command and the "on" and "off" fields for the arguments. */
  command: {
    name?: string;
    on: string;
    off: string;
    /** The data type of the `argument`. It's automatically filled from the given capability. */
    argumentType?: ArgumentType;
  };
}

/** @example {"state":{"value":"lock.value","on":"locked","off":"unlocked","label":"Lock: {{lock.value}}"}} */
// renamed this to avoid duplicate
export interface SwitchStateDup {
  /** To describe "on" and "off" state of a switch */
  state?: {
    /** Notation which indicates the value of an attribute */
    value: Value;
    /** The data type of the `value`. It's automatically filled from the given capability. */
    valueType?: ValueType;
    /** The attribute value that corresponds to the `on` state. */
    on: string;
    /** The attribute value that corresponds to the `off` state. */
    off: string;
    /**
     * This displays a string. This can be a formatted string with variables.
     * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
     */
    label?: FormattedLabel;
  };
}

/**
 * This displays a string. This can be a formatted string with variables.
 * Example: `{{attribute.value}} {{attribute.unit}}` (where `attribute` is the name of an attribute in your capability)
 * @example "{{temperatureMeasurement.value}}"
 */

// removed this line because it is a duplicate definition
// export type FormattedLabel = string;

/**
 * Notation which indicates the value of an attribute
 * @pattern (^[[a-z]*([A-Z][a-z]*)*){1,36}(\.value)+
 * @example "switch.value"
 */

// removed this line because it is a duplicate definition
// export type Value = string;

/**
 * The data type of the `value`. It's automatically filled from the given capability.
 * @example "double"
 */

// removed this line because it is a duplicate definition
// export type ValueType = string;

/**
 * The data type of the `argument`. It's automatically filled from the given capability.
 * @example "double"
 */

// removed this line because it is a duplicate definition
// export type ArgumentType = string;

export interface ContinyStatus {
  device?: Device;
  user?: User;
  isPlaying?: boolean;
  playedAt?: string;
}

/** @example {"geoplaceId":"6b3d1909-1e1c-43ec-adc2-5f941de4fbf9","ownerType":"LOCATION","ownerId":"9a437e5e-23c2-47ee-a915-056cf6f989b4","name":"Work","latitude":45.00708112,"longitude":-73.11223629,"regionRadius":250} */
export interface Geoplace {
  /**
   * The ID of the geoplace
   * @format uuid
   */
  geoplaceId: string;
  /** The type of owner that the Geoplace is associated to, including user permissioning. */
  ownerType: OwnerType;
  /** Global idenfifier for the given `ownerType` */
  ownerId: OwnerId;
  /** A nickname given for the Geoplace */
  name: Name;
  /** A geographical latitude */
  latitude: Latitude;
  /** A geographical longitude */
  longitude: Longitude;
  /** The radius in meters around latitude and longitude which defines this geoplace */
  regionRadius: RegionRadius;
  /**
   * A list of action that are currently permitted for the user.
   * If the value of this property is not null, then any documented action not included in the list value of the property is currently prohibited for the user.
   * If the value of this property is null (or absent), then no permission-related information is being provided.
   *   <ul>
   *   <li> d:linkedplaces - the user can delete this linked place
   *   <li> w:linkedplaces - the user can edit the name of this linked place
   *   <li> w:linkedplaces:geo - the user can edit the geo-coordinates of this linked place
   *   </ul>
   */
  allowed?: string[];
}

/** Represents a list of Geoplaces available for a specific owner */
export interface Geoplaces {
  items: Geoplace[];
}

/**
 * Global idenfifier for the given `ownerType`
 * @format uuid
 */
export type OwnerId = string;

/**
 * A nickname given for the Geoplace
 * @minLength 1
 * @maxLength 40
 * @example "Work"
 */
export type Name = string;

/**
 * A geographical latitude
 * @min -90
 * @exclusiveMin true
 * @max 90
 * @exclusiveMax true
 */
export type Latitude = number;

/**
 * A geographical longitude
 * @min -180
 * @exclusiveMin true
 * @max 180
 * @exclusiveMax true
 */
export type Longitude = number;

/**
 * The radius in meters around latitude and longitude which defines this geoplace
 * @format int32
 * @min 250
 * @max 30000
 */
export type RegionRadius = number;

/**
 * The timestamp of when a GeoPlace was created in UTC
 * @format date-time
 */
export type Created = string;

/**
 * The timestamp of when a GeoPlace was last updated in UTC
 * @format date-time
 */
export type LastModified = string;

/** @example {"ownerType":"LOCATION","ownerId":"9a437e5e-23c2-47ee-a915-056cf6f989b4","name":"Work","latitude":45.00708112,"longitude":-73.11223629,"regionRadius":250} */
export interface CreateGeoplaceRequest {
  /** The type of owner that the Geoplace is associated to, including user permissioning. */
  ownerType: OwnerType;
  /** Global idenfifier for the given `ownerType` */
  ownerId: OwnerId;
  /** A nickname given for the Geoplace */
  name: Name;
  /** A geographical latitude */
  latitude: Latitude;
  /** A geographical longitude */
  longitude: Longitude;
  /** The radius in meters around latitude and longitude which defines this geoplace */
  regionRadius: RegionRadius;
}

/** @example {"name":"Work","latitude":45.00708112,"longitude":-73.11223629,"regionRadius":250} */
export interface UpdateGeoplaceRequest {
  /** A nickname given for the Geoplace */
  name: Name;
  /** A geographical latitude */
  latitude?: Latitude;
  /** A geographical longitude */
  longitude?: Longitude;
  /** The radius in meters around latitude and longitude which defines this geoplace */
  regionRadius?: RegionRadius;
}

/** The device OTA configuration of a hub */
export interface DeviceOtaConfigurationStatus {
  /** True if hub supports Over The Air device firmware updates */
  supported?: boolean;
  /** True if hub has enabled Over The Air device firmware updates */
  enabled?: boolean;
  /** True if hub supports Over The Air device firmware updates for lights in particular */
  lightsEnabled?: boolean;
}

/** Set Device OTA configuration for a hub */
export interface DeviceOtaConfigurationSetting {
  /** Set to true to enable Over The Air device firmware updates for a hub */
  enabled?: boolean;
  /** Set to true to enable Over The Air device firmware updates for lights in particular for a hub */
  lightsEnabled?: boolean;
}

/** The Zigbee radio channel for a hub */
export interface ZigbeeRadioChannelObject {
  /** Zigbee radio channel */
  channel?: ZigbeeRadioChannel;
}

/**
 * Zigbee radio channel
 * @min 11
 * @max 26
 * @example 20
 */
export type ZigbeeRadioChannel = number;

/**
 * Zigbee Extended Unique Identifier
 * @format ^[0-9A-F]{16}$
 */
export type ZigbeeEui = string;

/**
 * @pattern ^[0-9a-fA-F]{16}$
 * @example "02B0D8DD6BB0E9C0"
 */
export type ZigbeeExtendedPanId = string;

export type ZigbeeInstallCode = string;

/** The Zigbee Secure Mode setting for a hub */
export interface ZigbeeSecureMode {
  /** True if the hub permits Zigbee unsecure rejoin */
  unsecureRejoinEnabled?: boolean;
}

/** The Zigbee network state for a hub */
export interface ZigbeeNetworkState {
  /**
   * Zigbee network states:
   *   * `UNKNOWN` - Unknown state
   *   * `INITIALIZING` - Radio initializing
   *   * `DOWN` - Radio down
   *   * `UP` - Radio up
   *   * `DISABLED` - Zigbee disabled
   */
  state?: 'UNKNOWN' | 'INITIALIZING' | 'DOWN' | 'UP' | 'DISABLED';
}

export interface ZwaveStartExclude {
  /**
   * The number of seconds to wait before stopping exclusion
   * @format int64
   * @min 0
   */
  timeoutSeconds?: number;
}

/** The hub's WI-FI link information. */
export interface WifiLinkInfo {
  /** True if there is a valid link to the WI-FI access point. */
  connected: boolean;
  /** An array of integers which contains up to 32 octets of arbitrary content representing SSID characters in a byte sequence. */
  ssid?: number[];
  /** An array of integers which represents the 48-bit identifier for basic service set. */
  bssid?: number[];
  /** The decibel milliwatts representing Received Signal Strength. */
  rssiDbm?: number;
  /** The frequency used by the WI-FI access point in kiloHertz. */
  frequencyKhz?: number;
  /** The receiving bitrate of the WI-FI access point in kilobits per second. */
  rxBitrateKbps?: number;
  /** The transmit bitrate of the WI-FI access point in kilobits per second. */
  txBitrateKbps?: number;
}

export interface JoinPrimaryData {
  zigbee?: JoinPrimaryZigbeeData;
  thread?: JoinPrimaryThreadData;
}

export interface JoinPrimaryZigbeeData {
  /** Zigbee radio channel */
  channel: ZigbeeRadioChannel;
  panId: U16;
  extendedPanId: ZigbeeExtendedPanId;
}

export interface JoinPrimaryThreadData {
  channel: ThreadChannel;
  panId: U16;
  extendedPanId: ThreadExtendedPanId;
  networkKey: ThreadNetworkKey;
}

export interface JoinSecondaryData {
  zigbee?: JoinSecondaryZigbeeData;
}

export interface JoinSecondaryZigbeeData {
  installationCode: ZigbeeInstallCode;
  /** Zigbee Extended Unique Identifier */
  euid: ZigbeeEui;
}

export interface ConvertToSecondaryData {
  primaryHubDeviceId: string;
  joinPrimaryData: JoinPrimaryData;
}

export enum SecondaryConversionState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/** Identifies the type of error. Included when state is FAILED. */
export enum SecondaryError {
  ZIGBEE = 'ZIGBEE',
  THREAD = 'THREAD',
  INTERNAL = 'INTERNAL',
}

export interface SecondaryConversionStatusResponse {
  state: SecondaryConversionState;
  /** This is null when the state is NOT_STARTED and otherwise it is the device id of the primary hub */
  primaryHubDeviceId?: string;
  /** Identifies the type of error. Included when state is FAILED. */
  error?: SecondaryError;
  /** English description of the error. Included when state is FAILED. */
  errorDetails?: string;
}

export enum SecondaryReversionState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export interface SecondaryReversionStatusResponse {
  state: SecondaryReversionState;
}

/**
 * 64-bit compressed fabric ID (hash of root public key and fabric ID) in ASCII-hexidecimal-format with leading zeroes
 * @pattern ^[0-9A-F]{16}$
 * @example "CAB195B90CDBCA9C"
 */
export type CompressedFabricId = string;

/**
 * Elliptic curve encryption public key in compressed form with prefix byte 0x04 followed by two 256-bit key points
 * @format byte
 * @pattern ^[A-Za-z0-9+/]{87}=$
 * @example "BDUoxoH1N+PlHpJGWYkXNxmQj27RPZEvOQFAotMUVrh2Rpvpg5uRjWQySxZUcAMARHWvCb2srv0FAnn1B4r8b68="
 */
export type EllipticCurvePublicKey = string;

export interface FabricDescriptor {
  /** the stable fabric index of the given fabric */
  fabricIndex: FabricIndex;
  /** the vendor ID of the fabric commissioner */
  vendorId: VendorId;
  /** the root CA public key for the given fabric */
  rootPublicKey: EllipticCurvePublicKey;
  /** the compressed fabric ID for the given fabric */
  compressedFabricId: CompressedFabricId;
  /** the ID of the fabric */
  fabricId: FabricId;
  /** the ID of the node within the fabric */
  nodeId: NodeId;
  /** the textual label of the fabric */
  fabricLabel: FabricLabel;
}

/**
 * @min 1
 * @max 255
 */
export type FabricIndex = number;

/**
 * @minLength 1
 * @maxLength 32
 * @example "SmartThings"
 */
export type FabricLabel = string;

/** Factory reset data */
export interface FactoryResetData {
  resetType?: ResetType;
}

export enum ResetType {
  SOFT = 'SOFT',
  HARD = 'HARD',
}

/**
 * 64-bit compressed fabric ID and 64-bit operational node ID, each expressed in ASCII-hexadecimal-format with leading zeroes, separated by a hyphen
 * @pattern ^[0-9A-F]{16}-(?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16}$
 * @example "CAB195B90CDBCA9C-E24BD96D4F235823"
 */
export type OperationalInstanceName = string;

/**
 * @min 0
 * @max 65524
 * @example 4362
 */
export type VendorId = number;

export interface MatterFabricList {
  /** commissioned fabrics in the target Matter device */
  fabrics: FabricDescriptor[];
  /**
   * the maximum number of fabrics that can be commissioned in the target Matter device
   * @min 5
   * @max 255
   */
  supportedFabrics: number;
  /** the index of the fabric in the target Matter device over which the hub is connected */
  currentFabricIndex: FabricIndex;
}

export interface MatterMigrationFabricRecord {
  /** the fabric's Root Certificate Authority public key */
  rootPublicKey: EllipticCurvePublicKey;
  /** the compressed ID of the given fabric */
  compressedFabricId: CompressedFabricId;
  /** the ID of the given fabric */
  fabricId: FabricId;
  /** the hub's node ID within the fabric */
  nodeId: NodeId;
}

export interface MatterNodeMigrationStatus {
  /** 64-bit compressed fabric ID and 64-bit operational node ID, each expressed in ASCII-hexadecimal-format with leading zeroes, separated by a hyphen */
  node?: OperationalInstanceName;
  status?: 'PENDING' | 'MIGRATED' | 'FAILED';
}

export interface MatterNodeMigrationStatusList {
  /** migration status for a collection of nodes */
  nodes?: MatterNodeMigrationStatus[];
}

export interface MatterOperationalServiceList {
  /** operational service records for Matter nodes */
  nodes?: OperationalInstanceName[];
}

export type CreateMatterFabricOperationalServiceEnumerationResponse = MatterOperationalServiceList;

export interface CreateMatterNodeMigrationCsrResponse {
  /** A PKCS#10 Certificate Signing Request in PEM format. */
  csr: CertificateSigningRequest;
}

export type GetMatterNodeMigrationFabricResponse = MatterMigrationFabricRecord;

export interface CreateMatterNodeMigrationFabricRequest {
  /** 64-bit fabric ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved value 0 */
  fabricId: FabricId;
  /** 64-bit operational node ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved values */
  nodeId: NodeId;
  /** An X.509v3 certificate in PEM format */
  nodeCertificate: Certificate;
  /** An X.509v3 certificate in PEM format */
  rootCA: Certificate;
  /**
   * A list of all intermediates certificate between the root and the node certificate.
   * @minItems 0
   */
  intermediateCA: Certificate[];
  /**
   * An array of Identity Protection Keys (IPKs) used within a fabric, which when fully populated represent
   * (previous, current, future) epoch keys.  To enable key rotation, nodes initiate CASE with the current key
   * and accept CASE with any of the previous, current, or future keys.  If two keys are presented, these are
   * (current, future).  If one key is presented, this is the (current) epoch key.  All APIs currently return
   * only a single (current) epoch key.
   */
  ipk: IdentityProtectionEpochKeys;
  /** The node identifier for the default administrator(s) on a fabric.  Typically, this embeds a CASE Authenticated Tag that administrators carry as an additional Relative Distinguished Name within their Node Operational Certificates. */
  adminSubject: AdminSubject;
}

export type CreateMatterNodeMigrationRequest = MatterOperationalServiceList;

export interface CreateMatterNodeMigrationResponse {
  /**
   * a unique identifier that can be used to poll the status of the node migration resource
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  migrationId?: string;
}

export type GetMatterNodeMigrationStatusResponse = MatterNodeMigrationStatusList;

export interface CreateMatterCommissioningWindowRequest {
  /**
   * the number of seconds for which to open the commissioning window
   * @min 180
   * @max 900
   */
  commissioningTimeout: number;
}

export interface CreateMatterCommissioningWindowResponse {
  /**
   * base38-encoded Matter onboarding payload with MT QR code prefix
   * @pattern ^MT:[0-9A-Z-.]+$
   * @example "MT:8IXS142C00KA0648G00"
   */
  onboardingPayload: string;
  /**
   * an 11 or 21-digit decimal numeric string
   * @pattern ^[0-9]{11}([0-9]{10})?$
   * @example "34970112332"
   */
  manualPairingCode: string;
}

/**
 * @min 0
 * @max 65535
 */
export type U16 = number;

export interface PartialUpdateMatterFabricRequest {
  /** the new label to set for the hub-connected fabric */
  fabricLabel: FabricLabel;
}

export interface ThreadNetworkInfo {
  /**
   * @pattern ^[0-9]{0,20}$
   * @example "1"
   */
  activeTimestamp: string;
  channel: ThreadChannel;
  extendedPanId: ThreadExtendedPanId;
  meshLocalPrefix: IpV6Prefix;
  networkKey: ThreadNetworkKey;
  networkName: ThreadNetworkName;
  panId: U16;
  pskc: ThreadPskc;
  /** 64-bit IEEE 802.15.4 Extended Address of Thread interface */
  extendedAddress: ThreadExtendedAddress;
}

export interface ThreadNetworkJoinInfo {
  channel: ThreadChannel;
  extendedPanId: ThreadExtendedPanId;
  networkKey: ThreadNetworkKey;
  panId: U16;
}

export interface ThreadOperationalDataSet {
  /**
   * @pattern ^[0-9a-f]{204}$
   * @example "0e080000000000000000000300000f35060004001fffe0020811111111222222220708fdacd1d8ab33adda051000112233445566778899aabbccddeeff030b536d6172745468696e6773010204d20410d54a302098c3adb116c5fd2137771d560c0402a0fff8"
   */
  operationalDataSet: string;
}

export interface ThreadBorderRouterScanResults {
  borderRouters: ThreadMeshcopRecord[];
}

/**
 * @min 11
 * @max 26
 * @example 20
 */
export type ThreadChannel = number;

/**
 * @pattern ^[0-9a-f]{16}$
 * @example "357351e001eb4ba3"
 */
export type ThreadExtendedPanId = string;

/**
 * @pattern ^[0-9a-f:/]{5,43}$
 * @example "fd5c:ef9c:acd5:55c9::/64"
 */
export type IpV6Prefix = string;

/**
 * @pattern ^[0-9a-f]{32}$
 * @example "00112233445566778899aabbccddeeff"
 */
export type ThreadNetworkKey = string;

/**
 * @minLength 1
 * @maxLength 16
 * @example "SmartThings"
 */
export type ThreadNetworkName = string;

/**
 * @pattern ^[0-9a-f]{32}$
 * @example "d54a302098c3adb116c5fd2137771d56"
 */
export type ThreadPskc = string;

/**
 * 64-bit IEEE 802.15.4 Extended Address of Thread interface
 * @pattern ^[0-9a-f]{16}$
 * @example "d60aba249cbcbd25"
 */
export type ThreadExtendedAddress = string;

export interface ThreadMeshcopRecord {
  /**
   * @minLength 1
   * @maxLength 3
   * @example "1"
   */
  recordVersion: string;
  /**
   * @pattern ^[0-9]+\.[0-9]+\.[0-9]+$
   * @example "1.3.0"
   */
  threadVersion: string;
  /**
   * @minLength 2
   * @maxLength 24
   * @example "OpenThread"
   */
  vendorName: string;
  /**
   * @minLength 1
   * @maxLength 24
   * @example "BorderRouter"
   */
  productName: string;
  networkName: ThreadNetworkName;
  extendedPanId: ThreadExtendedPanId;
  borderAgentDiscriminator: ThreadBorderAgentDiscriminator;
}

/**
 * @pattern ^[0-9a-f]{16}$
 * @example "8a6c8146b66fc487"
 */
export type ThreadBorderAgentDiscriminator = string;

/** A CreateVerificationCodeRequest. */
export interface CreateVerificationCodePostBody {
  /** verification code */
  verificationCode: string;
  /**
   * installedAppId for the device
   * @format uuid
   */
  installedAppId: string;
}

export interface GetDevicesVerificationCodeDetailsResponse {
  /**
   * installedAppId for the device
   * @format uuid
   */
  installedAppId?: string;
  /** true/false if the verification code has been setup */
  isVerificationCodeSetup?: boolean;
}

export interface SuccessResponse {
  /** will be true if successfull */
  success?: boolean;
}

export interface RestResponseLightEffectExecutionStatus {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Light effect execution status */
  data?: LightEffectExecutionStatus;
  /** Response result message */
  message?: string;
}

export interface RestResponseEmpty {
  /**
   * Response result code
   * @format int32
   */
  code?: number;
  /** Response data */
  data?: string;
  /** Response result message */
  message?: string;
}

/** FadeRequest */
export interface FadeRequest {
  /** Fade Type */
  type: 'WakeUp' | 'WindDown';
  devices: string[];
  /**
   * Duration in minutes(Min:1min, Max:60min) for which the light effect to be executed.
   * @example 30
   */
  duration: number;
  component: string;
  capability: string;
  command: string;
  /**
   * Start value of the capability's attribute for fade
   * @example 1
   */
  startLevel?: number;
  /**
   * End value of the capability's attribute for fade
   * @example 100
   */
  endLevel: number;
  /** An action to be performed after fade light effect is completed */
  afterAction?: {
    /** AfterAction type */
    type: 'KeepCurrent' | 'TurnOff' | 'Circadian' | 'ChangeMode';
    /** A java time zone ID reference. It is required only for Circadian after action. */
    timeZoneId?: string;
    /** Array of commands to be executed for devices */
    commands?: DeviceCommand[];
  };
}

/** CircadianRequest */
export interface CircadianRequest {
  devices: string[];
  /** A java time zone ID reference */
  timeZoneId: string;
}

/**
 * An empty object response.
 * @example {}
 */
export type EmptyObject = object;

export interface EphemeralDevice {
  /**
   * The ID of an ephemeral device comprised of a `locationId` UUID and `setupId` integer.
   * e.g., `2289e4e7-3e7f-41d1-b24c-2711043244d4-215`
   */
  ephemeralDeviceId?: EphemeralDeviceId;
  /** The ID of a Location Group */
  locationGroupId?: LocationGroupId;
  /** The ID of a Location */
  locationId?: LocationId;
  /** The ID of the canonical device */
  canonicalDeviceId?: CanonicalDeviceId;
  status: OnboardingStatus;
  /** Metadata for the onboarding ephemeral device */
  metadata: Record<string, object>;
}

/**
 * The ID of an ephemeral device comprised of a `locationId` UUID and `setupId` integer.
 * e.g., `2289e4e7-3e7f-41d1-b24c-2711043244d4-215`
 * @minLength 1
 * @maxLength 40
 */
export type EphemeralDeviceId = string;

/** The name of a Property */
export type LocationGroupName = string;

/** The name of a Device */
export type DeviceName = string;

/** The name of a Location */
export type LocationName = string;

/**
 * The ID of a Location Group
 * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
 * @example "736e3903-001c-4d40-b408-ff40d162a06b"
 */
export type LocationGroupId = string;

/**
 * The ID of a Location
 * @minLength 1
 * @maxLength 36
 */

// removed this line because it is a duplicate definition
// export type LocationId = string;

/**
 * The ID of the canonical device
 * @minLength 1
 * @maxLength 36
 */
export type CanonicalDeviceId = string;

/** @example {"locationGroupId":"81774dc9-9dfa-46f9-acca-dc7740b9aa2e","locationGroupName":"Dell Apartments","locationGroupStatistics":{"units":300,"inactive":1,"successes":2,"failures":1},"locationOnboardingReports":{"items":[{"locationId":"cf147866-a302-4d7b-870e-07de5a92daac","locationName":"Unit 101","locationStatistics":{"successes":2,"failures":1},"deviceNames":{"successes":["Samsung Range NZ30K6330RS","Samsung Dishwasher SZ30K6330RS"],"failures":["Samsung Oven NZ30K6330RS"]}},{"locationId":"22ee878a-3a8e-44b2-b785-24180fa5cbc9","locationName":"Unit 102","locationStatistics":{"successes":0,"failures":0},"deviceNames":{"successes":null,"failures":null}}]}} */
export interface LocationGroupOnboardingReport {
  /** The ID of a Location Group */
  locationGroupId?: LocationGroupId;
  /** The name of a Property */
  locationGroupName?: LocationGroupName;
  locationGroupStatistics?: LocationGroupStatistics;
  /** Represents a single page of location onboarding reports */
  locationOnboardingReports?: LocationOnboardingReports;
}

export interface LocationGroupOnboardingStatistics {
  /** The ID of a Location Group */
  locationGroupId?: LocationGroupId;
  statistics?: OnboardingStatistics;
}

export interface LocationOnboardingReport {
  /** The ID of a Location */
  locationId?: LocationId;
  /** The name of a Location */
  locationName?: LocationName;
  locationStatistics?: OnboardingStatistics;
  deviceNames?: OnboardingDeviceNames;
}

export interface LocationOnboardingStatistics {
  /** The ID of a Location Group */
  locationGroupId?: LocationGroupId;
  /** The ID of a Location */
  locationId?: LocationId;
  statistics?: OnboardingStatistics;
}

export enum OnboardingStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export interface OnboardingStatistics {
  /** Number of outstanding failed device onboardings */
  failures?: number;
  /** Number of successful device onboardings */
  successes?: number;
}

export interface LocationGroupStatistics {
  /** Total number of units within the property */
  units?: number;
  /** Number of units without any onboarded device */
  inactive?: number;
  /** Number of outstanding failed device onboardings */
  failures?: number;
  /** Number of successful device onboardings */
  successes?: number;
}

export interface OnboardingDeviceNames {
  successes?: DeviceName[];
  failures?: DeviceName[];
}

/** Represents a single page of location group onboarding statistics */
export interface PagedLocationGroupsOnboardingStatistics {
  items?: LocationGroupOnboardingStatistics[];
  _links?: Links;
}

/** Represents a single page of location onboarding reports */
export interface LocationOnboardingReports {
  items?: LocationOnboardingReport[];
}

/** Represents a single page of location onboarding statistics */
export interface PagedLocationsOnboardingStatistics {
  items?: LocationOnboardingStatistics[];
  _links?: Links;
}

/** Represents a single page of ephemeral devices */
export interface PagedEphemeralDevices {
  items?: EphemeralDevice[];
  _links?: Links;
}

/** @example {"status":"success","canonicalDeviceId":"81774dc9-9dfa-46f9-acca-dc7740b9aa2e","metadata":{"type":"device","category":"Washer","device":{"label":"Samsung WF45R6300AV/US","mnId":"0AJT","setupId":215,"modelNumber":"WF45R6300AV/US"}}} */
export interface PartialUpdateEphemeralDeviceRequest {
  status?: OnboardingStatus;
  /** The ID of the canonical device */
  canonicalDeviceId?: CanonicalDeviceId;
  /** Metadata for the onboarding ephemeral device */
  metadata?: Record<string, object>;
}

/** @example {"status":"failed","canonicalDeviceId":"81774dc9-9dfa-46f9-acca-dc7740b9aa2e","metadata":{"type":"device","category":"Washer","device":{"label":"Samsung WF45R6300AV/US","mnId":"0AJT","setupId":215,"modelNumber":"WF45R6300AV/US"}}} */
export interface UpsertEphemeralDeviceRequest {
  status: OnboardingStatus;
  /** The ID of the canonical device */
  canonicalDeviceId?: CanonicalDeviceId;
  /** Metadata for the onboarding ephemeral device */
  metadata: Record<string, object>;
}

export interface CreatePetitionRequest {
  /**
   * Optional. Override the default petitionType of "STANDARD".
   * Accepted values are "STANDARD" and "LINKSHARE"
   * @example "LINKSHARE"
   */
  petitionType?: string;
  /**
   * Optional.  Override the default petition lifetime of 5 minutes.
   * Specify a value on the range 1 to 10080 (minimum of 1 minute,
   * maximum of 7 days).
   * @example 5
   */
  lifetimeMinutes?: number;
  /**
   * Optional. Free-form text, limited to 80 characters.  If provided, it
   * will be attached to any access request created from the petition.
   * The value is used when constructing some user notifications.  THE
   * CALLER MUST ENSURE THAT REQUESTORS ARE ALLOWED TO SEE ALL INFORMATION
   * CONTAINED IN THE PRODUCT IDENTIFIER.  For instance, the petitioner
   * must never disclose the location name, location owner, etc.
   * @example "SmartThings Station"
   */
  productIdentifier?: string;
  /**
   * Optional.  Free-form text, limited to 2048 characters.  If provided,
   * it will be attached to any access request created from the petition.
   * This field is considered opaque; petition service does not interpret
   * the value.  Think of it as a generic mechanism to share data between
   * a petitioner and a requestor.  The value can be a plain text string
   * or some data encoded in a string (such as JSON).  BECAUSE PETITION
   * SERVICE DOES NOT INTERPRET THIS VALUE, THE CALLER MUST ENSURE THAT
   * REQUESTORS ARE ALLOWED TO SEE ALL INFORMATION CONTAINED IN THE
   * DESCRIPTION.  For instance, the petitioner must never disclose the
   * location name, location owner, etc.
   * @example "Optional description"
   */
  description?: string;
  /**
   * Optional. The grant to apply when approving access requests created
   * with this petition, unless overridden on the approval request.  If the
   * requestor already has access to the location by the time this approval
   * is processed (due to some other invitation, approval by another approver, etc.),
   * the existing grant will be left unchanged.  Accepted values are `SHARE` and
   * `RESTRICTEDSHARE`
   * @example "RESTRICTEDSHARE"
   */
  grantType?: string;
}

export interface PetitionResponse {
  /** @example "1b9b6ecb-a71a-4bff-af40-a03b54bac723" */
  petitionId: string;
  /** Type of petition. */
  petitionType: PetitionType;
  /** The grant type that is applied upon approval of access request */
  grantType: GrantType;
  /** The type of the resource requested access to */
  resourceType: ResourceType;
  /** @example "1b9b6ecb-a71a-4bff-af40-a03b54bac723" */
  resourceId: string;
  petitionerType: PrincipalType;
  /** @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b" */
  petitionerId: string;
  /**
   * The datetime that the petition expires.
   * @format dateTime
   * @example "2022-05-17T21:53:55.858Z"
   */
  expirationDate: string;
  /**
   * Optional. Free-form text, limited to 80 characters.  The product
   * identifier provided when creating the petition, if any.
   * @example "SmartThings Station"
   */
  productIdentifier?: string;
  /**
   * Optional. Free-form text, limited to 2048 characters.  The
   * description provided when creating the petition, if any.
   * @example "Optional description"
   */
  description?: string;
}

/** A page of petitions */
export interface PagedPetitions {
  items?: PetitionResponse[];
  links?: Links;
}

export interface AllowedPetitionResponse {
  /**
   * Whether the requestor is allowed to request access to the resource associated with the petition.
   * @example false
   */
  allowed: boolean;
  /** Optional, provided only if `allowed=false`. */
  reason?:
    | 'PETITION_ALREADY_USED'
    | 'NO_GRANTORS_AVAILABLE'
    | 'ALREADY_HAS_ACCESS'
    | 'ALREADY_HAS_PENDING'
    | 'REQUEST_LIMIT_REACHED'
    | 'RESOURCE_REQUEST_LIMIT_REACHED';
  /** Optional, provided only if `allowed=false` */
  details?: string;
}

/**
 * Optional. This is free-form text, but must be in valid JSON format.
 * If provided, it will be sent to locksmith to be stored.  The body
 * is considered opaque; petition service does not interpret the value.
 * BECAUSE PETITION SERVICE DOES NOT INTERPRET THIS VALUE, IT IS THE
 * CALLER'S RESPONSIBILITY TO ENSURE THAT THE DATA IS VALID.
 */
export type ConsentAgreementBody = string;

export interface AccessRequest {
  /**
   * A unique identifier for the access request
   * @example "d4f5e36c-a808-40cf-bd04-584fed7f22cb"
   */
  accessRequestId: string;
  /** Type of access request. */
  accessRequestType: AccessRequestType;
  /** The status of the access request */
  status: PetitionStatus;
  /** The grant type that is applied upon approval of access request */
  grantType?: GrantType;
  /** Type of petition. */
  petitionType: PetitionType;
  /**
   * The petition id used to create the access request
   * @example "1a06c285-5210-42f2-b5ef-6ecdc1321e69"
   */
  petitionId: string;
  /** The type of the resource requested access to */
  resourceType?: ResourceType;
  /**
   * Id of requested resource.
   * @example "1b9b6ecb-a71a-4bff-af40-a03b54bac723"
   */
  resourceId?: string;
  requestorType: PrincipalType;
  /**
   * UUID of the principal that requested access
   * @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b"
   */
  requestorId: string;
  /**
   * The name of the requstor in the SmartThings platform
   * @example "First Last"
   */
  requestorName?: string;
  /**
   * The email address of the requestor in the SmartThings platform
   * @example "firstlast@example.com"
   */
  requestorEmail?: string;
  grantorType?: PrincipalType;
  /**
   * UUID of the principal that approved or rejected the request
   * @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b"
   */
  grantorId?: string;
  /** The grant type that is applied upon approval of access request */
  approvedGrantType?: GrantType;
  /**
   * The datetime that the access request was submitted.
   * @format dateTime
   * @example "2022-04-17T21:53:55.858Z"
   */
  submitDate: string;
  /**
   * The datetime that the access request expires.
   * @format dateTime
   * @example "2022-05-17T21:53:55.858Z"
   */
  expirationDate: string;
  /**
   * Optional. The datetime that the access request was approved, rejected, or canceled.
   * @format dateTime
   * @example "2022-04-17T21:53:55.858Z"
   */
  reviewDate?: string;
  /**
   * Optional. Free-form text, limited to 80 characters.  The product
   * identifier provided when creating the petition, if any.
   */
  productIdentifier?: string;
  /**
   * Optional. Free-form text, limited to 2048 characters.  The
   * description provided when creating the petition, if any.
   */
  description?: string;
}

export interface MaskedAccessRequest {
  /**
   * A unique identifier for the access request
   * @example "d4f5e36c-a808-40cf-bd04-584fed7f22cb"
   */
  accessRequestId: string;
  /** Type of access request. */
  accessRequestType: AccessRequestType;
  /** The status of the access request */
  status: PetitionStatus;
  /** Type of petition. */
  petitionType: PetitionType;
  /**
   * The petition id used to create the access request
   * @example "1a06c285-5210-42f2-b5ef-6ecdc1321e69"
   */
  petitionId: string;
  requestorType: PrincipalType;
  /**
   * UUID of the principal that requested access
   * @example "3a0a1b4d-51b9-4828-b9f2-cd773d63545b"
   */
  requestorId: string;
  /**
   * The name of the requstor in the SmartThings platform
   * @example "First Last"
   */
  requestorName?: string;
  /**
   * The email address of the requestor in the SmartThings platform
   * @example "firstlast@example.com"
   */
  requestorEmail?: string;
  /**
   * The datetime that the access request was submitted.
   * @format dateTime
   * @example "2022-04-17T21:53:55.858Z"
   */
  submitDate: string;
  /**
   * The datetime that the access request expires.
   * @format dateTime
   * @example "2022-05-17T21:53:55.858Z"
   */
  expirationDate: string;
  /**
   * Optional. The datetime that the access request was approved, rejected, or canceled.
   * @format dateTime
   * @example "2022-04-17T21:53:55.858Z"
   */
  reviewDate?: string;
  /**
   * Optional. Free-form text, limited to 80 characters.  The product
   * identifier provided when creating the petition, if any.
   */
  productIdentifier?: string;
  /**
   * Optional. Free-form text, limited to 2048 characters.  The
   * description provided when creating the petition, if any.
   */
  description?: string;
}

/**
 * Type of access request.
 * @example "PETITION"
 */
export enum AccessRequestType {
  PETITION = 'PETITION',
}

/**
 * Type of petition.
 * @example "STANDARD"
 */
export enum PetitionType {
  STANDARD = 'STANDARD',
  LINKSHARE = 'LINKSHARE',
}

/**
 * The grant type that is applied upon approval of access request
 * @example "SHARE"
 */
export enum GrantType {
  SHARE = 'SHARE',
  RESTRICTEDSHARE = 'RESTRICTEDSHARE',
}

/**
 * The type of the resource requested access to
 * @example "LOCATION"
 */
export enum ResourceType {
  LOCATION = 'LOCATION',
}

/** @example "USER" */
export enum PrincipalType {
  USER = 'USER',
  HUB = 'HUB',
}

/**
 * The status of the access request
 * @example "PENDING"
 */
export enum PetitionStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

/**
 * Updated status of the access request
 * @example "APPROVED"
 */
export enum UpdatedPetitionStatus {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
}

/** A page of access requests */
export interface PagedAccessRequests {
  items?: AccessRequest[];
  links?: Links;
}

/** A page of access requests */
export interface PagedMaskedAccessRequests {
  items?: MaskedAccessRequest[];
  links?: Links;
}

export interface GetUserDeviceListResponse {
  devices: GetUserDeviceResponse[];
}

export interface GetUserDeviceResponse {
  /** device ID */
  deviceId: string;
  /** ssid */
  ssid?: string;
  /** model name ID */
  mnId?: string;
  /** setup ID */
  setupId?: string;
  /** serial number */
  serialNumber?: string;
  /**
   * The last 4 characters of the device's serial number
   * @maxLength 4
   */
  partialSerialNumber?: string;
  /**
   * This is a Map object delivered from the `POST /v3/oic/account` API
   * @example {"apSsid":"MyApNetwork"}
   */
  metadata: Record<string, object>;
}

export interface ConfirmDeviceRequest {
  /**
   * Location ID
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  locationId: string;
  /**
   * Room ID
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  roomId?: string;
  nickname: string;
  /**
   * Limits the lifetime of onboarding process (second)
   * @example 20
   */
  ttl: number;
}

export interface ConfirmDeviceResponse {
  /** Device ID */
  deviceId: string;
  /**
   * The time until device can possibly onboard (millisecond)
   * @format int64
   * @example 1673391600
   */
  validateIn: number;
}

export interface PublishRequest {
  /**
   * Device id. Unique device identifier.
   * @format uuid
   * @example "9cfbeb8e-5a1e-..."
   */
  di: string;
  /**
   * Name. Human understandable name for the resource; may be set locally or remotely
   * @example "Room light"
   */
  n?: string;
  /**
   * Time to indicate a RD How long to keep this published item. After this time (in seconds) elapses, the RD invalidates the links. To keep link alive the publishing device updates the ttl using the update schema.
   * @example 1000
   */
  lt?: number;
  /**
   * Model information
   * @example "T9000"
   */
  'x.model'?: string;
  /** Link. An Link embraces and extends typed web links concept as a means of expressing relationships between Resources. */
  links: LinkRequest[];
}

export interface LinkRequest {
  /**
   * Resource URI. Relative or fully qualified URI of the resource whose presence is being announced.
   * @format ^[0-9a-zA-Z\./\-_!~'()]+$
   * @example "/a/light"
   */
  href: string;
  /**
   * Resource Type. Resource Type is a class or category of Resources and a Resource is an instance of a Resource Type.
   * @example ["core.light"]
   */
  rt: string[];
  /** Interface. Property to declare the Interfaces supported by a Resource. */
  if: string[];
  /** The `type` parameter may be used to specify the various media types that are supported by a specific target Resource. */
  type: string[];
  /** The `p` parameter is used to specify whether this resource is observable or not. */
  p: {
    /** 1 discovrable, 2 observable, 3 discoverble & observable */
    bm?: number;
  };
  /** The `ins` parameter identifies a particular Link instance in a list of Links. */
  ins?: number;
  /** Default relationship. Specifies the default relationship to use for Links in the collection where the `rel` parameter has not been explicitly defined. */
  rel?: string;
  /** Resoruce Title. A human friendly name to designate the resource type. */
  title?: string;
  /** Time to live for this information expressed in seconds. */
  ttl?: number;
  /** This is used to override the context URI e.g. override the URI of the containing collection */
  anchor?: string;
}

export interface EssentialData {
  /**
   * Alpha-numeric code associated with an organization. When a user joins an organization, they can submit integrations using this mnId
   * @maxLength 4
   * @example "0AFD"
   */
  mnId?: string;
  /**
   * The Device serial setupId read from QR code
   * @maxLength 3
   * @example "600"
   */
  setupId?: string;
  /**
   * The device serial number
   * @maxLength 15
   * @example "A1B2CD3EFG4H"
   */
  serialNumber?: string;
  /**
   * The unique name that identifies a wireless network (Service Set Identifier)
   * @maxLength 32
   * @example "MyNetwork"
   */
  ssid?: string;
  /**
   * The model code
   * @maxLength 32
   * @example "WF45R6300AV/US"
   */
  modelCode?: string;
  /** Hashed MacAddress */
  macAddressHash?: HashedMacAddress;
}

/**
 * Start or Stop a recording. Stop action requires a pending clip
 * @example "START"
 */
export enum ClipAction {
  START = 'START',
  STOP = 'STOP',
}

/**
 * The clip id associated with the clip
 * @format uuid
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type ClipId = string;

/**
 * The datetime when the clip recording should start
 * @format dateTime
 * @example "2022-04-17T21:53:55.858Z"
 */
export type ClipRecordingStartDate = string;

/**
 * Clip recording type
 * @example "VIDEO"
 */
export enum ClipRecordingType {
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}

export interface CreateClipRequest {
  /** Start or Stop a recording. Stop action requires a pending clip */
  action: ClipAction;
  /** The device id associated with the camera device */
  deviceId: DeviceId;
  /** Clip duration in seconds */
  duration?: Duration;
  /** The image id associated with the clip */
  imageId?: ImageId;
  /** Seconds before current time for starting clip */
  prebuffer?: Prebuffer;
  /** Clip recording type */
  recordingType: ClipRecordingType;
  /** The datetime when the clip recording should start */
  startDate?: ClipRecordingStartDate;
  /** Unique ID of the event that triggered this record request */
  triggerId?: TriggerId;
  /** The type of the event that triggered the recording */
  triggerType?: TriggerType;
}

export interface CreateClipResponse {
  /** @example "START" */
  action?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  clipId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  deviceId?: string;
  /** @format dateTime */
  expirationDate?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  imageId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  locationId?: string;
  /**
   * @format uri
   * @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&clip_id=s6Pk0czd1CWWPAKL7owrJ"
   */
  mediaUrl?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  ownerId?: string;
  /** @example 0 */
  prebuffer?: number;
  /** @example "VIDEO" */
  recordingType?: string;
  /** @example 10 */
  requestedDuration?: number;
  /** @format dateTime */
  startDate?: string;
  /** @example "REQUESTED" */
  state?: string;
  /**
   * @format uri
   * @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&clip_id=s6Pk0czd1CWWPAKL7owrJ"
   */
  thumbUrl?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  triggerId?: string;
  /** @example "automation" */
  triggerType?: string;
}

export interface CreateImageRequest {
  /** The clip id associated with the clip */
  clipId?: ClipId;
  /** The device id associated with the camera device */
  deviceId: DeviceId;
  /** Unique ID of the event that triggered this record request */
  triggerId?: TriggerId;
  /** The type of the event that triggered the recording */
  triggerType?: TriggerType;
}

export interface CreateImageResponse {
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  clipId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  deviceId?: string;
  /**
   * @format dateTime
   * @example "2017-06-12T15:55:49.0Z"
   */
  expirationDate?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  imageId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  locationId?: string;
  /**
   * @format uri
   * @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&clip_id=s6Pk0czd1CWWPAKL7owrJ"
   */
  mediaUrl?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  ownerId?: string;
  /**
   * @format dateTime
   * @example "2017-06-12T15:55:49.0Z"
   */
  recordedDate?: string;
  /** @example "REQUESTED" */
  state?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  triggerId?: string;
  /** @example "automation" */
  triggerType?: string;
}

/**
 * An empty object response
 * @example {}
 */
export type DeleteClipResponse = object;

/**
 * An empty object response
 * @example {}
 */
export type DeleteImageResponse = object;

/**
 * The UUID representing a device
 * @format uuid
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type DeviceUUID = string;

/**
 * Clip duration in seconds
 * @min 10
 * @max 120
 * @default 10
 * @example 10
 */
export type Duration = number;

export interface GetClipByClipIdResponse {
  /** @example "START" */
  action?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  clipId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  deviceId?: string;
  /** @example 10 */
  duration?: number;
  /**
   * @format dateTime
   * @example "2017-06-12T15:55:49.0Z"
   */
  expirationDate?: string;
  /** @example 1024 */
  filesize?: number;
  /** @example "MP4" */
  format?: 'MP4' | 'DASH';
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  locationId?: string;
  /**
   * @format uri
   * @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&clip_id=s6Pk0czd1CWWPAKL7owrJ"
   */
  mediaUrl?: string;
  /** @example {} */
  mp4info?: {
    encryptionIV?: string;
    encryptionKey?: string;
    /** @example {} */
    mpd?: object;
    segments?: object[];
    tracks?: TrackData[];
  };
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  ownerId?: string;
  /** @example false */
  pinned?: boolean;
  /** @example 0 */
  prebuffer?: number;
  /** @example "VIDEO" */
  recordingType?: string;
  /** @example 10 */
  requestedDuration?: number;
  /**
   * @format dateTime
   * @example "2017-06-05T15:55:49.0Z"
   */
  startDate?: string;
  /** Clip upload state as received from the Media server or the Edge Device */
  state?: GetClipState;
  /** @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&image_id=s6Pk0czd1CWWPAKL7owrJ" */
  thumbUrl?: string;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  triggerId?: string;
  /** @example "Motion detected" */
  triggerType?: string;
}

/**
 * Clip upload state as received from the Media server or the Edge Device
 * @example "PENDING"
 */
export enum GetClipState {
  REQUESTED = 'REQUESTED',
  PENDING = 'PENDING',
  PRESENT = 'PRESENT',
  IGNORED = 'IGNORED',
  FAILED = 'FAILED',
}

export interface GetClipsResponse {
  _links?: Links;
  items?: GetClipByClipIdResponse[];
}

export interface GetImageByImageIdResponse {
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  clipId?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  deviceId?: string;
  /**
   * @format dateTime
   * @example "2017-06-12T15:55:49.0Z"
   */
  expirationDate?: string;
  /** @example 1024 */
  filesize?: number;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  imageId?: string;
  /** @example {} */
  imageInfo?: object;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  locationId?: string;
  /**
   * @format uri
   * @example "https://mediaserv.media13.ec2.st-av.net/clip?source_id=c2a60795-a553-4360-b664-cd821caa3b2b&clip_id=s6Pk0czd1CWWPAKL7owrJ"
   */
  mediaUrl?: string;
  /** @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3" */
  ownerId?: string;
  /** @example false */
  pinned?: boolean;
  /**
   * @format dateTime
   * @example "2017-06-12T15:55:49.0Z"
   */
  recordedDate?: string;
  /** Image upload state as received from the Media server or the Edge Device */
  state?: GetImageState;
  /**
   * @format uuid
   * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
   */
  triggerId?: string;
  /** @example "Motion detected" */
  triggerType?: string;
}

/**
 * Image upload state as received from the Media server or the Edge Device
 * @example "PENDING"
 */
export enum GetImageState {
  REQUESTED = 'REQUESTED',
  PENDING = 'PENDING',
  PRESENT = 'PRESENT',
  IGNORED = 'IGNORED',
  FAILED = 'FAILED',
}

export interface GetImagesResponse {
  _links?: Links;
  items?: GetImageByImageIdResponse[];
}

/**
 * The image id associated with the clip
 * @format uuid
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type ImageId = string;

/**
 * Seconds before current time for starting clip
 * @min 0
 * @max 15
 * @default 0
 * @example 0
 */
export type Prebuffer = number;

/** Track data */
export interface TrackData {
  /** @example "avc1.428029" */
  codecString?: string;
  /** @example "avc1" */
  coding?: string;
  /** @example 128 */
  compatibility?: number;
  /** @example 24 */
  depth?: number;
  /** @example 10 */
  duration?: number;
  /** @example 30 */
  framerate?: number;
  /** @example 1080 */
  height?: number;
  /** @example 41 */
  level?: number;
  /** @example "baseline" */
  profile?: string;
  /** @example 1 */
  trackId?: number;
  /** @example 1920 */
  width?: number;
}

/**
 * Unique ID of the event that triggered this record request
 * @format uuid
 * @example "6f5ea629-4c05-4a90-a244-cc129b0a80c3"
 */
export type TriggerId = string;

/**
 * The type of the event that triggered the recording
 * @example "automation"
 */
export type TriggerType = string;

export interface UpdateClipRequest {
  /** Clip duration in seconds */
  duration?: Duration;
  /**
   * File size in bytes
   * @min 1024
   */
  fileSize?: number;
  /** @example {} */
  mp4info?: object;
  /** Clip upload state as received from the Media server or the Edge Device */
  state?: UpdateClipState;
}

/**
 * Clip upload state as received from the Media server or the Edge Device
 * @example "PENDING"
 */
export enum UpdateClipState {
  PENDING = 'PENDING',
  PRESENT = 'PRESENT',
  IGNORED = 'IGNORED',
  FAILED = 'FAILED',
}

export interface UpdateImageRequest {
  /**
   * File size in bytes
   * @min 1024
   */
  fileSize?: number;
  /** @example {} */
  imageInfo?: object;
  /** Image upload state as received from the Media server or the Edge Device */
  imageState: UpdateImageState;
}

/**
 * Image upload state as received from the Media server or the Edge Device
 * @example "PENDING"
 */
export enum UpdateImageState {
  PENDING = 'PENDING',
  REQUESTED = 'REQUESTED',
  PRESENT = 'PRESENT',
  IGNORED = 'IGNORED',
  FAILED = 'FAILED',
}

/** A request to create a QR code location invitations */
export interface CreateLocationQRInviteRequest {
  /** The unique identifier for the location to share */
  locationId: string;
  /** One or more instances of consent. */
  consent?: QRConsentPayload;
  /** Optional access level of `full` or `restricted`.  Default is `full` */
  accessLevel?: string;
  /** Optional list of device UUIDs to be accessible to the invited user. If not provided, all devices will be accessible to the invited user. */
  deviceList?: DeviceUUID[];
  /** Optional time in epoch seconds in which the access granted by the invitation is revoked */
  accessExpiration?: string;
}

/** One or more instances of consent. */
export type QRConsentPayload = ConsentPayloadWithKeyItem[];

/** Contains information about consent */
export interface ConsentPayloadWithKeyItem {
  /**
   * The locksmith key for the consent record
   * @example "pp_location"
   */
  key: string;
  /** The 'data' element of the consent record stored in locksmith.  Contains details on the consent. */
  data?: {
    agreed?: ConsentPayloadAgreed[];
  };
}

/** A response to a create QR code location invitation request */
export interface CreateLocationQRInviteResponse {
  /** The unique identifier for the created invitation */
  invitationId: string;
  /** A long-form unique identifier for the invitation that should be used to generate the QR code image */
  longCode: string;
}

/** A request to accept QR code location invitation */
export interface AcceptLocationQRInviteRequest {
  /** One or more instances of consent. */
  consent?: QRConsentPayload;
}

/** A response to an accept QR code location invitation request */
export interface AcceptLocationQRInviteResponse {
  /** The unique identifier for the location */
  locationId: string;
  /** The user defined name for the location */
  locationName: string;
}

export interface ConsentPayloadAgreed {
  country: string;
  /** ISO 8601 date-time */
  updatetime: string;
  version: string;
  isOptional: boolean;
  isAgreed: boolean;
}

/** A page of schema invitations */
export interface SchemaInvitePage {
  items?: SchemaAppInvite[];
  links?: Links;
}

/** A request to create a schema app invitation */
export interface CreateSchemaAppInviteRequest {
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** An optional description field that can be used to add a description to the invitation */
  description?: string;
}

/** A response to a create Schema App invitation request */
export interface CreateSchemaAppInviteResponse {
  /** The unique identifier for the created invitation */
  invitationId?: string;
}

/** A schema app invitation */
export interface SchemaAppInvite {
  /** The unique Id of the invitation */
  id?: string;
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** Optional description attached to the invitation */
  description?: string;
  /** Optional expiration in seconds from epoc */
  expiration?: number;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  declineUrl?: string;
  /** The short code referencing the invitation */
  shortCode?: string;
}

/** Acceptance status of a schema invitation */
export interface CheckSchemaAppInviteAcceptanceResponse {
  /** The unique Id of the schema app */
  schemaAppId?: string;
  /** A boolean to represent if the invitation has been accepted or not */
  isAccepted?: boolean;
  /** Optional description attached to the invitation */
  description?: string;
  /** Optional expiration in seconds from epoc */
  expiration?: number;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  acceptUrl?: string;
  /**
   * The URL that can be used to accept the invitation
   * @example "https://www.example.com"
   */
  declineUrl?: string;
  /** The short code referencing the invitation */
  shortCode?: string;
}

/** Response from Accept schema app request */
export interface AcceptSchemaAppInviteResponse {
  /** The unique Id of the schema app */
  schemaAppId?: string;
}

export interface CreateIrDeviceParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetIrDeviceParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The Device ID */
  deviceId: string;
}

export interface UpdateIrDeviceParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The Device ID */
  deviceId: string;
}

export interface StudyIrCodeParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  parentDeviceId: string;
}

export interface GetIrCodeParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  parentDeviceId: string;
  childDevicePid: string;
}

export interface PatchDeviceParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The device id of the command you want to update */
  childDeviceId: string;
}

export interface ExecuteFunctionParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  parentDeviceId: string;
}

export interface QueryVersionParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  deviceId: string;
}

export interface OtaUpgradePayload {
  /**
   * URL of the OTA version to upgrade to
   * @example "http://version.broadlink.com/firmware/download/12345.bin"
   */
  url?: string;
}

export interface OtaUpgradeParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  deviceId: string;
}

export interface ListInstalledAppSummariesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** A filter for only fetching apps of some types */
  appType?: ('SMARTAPP' | 'ENDPOINTAPP')[];
  /** If set to true, endpoint apps may include the allow list property */
  allowed?: boolean;
}

export interface UninstallInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface PauseInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface ResumeInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface DashboardInstalledAppParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The ID of the installed application.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  installedAppId: string;
}

export interface ListConnectedServicesParams {
  /**
   * Optional location ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface ListDeviceStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * The capabilities are treated as an "and" so all capabilities must be present.
   */
  capability?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** Limit status results to only include capabilities found in the capability query. */
  filterByCapabilities?: boolean;
}

export interface ListDeviceGroupStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
  /**
   * The device capabilities to filter the results by.
   * If present, only statuses for capabilties in this list will be returned.
   */
  capability?: string[];
  /** If the device status should include data. */
  includeData?: boolean;
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface ListFavoritesParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
}

export interface CreateFavoriteParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
}

export type ReplaceFavoritesPayload = FavoriteUpdateObject[];

export interface ReplaceFavoritesParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
}

export interface DeleteFavoritesParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
}

export interface GetFavoriteParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
  /**
   * The id of the favorite.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  favoriteId: string;
}

export interface DeleteFavoriteParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /**
   * The bucket the Favorite(s) belong to. If not included uses location based favorites. [Max length = 50]
   * @format string
   */
  bucket?: string;
  /**
   * The id of the favorite.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  favoriteId: string;
}

export interface GetFavoritesMigrationStatusParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateFavoritesMigrationStatusParams {
  /**
   * The location the Favorite(s) belong to.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetActionIconParams {
  /** An option to specify the theme of the icon. Defaults to `day` */
  theme?: 'day' | 'night';
  /** *DEPRECATED* Please use `theme` parameter instead.  An option to specify the theme of the icon. Defaults to `day` */
  actionTheme?: 'day' | 'night';
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The action key for the icon. */
  actionIcon: string;
}

export interface GetBadgeIconParams {
  /** An option to specify the theme of the icon. Defaults to `day` */
  theme?: 'day' | 'night';
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The badge icon key for the icon. */
  badgeIcon: string;
  /** The badge state for the icon. One of `on` or `off`. */
  badgeIconState: string;
}

export interface GetAutoIconParams {
  /** An option to specify the theme of the icon. Defaults to `day` */
  theme?: 'day' | 'night';
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The auto icon key for the icon. */
  autoIcon: string;
  /** The auto state for the icon. One of `on` or `off`. */
  autoIconState: string;
}

export interface GetCapabilityAttributeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The capability ID for the icon. */
  capabilityId: string;
  /** The attribute name for the icon. */
  attributeName: string;
}

export interface GetGroupIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The group icon key for the icon. */
  groupIcon: string;
  /** The group state for the icon. */
  groupIconState: string;
}

export interface GetOcfDeviceTypeIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The OCF Device Type for the icon. */
  ocfDeviceType: string;
}

export interface GetOneuiIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The oneui icon key for the icon. */
  oneuiIcon: string;
  /** The oneui state for the icon. */
  oneuiIconState: string;
}

export interface GetPreloadIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The preload icon key for the icon. */
  preloadIcon: string;
  /** The preload state for the icon. */
  preloadIconState: string;
}

export interface GetSceneIconParams {
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
  /** The Scene key for the icon. */
  sceneIcon: string;
}

export interface ListDeviceIconUrlsParams {
  /** The device locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** An option to specify the size of the icon. */
  displaySize?: string;
  /** Convenience query parameter to specify the icon format. */
  contentType?: string;
}

export interface GetSwatchesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
}

export interface GetSwatchStatusesParams {
  /** The Locations to filter the results by. */
  locationId?: string[];
}

export interface GetLocationSummaryParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderLocationsPayload = string[];

export interface GetOrderedRoomsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderRoomsPayload = string[];

export interface UpdateUserSortOrderRoomsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetOrderedDevicesParams {
  /**
   * The ID of the Room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId: string;
  /** whether migration should happen. If true, migration will happen only if there is no data in nibbler, but there is data in cortex */
  migrate?: boolean;
}

export type UpdateUserSortOrderDevicesPayload = string[];

export interface UpdateUserSortOrderDevicesParams {
  /**
   * The ID of the Room.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  roomId: string;
}

export interface GetOrderedDevicesForLocationParams {
  /** whether migration should happen. If true, migration will happen only if there is no data in nibbler, but there is data in cortex */
  migrate?: boolean;
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  pathLocationId: string;
}

export interface GetOrderedAutomationsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderAutomationsPayload = string[];

export interface UpdateUserSortOrderAutomationsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetOrderedSmartAppsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderSmartAppsPayload = string[];

export interface UpdateUserSortOrderSmartAppsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetOrderedScenesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderScenesPayload = string[];

export interface UpdateUserSortOrderScenesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetOrderedLifeServicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderLifeServicesPayload = string[];

export interface UpdateUserSortOrderLifeServicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetOrderedStaticSummarySettingsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export type UpdateUserSortOrderStaticSummarySettingsPayload = (
  | 'LIGHTS'
  | 'TEMPERATURE'
  | 'HUMIDITY'
  | 'WEATHER'
  | 'OUTDOOR_AIR_QUALITY'
  | 'BLINDS'
)[];

export interface UpdateUserSortOrderStaticSummarySettingsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetSummaryLocationCardsSortOrderParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

/** @example "LIGHTS" */
export type UpdateLocationSummaryCardsSortOrderPayload = LocationSummaryDeviceType[];

export interface UpdateLocationSummaryCardsSortOrderParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetLocationSummarySettingsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateUserLocationSummarySettingsParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetLocationSummaryUnselectedDevicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface UpdateLocationSummaryUnselectedDevicesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface InternalListHiddenDevicesParams {
  /**
   * The ID of the user whose hidden devices should be fetched
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  userId: string;
}

export interface QueryVersionOnServerParams {
  deviceType: string;
}

export interface ListDeviceGroupsParams {
  /** The device group locations to filter the results by. */
  locationId?: string[];
  /** The device group types to filter the results by. */
  groupType?: ('GENERIC' | 'VIDEO_CAMERA' | 'LIGHTING')[];
}

export interface GetDevicesByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** isaId of the user. */
  isaId: string;
}

export interface PutIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId */
  isaId: string;
}

export interface DeleteIsaByIsaIdParams {
  /** locationId of the user. */
  locationId: string;
  /** isaId of the user. */
  isaId: string;
}

export interface GetPagesParams {
  /** page type */
  type: string;
  /** location id of the user */
  locationId: string;
  /**
   * Response of getOauthCallback API depends on this query parameter. If true, returns an HTML page with redirect link else returns an HTML page with "connection successful/failed" text.
   * @default false
   */
  redirectRequested?: boolean;
  /** SmartThings Schema App id */
  endpointAppId: string;
}

export interface ListScenesParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify the icon type. */
  iconType?: string;
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
}

export interface GetSceneParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** Specify the icon type. */
  iconType?: string;
  /**
   * The ID of the Scene.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface GetActivityHistoriesParams {
  /** One Location ID. */
  location: string;
  /** List of device IDs. e.g. device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37&device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37 */
  device?: string[];
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return. Default is 20.
   * @default 20
   */
  limit?: number;
  /** Optional. This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
  /** Optional parameter to filter by activities type, defaults to include everything. */
  include?: ('device' | 'execution' | 'mode')[];
  /**
   * Optional parameter that determines whether to include history of user level device.
   * @default false
   */
  includeUserLevelDeviceHistory?: boolean;
  /**
   * Optional parameter that determines whether to include rule execution of user level device.
   * @default false
   */
  includeUserLevelExecutionHistory?: boolean;
  /**
   * Optional parameter that determines whether to include native app history.
   * @default false
   */
  includeNativeAppHistory?: boolean;
}

export interface GetExecutionActionsParams {
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Number of records to return. Default is 20. Max is 100.
   * @default 20
   */
  limit?: number;
  /** Optional. This controls ordering of results. When not specified or 'oldestFirst=false', server will list newest history first, aka descending order.  */
  oldestFirst?: boolean;
  /** execution's Location ID */
  locationId: string;
  /** Execution ID */
  executionId: string;
}

export interface GetNotificationsParams {
  /** One or more Location ID. */
  location: string[];
  /** Optional. List of device IDs. e.g. device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37&device=f33cc984-cde7-4d61-b3b7-a78de9ab5a37 */
  device?: string[];
  /**
   * Paging parameter for going to previous page. Before epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate previous page) with event time before the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  before?: number;
  /**
   * Paging parameter for going to previous page. Before Hash (long). This needs to be specified when 'before' is specified.
   *  Please put in associated hash value of the record specified by the 'before' parameter.
   * @format int64
   */
  beforeHash?: number;
  /**
   * Paging parameter for going to next page. After epoch time (millisecond). Optional.
   *  Return the nearest records (the immediate next page) with event time after the specified value exclusively. e.g. 1511913638679. Note: type is a long.
   * @format int64
   */
  after?: number;
  /**
   * Paging parameter for going to next page. After Hash (long). this needs to be specified when 'after' is specified.
   *  Please put in associated hash value of the record specified by the 'after' parameter.
   * @format int64
   */
  afterHash?: number;
  /**
   * Optional. Number of records to return. Default is 20.
   * @default 20
   */
  limit?: number;
  /** Optional parameter to filter by notification type, defaults to include everything. */
  include?: ('device' | 'others')[];
  /**
   * Optional parameter that determines whether to include notification of user level device.
   * @default false
   */
  includeUserLevelNotificationHistory?: boolean;
}

export interface DeleteAccountParams {
  /** Unique device identifier. Format shall be UUID */
  di: string;
}

export interface GetDeviceInfoParams {
  /** Unique device identifier. Format shall be UUID */
  di?: string[];
}

export interface GetLocationProfileParams {
  /** The ID of the location. */
  locationId?: string[];
}

export interface GetLocationListParams {
  /** Group type ["public", "personal"] */
  type?: string[];
}

export interface UpdateLocationParams {
  /** Location update operation value. ["add", "delete", "move"] */
  op?: string;
  /** The ID of the location. */
  locationId: string;
}

export interface UpdateRoomParams {
  /** Room update operation value. ["add", "delete", "move"] */
  op?: string;
  /** The ID of the room */
  locationId: string;
  /** roomId */
  roomId: string;
}

export interface GetRegistrationParams {
  /** device */
  deviceId: string;
  /** location */
  locationId?: string;
}

export interface GetDeviceKeyParams {
  /** Cx_ID */
  deviceId: string;
}

export interface GetSharedkeyParams {
  /** deviceId */
  deviceId: string;
  sharedDeviceId: string;
}

export type PostApDetailPostPayload = APDetail[];

export type PostDeviceApDetailsUsingPostPayload = DeviceAPRequest[];

export interface GetAllDeviceApDetailsUsingGetParams {
  /** ST device id for an IoT device, filters to show only this device. */
  deviceId?: string;
}

export interface GetOcfDeviceModeParams {
  deviceId: string;
}

export interface GetCertificateUuidParams {
  /** mnId */
  mnId: string;
  /** certType */
  certType: string;
  /** hashPrefix */
  hashPrefix: string;
}

export interface PostFileLinkParams {
  /** Unique content id (issued to client developer. ex: Lux) */
  cid: string;
  /** UUID device Id */
  di: string;
  /** SCloud requirement (Content type to upload). Type of content to upload. The value specified here will be downloaded as it is if you don't specify 'response-content-type'. */
  scContentType: string;
  /** SCloud requirement (Content size to upload). Length of content to upload. The value must be equal to the actual upload content. The maximum value depends on the service. */
  scContentLength: number;
}

export interface GetFileLinkParams {
  /** Unique content id (issued to client developer. ex: Lux) */
  cid: string;
  /** UUID device Id */
  di: string;
  /** UUID file id */
  fileId: string;
}

export interface ListRulesParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location you want to list the Rules for.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * If set to true, the items in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * If set to true, all rules are returned
   * @default false
   */
  includeAllParents?: string;
  /** The max number of Rules to fetch */
  max?: number;
  /** The start index of Rules to fetch */
  offset?: number;
  /** Creator who created the behavior */
  creators?: ('SMARTTHINGS' | 'ARB' | 'RECIPE' | 'UNDEFINED')[];
}

export interface CreateRuleParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location you want to contain your Rule.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * If set to true, the item in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
}

export interface DeleteAllRulesParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location in which the rules must be deleted.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRuleParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location containing the Rule you want to list.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * If set to true, the item in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * The ID of a Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface UpdateRuleParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location containing the Rule.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * If set to true, the item in the response may contain the allowed list property
   * @default false
   */
  allowed?: string;
  /**
   * The ID of a Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface DeleteRuleParams {
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of the location containing the Rule you want to delete.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * The ID of a Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface ExecuteAdhocRuleParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface ExecuteRuleParams {
  /**
   * Optional location ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of a Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
}

export interface UpdateRuleStatusParams {
  /**
   * Optional location ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /** The owner of the rule (USER | LOCATION) */
  ownerType?: 'LOCATION' | 'USER';
  /**
   * The ID of a Rule
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  ruleId: string;
  /**
   * The status of a Behavior. This value only allowed 'Enable' or 'Disable' with case insensitive
   * @format (?i)\benable\b|\bdisable\b
   */
  status: string;
}

export interface GetPlcmDeliveryOrderParams {
  /** Document Number */
  documentNumber?: string;
  /** Delivery Item */
  deliveryItem?: string[];
}

export interface GetDevicesParams {
  /**
   * all|visible|invisible
   * default : visible
   * @default "visible"
   */
  visibility?: string;
  /**
   * desc|asc
   * default : desc
   * @default "desc"
   */
  orderBy?: string;
  /** FOA | PDD | PRS | PLCM | SNF */
  sourceType?: string;
}

export interface DeletePlcmDeviceParams {
  serialNumber?: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA-512 algorithm
   * @format ^[a-f0-9]{128}$
   */
  hashedSerialNumber?: string;
  setupId: string;
  mnId: string;
}

export interface GetGeolocationsByDeviceIdsParams {
  /** The device IDs of tracker to filter the results by. */
  deviceId: string[];
}

export interface CreateTrackerGeolocationsPayload {
  geolocations?: GeolocationInput[];
}

export interface ListHubsDeprecatedParams {
  locationId: string;
}

export interface GetHubDeprecatedParams {
  locationId: string;
  /**
   * The Hub's ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubId: string;
}

export interface DeleteHubDeprecatedParams {
  locationId: string;
  /**
   * The Hub's ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubId: string;
}

export interface PutHubDeprecatedParams {
  locationId: string;
  /**
   * The Hub's ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubId: string;
}

export interface GetZigbeeGraphParams {
  locationId: string;
  /**
   * The Hub's ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubId: string;
}

export interface GetZWaveGraphParams {
  locationId: string;
  /**
   * The Hub's ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubId: string;
}

export interface ListHubCharactersticsParams {
  /**
   * The subset of names you want to filter the characterstics to. If not specified all values will be returned
   * These values have to be exact matches to (including proper capitilization)
   */
  characteristicNames?: string[];
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface GetHubReplacementCandidatesParams {
  /** The destination hub to filter candidates results to. */
  destinationHubId?: string;
  /**
   * The Hub's Device ID. This is sometimes referred to as the Hub UUID or HubId
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  hubDeviceId: string;
}

export interface GetRoomsSduiParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface GetRulesSduiParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
}

export interface StartAppInstallParams {
  /**
   * The ID of the Location that both the installed SmartApp and source are associated with.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The app to be installed. */
  appId: string;
}

export interface GetAllDeviceConfigurationParams {
  /**
   * device profile id list
   * @format key = value multiple times with &
   */
  profileId: string;
}

export interface Link2 {
  /**
   * device profile id list
   * @format key = value multiple times with &
   */
  profileId: string;
}

export interface GetContinyDevicesParams {
  /** provider id */
  providerId?: string;
  /** country code */
  country?: string;
  /** group id */
  groupId?: string;
  /** version for netflix support(test version=1 for netflix) */
  version?: string;
}

export interface ExecuteContinyValidateDevicesParams {
  /** version for netflix support(test version=1 for netflix) */
  version?: string;
}

export interface ExecuteContinyPlayContentsParams {
  /** provider id */
  providerId: string;
  /** version */
  version?: string;
  deviceId: string;
}

export interface GetContinySessionsParams {
  /** provider id */
  providerId?: string;
  /** session id */
  sessionId?: string;
  /** version */
  version?: string;
}

export interface GetContinyPlaybackInfoParams {
  /** provider id */
  providerId: string;
}

export interface GetContinyUserModelParams {
  /** Current Version with the Client */
  version?: string;
}

export interface GetContinyProvidersListParams {
  /** version for netflix support(test version=1 for netflix) */
  version?: string;
}

export interface GetMetricsSessionParams {
  /** version */
  version?: string;
}

export interface GetDevicePresentationParams {
  /** System generated identifier that corresponds to a device presentation (formerly `vid`) */
  presentationId: string;
  /** Secondary namespacing key for grouping presentations (formerly `mnmn`) */
  manufacturerName?: string;
  /**
   * The ID of a device for which we want to load the device presentation.
   * If the device ID is provided, no other fields are required.
   */
  deviceId?: string;
  /** view type */
  view?: 'dashboard' | 'detailView' | 'automation';
  /**
   * Optional location ID.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface ListDevicePresentationParams {
  /** view type */
  view?: 'dashboard' | 'detailView' | 'automation';
  /** The Locations to filter the results by. */
  locationId?: string[];
  /** The device ids to filter the results by. */
  deviceId?: string[];
  /** The device types to filter the results by. */
  type?: string[];
  /** The device categories to filter the results by. */
  category?: string[];
  /**
   * Treat all capability filter query params as a logical "or" or "and" with a default of "and".
   * @default "and"
   */
  capabilitiesMode?: 'or' | 'and';
  /**
   * Restricted devices are hidden by default. This query parameter will reveal them. Device status will
   * not be provided if the token does not have sufficient access level to view the device status even
   * if includeStatus parameter is set to true.
   */
  includeRestricted?: boolean;
  /** Only list devices accessible by the given accessLevel. */
  accessLevel?: number;
  /**
   * User-level devices are devices that are not tied to a location, but are instead tied to the user. In order
   * to include these devices in the list, a flag is needed to differentiate from devices listed by location.
   */
  includeUserDevices?: boolean;
  /** Use this in conjunction with includeUserDevices to get only User-level devices. */
  excludeLocationDevices?: boolean;
}

export interface GetHintsDevicesParams {
  /**
   * Whether all hints are returned or not (by default, it is false)
   * @default false
   */
  showall?: boolean;
  /** whether device's alias name is included or not (by default, it is false) */
  includealias?: boolean;
}

export interface GetDeviceHintsUsingGetParams {
  /**
   * Whether all hints are returned or not (by default, it is false)
   * @default false
   */
  showall?: boolean;
  /** whether device's alias name is included or not (by default, it is false) */
  includealias?: boolean;
  /** deviceId */
  deviceId: string;
}

export interface GetHintsCapabilityParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** SmartThings capability name */
  stCapability: string;
}

export interface GetDialoguesParams {
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration). It can be comma separated list. */
  voiceintent?: string;
  /** source of dialogue */
  origin?: 'system' | 'custom';
  /** manufacturer name */
  mnmn?: string;
  /** bixby invoke mode */
  mode?: 'handsOn' | 'handsFree';
}

export interface GetDialogues2Params {
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration). It can be comma separated list. */
  voiceintent?: string;
  /** bixby invoke mode */
  mode?: 'handsOn' | 'handsFree';
  voiceIntent: string;
}

export interface GetDialogueListParams {
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration). It can be comma separated list. */
  voiceintent?: string;
  /** bixby invoke mode */
  mode?: 'handsOn' | 'handsFree';
  /** source of dialogue */
  origin?: 'system' | 'custom';
  /** manufacturer name */
  mnmn?: string;
  voiceIntent: string;
}

export interface GetVocabsParams {
  /** Name of Bixby vocabulary type */
  type?: string;
}

export interface GetVoiceIntentListParams {
  /** Device type to filter utterance */
  devicetype?: string;
  /** The page number */
  page?: number;
  /** The number of voice intents in a page (by default, the limit size is 50) */
  limit?: number;
}

export interface GetVoiceIntentsParams {
  /** Voice Intent :(voice capability)-(voice action)-(voice enumeration). It can be comma separated list. */
  voiceintent?: string;
  /** Device type to filter utterance */
  devicetype?: string;
  voiceIntent: string;
}

export interface GetScenesHintsParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface GetSceneHintsParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
  /**
   * scene ID
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  sceneId: string;
}

export interface GetLocationsHintsParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface HintsAutomationcreationParams {
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId?: string;
}

export interface GetVoiceCatalogParams {
  /**
   * amazon_alexa | google_assistant
   * @format string
   */
  partner: string;
  /**
   * all | owned, default all
   * @format string
   */
  catalogType: string;
}

export interface GetAddressesParams {
  /**
   * Country code in ISO Alpha-2 format
   * @format [A-Z]{2}
   */
  country: string;
  /** The postal code of the area served by the headend */
  postalCode?: string;
}

export interface GetHeadendsParams {
  /**
   * Country code in ISO Alpha-2 format
   * @format [A-Z]{2}
   */
  country: string;
  /** Name of state */
  state?: string;
  /** Name of City */
  city?: string;
  /** The postal code of the area served by the headend */
  postalCode?: string;
}

export interface GetTransactionStatusParams {
  /** transactionId */
  transactionId: string;
}

export interface ListGeoplacesParams {
  /**
   * The type of owner that the Geoplace is associated to, including user permissioning. If present, `ownerId` must also be present.
   * @default "LOCATION"
   */
  ownerType?: 'LOCATION';
  /**
   * Global identifier for the given `ownerType`. If present, `ownerType` must also be present.
   * @format uuid
   */
  ownerId?: string;
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
}

export interface DeleteGeoplacesParams {
  /**
   * The type of owner that the Geoplace is associated to, including user permissioning. If present, `ownerId` must also be present.
   * @default "LOCATION"
   */
  ownerType?: 'LOCATION';
  /**
   * Global identifier for the given `ownerType`. If present, `ownerType` must also be present.
   * @format uuid
   */
  ownerId?: string;
}

export interface GetGeoplaceParams {
  /** If set to true, the response may contain the allowed list property */
  allowed?: boolean;
  /** The Id of the geoplace */
  geoplaceId: string;
}

export interface ListEssentialDataParams {
  /**
   * The identifier for the location
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  locationId?: string;
  /** Alpha-numeric code associated with an organization. When a user joins an organization, they can submit integrations using this mnId */
  mnId?: string;
  /** The device serial number */
  serialNumber?: string;
  /**
   * Hexadecimal representation of the hashed device's serial number using SHA512 algorithm
   * @format ^[a-z0-9]{128}$
   */
  hashedSerialNumber?: string;
  macAddressType?: 'wifi' | 'ble' | 'p2p' | 'bt' | 'upnp';
  hashedValue?: string;
  /** An String value to be passed back to the query to get the next page, since pagination works in a forward-only fashion. This value is obtained from the next property of the previous response */
  nextKey?: string;
}

export interface GetClientsParams {
  /** Optional. Number of clients to return. Default is 20. Max is 100. */
  limit?: number;
  /** The Continuation token */
  continuationToken?: string;
}

export interface GetTariffsParams {
  partnerCode?: string;
  partnerName?: string;
  partnerDeviceId?: string;
  partnerId?: string;
  sn?: string;
  deviceId?: string;
}

export interface GetTariffByIdParams {
  partnerCode?: string;
  partnerName?: string;
  partnerDeviceId?: string;
  partnerId?: string;
  sn?: string;
  deviceId?: string;
  tariffId: number;
}

export interface GetPolicyParams {
  /** @default "CAMERA" */
  deviceType: string;
  partnerCode: string;
  /** @default "open_us" */
  partnerName: string;
}

export interface DeleteDeviceFromTariffParams {
  id: number;
}

export interface SearchTariffsParams {
  /** @default "CAMERA" */
  deviceType: string;
  /** @default "open_us" */
  partnerName: string;
  /** @default "testSn" */
  sn: string;
}

export interface SelectKitsParams {
  /** @default "kitSn" */
  sn?: string;
  /** @default "HUB" */
  type?: string;
}

export interface DeleteKitsBySnAndTypeParams {
  /** @default "kitSn" */
  sn: string;
  /** @default "HUB" */
  type: string;
}

export interface CreatePlansParams {
  region?: string;
}

export interface DeletePlansParams {
  region?: string;
  id: number;
}

export interface AddPlanServiceParams {
  /** @default "false" */
  noti?: boolean;
  /** @default "na" */
  region?: string;
  name: string;
  id: number;
}

export interface DeletePlanServiceParams {
  /** @default "HMVS_OPEN" */
  name?: string[];
  /** @default "na" */
  region?: string;
  id: number;
}

export interface GetSercommDevicesParams {
  /** @default "kitSn" */
  hubSn: string;
}

export interface GetSercommDevices2Params {
  /** @default "kitSn" */
  hubSn: string;
}

export interface ListHowToUseParams {
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. This parameter is optional and can be `true` or `false` */
  preview?: 'true' | 'false';
  /** Determines whether data is presented in dark mode or not. This parameter is optional and can be `true` or `false` */
  darkmode?: 'true' | 'false';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc) or
   * with Country Code for `DID` content (example: en-US, ko-KR, zh-CN, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other' | 'windows';
}

export interface ListNotificationParams {
  /**
   * Providers
   * `othersp`: For other service providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /** Determines whether data is presented in dark mode or not. This parameter is optional and can be `true` or `false` */
  darkmode?: 'true' | 'false';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface ListVideoParams {
  /**
   * Providers
   * `othersp`: For other sevice providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface ListHeroBannerParams {
  /**
   * Providers
   * `othersp`: For other sevice providers that is not listed
   */
  providers?: ('none' | 'vdf262002' | 'singtel' | 'maxis' | 'labs' | 'othersp')[];
  /** Type of HeroBanner */
  type?: 'air' | 'energy' | 'carrier' | 'labs';
  /** Get contents with moderation state `draft`. The only valid value for this query parameter (if included) is `true`. */
  preview?: 'true';
  /**
   * App querying version
   * @min 1
   * @max 100
   */
  appVersion: number;
  /** Country Id - `ISO 3166-1 alpha-2` Country Code (example: KR, US, CN, etc) */
  countryId: string;
  /**
   * Language Id - `ISO 639-1` Language Code (example: en, ko, zh, etc)
   * @minLength 2
   * @maxLength 7
   */
  lngId: string;
  /**
   * Device Type
   * `other`: For non galaxy Android devices
   */
  device: 'galaxy' | 'ios' | 'tizen' | 'other';
}

export interface GetLocationOnboardingStatisticsParams {
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
}

export interface GetEphemeralDevicesParams {
  /**
   * Returns devices matching only the supplied status. Status:
   *   * `FAILED` - returns failed onboardings only
   *   * `SUCCESS` - returns successful onboardings only
   */
  status?: 'FAILED' | 'SUCCESS';
  /**
   * The ID of the location.
   * @format ^(?:([0-9a-fA-F]{32})|([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}))$
   */
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
}

export interface GetEphemeralDeviceParams {
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
  /**
   * Identifier of an ephemeral device
   * @format UUID
   * @minLength 1
   * @maxLength 36
   */
  ephemeralDeviceId: string;
}

export interface UpsertEphemeralDeviceParams {
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
  /**
   * Identifier of an ephemeral device
   * @format UUID
   * @minLength 1
   * @maxLength 36
   */
  ephemeralDeviceId: string;
}

export interface PartialUpdateEphemeralDeviceParams {
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
  /**
   * Identifier of an ephemeral device
   * @format UUID
   * @minLength 1
   * @maxLength 36
   */
  ephemeralDeviceId: string;
}

export interface DeleteEphemeralDeviceParams {
  locationId: string;
  /** The ID of the Location Group. */
  locationGroupId: string;
  /**
   * Identifier of an ephemeral device
   * @format UUID
   * @minLength 1
   * @maxLength 36
   */
  ephemeralDeviceId: string;
}

export interface RetrieveResourcePetitionParams {
  /**
   * The identifier for the location
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  locationId?: string;
  /** Fetch only petitions with a specified type. Only a single value is allowed. Example: STANDARD */
  petitionType?: 'STANDARD' | 'LINKSHARE';
  /** The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100). Example: 10 */
  limit?: number;
  /** The page key, used when retrieving the next page of results. Example: ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0= */
  page?: string;
  resourceType: string;
  resourceId: string;
}

export interface ListAccessRequestsParams {
  /** Fetch only access requests with a specified status. Only a single value is allowed. Example: PENDING */
  status?: 'PENDING' | 'APPROVED' | 'REJECTED';
  /** The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100). Example: 10 */
  limit?: number;
  /** The page key, used when retrieving the next page of results. Example: ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0= */
  page?: string;
}

export interface ListGrantorAccessRequestsParams {
  /** Limit the query to a specific resource type. */
  resourceType?: 'LOCATION';
  /** Limit the query to a specific resource id. */
  resourceId?: string;
  /** Limit the query to a specific petition type */
  petitionType?: 'STANDARD' | 'LINKSHARE';
  /** Limit the query to a specific petitionId. */
  petitionId?: string;
  /** The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100). Example: 10 */
  limit?: number;
  /** The page key, used when retrieving the next page of results. Example: ewogICJTb3J0SWQiIDogewogICAgInMiIDogImkvYTgzOTk4NjEtMWU1Zi00MjFkLTkyM2EtZTlkNWNjOTE1OTE4LzI2YmNiNGRmLWI3ZDQtNDUwYi1hMDNjLTZiNTA3ZTRlNWI1NyIKICB9LAogICJQYXJ0aXRpb25JZCIgOiB7CiAgICAicyIgOiAic3QxOjU6OjEyL2JhY2RiMzQ1LTYzN2MtNGVmNC1hN2U4LWEwNWQ0YzVkZWE2YSIKICB9Cn0= */
  page?: string;
}

export interface ApproveAccessRequestParams {
  /**
   * The grant to apply when approving the access request, overriding
   * the default set on the access request.  If the requestor already
   * has access to the location by the time this approval is processed
   * (due to some other invitation, approval by another approver, etc.),
   * the existing grant will be left unchanged.
   */
  grantType?: 'SHARE' | 'RESTRICTEDSHARE';
  /** The id of the access request. Example: d4f5e36c-a808-40cf-bd04-584fed7f22cb */
  accessRequestId: string;
}

export interface ListAddressesParams {
  /** parameter to query address */
  keyword?: string;
  /** parameter to query latitude */
  latitude?: number;
  /** parameter to query longitude */
  longitude?: number;
  /** radius distance from latitude and longitude. The unit is meter. Default value is 1000. */
  radius?: number;
  /** Next page result set key. Default page value is 0. */
  page?: number;
  /** Maximum number of Addresses returned in a paged result set. Default value is 20. */
  limit?: number;
}

export interface GetIndoormapParams {
  locationId: string;
}

export interface UpdateIndoormapParams {
  locationId: string;
}

export interface DeleteIndoormapParams {
  locationId: string;
}

export interface GetClipsParams {
  /** @format uuid */
  locationId?: string;
  /** @format uuid */
  deviceId?: string;
  /** @format datetime */
  startDate: string;
  /** @format datetime */
  endDate: string;
  recordingType?: 'VIDEO' | 'AUDIO';
}

export interface GetLatestClipByDeviceIdParams {
  deviceId: string;
}

export interface GetLatestImageByDeviceIdParams {
  deviceId: string;
}

export interface GetImagesParams {
  /** @format uuid */
  locationId?: string;
  /** @format uuid */
  deviceId?: string;
  /** @format datetime */
  startDate: string;
  /** @format datetime */
  endDate: string;
}

export interface ListSchemaAppInvitationsParams {
  /** The schema app ID you would like a list of invitations for. */
  schemaAppId: string;
  /** The maximum number of records to return in a single page. Acceptable values: 1-100 (Default = 100) */
  limit?: number;
  /** The page key, used when retreiving the next page of results */
  page?: string;
}

export interface SchemaAppCheckAcceptanceParams {
  /** The invitationId you would like to see the acceptance status of. */
  invitationId: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = 'https://client.smartthings.com';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Client API
 * @version 1.0
 * @baseUrl https://client.smartthings.com
 *
 * API endpoints for mobile clients
 */
export class ClientV1Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  irdevices = {
    /**
     * @description Create a new IR Blaster device.
     *
     * @tags irdevices
     * @name CreateIrDevice
     * @summary Create an IR Device
     * @request POST:/irdevices
     * @secure
     */
    createIrDevice: (query: CreateIrDeviceParams, createDevice: CreateIrDevice, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices`,
        method: 'POST',
        query: query,
        body: createDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the details of the device.
     *
     * @tags irdevices
     * @name GetIrDevice
     * @summary Get device details
     * @request GET:/irdevices/{deviceId}
     * @secure
     */
    getIrDevice: ({ deviceId, ...query }: GetIrDeviceParams, params: RequestParams = {}) =>
      this.request<IrDevice, ErrorResponse>({
        path: `/irdevices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the device record. Examples include switching device profiles in response to capability changes, syncing and device supplied data.
     *
     * @tags irdevices
     * @name UpdateIrDevice
     * @summary Update an IR Device
     * @request PUT:/irdevices/{deviceId}
     * @secure
     */
    updateIrDevice: (
      { deviceId, ...query }: UpdateIrDeviceParams,
      updateDevice: IrUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<IrDevice, any>({
        path: `/irdevices/${deviceId}`,
        method: 'PUT',
        query: query,
        body: updateDevice,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name StudyIrCode
     * @summary Put an IR Device into a learning state
     * @request PUT:/irdevices/{parentDeviceId}/learning
     */
    studyIrCode: (
      { parentDeviceId, ...query }: StudyIrCodeParams,
      enterLearningState: IrLearningRequest,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, any>({
        path: `/irdevices/${parentDeviceId}/learning`,
        method: 'PUT',
        query: query,
        body: enterLearningState,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name GetIrCode
     * @summary Get the IR Code that was just learned
     * @request GET:/irdevices/{parentDeviceId}/ircode/{childDevicePid}
     */
    getIrCode: ({ parentDeviceId, childDevicePid, ...query }: GetIrCodeParams, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * IR Code
           * @example "260050...000"
           */
          code?: string;
        },
        any
      >({
        path: `/irdevices/${parentDeviceId}/ircode/${childDevicePid}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name PatchDevice
     * @summary Partial update of a device's metadata and commands
     * @request PATCH:/irdevices/{childDeviceId}
     */
    patchDevice: ({ childDeviceId, ...query }: PatchDeviceParams, body: DevicePatch, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, any>({
        path: `/irdevices/${childDeviceId}`,
        method: 'PATCH',
        query: query,
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name ExecuteFunction
     * @summary Execute a function on a device
     * @request POST:/irdevices/{parentDeviceId}/control
     */
    executeFunction: (
      { parentDeviceId, ...query }: ExecuteFunctionParams,
      body: Function,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, any>({
        path: `/irdevices/${parentDeviceId}/control`,
        method: 'POST',
        query: query,
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name QueryVersion
     * @summary Query the OTA version by device
     * @request GET:/irdevices/{deviceId}/ota/version
     */
    queryVersion: ({ deviceId, ...query }: QueryVersionParams, params: RequestParams = {}) =>
      this.request<DeviceOTAVersion, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags irdevices
     * @name OtaUpgrade
     * @summary Upgrade the OTA Version
     * @request PUT:/irdevices/{deviceId}/ota/version
     */
    otaUpgrade: ({ deviceId, ...query }: OtaUpgradeParams, body: OtaUpgradePayload, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, any>({
        path: `/irdevices/${deviceId}/ota/version`,
        method: 'PUT',
        query: query,
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  installedapps = {
    /**
     * @description Fetch a list of Installed App Summaries. This request combines results from the public API and legacy SmartApps
     *
     * @tags installedapps
     * @name ListInstalledAppSummaries
     * @summary List Installed App Summaries
     * @request GET:/installedapps
     * @secure
     */
    listInstalledAppSummaries: (query: ListInstalledAppSummariesParams, params: RequestParams = {}) =>
      this.request<InstalledAppSummary[], void>({
        path: `/installedapps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name UninstallInstalledApp
     * @summary Uninstall
     * @request DELETE:/installedapps/{installedAppId}
     * @secure
     */
    uninstallInstalledApp: ({ installedAppId, ...query }: UninstallInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Pause the installed app for the given installedAppId
     *
     * @tags installedapps
     * @name PauseInstalledApp
     * @summary Pause
     * @request PUT:/installedapps/{installedAppId}/pause
     * @secure
     */
    pauseInstalledApp: ({ installedAppId, ...query }: PauseInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/pause`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Resume the paused installed app for the given installedAppId
     *
     * @tags installedapps
     * @name ResumeInstalledApp
     * @summary Resume
     * @request PUT:/installedapps/{installedAppId}/resume
     * @secure
     */
    resumeInstalledApp: ({ installedAppId, ...query }: ResumeInstalledAppParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, void>({
        path: `/installedapps/${installedAppId}/resume`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute an Installed SmartApp's DASHBOARD Lifecycle.
     *
     * @tags installedapps
     * @name DashboardInstalledApp
     * @summary Execute an Installed SmartApp's DASHBOARD Lifecycle.
     * @request POST:/installedapps/{installedAppId}/dashboard
     * @secure
     */
    dashboardInstalledApp: (
      { installedAppId, ...query }: DashboardInstalledAppParams,
      installedAppDashboardRequest: InstalledAppDashboardRequest,
      params: RequestParams = {},
    ) =>
      this.request<DashboardResponseData, ErrorResponse>({
        path: `/installedapps/${installedAppId}/dashboard`,
        method: 'POST',
        query: query,
        body: installedAppDashboardRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  connectedservices = {
    /**
     * @description Fetch a list of ConnectedServices
     *
     * @tags connectedservices
     * @name ListConnectedServices
     * @summary List Connected Services
     * @request GET:/connectedservices
     * @secure
     */
    listConnectedServices: (query: ListConnectedServicesParams, params: RequestParams = {}) =>
      this.request<ConnectedServiceSummary[], void>({
        path: `/connectedservices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Uninstall the connected service for the given id. If there are only errored results, and at least one is not HTTP 403, throw an ApiException with the highest error code.
     *
     * @tags connectedservices
     * @name UninstallConnectedService
     * @summary Uninstall
     * @request DELETE:/connectedservices/{id}
     * @secure
     */
    uninstallConnectedService: (id: string, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/connectedservices/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of device statuses. If locationIds are provided, the list of Device statuses will be filtered to only those locations.
     *
     * @tags devices
     * @name ListDeviceStatuses
     * @summary Get a list of device statuses
     * @request GET:/devices/status
     * @secure
     */
    listDeviceStatuses: (query: ListDeviceStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceStatusPagedResult, ErrorResponse>({
        path: `/devices/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the preferences for a particular device
     *
     * @tags devices
     * @name GetDevicePreferences
     * @summary Get device preferences
     * @request GET:/devices/{deviceId}/preferences
     * @secure
     */
    getDevicePreferences: (deviceId: string, params: RequestParams = {}) =>
      this.request<DevicePreference[], any>({
        path: `/devices/${deviceId}/preferences`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Set the preferences for a particular device. Must include complete set of preferences, existing set of preferences are overridden
     *
     * @tags devices
     * @name UpdateDevicePreferences
     * @summary Update device preferences for device
     * @request PUT:/devices/{deviceId}/preferences
     * @secure
     */
    updateDevicePreferences: (
      deviceId: string,
      updateDevicePreferencesRequest: UpdateDevicePreferencesRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/devices/${deviceId}/preferences`,
        method: 'PUT',
        body: updateDevicePreferencesRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete the value of a the preference for the device. Future get requests will return the default or null if a default is not defined in the preference definition.
     *
     * @tags Devices
     * @name DeleteDevicePreference
     * @summary Remove the value of a preference.
     * @request DELETE:/devices/{deviceId}/preferences/{preferenceId}
     * @secure
     */
    deleteDevicePreference: (deviceId: string, preferenceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/devices/${deviceId}/preferences/${preferenceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Additional device properties not on the device primitive. These properties are derived from other parts of the platform and used as hints to the UI.
     *
     * @tags devices
     * @name GetDeviceAdditionalProperties
     * @summary Get additional device properties
     * @request GET:/devices/{deviceId}/additionalProperties
     * @secure
     */
    getDeviceAdditionalProperties: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceAdditionalProperties, any>({
        path: `/devices/${deviceId}/additionalProperties`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devicegroups = {
    /**
     * @description Get a list of device group statuses with optional filtering by location, capability and group type
     *
     * @tags devicegroups
     * @name ListDeviceGroupStatuses
     * @summary Get a list of device group statuses
     * @request GET:/devicegroups/status
     * @secure
     */
    listDeviceGroupStatuses: (query: ListDeviceGroupStatusesParams, params: RequestParams = {}) =>
      this.request<FlatDeviceGroupStatusPagedResult, ErrorResponse>({
        path: `/devicegroups/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  favorites = {
    /**
     * @description List Favorites.
     *
     * @tags favorites
     * @name ListFavorites
     * @summary List Favorites
     * @request GET:/favorites
     * @secure
     */
    listFavorites: (query: ListFavoritesParams, params: RequestParams = {}) =>
      this.request<Favorite[], void | ErrorResponse>({
        path: `/favorites`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a single Favorite.
     *
     * @tags favorites
     * @name CreateFavorite
     * @summary Create Favorite
     * @request POST:/favorites
     * @secure
     */
    createFavorite: (query: CreateFavoriteParams, jsonBody: FavoriteCreateObject, params: RequestParams = {}) =>
      this.request<Favorite, ErrorResponse>({
        path: `/favorites`,
        method: 'POST',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Completely replaces all Favorites for the Location. New Favorites are created if favoriteId is null, and missing Favorites for the Location are deleted.
     *
     * @tags favorites
     * @name ReplaceFavorites
     * @summary Replace Favorites
     * @request PUT:/favorites
     * @secure
     */
    replaceFavorites: (query: ReplaceFavoritesParams, jsonBody: ReplaceFavoritesPayload, params: RequestParams = {}) =>
      this.request<Favorite[], ErrorResponse>({
        path: `/favorites`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove all Favorites for the user.
     *
     * @tags favorites
     * @name DeleteFavorites
     * @summary Delete Favorites
     * @request DELETE:/favorites
     * @secure
     */
    deleteFavorites: (query: DeleteFavoritesParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/favorites`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a Favorite by ID.
     *
     * @tags favorites
     * @name GetFavorite
     * @summary Get Favorite
     * @request GET:/favorites/{favoriteId}
     * @secure
     */
    getFavorite: ({ favoriteId, ...query }: GetFavoriteParams, params: RequestParams = {}) =>
      this.request<Favorite, void | ErrorResponse>({
        path: `/favorites/${favoriteId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a Favorite by ID.
     *
     * @tags favorites
     * @name DeleteFavorite
     * @summary Delete Favorite
     * @request DELETE:/favorites/{favoriteId}
     * @secure
     */
    deleteFavorite: ({ favoriteId, ...query }: DeleteFavoriteParams, params: RequestParams = {}) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/favorites/${favoriteId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the migration status for Favorites.
     *
     * @tags favorites
     * @name GetFavoritesMigrationStatus
     * @summary Get Favorites Migration Status
     * @request GET:/favorites/migrated
     * @secure
     */
    getFavoritesMigrationStatus: (query: GetFavoritesMigrationStatusParams, params: RequestParams = {}) =>
      this.request<FavoriteMigrationStatus, ErrorResponse>({
        path: `/favorites/migrated`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the migration status for Favorites. For use in testing favorites migration, clients should not call this under normal usage.
     *
     * @tags favorites
     * @name UpdateFavoritesMigrationStatus
     * @summary Update Favorites Migration Status
     * @request PUT:/favorites/migrated
     * @secure
     */
    updateFavoritesMigrationStatus: (
      query: UpdateFavoritesMigrationStatusParams,
      jsonBody: FavoriteMigrationStatus,
      params: RequestParams = {},
    ) =>
      this.request<StandardSuccessResponse, ErrorResponse>({
        path: `/favorites/migrated`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Favorites aggregated across all locations available to the caller.
     *
     * @tags favorites
     * @name ListAllFavorites
     * @summary List Favorites aggregated across all locations available to the caller.
     * @request GET:/favorites/all
     * @secure
     */
    listAllFavorites: (params: RequestParams = {}) =>
      this.request<Favorite[], void | ErrorResponse>({
        path: `/favorites/all`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  androidauto = {
    /**
     * @description Create the locations and items if they doesn't exist. Update them if they do exist
     *
     * @tags android auto
     * @name CreateOrUpdateAndroidAutoLocations
     * @summary Create or update existing Android Auto locations and items
     * @request PUT:/androidauto/locations
     * @secure
     */
    createOrUpdateAndroidAutoLocations: (jsonBody: AndroidAutoLocations, params: RequestParams = {}) =>
      this.request<AndroidAutoLocations, ErrorResponse>({
        path: `/androidauto/locations`,
        method: 'PUT',
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all Android Auto locations and items
     *
     * @tags android auto
     * @name GetAndroidAutoLocations
     * @summary Get all Android Auto locations and items
     * @request GET:/androidauto/locations
     * @secure
     */
    getAndroidAutoLocations: (params: RequestParams = {}) =>
      this.request<AndroidAutoLocations, void | ErrorResponse>({
        path: `/androidauto/locations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get connection status for the Android Auto account
     *
     * @tags android auto
     * @name GetAndroidAutoConnectionStatus
     * @summary Get connection status for the Android Auto account
     * @request GET:/androidauto/connectionstatus
     * @secure
     */
    getAndroidAutoConnectionStatus: (params: RequestParams = {}) =>
      this.request<AndroidAutoConnectionStatus, void | ErrorResponse>({
        path: `/androidauto/connectionstatus`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the car settings if they doesn't exist. Update them if they do exist
     *
     * @tags android auto
     * @name CreateOrUpdateAndroidAutoCarSettings
     * @summary Create or update existing Android Auto car settings
     * @request PUT:/androidauto/car/settings
     * @secure
     */
    createOrUpdateAndroidAutoCarSettings: (jsonBody: AndroidAutoSettings, params: RequestParams = {}) =>
      this.request<AndroidAutoSettings, ErrorResponse>({
        path: `/androidauto/car/settings`,
        method: 'PUT',
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Android Auto settings
     *
     * @tags android auto
     * @name GetAndroidAutoSettings
     * @summary Get Android Auto settings
     * @request GET:/androidauto/car/settings
     * @secure
     */
    getAndroidAutoSettings: (params: RequestParams = {}) =>
      this.request<AndroidAutoSettings, void | ErrorResponse>({
        path: `/androidauto/car/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Android Auto settings
     *
     * @tags android auto
     * @name DeleteAndroidAutoSettings
     * @summary Delete Android Auto settings
     * @request DELETE:/androidauto/car/settings
     * @secure
     */
    deleteAndroidAutoSettings: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/androidauto/car/settings`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  icons = {
    /**
     * @description Fetch an Action Icon.
     *
     * @tags icons
     * @name GetActionIcon
     * @summary Fetch an Action Icon
     * @request GET:/icons/actions/{actionIcon}
     */
    getActionIcon: ({ actionIcon, ...query }: GetActionIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/actions/${actionIcon}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Badge Icon.
     *
     * @tags icons
     * @name GetBadgeIcon
     * @summary Fetch a badge Icon
     * @request GET:/icons/badges/{badgeIcon}/{badgeIconState}
     */
    getBadgeIcon: ({ badgeIcon, badgeIconState, ...query }: GetBadgeIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/badges/${badgeIcon}/${badgeIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch an Auto Icon.
     *
     * @tags icons
     * @name GetAutoIcon
     * @summary Fetch an auto Icon
     * @request GET:/icons/auto/{autoIcon}/{autoIconState}
     */
    getAutoIcon: ({ autoIcon, autoIconState, ...query }: GetAutoIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/auto/${autoIcon}/${autoIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a capability icon given a capability and an attribute.
     *
     * @tags icons
     * @name GetCapabilityAttributeIcon
     * @summary Fetch a capability attribute icon
     * @request GET:/icons/capabilities/{capabilityId}/{attributeName}
     */
    getCapabilityAttributeIcon: (
      { capabilityId, attributeName, ...query }: GetCapabilityAttributeIconParams,
      params: RequestParams = {},
    ) =>
      this.request<any, void>({
        path: `/icons/capabilities/${capabilityId}/${attributeName}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Device Group Icon.
     *
     * @tags icons
     * @name GetGroupIcon
     * @summary Fetch a Device Group Icon
     * @request GET:/icons/group/{groupIcon}/{groupIconState}
     */
    getGroupIcon: ({ groupIcon, groupIconState, ...query }: GetGroupIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/group/${groupIcon}/${groupIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch an OCF Device Type Icon.
     *
     * @tags icons
     * @name GetOcfDeviceTypeIcon
     * @summary Fetch an OCF Device Type Icon
     * @request GET:/icons/ocfDeviceType/{ocfDeviceType}
     */
    getOcfDeviceTypeIcon: ({ ocfDeviceType, ...query }: GetOcfDeviceTypeIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/ocfDeviceType/${ocfDeviceType}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Oneui Icon.
     *
     * @tags icons
     * @name GetOneuiIcon
     * @summary Fetch a Oneui Icon
     * @request GET:/icons/oneui/{oneuiIcon}/{oneuiIconState}
     */
    getOneuiIcon: ({ oneuiIcon, oneuiIconState, ...query }: GetOneuiIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/oneui/${oneuiIcon}/${oneuiIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Preload Icon.
     *
     * @tags icons
     * @name GetPreloadIcon
     * @summary Fetch a Preload Icon
     * @request GET:/icons/preload/{preloadIcon}/{preloadIconState}
     */
    getPreloadIcon: ({ preloadIcon, preloadIconState, ...query }: GetPreloadIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/preload/${preloadIcon}/${preloadIconState}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description Fetch a Scene Icon.
     *
     * @tags icons
     * @name GetSceneIcon
     * @summary Fetch a Scene Icon
     * @request GET:/icons/scenes/{sceneIcon}
     */
    getSceneIcon: ({ sceneIcon, ...query }: GetSceneIconParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/icons/scenes/${sceneIcon}`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * @description List device icon urls.
     *
     * @tags icons
     * @name ListDeviceIconUrls
     * @summary List Device icon urls
     * @request GET:/icons/devices
     * @secure
     */
    listDeviceIconUrls: (query: ListDeviceIconUrlsParams, params: RequestParams = {}) =>
      this.request<DeviceIconData[], void | ErrorResponse>({
        path: `/icons/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  swatches = {
    /**
     * @description Get a list of DeviceSwatches that have been modified or deleted since the provided ETag was created. If locationIds are provided, the list of Swatches will be filtered to only those locations.
     *
     * @tags swatches
     * @name GetSwatches
     * @summary Get a partial list of DeviceSwatches
     * @request GET:/swatches
     * @secure
     */
    getSwatches: (query: GetSwatchesParams, params: RequestParams = {}) =>
      this.request<PartialDeviceSwatchResponse, void | ErrorResponse>({
        path: `/swatches`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a list of Swatch Statuses. If locationId's are provided, the list of Swatch Statuses will be filtered to only those locations.
     *
     * @tags swatches
     * @name GetSwatchStatuses
     * @summary Get a paginated list of Swatch Statuses
     * @request GET:/swatches/status
     * @secure
     */
    getSwatchStatuses: (query: GetSwatchStatusesParams, params: RequestParams = {}) =>
      this.request<SwatchStatusPagedResult, ErrorResponse>({
        path: `/swatches/status`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  summary = {
    /**
     * @description Get a list of location summary cards
     *
     * @tags summary
     * @name GetLocationSummary
     * @summary Get a list of location summary cards
     * @request GET:/summary
     * @secure
     */
    getLocationSummary: (query: GetLocationSummaryParams, params: RequestParams = {}) =>
      this.request<WrappedMainCard[], void | ErrorResponse>({
        path: `/summary`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the summary presentation definitions for static/dynamic cards
     *
     * @tags summary
     * @name GetSummaryPresentation
     * @summary Get the summary presentation definitions for static/dynamic cards
     * @request GET:/summary/presentation
     * @secure
     */
    getSummaryPresentation: (params: RequestParams = {}) =>
      this.request<SummaryPresentation, void | ErrorResponse>({
        path: `/summary/presentation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  nibbler = {
    /**
     * @description Get the users last used location
     *
     * @tags settings
     * @name GetLastUsedLocation
     * @summary Get the users last used location
     * @request GET:/nibbler/settings/lastUsedLocation
     * @secure
     */
    getLastUsedLocation: (params: RequestParams = {}) =>
      this.request<LastUsedLocationResponse, ErrorResponse>({
        path: `/nibbler/settings/lastUsedLocation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags nibbler
     * @name UpdateLastUsedLocation
     * @summary Update the users last used location
     * @request PUT:/nibbler/settings/lastUsedLocation
     * @secure
     */
    updateLastUsedLocation: (lastUsedLocationId: LastUsedLocationRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/lastUsedLocation`,
        method: 'PUT',
        body: lastUsedLocationId,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered locations
     *
     * @tags settings
     * @name GetOrderedLocations
     * @summary Get the users ordered locations
     * @request GET:/nibbler/settings/sortOrder/locations
     * @secure
     */
    getOrderedLocations: (params: RequestParams = {}) =>
      this.request<LocationsOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/locations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of a users locations. Must provide all location Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderLocations
     * @summary Update the users location sort order
     * @request PUT:/nibbler/settings/sortOrder/locations
     * @secure
     */
    updateUserSortOrderLocations: (jsonBody: UpdateUserSortOrderLocationsPayload, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/locations`,
        method: 'PUT',
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered rooms for a location
     *
     * @tags settings
     * @name GetOrderedRooms
     * @summary Get the users ordered rooms for a location
     * @request GET:/nibbler/settings/sortOrder/rooms
     * @secure
     */
    getOrderedRooms: (query: GetOrderedRoomsParams, params: RequestParams = {}) =>
      this.request<RoomsOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of room Ids for a location. Must provide all room Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderRooms
     * @summary Update the users rooms sort order for a location
     * @request PUT:/nibbler/settings/sortOrder/rooms
     * @secure
     */
    updateUserSortOrderRooms: (
      query: UpdateUserSortOrderRoomsParams,
      jsonBody: UpdateUserSortOrderRoomsPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/rooms`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered devices for a room
     *
     * @tags settings
     * @name GetOrderedDevices
     * @summary Get the users ordered devices for a room
     * @request GET:/nibbler/settings/sortOrder/devices
     * @secure
     */
    getOrderedDevices: (query: GetOrderedDevicesParams, params: RequestParams = {}) =>
      this.request<RoomsDevicesOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of devices Ids for a room. Must provide all devices Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderDevices
     * @summary Update the users devices sort order for a room
     * @request PUT:/nibbler/settings/sortOrder/devices
     * @secure
     */
    updateUserSortOrderDevices: (
      query: UpdateUserSortOrderDevicesParams,
      jsonBody: UpdateUserSortOrderDevicesPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/devices`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered devices for all rooms in a location
     *
     * @tags settings
     * @name GetOrderedDevicesForLocation
     * @summary Get the users ordered devices for all rooms in a location
     * @request GET:/nibbler/settings/sortOrder/devices/{pathLocationId}
     * @secure
     */
    getOrderedDevicesForLocation: (
      { pathLocationId, ...query }: GetOrderedDevicesForLocationParams,
      params: RequestParams = {},
    ) =>
      this.request<LocationDevicesOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/devices/${pathLocationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the users ordered automations
     *
     * @tags settings
     * @name GetOrderedAutomations
     * @summary Get the users ordered automations
     * @request GET:/nibbler/settings/sortOrder/automations
     * @secure
     */
    getOrderedAutomations: (query: GetOrderedAutomationsParams, params: RequestParams = {}) =>
      this.request<AutomationsOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/automations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of automations Ids for a room. Must provide all automations Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderAutomations
     * @summary Update the users automations sort order
     * @request PUT:/nibbler/settings/sortOrder/automations
     * @secure
     */
    updateUserSortOrderAutomations: (
      query: UpdateUserSortOrderAutomationsParams,
      jsonBody: UpdateUserSortOrderAutomationsPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/automations`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered smartApps for a location
     *
     * @tags settings
     * @name GetOrderedSmartApps
     * @summary Get the users ordered smartApps for a location
     * @request GET:/nibbler/settings/sortOrder/smartApps
     * @secure
     */
    getOrderedSmartApps: (query: GetOrderedSmartAppsParams, params: RequestParams = {}) =>
      this.request<SmartAppsOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/smartApps`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of smartApps Ids for a location. Must provide all smartApps Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderSmartApps
     * @summary Update the users smartApps sort order for a location
     * @request PUT:/nibbler/settings/sortOrder/smartApps
     * @secure
     */
    updateUserSortOrderSmartApps: (
      query: UpdateUserSortOrderSmartAppsParams,
      jsonBody: UpdateUserSortOrderSmartAppsPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/smartApps`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered scenes for a location
     *
     * @tags settings
     * @name GetOrderedScenes
     * @summary Get the users ordered scenes for a location
     * @request GET:/nibbler/settings/sortOrder/scenes
     * @secure
     */
    getOrderedScenes: (query: GetOrderedScenesParams, params: RequestParams = {}) =>
      this.request<ScenesOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/scenes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of sceneIds for a location. Must provide all scene Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderScenes
     * @summary Update the users scenes sort order for a location
     * @request PUT:/nibbler/settings/sortOrder/scenes
     * @secure
     */
    updateUserSortOrderScenes: (
      query: UpdateUserSortOrderScenesParams,
      jsonBody: UpdateUserSortOrderScenesPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/scenes`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered life services for a location
     *
     * @tags settings
     * @name GetOrderedLifeServices
     * @summary Get the users ordered life services for a location
     * @request GET:/nibbler/settings/sortOrder/lifeServices
     * @secure
     */
    getOrderedLifeServices: (query: GetOrderedLifeServicesParams, params: RequestParams = {}) =>
      this.request<LifeServicesOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/lifeServices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of lifeServicesIds for a location. Must provide all life services Ids.
     *
     * @tags settings
     * @name UpdateUserSortOrderLifeServices
     * @summary Update the users life services sort order for a location
     * @request PUT:/nibbler/settings/sortOrder/lifeServices
     * @secure
     */
    updateUserSortOrderLifeServices: (
      query: UpdateUserSortOrderLifeServicesParams,
      jsonBody: UpdateUserSortOrderLifeServicesPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/lifeServices`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users ordered static summary settings for a location
     *
     * @tags settings
     * @name GetOrderedStaticSummarySettings
     * @summary Get the users ordered static summary settings for a location
     * @request GET:/nibbler/settings/sortOrder/static
     * @secure
     */
    getOrderedStaticSummarySettings: (query: GetOrderedStaticSummarySettingsParams, params: RequestParams = {}) =>
      this.request<StaticSummaryOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/static`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update sort order of static summary settings for a location.
     *
     * @tags settings
     * @name UpdateUserSortOrderStaticSummarySettings
     * @summary Update the users static summary settings sort order for a location
     * @request PUT:/nibbler/settings/sortOrder/static
     * @secure
     */
    updateUserSortOrderStaticSummarySettings: (
      query: UpdateUserSortOrderStaticSummarySettingsParams,
      jsonBody: UpdateUserSortOrderStaticSummarySettingsPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/static`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users location summary cards order for a location
     *
     * @tags settings
     * @name GetSummaryLocationCardsSortOrder
     * @summary Get the users location summary cards order for a location
     * @request GET:/nibbler/settings/sortOrder/summaryCards
     * @secure
     */
    getSummaryLocationCardsSortOrder: (query: GetSummaryLocationCardsSortOrderParams, params: RequestParams = {}) =>
      this.request<LocationSummaryCardsSortOrderResponse, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/summaryCards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the users location summary cards order for a location.
     *
     * @tags settings
     * @name UpdateLocationSummaryCardsSortOrder
     * @summary Update the users location summary cards order for a location
     * @request PUT:/nibbler/settings/sortOrder/summaryCards
     * @secure
     */
    updateLocationSummaryCardsSortOrder: (
      query: UpdateLocationSummaryCardsSortOrderParams,
      jsonBody: UpdateLocationSummaryCardsSortOrderPayload,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/sortOrder/summaryCards`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users summary settings for a location.  Settings with available sort orders, will be returned in order.
     *
     * @tags settings
     * @name GetLocationSummarySettings
     * @summary Get the users summary settings for a location
     * @request GET:/nibbler/settings/summary/location
     * @secure
     */
    getLocationSummarySettings: (query: GetLocationSummarySettingsParams, params: RequestParams = {}) =>
      this.request<LocationSummarySettingsResponse, ErrorResponse>({
        path: `/nibbler/settings/summary/location`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the users summary settings for a location
     *
     * @tags settings
     * @name UpdateUserLocationSummarySettings
     * @summary Update the users summary settings for a location
     * @request PUT:/nibbler/settings/summary/location
     * @secure
     */
    updateUserLocationSummarySettings: (
      query: UpdateUserLocationSummarySettingsParams,
      jsonBody: UpdateLocationSummarySettingsBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/summary/location`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get the users summary unselected devices for a location
     *
     * @tags settings
     * @name GetLocationSummaryUnselectedDevices
     * @summary Get the users summary unselected devices for a location
     * @request GET:/nibbler/settings/summary/location/unselectedDevices
     * @secure
     */
    getLocationSummaryUnselectedDevices: (
      query: GetLocationSummaryUnselectedDevicesParams,
      params: RequestParams = {},
    ) =>
      this.request<UserUnselectedDevices, ErrorResponse>({
        path: `/nibbler/settings/summary/location/unselectedDevices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update the users summary unselected devices for a location.
     *
     * @tags settings
     * @name UpdateLocationSummaryUnselectedDevices
     * @summary Update the users summary unselected devices for a location
     * @request PUT:/nibbler/settings/summary/location/unselectedDevices
     * @secure
     */
    updateLocationSummaryUnselectedDevices: (
      query: UpdateLocationSummaryUnselectedDevicesParams,
      jsonBody: UpdateLocationSummaryUnselectedDevicesBodyObject,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/summary/location/unselectedDevices`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Mark a device as seen by the users.
     *
     * @tags settings
     * @name MarkDeviceAsSeen
     * @summary Mark a device as seen
     * @request DELETE:/nibbler/settings/unseen_devices/{deviceId}
     * @secure
     */
    markDeviceAsSeen: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nibbler/settings/unseen_devices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description Hide or show the devices. Hiding the device will stop notifications for that device and showing will resume.
     *
     * @tags settings
     * @name UpdateHiddenDevices
     * @summary Update hidden devices
     * @request PUT:/nibbler/settings/hidden_devices
     * @secure
     */
    updateHiddenDevices: (body: UpdateHiddenDevicesRequest, params: RequestParams = {}) =>
      this.request<void, void | ErrorResponse>({
        path: `/nibbler/settings/hidden_devices`,
        method: 'PUT',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get devices hidden by the user
     *
     * @tags settings
     * @name InternalListHiddenDevices
     * @summary Internal list hidden devices
     * @request PUT:/nibbler/internal/settings/hidden_devices
     * @secure
     */
    internalListHiddenDevices: (query: InternalListHiddenDevicesParams, params: RequestParams = {}) =>
      this.request<CertificateUuidResponse, void>({
        path: `/nibbler/internal/settings/hidden_devices`,
        method: 'PUT',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  broadlink = {
    /**
     * No description
     *
     * @tags broadlink
     * @name GetDevType
     * @summary Get device types
     * @request GET:/broadlink/devtype
     */
    getDevType: (params: RequestParams = {}) =>
      this.request<DevTypes, any>({
        path: `/broadlink/devtype`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetBrand
     * @summary Get brands
     * @request GET:/broadlink/devtype/{devTypeId}/brand
     */
    getBrand: (devTypeId: string, params: RequestParams = {}) =>
      this.request<Brands, any>({
        path: `/broadlink/devtype/${devTypeId}/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetIrCode
     * @summary Get ircode info
     * @request GET:/broadlink/devtype/{devTypeId}/brand/{brandId}/ircode
     */
    getIrCode: (devTypeId: string, brandId: string, params: RequestParams = {}) =>
      this.request<IrCodes, any>({
        path: `/broadlink/devtype/${devTypeId}/brand/${brandId}/ircode`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetLocate
     * @summary Get location information
     * @request GET:/broadlink/location/{locationId}
     */
    getLocate: (locationId: string, params: RequestParams = {}) =>
      this.request<SubAreaInfo, any>({
        path: `/broadlink/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProvider
     * @summary Get provider info for a location
     * @request GET:/broadlink/location/{locationId}/provider
     */
    getProvider: (locationId: string, params: RequestParams = {}) =>
      this.request<Providers, any>({
        path: `/broadlink/location/${locationId}/provider`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetProviderBrand
     * @summary Get full list of provider brands
     * @request GET:/broadlink/provider/brand
     */
    getProviderBrand: (params: RequestParams = {}) =>
      this.request<ProviderBrands, any>({
        path: `/broadlink/provider/brand`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name GetChannel
     * @summary Get list of channels for a location and provider
     * @request GET:/broadlink/location/{locationId}/provider/{providerId}/channel
     */
    getChannel: (locationId: string, providerId: string, params: RequestParams = {}) =>
      this.request<Channels, any>({
        path: `/broadlink/location/${locationId}/provider/${providerId}/channel`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name MatchIrCode
     * @summary Match IR Code
     * @request GET:/broadlink/dnacode/{dnaCode}
     */
    matchIrCode: (dnaCode: string, params: RequestParams = {}) =>
      this.request<MatchIRCode, any>({
        path: `/broadlink/dnacode/${dnaCode}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags broadlink
     * @name QueryVersionOnServer
     * @summary Query the OTA version on server
     * @request GET:/broadlink/ota/version/server
     */
    queryVersionOnServer: (query: QueryVersionOnServerParams, params: RequestParams = {}) =>
      this.request<OTAVersions, any>({
        path: `/broadlink/ota/version/server`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  ocfdevicegroups = {
    /**
     * @description Get a list of device groups
     *
     * @tags ocfdevicegroups
     * @name ListDeviceGroups
     * @summary List all device groups for the user
     * @request GET:/ocfdevicegroups
     * @secure
     */
    listDeviceGroups: (query: ListDeviceGroupsParams, params: RequestParams = {}) =>
      this.request<PagedDeviceGroups, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new device group
     *
     * @tags ocfdevicegroups
     * @name CreateDeviceGroup
     * @summary Create a device group
     * @request POST:/ocfdevicegroups
     * @secure
     */
    createDeviceGroup: (request: DeviceGroupCreateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute a device group command or get the status of a device group.
     *
     * @tags ocfdevicegroups
     * @name DeviceGroupCommandRequest
     * @summary Take OCF command or status request
     * @request POST:/ocfdevicegroups/request
     * @secure
     */
    deviceGroupCommandRequest: (executeDeviceGroupCommand: OcfDeviceGroupsCommandRequest, params: RequestParams = {}) =>
      this.request<OcfDeviceGroupsCommandResponse, void | Error>({
        path: `/ocfdevicegroups/request`,
        method: 'POST',
        body: executeDeviceGroupCommand,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a single device group by Id
     *
     * @tags ocfdevicegroups
     * @name GetDeviceGroup
     * @summary Show device group by id
     * @request GET:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    getDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description update device group with a new set of devices or name. Keep same id.
     *
     * @tags ocfdevicegroups
     * @name UpdateDeviceGroup
     * @summary Update device group with a new set of devices or a name. Keep same id.
     * @request PUT:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    updateDeviceGroup: (deviceGroupId: string, request: DeviceGroupUpdateRequest, params: RequestParams = {}) =>
      this.request<DeviceGroupResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device group based on deviceGroupId
     *
     * @tags ocfdevicegroups
     * @name DeleteDeviceGroup
     * @summary Delete device group based on deviceGroupId
     * @request DELETE:/ocfdevicegroups/{deviceGroupId}
     * @secure
     */
    deleteDeviceGroup: (deviceGroupId: string, params: RequestParams = {}) =>
      this.request<DeviceGroupDeleteResponse, void | Error>({
        path: `/ocfdevicegroups/${deviceGroupId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  viper = {
    /**
     * @description Get devices and app related info for the given isaId. If relogin is not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. If relogin is needed, the pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. Used by mobile
     *
     * @tags viper
     * @name GetDevicesByIsaId
     * @request GET:/viper/isa/{isaId}
     */
    getDevicesByIsaId: ({ isaId, ...query }: GetDevicesByIsaIdParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/isa/${isaId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates specified isaId related information.
     *
     * @tags viper
     * @name PutIsaByIsaId
     * @request PUT:/viper/isa/{isaId}
     */
    putIsaByIsaId: (
      { isaId, ...query }: PutIsaByIsaIdParams,
      PutIsaBody: PutIsaBody,
      params: RequestParams = {},
    ) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'PUT',
        query: query,
        body: PutIsaBody,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Deletes specified isaId and associated devices with isaId.
     *
     * @tags viper
     * @name DeleteIsaByIsaId
     * @request DELETE:/viper/isa/{isaId}
     */
    deleteIsaByIsaId: ({ isaId, ...query }: DeleteIsaByIsaIdParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/viper/isa/${isaId}`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Gets installed SchemaApps for the specified locationId
     *
     * @tags viper
     * @name GetIsaByLocationId
     * @request GET:/viper/isa/location/{locationId}
     */
    getIsaByLocationId: (locationId: string, params: RequestParams = {}) =>
      this.request<LocationIsa, void>({
        path: `/viper/isa/location/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Requests page to start app install for the user. The pageType will be set to "requiresLogin" and only the "oauthLink" value will be populated in the response. If the app is already installed and relogin in not required then the pageType will be set to "loggedIn" and we return the isaId, devices, partnerName, appName and icons. Used by mobile app.
     *
     * @tags viper
     * @name GetPages
     * @request GET:/viper/pages/{endpointAppId}
     */
    getPages: ({ endpointAppId, ...query }: GetPagesParams, params: RequestParams = {}) =>
      this.request<Isa, void>({
        path: `/viper/pages/${endpointAppId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  strongman = {
    /**
     * @description Begin installation or update of an installed app. Returns the installed app and a `STAGED` configuration. The returned configuration has been initialized with either the current `AUTHORIZED` configuration, if available, or the most recent `DONE`/`STAGED` configuration. | The optional installedAppId (request body) will indicate whether to create a new installed app (without installedAppId) or edit an existing installed app (with installedAppId). Additionally, if the app is a singleton and an installed app already exists, a request without an installedAppId will be treated as an edit to the existing installed app.
     *
     * @tags Installedapps
     * @name InitializeInstall
     * @summary Begin installation or update of an installed app.
     * @request PUT:/strongman/installedapps/initialize
     * @secure
     */
    initializeInstall: (initializeRequest: InitializeRequest, params: RequestParams = {}) =>
      this.request<InitializeResponse, ErrorResponse>({
        path: `/strongman/installedapps/initialize`,
        method: 'PUT',
        body: initializeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancel installation or update of an installed app by revoking a `STAGED` configuration for an `AUTHORIZED` installed app, or deleting the installed app if it has not been `AUTHORIZED`.
     *
     * @tags Installedapps
     * @name CancelInstall
     * @summary Cancel installation or update of an installed app.
     * @request PUT:/strongman/installedapps/{installedAppId}/cancel
     * @secure
     */
    cancelInstall: (installedAppId: string, cancelRequest: CancelRequest, params: RequestParams = {}) =>
      this.request<CancelResponse, ErrorResponse>({
        path: `/strongman/installedapps/${installedAppId}/cancel`,
        method: 'PUT',
        body: cancelRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts the process of completing an Endpoint App installation. If the app is preauthorized, the configuration provided in the request will be marked as authorized and an install/update lifecycle event will be sent. The endpoint will respond with a JSON body containing message:"success". No further action is required. If the app is not preauthorized, a JSON response containing a URL to consigliere will be provided. This URL is used to confirm the permissions and will redirect to the strongman install/finalize endpoint to mark the configuration as authorized and send an install/update lifecycle event. The config sent in the request must not be null or empty.
     *
     * @tags strongman
     * @name InstallComplete
     * @summary Start the process of completing an Endpoint App installation.
     * @request POST:/strongman/install/complete
     * @secure
     */
    installComplete: (serviceInstallCompleteRequest: ServiceAppCompleteRequest, params: RequestParams = {}) =>
      this.request<ServiceAppCompleteResponse, Error | void>({
        path: `/strongman/install/complete`,
        method: 'POST',
        body: serviceInstallCompleteRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  scenes = {
    /**
     * @description Fetch a list of Scenes for the logged in user and given locationId
     *
     * @tags scenes
     * @name ListScenes
     * @summary List Scenes
     * @request GET:/scenes
     * @secure
     */
    listScenes: (query: ListScenesParams, params: RequestParams = {}) =>
      this.request<ScenePagedResult, ErrorResponse>({
        path: `/scenes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Fetch a Scene by id for the logged in user and given locationId
     *
     * @tags scenes
     * @name GetScene
     * @summary Get Scene
     * @request GET:/scenes/{sceneId}
     * @secure
     */
    getScene: ({ sceneId, ...query }: GetSceneParams, params: RequestParams = {}) =>
      this.request<Scene, ErrorResponse>({
        path: `/scenes/${sceneId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  activities = {
    /**
     * @description Retrieve device and execution activity history. Can be filtered by location IDs and/or a list of device IDs. Location filter will apply to all events. Other filtering are based on source of event (device, execution, or location mode). For example if device IDs is specified, only device activities will be returned. When both location and devices filter are specified, only device activities in the specified locations will be returned.
     *
     * @tags activities
     * @name GetActivityHistories
     * @summary Retrieve device, execution, mode and native activity history
     * @request GET:/activities
     * @secure
     */
    getActivityHistories: (query: GetActivityHistoriesParams, request: ActivitiesRequest, params: RequestParams = {}) =>
      this.request<ActivityHistoryPage, void>({
        path: `/activities`,
        method: 'GET',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve list of execution action
     *
     * @tags activities
     * @name GetExecutionActions
     * @summary Retrieve execution action details
     * @request GET:/activities/{locationId}/executions/{executionId}/actions
     * @deprecated
     * @secure
     */
    getExecutionActions: (
      { locationId, executionId, ...query }: GetExecutionActionsParams,
      params: RequestParams = {},
    ) =>
      this.request<ExecutionActionsResponse, void>({
        path: `/activities/${locationId}/executions/${executionId}/actions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  notification = {
    /**
     * @description Retrieve notification history, can be filtered by location IDs and/or device IDs, both optional. Newest notification will be listed first.
     *
     * @tags notification
     * @name GetNotifications
     * @summary Retrieve notification history
     * @request GET:/notification
     * @secure
     */
    getNotifications: (query: GetNotificationsParams, request: NotificationRequest, params: RequestParams = {}) =>
      this.request<NotificationPage, void>({
        path: `/notification`,
        method: 'GET',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Send push to devices belongs to the location.
     *
     * @tags notification
     * @name SendPushByLocationId
     * @summary Send push to devices belongs to the location.
     * @request POST:/notification
     * @secure
     */
    sendPushByLocationId: (NotificationRequest: NotificationRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/notification`,
        method: 'POST',
        body: NotificationRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update notification blacklist of installedapps and devices.
     *
     * @tags notification
     * @name UpdateNotificationBlacklist
     * @summary Update notification blacklist of installedapps and devices.
     * @request PUT:/notification/config
     * @secure
     */
    updateNotificationBlacklist: (NotificationBlacklistRequest: ServiceBlacklistRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/notification/config`,
        method: 'PUT',
        body: NotificationBlacklistRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Delete notification blacklist of installedapps and devices.
     *
     * @tags notification
     * @name DeleteNotificationBlacklist
     * @summary Delete notification blacklist of installedapps and devices.
     * @request DELETE:/notification/config
     * @secure
     */
    deleteNotificationBlacklist: (NotificationBlacklistRequest: ServiceBlacklistRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/notification/config`,
        method: 'DELETE',
        body: NotificationBlacklistRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get notification blacklist of installedapps and devices.
     *
     * @tags notification
     * @name GetNotifiationBlacklist
     * @summary Get notification blacklist of installedapps and devices.
     * @request GET:/notification/config
     * @secure
     */
    getNotifiationBlacklist: (params: RequestParams = {}) =>
      this.request<ServiceBlacklistRequest, ErrorResponse>({
        path: `/notification/config`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update notification profile.
     *
     * @tags notification
     * @name UpdateNotificationProfile
     * @summary Update notification profile.
     * @request POST:/notification/profile
     * @secure
     */
    updateNotificationProfile: (NotificationProfileRequest: NotificationProfileRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/notification/profile`,
        method: 'POST',
        body: NotificationProfileRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get notification profile.
     *
     * @tags notification
     * @name GetNotificationProfile
     * @summary Get notification profile.
     * @request GET:/notification/profile/{deviceId}
     * @secure
     */
    getNotificationProfile: (deviceId: string, params: RequestParams = {}) =>
      this.request<NotificationProfileRequest, ErrorResponse>({
        path: `/notification/profile/${deviceId}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  ocfaccount = {
    /**
     * @description Create device account using either auth code or access token for v2.
     *
     * @tags ocfaccount
     * @name SignUp
     * @summary Sign Up
     * @request POST:/ocfaccount/oic/account
     * @secure
     */
    signUp: (request: TokenSignUpRequest, params: RequestParams = {}) =>
      this.request<SignUpResponse, void>({
        path: `/ocfaccount/oic/account`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete device and remove all associated resources on the cloud.
     *
     * @tags ocfaccount
     * @name DeleteAccount
     * @summary Delete device or account
     * @request DELETE:/ocfaccount/oic/account
     * @secure
     */
    deleteAccount: (query: DeleteAccountParams, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/account`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Device sign-in/sign-out to/from the cloud for v2
     *
     * @tags ocfaccount
     * @name SignIn
     * @summary Sign in
     * @request POST:/ocfaccount/oic/account/session
     * @secure
     */
    signIn: (request: SignInRequest, params: RequestParams = {}) =>
      this.request<SignInResponse, void>({
        path: `/ocfaccount/oic/account/session`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description query user's info
     *
     * @tags ocfaccount
     * @name GetUserInfo
     * @summary Get user info By uid
     * @request GET:/ocfaccount/oic/account/profile
     * @secure
     */
    getUserInfo: (params: RequestParams = {}) =>
      this.request<GetUserInfoResponse, void>({
        path: `/ocfaccount/oic/account/profile`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ocfaccount
     * @name UpdateUserInfo
     * @summary Set user info By uid
     * @request PUT:/ocfaccount/oic/account/profile
     * @secure
     */
    updateUserInfo: (updateUserInfoRequest: UpdateUserInfoRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/account/profile`,
        method: 'PUT',
        body: updateUserInfoRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description query device's info list
     *
     * @tags ocfaccount
     * @name GetDeviceInfo
     * @summary Get device info By di
     * @request GET:/ocfaccount/oic/account/profile/device
     * @secure
     */
    getDeviceInfo: (query: GetDeviceInfoParams, params: RequestParams = {}) =>
      this.request<GetDeviceInfoListResponse, void>({
        path: `/ocfaccount/oic/account/profile/device`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ocfaccount
     * @name UpdateDeviceInfo
     * @summary Set device info By di
     * @request PUT:/ocfaccount/oic/account/profile/device
     * @secure
     */
    updateDeviceInfo: (updateDeviceInfoListRequest: UpdateDeviceInfoListRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/account/profile/device`,
        method: 'PUT',
        body: updateDeviceInfoListRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Location Profile
     *
     * @tags ocfaccount
     * @name GetLocationProfile
     * @summary Get Location profile
     * @request GET:/ocfaccount/oic/account/profile/group
     * @secure
     */
    getLocationProfile: (query: GetLocationProfileParams, params: RequestParams = {}) =>
      this.request<GetLocationProfileResponse, void>({
        path: `/ocfaccount/oic/account/profile/group`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Location profile.
     *
     * @tags ocfaccount
     * @name UpdateLocationProfile
     * @summary Update Location profile
     * @request PUT:/ocfaccount/oic/account/profile/group
     * @secure
     */
    updateLocationProfile: (request: UpdateLocationProfileRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/account/profile/group`,
        method: 'PUT',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get all location list. The type parameter will be deprecated
     *
     * @tags ocfaccount
     * @name GetLocationList
     * @summary Get Location List
     * @request GET:/ocfaccount/oic/acl/group
     * @secure
     */
    getLocationList: (query: GetLocationListParams, params: RequestParams = {}) =>
      this.request<GetLocationListResponse, void>({
        path: `/ocfaccount/oic/acl/group`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create Location.
     *
     * @tags ocfaccount
     * @name CreateLocation
     * @summary Create Location
     * @request POST:/ocfaccount/oic/acl/group
     * @secure
     */
    createLocation: (request: CreateLocationRequest, params: RequestParams = {}) =>
      this.request<CreateLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group`,
        method: 'POST',
        body: request,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the location if user doesn't have any location. If location exist, returns error.
     *
     * @tags ocfaccount
     * @name CreateDefaultLocation
     * @summary Create default location
     * @request POST:/ocfaccount/oic/acl/group/default
     * @secure
     */
    createDefaultLocation: (request: CreateLocationRequest, params: RequestParams = {}) =>
      this.request<CreateLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/default`,
        method: 'POST',
        body: request,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the personal location for smart watch and so on.
     *
     * @tags ocfaccount
     * @name CreatePersonalLocation
     * @summary Create personal location
     * @request POST:/ocfaccount/oic/acl/group/personal
     * @secure
     */
    createPersonalLocation: (request: CreateLocationRequest, params: RequestParams = {}) =>
      this.request<CreateLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/personal`,
        method: 'POST',
        body: request,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Set bookmark bookmark settings for locations.
     *
     * @tags ocfaccount
     * @name CreateBookmark
     * @summary Set bookmark
     * @request POST:/ocfaccount/oic/acl/group/settings/bookmark
     * @secure
     */
    createBookmark: (bookmark: BookmarkLocation, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/acl/group/settings/bookmark`,
        method: 'POST',
        body: bookmark,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove bookmark settings for locations
     *
     * @tags ocfaccount
     * @name DeleteBookmark
     * @summary Delete bookmark
     * @request DELETE:/ocfaccount/oic/acl/group/settings/bookmark
     * @secure
     */
    deleteBookmark: (params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/acl/group/settings/bookmark`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get location by given locationId.
     *
     * @tags ocfaccount
     * @name GetLocation
     * @summary Get Location
     * @request GET:/ocfaccount/oic/acl/group/{locationId}
     * @secure
     */
    getLocation: (locationId: string, params: RequestParams = {}) =>
      this.request<GetLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update location by given locationId.
     *
     * @tags ocfaccount
     * @name UpdateLocation
     * @summary Update Location
     * @request POST:/ocfaccount/oic/acl/group/{locationId}
     * @secure
     */
    updateLocation: (
      { locationId, ...query }: UpdateLocationParams,
      request: UpdateLocationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete location by given locationId.
     *
     * @tags ocfaccount
     * @name DeleteLocation
     * @summary Delete Location
     * @request DELETE:/ocfaccount/oic/acl/group/{locationId}
     * @secure
     */
    deleteLocation: (locationId: string, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get room list by given locationId.
     *
     * @tags ocfaccount
     * @name GetRoomList
     * @summary Get room list
     * @request GET:/ocfaccount/oic/acl/group/{locationId}/room
     * @secure
     */
    getRoomList: (locationId: string, params: RequestParams = {}) =>
      this.request<GetLocationListResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}/room`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create room by given locationId.
     *
     * @tags ocfaccount
     * @name CreateRoom
     * @summary Create room
     * @request POST:/ocfaccount/oic/acl/group/{locationId}/room
     * @secure
     */
    createRoom: (locationId: string, request: CreateRoomRequest, params: RequestParams = {}) =>
      this.request<CreateRoomResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}/room`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update room by given roomId.
     *
     * @tags ocfaccount
     * @name UpdateRoom
     * @summary Update room
     * @request POST:/ocfaccount/oic/acl/group/{locationId}/room/{roomId}
     * @secure
     */
    updateRoom: (
      { locationId, roomId, ...query }: UpdateRoomParams,
      request: UpdateRoomRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}/room/${roomId}`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete Room by given roomId.
     *
     * @tags ocfaccount
     * @name DeleteRoom
     * @summary Delete room
     * @request DELETE:/ocfaccount/oic/acl/group/{locationId}/room/{roomId}
     * @secure
     */
    deleteRoom: (locationId: string, roomId: string, params: RequestParams = {}) =>
      this.request<CommonResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}/room/${roomId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get room by given roomId.
     *
     * @tags ocfaccount
     * @name GetRoom
     * @summary Get room
     * @request GET:/ocfaccount/oic/acl/group/{locationId}/room/{roomId}
     * @secure
     */
    getRoom: (locationId: string, roomId: string, params: RequestParams = {}) =>
      this.request<GetLocationResponse, void>({
        path: `/ocfaccount/oic/acl/group/${locationId}/room/${roomId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  chamber = {
    /**
     * @description Vallidate the device registration for the user
     *
     * @tags chamber
     * @name GetRegistration
     * @summary Validate registration
     * @request GET:/chamber/device
     * @secure
     */
    getRegistration: (query: GetRegistrationParams, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/chamber/device`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Register device from mobile
     *
     * @tags chamber
     * @name PostNonce
     * @summary Register device
     * @request POST:/chamber/device
     * @secure
     */
    postNonce: (Payload: DeviceRequest, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/chamber/device`,
        method: 'POST',
        body: Payload,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags chamber
     * @name GetDeviceKey
     * @summary Get device key
     * @request GET:/chamber/device/key
     * @secure
     */
    getDeviceKey: (query: GetDeviceKeyParams, params: RequestParams = {}) =>
      this.request<any, ErrorResponse>({
        path: `/chamber/device/key`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags chamber
     * @name PutDeviceKey
     * @summary Update device key
     * @request PUT:/chamber/device/key
     * @secure
     */
    putDeviceKey: (Payload: EncryptionKeyRequest, params: RequestParams = {}) =>
      this.request<any, ErrorResponse>({
        path: `/chamber/device/key`,
        method: 'PUT',
        body: Payload,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description API returns the signature of the user defined by AUTHORIZATION header.
     *
     * @tags chamber
     * @name GetSharedkey
     * @summary Get shared key
     * @request GET:/chamber/device/sharedkey
     * @secure
     */
    getSharedkey: (query: GetSharedkeyParams, params: RequestParams = {}) =>
      this.request<SharedKeyResponse[], ErrorResponse>({
        path: `/chamber/device/sharedkey`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update shared key
     *
     * @tags chamber
     * @name PutSharedkey
     * @summary Put shared key
     * @request PUT:/chamber/device/sharedkey
     * @secure
     */
    putSharedkey: (Payload: SharedKeyRequest, params: RequestParams = {}) =>
      this.request<any, ErrorResponse>({
        path: `/chamber/device/sharedkey`,
        method: 'PUT',
        body: Payload,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Register nonce from mobile
     *
     * @tags chamber
     * @name PostNonce2
     * @summary Register nonce
     * @request POST:/chamber/device/nonce
     * @originalName postNonce
     * @duplicate
     * @secure
     */
    postNonce2: (Payload: NonceRequest, params: RequestParams = {}) =>
      this.request<NonceResponse, ErrorResponse>({
        path: `/chamber/device/nonce`,
        method: 'POST',
        body: Payload,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chamber
     * @name PostValidate
     * @summary Validate nonce
     * @request POST:/chamber/device/nonce/validate
     * @secure
     */
    postValidate: (Payload: DeviceRequest, params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/chamber/device/nonce/validate`,
        method: 'POST',
        body: Payload,
        secure: true,
        ...params,
      }),
  };
  wifilocker = {
    /**
     * No description
     *
     * @tags wifi-controller
     * @name GetApDetailUsingGet
     * @summary This API is used by the devices to get wifi credentials stored in wifi-locker for a device.
     * @request GET:/wifilocker/apdetail
     * @deprecated
     * @secure
     */
    getApDetailUsingGet: (deviceId: string, params: RequestParams = {}) =>
      this.request<GetAPDetailResponse, void>({
        path: `/wifilocker/apdetail`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name GetAllApDetailsUsingGet
     * @summary This API is used by the devices to get wifi credentials stored in wifi-locker for a user.
     * @request GET:/wifilocker/apdetails
     * @deprecated
     * @secure
     */
    getAllApDetailsUsingGet: (params: RequestParams = {}) =>
      this.request<GetAllAPDetailsResponse, void>({
        path: `/wifilocker/apdetails`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name PostApDetailPost
     * @summary This API is used for adding a new AP details in wifi-locker server.
     * @request POST:/wifilocker/apdetails
     * @deprecated
     * @secure
     */
    postApDetailPost: (body: PostApDetailPostPayload, params: RequestParams = {}) =>
      this.request<PostAPDetailResponse, void>({
        path: `/wifilocker/apdetails`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name DeleteApDetailsDelete
     * @summary This API is used for deleting all existing AP details for an user in wifi-locker server.
     * @request DELETE:/wifilocker/apdetails
     * @deprecated
     */
    deleteApDetailsDelete: (params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/apdetails`,
        method: 'DELETE',
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name InvalidateApDetailsByDeviceIdsPost
     * @summary This API is used for invalidating existing AP details in wifi-locker for a list of devices. This will de-link provided deviceIds with existing AP details.
     * @request POST:/wifilocker/invalid/deviceIds
     * @deprecated
     * @secure
     */
    invalidateApDetailsByDeviceIdsPost: (body: KeyList, params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/invalid/deviceIds`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name InvalidateApDetailsByKeysPost
     * @summary This API is used for invalidating existing AP details in wifi-locker server.
     * @request POST:/wifilocker/invalid/apdetails
     * @deprecated
     * @secure
     */
    invalidateApDetailsByKeysPost: (body: KeyList, params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/invalid/apdetails`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name DeleteApDetailsDeleteDeprecated
     * @summary This API is used for deleting all existing AP details for an user in wifi-locker server.
     * @request DELETE:/wifilocker/user/apdetails
     * @deprecated
     * @secure
     */
    deleteApDetailsDeleteDeprecated: (params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/user/apdetails`,
        method: 'DELETE',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name GetUserConsent
     * @summary This API is used by the client to get wifi-locker setting Consent detail for a user. This would be used for multi-device use case.
     * @request GET:/wifilocker/setting
     * @deprecated
     * @secure
     */
    getUserConsent: (params: RequestParams = {}) =>
      this.request<GetConsentResponse, void>({
        path: `/wifilocker/setting`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags wifi-controller
     * @name PostUserConsent
     * @summary This API is used to save wifi-locker consent setting for a user. This would be used for multi-device use case.
     * @request POST:/wifilocker/setting
     * @deprecated
     * @secure
     */
    postUserConsent: (body: ConsentObject, params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/setting`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags device-ap-controller
     * @name PostDeviceApDetailsUsingPost
     * @summary This API is used for adding/updating a new device AP details in wifi-locker server. It requires `mobile` scope token.
     * @request POST:/wifilocker/device/apdetails
     * @secure
     */
    postDeviceApDetailsUsingPost: (body: PostDeviceApDetailsUsingPostPayload, params: RequestParams = {}) =>
      this.request<PostDeviceAPErrorResponse, void>({
        path: `/wifilocker/device/apdetails`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags device-ap-controller
     * @name GetAllDeviceApDetailsUsingGet
     * @summary This API is used by the devices to get all device APs stored in wifi-locker for a user. It requires `mobile` scope token.
     * @request GET:/wifilocker/device/apdetails
     */
    getAllDeviceApDetailsUsingGet: (query: GetAllDeviceApDetailsUsingGetParams, params: RequestParams = {}) =>
      this.request<GetAllDeviceAPDetailsResponse, void>({
        path: `/wifilocker/device/apdetails`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags device-ap-controller
     * @name DeleteDeviceApDetailsUsingDelete
     * @summary This API is used to delete all device AP details for an user in wifi-locker server. It requires `mobile` scope token.
     * @request DELETE:/wifilocker/device/apdetails
     */
    deleteDeviceApDetailsUsingDelete: (params: RequestParams = {}) =>
      this.request<GeneralPostResponseWithData, void>({
        path: `/wifilocker/device/apdetails`,
        method: 'DELETE',
        ...params,
      }),

    /**
     * No description
     *
     * @tags device-ap-controller
     * @name InvalidateApDetailsByDeviceIdPost
     * @summary This API is used for invalidating existing AP details in wifi-locker for a list of devices. This will de-link provided deviceIds with existing AP details. This API could be called with Max 20 deviceId at a time. It requires `mobile` scope token.
     * @request POST:/wifilocker/device/invalid
     */
    invalidateApDetailsByDeviceIdPost: (body: DeviceKeyList, params: RequestParams = {}) =>
      this.request<GeneralPostResponseWithData, void>({
        path: `/wifilocker/device/invalid`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-controller
     * @name GetUserSettingUsingPost
     * @summary This API is used to get user setting details. This would be used for multi-device use case.
     * @request GET:/wifilocker/user/setting
     * @secure
     */
    getUserSettingUsingPost: (params: RequestParams = {}) =>
      this.request<GetUserSettingResponse, void>({
        path: `/wifilocker/user/setting`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags user-controller
     * @name ChangeUserSettingUsingPost
     * @summary This API is used to save or modify user setting details. This would be used for multi-device use case.
     * @request POST:/wifilocker/user/setting
     * @secure
     */
    changeUserSettingUsingPost: (body: UserSettingObject, params: RequestParams = {}) =>
      this.request<GeneralPostResponse, void>({
        path: `/wifilocker/user/setting`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  nexo = {
    /**
     * @description Set the location used for previous on-boarding as the default for a specific period
     *
     * @tags nexo
     * @name LocationSetting
     * @summary Set the default location for a specific period
     * @request POST:/nexo/settings/location
     * @secure
     */
    locationSetting: (locationSetting: LocationSettingRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/nexo/settings/location`,
        method: 'POST',
        body: locationSetting,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Create a JWT token
     *
     * @tags nexo
     * @name CreateJwtToken
     * @summary Create a JWT token
     * @request POST:/nexo/auth/jwt
     * @secure
     */
    createJwtToken: (createJwtToken: CreateJwtTokenRequest, params: RequestParams = {}) =>
      this.request<CreateJwtResponse, ErrorResponse>({
        path: `/nexo/auth/jwt`,
        method: 'POST',
        body: createJwtToken,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get device mode by deviceId
     *
     * @tags ocf
     * @name GetOcfDeviceMode
     * @summary Get device mode
     * @request GET:/nexo/ocf/devicemode
     * @secure
     */
    getOcfDeviceMode: (query: GetOcfDeviceModeParams, params: RequestParams = {}) =>
      this.request<DeviceMode, ErrorResponse>({
        path: `/nexo/ocf/devicemode`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  identity = {
    /**
     * No description
     *
     * @tags identity
     * @name GetCertificateUuid
     * @summary Get certificate uuid list by mnId, certificate type and cert-uuid hash prefix
     * @request GET:/identity/certificate/certificate-uuid
     * @secure
     */
    getCertificateUuid: (query: GetCertificateUuidParams, params: RequestParams = {}) =>
      this.request<CertificateUuidResponse, void>({
        path: `/identity/certificate/certificate-uuid`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags identity
     * @name GetPublisherDetailsUsing
     * @summary Get Publisher details corresponding to mn-id
     * @request GET:/identity/publisher/details
     * @secure
     */
    getPublisherDetailsUsing: (params: RequestParams = {}) =>
      this.request<PublisherDetailsResponse, void>({
        path: `/identity/publisher/details`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags identity
     * @name PostEasySetupBlob
     * @summary Generates encrypted blob for a given random value using public key of the device provided
     * @request POST:/identity/easysetup/blob
     * @secure
     */
    postEasySetupBlob: (easySetupBlobReq: EasySetupBlobReq, params: RequestParams = {}) =>
      this.request<RestResponseListEasySetupBlobRes, void>({
        path: `/identity/easysetup/blob`,
        method: 'POST',
        body: easySetupBlobReq,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  udo = {
    /**
     * @description Request upload url for announcement
     *
     * @tags udo
     * @name PostFileLink
     * @request POST:/udo/file_links
     * @secure
     */
    postFileLink: (query: PostFileLinkParams, params: RequestParams = {}) =>
      this.request<LuxFileLinkResult, void>({
        path: `/udo/file_links`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description download content for announcement.
     *
     * @tags udo
     * @name GetFileLink
     * @request GET:/udo/file_links/{fileId}
     * @secure
     */
    getFileLink: ({ fileId, ...query }: GetFileLinkParams, params: RequestParams = {}) =>
      this.request<any, void>({
        path: `/udo/file_links/${fileId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
  rules = {
    /**
     * @description Return a list of Rules for a given token principal. Either a locationId or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name ListRules
     * @summary List Rules
     * @request GET:/rules
     * @secure
     */
    listRules: (query: ListRulesParams, params: RequestParams = {}) =>
      this.request<PagedRules, void | Error>({
        path: `/rules`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Creates a Rule. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name CreateRule
     * @summary Create a Rule
     * @request POST:/rules
     * @secure
     */
    createRule: (query: CreateRuleParams, request: RuleRequest, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all rules in a location
     *
     * @tags rules
     * @name DeleteAllRules
     * @summary Delete all rules
     * @request DELETE:/rules
     * @secure
     */
    deleteAllRules: (query: DeleteAllRulesParams, params: RequestParams = {}) =>
      this.request<void, void | Error>({
        path: `/rules`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get the logic of a Rule. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name GetRule
     * @summary Get a Rule
     * @request GET:/rules/{ruleId}
     * @secure
     */
    getRule: ({ ruleId, ...query }: GetRuleParams, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a Rule. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name UpdateRule
     * @summary Update a Rule
     * @request PUT:/rules/{ruleId}
     * @secure
     */
    updateRule: ({ ruleId, ...query }: UpdateRuleParams, request: RuleRequest, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'PUT',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Deletes a Rule. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name DeleteRule
     * @summary Delete a Rule
     * @request DELETE:/rules/{ruleId}
     * @secure
     */
    deleteRule: ({ ruleId, ...query }: DeleteRuleParams, params: RequestParams = {}) =>
      this.request<Rule, void | Error>({
        path: `/rules/${ruleId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute the given Rule on an ad hoc basis for the logged in user and given locationId
     *
     * @tags rules
     * @name ExecuteAdhocRule
     * @summary Execute Adhoc Rule
     * @request POST:/rules/execute
     * @secure
     */
    executeAdhocRule: (query: ExecuteAdhocRuleParams, request: RuleAdhocRequest, params: RequestParams = {}) =>
      this.request<RuleExecutionResponse, void | Error>({
        path: `/rules/execute`,
        method: 'POST',
        query: query,
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Triggers Rule execution given a Rule ID. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name ExecuteRule
     * @summary Execute a Rule
     * @request POST:/rules/execute/{ruleId}
     * @secure
     */
    executeRule: ({ ruleId, ...query }: ExecuteRuleParams, params: RequestParams = {}) =>
      this.request<RuleExecutionResponse, void | Error>({
        path: `/rules/execute/${ruleId}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Updates a Rule status. Enabled or Disabled. Either the locationId of the Rule or 'ownerType=USER' is required, but not both.
     *
     * @tags rules
     * @name UpdateRuleStatus
     * @summary Update a Rule status
     * @request PUT:/rules/{ruleId}/status/{status}
     * @secure
     */
    updateRuleStatus: ({ ruleId, status, ...query }: UpdateRuleStatusParams, params: RequestParams = {}) =>
      this.request<void, void | Error>({
        path: `/rules/${ruleId}/status/${status}`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),
  };
  accio = {
    /**
     * No description
     *
     * @tags accio
     * @name CreateD2DDeviceInfo
     * @request POST:/accio/smartthings/devices/d2d
     * @secure
     */
    createD2DDeviceInfo: (Payload: StD2DDeviceCreateRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/accio/smartthings/devices/d2d`,
        method: 'POST',
        body: Payload,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Get Delivery Order
     *
     * @tags accio
     * @name GetPlcmDeliveryOrder
     * @summary Get PLCM Delivery Order
     * @request GET:/accio/plcm/deliveryorder
     * @secure
     */
    getPlcmDeliveryOrder: (query: GetPlcmDeliveryOrderParams, params: RequestParams = {}) =>
      this.request<GetDeliveryOrderResponse[], ErrorResponse>({
        path: `/accio/plcm/deliveryorder`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update Delivery Order by Document Number
     *
     * @tags accio
     * @name UpdateDeliveryOrderByDocumentNumber
     * @summary Update Delivery Order by Document Number
     * @request PUT:/accio/plcm/deliveryorder/{documentNumber}
     * @secure
     */
    updateDeliveryOrderByDocumentNumber: (documentNumber: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/accio/plcm/deliveryorder/${documentNumber}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description Update installation by document number
     *
     * @tags accio
     * @name UpdateInstallationByDocumentNumber
     * @summary Update installation by document number
     * @request PUT:/accio/plcm/installation/{documentNumber}
     * @secure
     */
    updateInstallationByDocumentNumber: (documentNumber: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/accio/plcm/installation/${documentNumber}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * @description request body : - If sourceType is PDD or FOA, discovererDevice is required. - If sourceType is PDD and deviceType is not MP, deviceId is required. - If sourceType is FOA, MP is not supported. - If sourceType is FOA, deviceId is required. - [serialNumber] or [hashedSerialNumber and partialSerialNumber] should be present" response body : - Generated mnId and setupId by model code on the server (Except PDD) - Client passes mnId and setupId without modelCode (Only for PDD) - If serialNumber is provided, then hashedSerialNumber and partialSerialNumber will be computed from it. If hashed and partial serial numbers are also provided, then the user-provided version will be used instead of the computed one.
     *
     * @tags PlcmClientController, accio
     * @name CreateDevice
     * @summary createDevice
     * @request POST:/accio/plcm/devices
     */
    createDevice: (body: PlcmDevicePostRequest, params: RequestParams = {}) =>
      this.request<PostPlcmDeviceResponse, any>({
        path: `/accio/plcm/devices`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlcmClientController, accio
     * @name GetDevices
     * @summary getDevices
     * @request GET:/accio/plcm/devices
     */
    getDevices: (query: GetDevicesParams, params: RequestParams = {}) =>
      this.request<GetPlcmDevicesResponse, any>({
        path: `/accio/plcm/devices`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description serialNumber or hashedSerialNumber should be present
     *
     * @tags accio
     * @name DeletePlcmDevice
     * @summary deleteDeviceById
     * @request DELETE:/accio/plcm/devices
     */
    deletePlcmDevice: (query: DeletePlcmDeviceParams, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/accio/plcm/devices`,
        method: 'DELETE',
        query: query,
        ...params,
      }),

    /**
     * @description Update device visibility. serialNumber or hashedSerialNumber should be present
     *
     * @tags accio
     * @name UpdatePlcmDevice
     * @summary updatePlcmDevice
     * @request PUT:/accio/plcm/devices
     */
    updatePlcmDevice: (body: PlcmDevicePutRequest, params: RequestParams = {}) =>
      this.request<PostPlcmDeviceResponse, any>({
        path: `/accio/plcm/devices`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  chaser = {
    /**
     * @description Get geolocation entries of multiple devices up to 20, based on a paramter `devicdId`. This api will return only the latest locations of devices.
     *
     * @tags chaser
     * @name GetGeolocationsByDeviceIds
     * @summary Get geolocations
     * @request GET:/chaser/geolocations
     * @secure
     */
    getGeolocationsByDeviceIds: (query: GetGeolocationsByDeviceIdsParams, params: RequestParams = {}) =>
      this.request<GeolocationResponse, ErrorResponse>({
        path: `/chaser/geolocations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a single key pair
     *
     * @tags chaser
     * @name CreateKeyPair
     * @summary Create key pair
     * @request POST:/chaser/keys
     * @secure
     */
    createKeyPair: (data: Key, params: RequestParams = {}) =>
      this.request<
        {
          code?: number;
          message?: string;
        },
        ErrorResponse
      >({
        path: `/chaser/keys`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create geolocation entries of a device.
     *
     * @tags chaser
     * @name CreateTrackerGeolocations
     * @summary Create a tracker's geolocations
     * @request POST:/chaser/trackers/{deviceId}/geolocations
     * @secure
     */
    createTrackerGeolocations: (deviceId: string, data: CreateTrackerGeolocationsPayload, params: RequestParams = {}) =>
      this.request<
        {
          result?: string;
        },
        ErrorResponse
      >({
        path: `/chaser/trackers/${deviceId}/geolocations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description | state         | description                                         | | ------------- | --------------------------------------------------- | | undefined     | Default value                                       | | connected     | Tracker connected to owners phone                   | | disconnected  | Tracker disconnected from owners phone              | | lost          | Tracker marked as lost                              | | found         | When the geolocation of "lost" device is registered |
     *
     * @tags chaser
     * @name PutTrackerDidState
     * @summary Update tracker's state
     * @request PUT:/chaser/trackers/{deviceId}/state
     * @secure
     */
    putTrackerDidState: (deviceId: string, payload: TrackerStateItemInput, params: RequestParams = {}) =>
      this.request<
        {
          /** http status code */
          code?: number;
          message?: string;
          /** Current epoch time of the server to sync with tag (in sec) */
          currentServerTime?: string;
        },
        any
      >({
        path: `/chaser/trackers/${deviceId}/state`,
        method: 'PUT',
        body: payload,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chaser
     * @name GetTrackerDidState
     * @summary Get tracker's state
     * @request GET:/chaser/trackers/{deviceId}/state
     * @secure
     */
    getTrackerDidState: (deviceId: string, params: RequestParams = {}) =>
      this.request<TrackerStateItemOutput, any>({
        path: `/chaser/trackers/${deviceId}/state`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a public key of a device.
     *
     * @tags chaser
     * @name GetTrackerPublicKey
     * @summary Get a tracker's public key
     * @request GET:/chaser/trackers/{deviceId}/pubKeys
     * @secure
     */
    getTrackerPublicKey: (deviceId: string, params: RequestParams = {}) =>
      this.request<
        {
          pubKey?: string;
        },
        ErrorResponse
      >({
        path: `/chaser/trackers/${deviceId}/pubKeys`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Inform the tag’s timer is synced with the value in the payload
     *
     * @tags chaser
     * @name UpdateTrackerTimer
     * @summary Update a tracker's synced datetime
     * @request PUT:/chaser/trackers/{deviceId}/timer
     * @secure
     */
    updateTrackerTimer: (deviceId: string, payload: TrackerTimerItemInput, params: RequestParams = {}) =>
      this.request<TrackerTimerItemOutput, ErrorResponse>({
        path: `/chaser/trackers/${deviceId}/timer`,
        method: 'PUT',
        body: payload,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  lighteffect = {
    /**
     * @description Executes wakeup or winddown light effects
     *
     * @tags lighteffect
     * @name ExecuteFadeLightEffect
     * @summary Execute WakeUp or WindDown Light Effects
     * @request POST:/lighteffect/fade/execute
     * @secure
     */
    executeFadeLightEffect: (fadeRequest: FadeRequest, params: RequestParams = {}) =>
      this.request<RestResponseEmpty, void>({
        path: `/lighteffect/fade/execute`,
        method: 'POST',
        body: fadeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancels wakeUp or windDown light effect related to a specific device
     *
     * @tags lighteffect
     * @name CancelFadeLightEffectByDeviceId
     * @summary Cancel WakeUp or WindDown Light Effect for a Device
     * @request POST:/lighteffect/fade/cancel/device/{deviceId}
     * @secure
     */
    cancelFadeLightEffectByDeviceId: (deviceId: string, params: RequestParams = {}) =>
      this.request<RestResponseEmpty, void>({
        path: `/lighteffect/fade/cancel/device/${deviceId}`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Executes circadian light effect
     *
     * @tags lighteffect
     * @name ExecuteCircadianLightEffect
     * @summary Execute Circadian Light Effect
     * @request POST:/lighteffect/circadian/execute
     * @secure
     */
    executeCircadianLightEffect: (circadianRequest: CircadianRequest, params: RequestParams = {}) =>
      this.request<RestResponseEmpty, void>({
        path: `/lighteffect/circadian/execute`,
        method: 'POST',
        body: circadianRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Cancels circadian light Effect related to a specific device
     *
     * @tags lighteffect
     * @name CancelCircadianLightEffectByDeviceId
     * @summary Cancel Circadian Light Effect for a Device
     * @request POST:/lighteffect/circadian/cancel/device/{deviceId}
     * @secure
     */
    cancelCircadianLightEffectByDeviceId: (deviceId: string, params: RequestParams = {}) =>
      this.request<RestResponseEmpty, void>({
        path: `/lighteffect/circadian/cancel/device/${deviceId}`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description get the light effect execution status related to a device
     *
     * @tags lighteffect
     * @name GetLightEffectStatusByDeviceId
     * @summary Get Light Effect Execution Status for a Device
     * @request GET:/lighteffect/status/device/{deviceId}
     * @secure
     */
    getLightEffectStatusByDeviceId: (deviceId: string, params: RequestParams = {}) =>
      this.request<RestResponseLightEffectExecutionStatus, void>({
        path: `/lighteffect/status/device/${deviceId}`,
        method: 'GET',
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  lighteffects = {
    /**
     * @description Cancel fade light effects for a device (and component)
     *
     * @tags lighteffects
     * @name CancelFadeByDeviceIdAndComponentIds
     * @summary Cancel fade light effects for a device (and component)
     * @request POST:/lighteffects/fade/cancel
     * @secure
     */
    cancelFadeByDeviceIdAndComponentIds: (fadeCancelRequest: FadeCancelRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/lighteffects/fade/cancel`,
        method: 'POST',
        body: fadeCancelRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Cancels circadian light effect related to a specific device (and component)
     *
     * @tags lighteffects
     * @name CancelCircadianByDeviceIdAndComponentId
     * @summary Cancel circadian light effect for a device (and component)
     * @request POST:/lighteffects/circadian/cancel
     * @secure
     */
    cancelCircadianByDeviceIdAndComponentId: (
      circadianCancelRequest: CircadianCancelRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/lighteffects/circadian/cancel`,
        method: 'POST',
        body: circadianCancelRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  hubapi = {
    /**
     * @description Ping the hub to see if it is available.
     *
     * @tags hubapi
     * @name GetPing
     * @request GET:/hubapi/{hubDeviceId}/util/ping
     * @secure
     */
    getPing: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/util/ping`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reboot the hub if capable.
     *
     * @tags hubapi
     * @name Reboot
     * @request POST:/hubapi/{hubDeviceId}/util/reboot
     * @secure
     */
    reboot: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/util/reboot`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Gets OTA support, current enabled OTA status, and lights enabled status for a given hub
     *
     * @tags hubapi
     * @name GetOtaConfiguration
     * @request GET:/hubapi/{hubDeviceId}/config/deviceOta
     * @secure
     */
    getOtaConfiguration: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<DeviceOtaConfigurationStatus, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/config/deviceOta`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sets OTA firmware update device support for hub and lights
     *
     * @tags hubapi
     * @name SetOtaConfiguration
     * @request POST:/hubapi/{hubDeviceId}/config/deviceOta
     * @secure
     */
    setOtaConfiguration: (
      hubDeviceId: string,
      DeviceOtaConfigurationSetting: DeviceOtaConfigurationSetting,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/config/deviceOta`,
        method: 'POST',
        body: DeviceOtaConfigurationSetting,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Zigbee Secure Mode state
     *
     * @tags hubapi
     * @name GetZigbeeSecureMode
     * @request GET:/hubapi/{hubDeviceId}/zigbee/secureMode
     * @secure
     */
    getZigbeeSecureMode: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ZigbeeSecureMode, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zigbee/secureMode`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sets Zigbee unsecure rejoin state
     *
     * @tags hubapi
     * @name SetZigbeeSecureMode
     * @request POST:/hubapi/{hubDeviceId}/zigbee/secureMode
     * @secure
     */
    setZigbeeSecureMode: (hubDeviceId: string, ZigbeeSecureMode: ZigbeeSecureMode, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zigbee/secureMode`,
        method: 'POST',
        body: ZigbeeSecureMode,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get integer value for Zigbee radio channel (11-25)
     *
     * @tags hubapi
     * @name GetZigbeeRadioChannel
     * @request GET:/hubapi/{hubDeviceId}/zigbee/channel
     * @secure
     */
    getZigbeeRadioChannel: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ZigbeeRadioChannelObject, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zigbee/channel`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Set integer value for Zigbee radio channel (11-25)
     *
     * @tags hubapi
     * @name SetZigbeeRadioChannel
     * @request POST:/hubapi/{hubDeviceId}/zigbee/channel
     * @secure
     */
    setZigbeeRadioChannel: (hubDeviceId: string, ZigbeeChannel: ZigbeeRadioChannelObject, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zigbee/channel`,
        method: 'POST',
        body: ZigbeeChannel,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Zigbee network state for hub.
     *
     * @tags hubapi
     * @name GetZigbeeNetworkState
     * @request GET:/hubapi/{hubDeviceId}/zigbee/state
     * @secure
     */
    getZigbeeNetworkState: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ZigbeeNetworkState, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zigbee/state`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiates Z-Wave network repair for hub
     *
     * @tags hubapi
     * @name ZwaveStartRepair
     * @request POST:/hubapi/{hubDeviceId}/zwave/repair/start
     * @secure
     */
    zwaveStartRepair: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zwave/repair/start`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stops existing Z-Wave network repair for hub
     *
     * @tags hubapi
     * @name ZwaveStopRepair
     * @request POST:/hubapi/{hubDeviceId}/zwave/repair/stop
     * @secure
     */
    zwaveStopRepair: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zwave/repair/stop`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stop currently executing exclusion
     *
     * @tags hubapi
     * @name ZwaveStopExclude
     * @request POST:/hubapi/{hubDeviceId}/zwave/exclude/stop
     * @secure
     */
    zwaveStopExclude: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zwave/exclude/stop`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Start Z-Wave exclusion for hub
     *
     * @tags hubapi
     * @name ZwaveStartExclude
     * @request POST:/hubapi/{hubDeviceId}/zwave/exclude/start
     * @secure
     */
    zwaveStartExclude: (hubDeviceId: string, ZwaveStartExclude: ZwaveStartExclude, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/zwave/exclude/start`,
        method: 'POST',
        body: ZwaveStartExclude,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get wifi link info for hub.
     *
     * @tags hubapi
     * @name GetWifiLinkInfo
     * @request GET:/hubapi/{hubDeviceId}/wifi/linkInfo
     * @secure
     */
    getWifiLinkInfo: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<WifiLinkInfo, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/wifi/linkInfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Discover Matter nodes on a given fabric.
     *
     * @tags hubapi
     * @name PostMatterFabricOperationalServiceEnumeration
     * @request POST:/hubapi/{hubDeviceId}/matter/fabrics/{compressedFabricId}/operationalServiceEnumeration
     * @secure
     */
    postMatterFabricOperationalServiceEnumeration: (
      hubDeviceId: string,
      compressedFabricId: string,
      params: RequestParams = {},
    ) =>
      this.request<CreateMatterFabricOperationalServiceEnumerationResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/fabrics/${compressedFabricId}/operationalServiceEnumeration`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create and return a Certificate Signing Request for the Hub to join a Matter fabric as an administrator for the purpose of migrating nodes on the fabric to the hub's current, active fabric.
     *
     * @tags hubapi
     * @name PostMatterNodeMigrationCsr
     * @request POST:/hubapi/{hubDeviceId}/matter/nodeMigration/certificateSigningRequest
     * @secure
     */
    postMatterNodeMigrationCsr: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<CreateMatterNodeMigrationCsrResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/nodeMigration/certificateSigningRequest`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the record for a specific node migration fabric that the hub administers.
     *
     * @tags hubapi
     * @name GetMatterNodeMigrationFabric
     * @request GET:/hubapi/{hubDeviceId}/matter/nodeMigration/fabrics/{compressedFabricId}
     * @secure
     */
    getMatterNodeMigrationFabric: (hubDeviceId: string, compressedFabricId: string, params: RequestParams = {}) =>
      this.request<GetMatterNodeMigrationFabricResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/nodeMigration/fabrics/${compressedFabricId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Install a node migration fabric on a hub.  A node migration fabric is a fabric that a hub temporarily administers in order to migrate nodes to its primary, active fabric.  A certificate signing request with public key matching that in the enclosed NOC must have been previously created in order for the request to succeed.
     *
     * @tags hubapi
     * @name PostMatterNodeMigrationFabric
     * @request POST:/hubapi/{hubDeviceId}/matter/nodeMigration/fabrics/{compressedFabricId}
     * @secure
     */
    postMatterNodeMigrationFabric: (
      hubDeviceId: string,
      compressedFabricId: string,
      createNodeMigrationFabricRequest: CreateMatterNodeMigrationFabricRequest,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/nodeMigration/fabrics/${compressedFabricId}`,
        method: 'POST',
        body: createNodeMigrationFabricRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a resource to migrate the client-specified Matter nodes to the hub's primary fabric.
     *
     * @tags hubapi
     * @name PostMatterNodeMigration
     * @request POST:/hubapi/{hubDeviceId}/matter/nodeMigration/migrations
     * @secure
     */
    postMatterNodeMigration: (
      hubDeviceId: string,
      createMatterNodeMigrationRequest: CreateMatterNodeMigrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMatterNodeMigrationResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/nodeMigration/migrations`,
        method: 'POST',
        body: createMatterNodeMigrationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Poll a node migration resource to view status of nodes as they are commissioned to the hub's primary fabric.
     *
     * @tags hubapi
     * @name GetMatterNodeMigrationStatus
     * @request GET:/hubapi/{hubDeviceId}/matter/nodeMigration/fabrics/{migrationId}
     * @secure
     */
    getMatterNodeMigrationStatus: (hubDeviceId: string, migrationId: string, params: RequestParams = {}) =>
      this.request<GetMatterNodeMigrationStatusResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/matter/nodeMigration/fabrics/${migrationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description | Get a primary hub's join data which is needed for a secondary hub to | join this hub's mesh networks
     *
     * @tags hubapi
     * @name GetMultiHubJoinPrimaryData
     * @request GET:/hubapi/{hubDeviceId}/multihub/joinPrimaryData
     * @secure
     */
    getMultiHubJoinPrimaryData: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<JoinPrimaryData, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/joinPrimaryData`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get information necessary to add this hub to the primary hub's mesh networks
     *
     * @tags hubapi
     * @name GetMultiHubJoinSecondaryData
     * @request GET:/hubapi/{hubDeviceId}/multihub/joinSecondaryData
     * @secure
     */
    getMultiHubJoinSecondaryData: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<JoinSecondaryData, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/joinSecondaryData`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Request that a hub begin the conversion to a secondary hub
     *
     * @tags hubapi
     * @name PostConvertToSecondary
     * @request POST:/hubapi/{hubDeviceId}/multihub/convertToSecondary
     * @secure
     */
    postConvertToSecondary: (
      hubDeviceId: string,
      ConvertToSecondaryData: ConvertToSecondaryData,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/convertToSecondary`,
        method: 'POST',
        body: ConvertToSecondaryData,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the state of a hub's conversion into a secondary hub
     *
     * @tags hubapi
     * @name GetConvertToSecondaryStatus
     * @request GET:/hubapi/{hubDeviceId}/multihub/convertToSecondaryStatus
     * @secure
     */
    getConvertToSecondaryStatus: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<SecondaryConversionStatusResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/convertToSecondaryStatus`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags hubapi
     * @name PostRevertFromSecondary
     * @request POST:/hubapi/{hubDeviceId}/multihub/revertFromSecondary
     * @secure
     */
    postRevertFromSecondary: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/revertFromSecondary`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags hubapi
     * @name GetRevertFromSecondaryStatus
     * @request GET:/hubapi/{hubDeviceId}/multihub/revertFromSecondaryStatus
     * @secure
     */
    getRevertFromSecondaryStatus: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<SecondaryReversionStatusResponse, ErrorResponse>({
        path: `/hubapi/${hubDeviceId}/multihub/revertFromSecondaryStatus`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  hubs = {
    /**
     * @description Fetch all hubs, using an Oauth token with a principal. Only hubs that allow principal access will be returned in the response.
     *
     * @tags hubs
     * @name ListHubsDeprecated
     * @summary List hubs for location
     * @request GET:/hubs/{locationId}
     * @deprecated
     * @secure
     */
    listHubsDeprecated: ({ locationId, ...query }: ListHubsDeprecatedParams, params: RequestParams = {}) =>
      this.request<Hub[], ErrorResponse>({
        path: `/hubs/${locationId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags hubs
     * @name GetHubDeprecated
     * @summary Get hub
     * @request GET:/hubs/{locationId}/{hubId}
     * @deprecated
     * @secure
     */
    getHubDeprecated: ({ hubId, locationId, ...query }: GetHubDeprecatedParams, params: RequestParams = {}) =>
      this.request<Hub, ErrorResponse>({
        path: `/hubs/${locationId}/${hubId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags hubs
     * @name DeleteHubDeprecated
     * @summary Delete a hub
     * @request DELETE:/hubs/{locationId}/{hubId}
     * @deprecated
     * @secure
     */
    deleteHubDeprecated: (
      { hubId, locationId, ...query }: DeleteHubDeprecatedParams,
      updateHubRequest: HubUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubs/${locationId}/${hubId}`,
        method: 'DELETE',
        query: query,
        body: updateHubRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Update a hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags hubs
     * @name PutHubDeprecated
     * @summary Update a hub
     * @request PUT:/hubs/{locationId}/{hubId}
     * @deprecated
     * @secure
     */
    putHubDeprecated: ({ hubId, locationId, ...query }: PutHubDeprecatedParams, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubs/${locationId}/${hubId}`,
        method: 'PUT',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get the Zigbee graph for a specified hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags hubs
     * @name GetZigbeeGraph
     * @summary Get Zigbee graph
     * @request GET:/hubs/{locationId}/{hubId}/zigbee/graph
     * @deprecated
     * @secure
     */
    getZigbeeGraph: ({ hubId, locationId, ...query }: GetZigbeeGraphParams, params: RequestParams = {}) =>
      this.request<MeshGraph, ErrorResponse>({
        path: `/hubs/${locationId}/${hubId}/zigbee/graph`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the Z-Wave graph for a specified hub, using an Oauth token with a principal. For the operation to succeed the token needs to have the appropriate scopes and the principal needs to have access to the Hub.
     *
     * @tags hubs
     * @name GetZWaveGraph
     * @summary Get Z-Wave graph
     * @request GET:/hubs/{locationId}/{hubId}/zwave/graph
     * @deprecated
     * @secure
     */
    getZWaveGraph: ({ hubId, locationId, ...query }: GetZWaveGraphParams, params: RequestParams = {}) =>
      this.request<MeshGraph, ErrorResponse>({
        path: `/hubs/${locationId}/${hubId}/zwave/graph`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  hubdevices = {
    /**
     * @description Sends a discovery command down to the hubs for LAN, Zigbee, Z-Wave, and Bluetooth devices
     *
     * @tags HubDevices
     * @name DiscoveryStart
     * @summary Starts Hub Device Discovery
     * @request POST:/hubdevices/{hubDeviceId}/discovery/start
     * @secure
     */
    discoveryStart: (hubDeviceId: string, discoveryStartRequest: DiscoveryStartRequest, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/start`,
        method: 'POST',
        body: discoveryStartRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Sends a stop discovery command down to the hubs
     *
     * @tags HubDevices
     * @name DiscoveryStop
     * @summary Stops Hub Device Discovery
     * @request POST:/hubdevices/{hubDeviceId}/discovery/stop
     * @secure
     */
    discoveryStop: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/stop`,
        method: 'POST',
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Nova, Zigbee3, and ZWave S2 devices require a user submitted code as a security mechanism
     *
     * @tags HubDevices
     * @name SendHubDeviceDiscoveryCode
     * @summary Send Hub Device Discovery Code
     * @request POST:/hubdevices/{hubDeviceId}/discovery/code
     * @secure
     */
    sendHubDeviceDiscoveryCode: (
      hubDeviceId: string,
      DiscoveryCodeRequest: DiscoveryCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/discovery/code`,
        method: 'POST',
        body: DiscoveryCodeRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Returns a map of key/value pairs. Values could be of any type. There are no required keys. More information is available [here](https://smartthings.atlassian.net/wiki/spaces/HUBPLT/pages/2348782106/Hub+Characteristics+Guidelines+and+Schema)
     *
     * @tags HubDevices
     * @name ListHubCharacterstics
     * @summary List Hub Characterstics
     * @request GET:/hubdevices/{hubDeviceId}/characteristics
     * @secure
     */
    listHubCharacterstics: ({ hubDeviceId, ...query }: ListHubCharactersticsParams, params: RequestParams = {}) =>
      this.request<HubCharacteristics, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/characteristics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sends a Matter rendezvous request to the hub
     *
     * @tags HubDevices, Matter
     * @name SendRendezvousRequest
     * @summary Sends a Matter rendezvous request to the hub
     * @request POST:/hubdevices/{hubDeviceId}/matter/rendezvous
     */
    sendRendezvousRequest: (
      hubDeviceId: string,
      rendezvousRequest: MatterRendezvousRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/matter/rendezvous`,
        method: 'POST',
        body: rendezvousRequest,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Request hub logs be collected by the hub and sent to the cloud for future analysis. Intended for uploading logs for a hub owned by user or owned by user being acted on behalf of Note: This doesn't return the logs, but instead information about where the logs are stored in the cloud
     *
     * @tags HubDevices
     * @name RequestHubLogs
     * @summary Request Hub Logs
     * @request POST:/hubdevices/{hubDeviceId}/upload/logs
     * @secure
     */
    requestHubLogs: (
      hubDeviceId: string,
      hubRequestLogsAuditData: HubRequestLogsAuditData,
      params: RequestParams = {},
    ) =>
      this.request<FetchLogsResponse, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/upload/logs`,
        method: 'POST',
        body: hubRequestLogsAuditData,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Starts the hub replacement process. Takes in the "destinationHubId" as a route param and the "sourceHubId" as a request body param. Will begin the process of transferring data from the source hub to the destination hub and overall replacing the source hub with the destination hub. This is an Async request and a 202 just represents the passing of initial validation checks. Additional status updates will be reported as events or by manually retrieving them using "Get Replacement Status"
     *
     * @tags HubDevices, Replacement
     * @name StartHubReplacement
     * @summary Start Hub Replacement
     * @request POST:/hubdevices/{hubDeviceId}/replacement
     * @secure
     */
    startHubReplacement: (hubDeviceId: string, ReplacementRequest: ReplacementRequest, params: RequestParams = {}) =>
      this.request<HubReplacementProgress, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement`,
        method: 'POST',
        body: ReplacementRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieves the current status of any replacement job that is active for the given hubDeviceId. If no job is currently active this returns a 404 not found
     *
     * @tags HubDevices, Replacement
     * @name GetHubReplacementStatus
     * @summary Get Hub Replacement Status
     * @request GET:/hubdevices/{hubDeviceId}/replacement
     * @secure
     */
    getHubReplacementStatus: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<HubReplacementProgress, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Given a Source HubDeviceId it returns the list of possible hubs in the same location that could be used to replace the given hub. Returns metadata information about if replacement should be allowed, and also information on what devices and protocols won't be support on the destination hub if replacement is initiated If a destinationHubId is passed in as a query param the results will be filtered down to the single candidate hub in question.
     *
     * @tags HubDevices, Replacement
     * @name GetHubReplacementCandidates
     * @summary Get Hub Replacement Candidates For the Given HubDeviceId
     * @request GET:/hubdevices/{hubDeviceId}/replacement/candidates
     * @secure
     */
    getHubReplacementCandidates: (
      { hubDeviceId, ...query }: GetHubReplacementCandidatesParams,
      params: RequestParams = {},
    ) =>
      this.request<ReplacementCandidates, ErrorResponse>({
        path: `/hubdevices/${hubDeviceId}/replacement/candidates`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  ui = {
    /**
     * @description get SDUI view of rooms for a given location
     *
     * @tags ui
     * @name GetRoomsSdui
     * @summary get SDUI view of rooms for a given location
     * @request GET:/ui/rooms
     * @secure
     */
    getRoomsSdui: (query: GetRoomsSduiParams, params: RequestParams = {}) =>
      this.request<UiComponent, ErrorResponse>({
        path: `/ui/rooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description get SDUI view of rules for a given location
     *
     * @tags ui
     * @name GetRulesSdui
     * @summary get SDUI view of rules for a given location
     * @request GET:/ui/rules
     * @secure
     */
    getRulesSdui: (query: GetRulesSduiParams, params: RequestParams = {}) =>
      this.request<UiComponent, ErrorResponse>({
        path: `/ui/rules`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Start installation of the app
     *
     * @tags ui
     * @name StartAppInstall
     * @summary Start installation of the app
     * @request POST:/ui/strongman/install/initialize
     * @secure
     */
    startAppInstall: (query: StartAppInstallParams, params: RequestParams = {}) =>
      this.request<UiComponent, ErrorResponse>({
        path: `/ui/strongman/install/initialize`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  configure = {
    /**
     * @description BLE type devices need to configuration. so miniature support to serve the those kinds of configuration by profile Id. this api can get configuration by profile id list. it can be call from internally
     *
     * @tags configure
     * @name GetAllDeviceConfiguration
     * @summary get Device configuration by profile id List
     * @request GET:/configure
     */
    getAllDeviceConfiguration: (query: GetAllDeviceConfigurationParams, params: RequestParams = {}) =>
      this.request<GetConfigurationList, any>({
        path: `/configure`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  miniature = {
    /**
     * @description BLE type devices need to configuration. so miniature support to serve the those kinds of configuration by profile Id. this api can make configuration by profile id list. it can be call from internally
     *
     * @tags miniature
     * @name CreateDeviceConfiguration
     * @summary create Device configuration by profile Id
     * @request POST:/miniature/configure
     * @secure
     */
    createDeviceConfiguration: (createdeviceconfiguration: CreateConfigurationRequest, params: RequestParams = {}) =>
      this.request<CreateConfigurationResponse, void>({
        path: `/miniature/configure`,
        method: 'POST',
        body: createdeviceconfiguration,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description BLE type devices need to configuration. so miniature support to serve the those kinds of configuration by profile Id. this api can get configuration by profile id list. it can be call from internally
     *
     * @tags miniature
     * @name GetAllDeviceConfiguration
     * @summary get Device configuration by profile id List
     * @request GET:/miniature/configure
     */
    getAllDeviceConfiguration: (query: Link2, params: RequestParams = {}) =>
      this.request<GetConfigurationList, any>({
        path: `/miniature/configure`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create the a event for support the BLE D2D type event feature
     *
     * @tags miniature
     * @name CreateBleTypeDeviceEvent
     * @summary create BLE D2D type event
     * @request POST:/miniature/{deviceId}/events
     * @secure
     */
    createBleTypeDeviceEvent: (
      deviceId: string,
      deviceEventRequest: BackendDeviceEventsRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateBackendEventsResponse, ErrorResponse>({
        path: `/miniature/${deviceId}/events`,
        method: 'POST',
        body: deviceEventRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description creating the BLE_D2D type devices to smartthings cloud. this is open by doorbell service
     *
     * @tags miniature
     * @name OnboardingDevice
     * @summary onboarding ble d2d device to smartthings cloud.
     * @request POST:/miniature/mobile
     * @secure
     */
    onboardingDevice: (CreateDeviceRequest: CreateDeviceRequest, params: RequestParams = {}) =>
      this.request<CreateDeviceResponse, ErrorResponse>({
        path: `/miniature/mobile`,
        method: 'POST',
        body: CreateDeviceRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Accessories information from the ocfaccount
     *
     * @tags miniature
     * @name GetPeripheralItemList
     * @summary get Accessories about legacy device
     * @request GET:/miniature/peripheral
     */
    getPeripheralItemList: (params: RequestParams = {}) =>
      this.request<GetPeripheralItemList, void>({
        path: `/miniature/peripheral`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  mcs = {
    /**
     * @description MCS users signin
     *
     * @tags mcs
     * @name ContentsUsersSignin
     * @summary MCS users signin
     * @request POST:/mcs/contents/users/signin
     * @secure
     */
    contentsUsersSignin: (request: UsersSigninRequest, params: RequestParams = {}) =>
      this.request<UsersSigninResponse, void>({
        path: `/mcs/contents/users/signin`,
        method: 'POST',
        body: request,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  continy = {
    /**
     * No description
     *
     * @tags continy
     * @name GetContinyDevices
     * @summary Returns all devices which are online and continuity supported.
     * @request GET:/continy/devices
     * @secure
     */
    getContinyDevices: (query: GetContinyDevicesParams, params: RequestParams = {}) =>
      this.request<AvailablePlayersResponse, ErrorResponse>({
        path: `/continy/devices`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags continy
     * @name ExecuteContinyValidateDevices
     * @summary Endpoint to validate list of continuity supporting devices.
     * @request POST:/continy/devices/validate
     * @secure
     */
    executeContinyValidateDevices: (
      query: ExecuteContinyValidateDevicesParams,
      body: ValidateDeviceBody,
      params: RequestParams = {},
    ) =>
      this.request<AvailableValidateDeviceResponse, ErrorResponse>({
        path: `/continy/devices/validate`,
        method: 'POST',
        query: query,
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
 * @description SmartThings Cloud must provide the endpoint to get the user's current playback information. Samsung IoT Cloud makes a request to get current playback information from Spotify Server so that Samsung IoT Cloud figures out next step getting currently playing content or getting recently played content. Once Samsung IoT Cloud gets the content metadata, Samsung IoT Cloud notifies IoT Agent of it, then IoT Agent invokes the Play API that Spotify App provides. Action commands : "play", "transfer", "ready", "lookup", "adduser" and "cancel"
 *
 * @tags continy
 * @name ExecuteContinyPlayContents
 * @summary Make a play request to the device with CP ID
Ready to play and provide the devices's current state.
 * @request POST:/continy/devices/{deviceId}/command
 * @secure
 */
    executeContinyPlayContents: (
      { deviceId, ...query }: ExecuteContinyPlayContentsParams,
      body: DeviceBody,
      params: RequestParams = {},
    ) =>
      this.request<DeviceResponse, ErrorResponse>({
        path: `/continy/devices/${deviceId}/command`,
        method: 'POST',
        query: query,
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags continy
     * @name GetContinySessions
     * @summary Get user's current session information.
     * @request GET:/continy/sessions
     * @secure
     */
    getContinySessions: (query: GetContinySessionsParams, params: RequestParams = {}) =>
      this.request<SessionList, ErrorResponse>({
        path: `/continy/sessions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags continy
     * @name GetContinyPlaybackInfo
     * @summary Get user's current playback information.
     * @request GET:/continy/playbackInfo
     * @secure
     */
    getContinyPlaybackInfo: (query: GetContinyPlaybackInfoParams, params: RequestParams = {}) =>
      this.request<ContinyStatus, ErrorResponse>({
        path: `/continy/playbackInfo`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Receive user feedback when user selects later or never option in continy HUN
     *
     * @tags continy
     * @name CreateContinyFeedback
     * @request POST:/continy/userbehavior/feedback
     * @secure
     */
    createContinyFeedback: (body: UserFeedback, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/continy/userbehavior/feedback`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Client calls this api to download user specific trained model
     *
     * @tags continy
     * @name GetContinyUserModel
     * @request GET:/continy/userbehavior/model
     * @secure
     */
    getContinyUserModel: (query: GetContinyUserModelParams, params: RequestParams = {}) =>
      this.request<UserBehaviorModel, ErrorResponse>({
        path: `/continy/userbehavior/model`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description It returns the list of continuity supported content provider registry. SmartThings Cloud must provide the endpoint to look up Content Continuity Provider Registry.
     *
     * @tags continy
     * @name GetContinyProvidersList
     * @summary Content Continuity Provider Registry
     * @request GET:/continy/providers
     * @secure
     */
    getContinyProvidersList: (query: GetContinyProvidersListParams, params: RequestParams = {}) =>
      this.request<ContentProviderList, ErrorResponse>({
        path: `/continy/providers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description This API is used to get play metrics
     *
     * @tags continy
     * @name GetMetricsSession
     * @summary Get play metrics
     * @request POST:/continy/metrics/session
     */
    getMetricsSession: (query: GetMetricsSessionParams, body: ValidateMetricBody, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/continy/metrics/session`,
        method: 'POST',
        query: query,
        body: body,
        type: ContentType.Json,
        ...params,
      }),
  };
  presentation = {
    /**
     * @description Device Presentations represents a full definition of a device's UI elements (dashboard, detail view, automation), as well as how it can interact with the platform or other integrations. This differs from a device configuration in that a device configuration is only the user configurable portion that is fed as an input to the generation of the device presentation.
     *
     * @tags presentation
     * @name GetDevicePresentation
     * @summary Get a device presentation
     * @request GET:/presentation
     * @secure
     */
    getDevicePresentation: (query: GetDevicePresentationParams, params: RequestParams = {}) =>
      this.request<DevicePresentation, ErrorResponse>({
        path: `/presentation`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  presentations = {
    /**
     * @description Device Presentations represents a full definition of a device's UI elements (dashboard, detail view, automation), as well as how it can interact with the platform or other integrations. This differs from a device configuration in that a device configuration is only the user configurable portion that is fed as an input to the generation of the device presentation. If locationId(s) are provided, devices will be filtered by those locations. If no locationId(s), all user locations will be used to retrieve device presentations
     *
     * @tags presentations
     * @name ListDevicePresentation
     * @summary Get a list of device presentations by location(s)
     * @request GET:/presentations
     * @secure
     */
    listDevicePresentation: (query: ListDevicePresentationParams, params: RequestParams = {}) =>
      this.request<
        {
          items?: DevicePresentation[];
          links?: Links;
        },
        ErrorResponse
      >({
        path: `/presentations`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  bixby = {
    /**
     * @description Retrieve hints for all devices in user account
     *
     * @tags bixby
     * @name GetHintsDevices
     * @summary Get Devices Hints
     * @request GET:/bixby/hints/devices
     * @secure
     */
    getHintsDevices: (query: GetHintsDevicesParams, params: RequestParams = {}) =>
      this.request<HintsForDevicesResponse, ErrorResponse>({
        path: `/bixby/hints/devices`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve hints for specific device in user account
     *
     * @tags bixby
     * @name GetDeviceHintsUsingGet
     * @summary Get Device Hints
     * @request GET:/bixby/hints/devices/{deviceId}
     * @secure
     */
    getDeviceHintsUsingGet: ({ deviceId, ...query }: GetDeviceHintsUsingGetParams, params: RequestParams = {}) =>
      this.request<HintsForDeviceResponse, ErrorResponse>({
        path: `/bixby/hints/devices/${deviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetHintsCapability
     * @summary Retreive hints for specific SmartThings capability
     * @request GET:/bixby/hints/capabilities/{STCapability}
     */
    getHintsCapability: ({ stCapability, ...query }: GetHintsCapabilityParams, params: RequestParams = {}) =>
      this.request<HintsForCapabilityResponse, ErrorResponse>({
        path: `/bixby/hints/capabilities/${stCapability}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogues
     * @summary Retreive dialogue list
     * @request GET:/bixby/dialogues
     */
    getDialogues: (query: GetDialoguesParams, params: RequestParams = {}) =>
      this.request<DialoguesForVoiceIntentResponse, ErrorResponse>({
        path: `/bixby/dialogues`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retreive human readable responses(NLG) for a specific voice intent
     *
     * @tags bixby
     * @name GetDialogues2
     * @summary Get Dialogues
     * @request GET:/bixby/dialogues/{voiceIntent}
     * @originalName getDialogues
     * @duplicate
     * @secure
     */
    getDialogues2: ({ voiceIntent, ...query }: GetDialogues2Params, params: RequestParams = {}) =>
      this.request<DialoguesForVoiceIntentResponse, ErrorResponse>({
        path: `/bixby/dialogues/${voiceIntent}`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogueList
     * @summary Retreive dialogue for the specific voice intent
     * @request GET:/bixby/dialogues/voiceintents/{voiceIntent}
     */
    getDialogueList: ({ voiceIntent, ...query }: GetDialogueListParams, params: RequestParams = {}) =>
      this.request<DialoguesForVoiceIntentResponse, ErrorResponse>({
        path: `/bixby/dialogues/voiceintents/${voiceIntent}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retreive human readable words
     *
     * @tags bixby
     * @name GetVocabs
     * @summary Get Vocabs
     * @request GET:/bixby/vocabularies
     * @secure
     */
    getVocabs: (query: GetVocabsParams, params: RequestParams = {}) =>
      this.request<VocabsDataResponse, ErrorResponse>({
        path: `/bixby/vocabularies`,
        method: 'GET',
        query: query,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetVoiceIntentList
     * @summary Retreive hints for all voice intents
     * @request GET:/bixby/hints/voiceintents
     */
    getVoiceIntentList: (query: GetVoiceIntentListParams, params: RequestParams = {}) =>
      this.request<HintsForVoiceIntentsResponse, ErrorResponse>({
        path: `/bixby/hints/voiceintents`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetVoiceIntents
     * @summary Retreive hints for specific voice intent
     * @request GET:/bixby/hints/voiceintents/{voiceIntent}
     */
    getVoiceIntents: ({ voiceIntent, ...query }: GetVoiceIntentsParams, params: RequestParams = {}) =>
      this.request<HintsForVoiceIntentResponse, ErrorResponse>({
        path: `/bixby/hints/voiceintents/${voiceIntent}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags dialogues
     * @name GetDialogueNlg
     * @summary Make NLG with dialogue template and parameters
     * @request POST:/bixby/nlgs
     */
    getDialogueNlg: (DialogueNLGRequest: DialogueNLGRequest, params: RequestParams = {}) =>
      this.request<DialogueNLGResponse, ErrorResponse>({
        path: `/bixby/nlgs`,
        method: 'POST',
        body: DialogueNLGRequest,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetScenesHints
     * @summary Retreive hints for scenes
     * @request GET:/bixby/hints/scenes
     */
    getScenesHints: (query: GetScenesHintsParams, params: RequestParams = {}) =>
      this.request<HintsForScenesResponse, ErrorResponse>({
        path: `/bixby/hints/scenes`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetSceneHints
     * @summary Retreive hints for a scene
     * @request GET:/bixby/hints/scenes/{sceneId}
     */
    getSceneHints: ({ sceneId, ...query }: GetSceneHintsParams, params: RequestParams = {}) =>
      this.request<HintsForSceneResponse, ErrorResponse>({
        path: `/bixby/hints/scenes/${sceneId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetLocationsHints
     * @summary Retreive hints for ST app related commands and the location or room related commands
     * @request GET:/bixby/hints/locations
     */
    getLocationsHints: (query: GetLocationsHintsParams, params: RequestParams = {}) =>
      this.request<HintsForLocationsResponse, ErrorResponse>({
        path: `/bixby/hints/locations`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name GetLocationHints
     * @summary Retreive  hints for ST app related commands and the location or room related commands for a specific location
     * @request GET:/bixby/hints/locations/{locationId}
     */
    getLocationHints: (locationId: string, params: RequestParams = {}) =>
      this.request<HintsForLocationResponse, ErrorResponse>({
        path: `/bixby/hints/locations/${locationId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags bixby
     * @name HintsAutomationcreation
     * @summary Retreive automation hints for devices
     * @request GET:/bixby/hints/automationcreation
     */
    hintsAutomationcreation: (query: HintsAutomationcreationParams, params: RequestParams = {}) =>
      this.request<HintsForAutomationCreationResponse, ErrorResponse>({
        path: `/bixby/hints/automationcreation`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  vox = {
    /**
     * @description Get the static catalog of what is supported by voice for partner
     *
     * @tags vox
     * @name GetVoiceCatalog
     * @request GET:/vox/voicecatalog
     * @secure
     */
    getVoiceCatalog: (query: GetVoiceCatalogParams, params: RequestParams = {}) =>
      this.request<VoiceCatalog, void>({
        path: `/vox/voicecatalog`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  shp = {
    /**
     * @description Migrate Shp Devices into Ocf. You can check the result through the only HTTP response code. Please read the description of each HTTP response code.
     *
     * @tags shp
     * @name MigrateShpDevices
     * @request POST:/shp/migration
     * @secure
     */
    migrateShpDevices: (params: RequestParams = {}) =>
      this.request<SuccessRestResponse, ErrorInBridgeRestResponse | DeviceNotFoundRestResponse | ErrorResponse>({
        path: `/shp/migration`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  chipper = {
    /**
     * @description Create a new node id with the public key available in the CSR within the hub's fabric.
     *
     * @tags chipper
     * @name CreateNodeWithHub
     * @summary Create a new node associated within a Hub's fabric
     * @request POST:/chipper/fabric/{hubId}/node
     * @secure
     */
    createNodeWithHub: (hubId: string, CreateNodeRequest: CreateNodeRequest, params: RequestParams = {}) =>
      this.request<NodeCreatedResponse, ErrorResponse>({
        path: `/chipper/fabric/${hubId}/node`,
        method: 'POST',
        body: CreateNodeRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new galaxy fabric associated with the user making the request, if none exists. If a fabric is already associated with the user, then a new admin certificate is issued. The subject will be different on every call to this API. No attempt is made by the PKI service to verify the new key matches previous one.
     *
     * @tags chipper
     * @name CreateGalaxyFabric
     * @summary Create a new galaxy fabric associated with a Galaxy user
     * @request POST:/chipper/fabric/galaxy
     * @secure
     */
    createGalaxyFabric: (CreateFabricRequest: CreateFabricRequest, params: RequestParams = {}) =>
      this.request<NodeCreatedResponse, ErrorResponse>({
        path: `/chipper/fabric/galaxy`,
        method: 'POST',
        body: CreateFabricRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a new node id with the public key available in the CSR within the galaxy fabric.
     *
     * @tags chipper
     * @name CreateGalaxyNode
     * @summary Create a new node associated with the user's Galaxy fabric
     * @request POST:/chipper/fabric/galaxy/node
     * @secure
     */
    createGalaxyNode: (CreateNodeRequest: CreateNodeRequest, params: RequestParams = {}) =>
      this.request<NodeCreatedResponse, ErrorResponse>({
        path: `/chipper/fabric/galaxy/node`,
        method: 'POST',
        body: CreateNodeRequest,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Renew the certificate of the given node. The new key pair can be different from the previous one and no attempt is made by the PKI service to verify the key matches.
     *
     * @tags chipper
     * @name UpdateGalaxyNode
     * @summary Update a node certificate within the user's Galaxy fabric
     * @request PUT:/chipper/fabric/galaxy/node/{nodeId}
     * @secure
     */
    updateGalaxyNode: (nodeId: string, UpdateNodeRequest: CreateNodeRequest, params: RequestParams = {}) =>
      this.request<NodeCreatedResponse, ErrorResponse>({
        path: `/chipper/fabric/galaxy/node/${nodeId}`,
        method: 'PUT',
        body: UpdateNodeRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags chipper
     * @name GetRootCertificates
     * @summary Get the list of non-expired root CAs used for Galaxy fabrics
     * @request GET:/chipper/ca/galaxy/roots
     * @secure
     */
    getRootCertificates: (params: RequestParams = {}) =>
      this.request<GetRootCertificatesResponse, any>({
        path: `/chipper/ca/galaxy/roots`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  datetime = {
    /**
     * @description Get the date/time in UTC format.
     *
     * @tags datetime
     * @name GetDateTime
     * @summary Get the date/time in UTC format.
     * @request GET:/datetime
     */
    getDateTime: (params: RequestParams = {}) =>
      this.request<CommandArguments, any>({
        path: `/datetime`,
        method: 'GET',
        format: 'json',
        ...params,
      }),
  };
  antenna = {
    /**
     * @description Returns address list based on country.
     *
     * @tags antenna
     * @name GetAddresses
     * @request GET:/antenna/addresses
     */
    getAddresses: (query: GetAddressesParams, params: RequestParams = {}) =>
      this.request<AddressesResults, ErrorResponse>({
        path: `/antenna/addresses`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Returns headend list based on address(state & city) or postal code. If address and postal code are passed together, postal code is higher priorty than address. One of the two (postalCode or city&state) should be passed together with country
     *
     * @tags antenna
     * @name GetHeadends
     * @request GET:/antenna/headends
     */
    getHeadends: (query: GetHeadendsParams, params: RequestParams = {}) =>
      this.request<HeadendResults, ErrorResponse>({
        path: `/antenna/headends`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  gdpr = {
    /**
     * No description
     *
     * @tags gdpr
     * @name GetUserPiiData
     * @summary This API is used by the SC client to initiate a GET User PII data.
     * @request GET:/gdpr/pii
     */
    getUserPiiData: (params: RequestParams = {}) =>
      this.request<RestResponseUserPIIGetRequest, ErrorResponse>({
        path: `/gdpr/pii`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags gdpr
     * @name DeleteUserPiiData
     * @summary Delete the User's Personally identifiable information
     * @request DELETE:/gdpr/pii
     */
    deleteUserPiiData: (params: RequestParams = {}) =>
      this.request<RestResponseUserPIIDeleteRequest, ErrorResponse>({
        path: `/gdpr/pii`,
        method: 'DELETE',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags gdpr
     * @name GetDeleteTransactionStatus
     * @summary Check previous Delete (Erasure) User PII Transaction request Status
     * @request GET:/gdpr/status
     */
    getDeleteTransactionStatus: (params: RequestParams = {}) =>
      this.request<RestResponseUserPIIGetDeleteStatusRequest, ErrorResponse>({
        path: `/gdpr/status`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags gdpr
     * @name GetTransactionStatus
     * @summary This API is used by the SC client to check the status of transaction initiated earlier.
     * @request GET:/gdpr/pii/status
     */
    getTransactionStatus: (query: GetTransactionStatusParams, params: RequestParams = {}) =>
      this.request<RestResponseUserPIIGetRequest, ErrorResponse>({
        path: `/gdpr/pii/status`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  matter = {
    /**
     * @description Validate the PAI and DAC certificates from the request.  If valid, Pachinko will randomly generate an attestation nonce and create a reservation record with 5 minutes expiration time.
     *
     * @tags Matter
     * @name PostAttestationValidationNonce
     * @summary Validate DAC with PAI and return Nonce
     * @request POST:/matter/attestation/nonce
     * @secure
     */
    postAttestationValidationNonce: (postDACValidationBody: PostDACValidationBody, params: RequestParams = {}) =>
      this.request<
        {
          /** ID used to identify requests/workflows */
          transactionId: MatterAttestationTransactionId;
          /** attestation nonce base64 string */
          nonce: MatterAttestationNonce;
        },
        ErrorResponse
      >({
        path: `/matter/attestation/nonce`,
        method: 'POST',
        body: postDACValidationBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description To verify attestation and certification status of a device according to Section 6.2.3 of the Matter Specification, the “Device Attestation Procedure”.
     *
     * @tags Matter
     * @name PostAttestationTransaction
     * @summary Verify attestation and certification status, then return vid and pid of the device
     * @request POST:/matter/attestation/{transactionId}
     * @secure
     */
    postAttestationTransaction: (
      transactionId: string,
      postAttestationTransactionBody: PostAttestationTransactionBody,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** vendor ID */
          vid: DclVendorId;
          /** product ID */
          pid: DclProductId;
        },
        ErrorResponse
      >({
        path: `/matter/attestation/${transactionId}`,
        method: 'POST',
        body: postAttestationTransactionBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Given a list of vids and pids, return all the available software versions found in DCL
     *
     * @tags Matter
     * @name PostSoftwareVersions
     * @summary Get software versions given array of vids and pids
     * @request POST:/matter/software-versions
     * @secure
     */
    postSoftwareVersions: (postSoftwareVersionsBody: PostSoftwareVersionsBody, params: RequestParams = {}) =>
      this.request<
        {
          models: DclModelVersions[];
        },
        ErrorResponse
      >({
        path: `/matter/software-versions`,
        method: 'POST',
        body: postSoftwareVersionsBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Given a list of vids and pids, return all the available software versions detail found in DCL
     *
     * @tags Matter
     * @name PostSoftwareVersions2
     * @summary Get software version details given array of vids and pids
     * @request POST:/matter/software-versions/detail
     * @originalName postSoftwareVersions
     * @duplicate
     * @secure
     */
    postSoftwareVersions2: (
      postSoftwareVersionDetailsBody: PostSoftwareVersionDetailsBody,
      params: RequestParams = {},
    ) =>
      this.request<
        {
          models: DclSoftwareVersionDetails[];
        },
        ErrorResponse
      >({
        path: `/matter/software-versions/detail`,
        method: 'POST',
        body: postSoftwareVersionDetailsBody,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Return vendor information from DCL with the given vid
     *
     * @tags Matter
     * @name GetVendorinfoVendorInfo
     * @summary Get vendor information
     * @request GET:/matter/vendors/{vid}
     * @secure
     */
    getVendorinfoVendorInfo: (vid: number, params: RequestParams = {}) =>
      this.request<
        {
          vendorInfo: DclVendorInfo;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Return all available device models found in DCL with the given vid
     *
     * @tags Matter
     * @name GetAllVendorModels
     * @summary Get all device models from the given vendor
     * @request GET:/matter/vendors/{vid}/products
     * @secure
     */
    getAllVendorModels: (vid: number, params: RequestParams = {}) =>
      this.request<
        {
          vendorProducts: DclVendorProducts;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}/products`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Return the device model information from DCL with the given vid and pid
     *
     * @tags Matter
     * @name GetModel
     * @summary Get device model information
     * @request GET:/matter/vendors/{vid}/products/{pid}
     * @secure
     */
    getModel: (pid: number, vid: number, params: RequestParams = {}) =>
      this.request<
        {
          model: DclModel;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}/products/${pid}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Return all available software versions for the given vid and pid from DCL
     *
     * @tags Matter
     * @name GetAllModelVersions
     * @summary Get all software versions
     * @request GET:/matter/vendors/{vid}/products/{pid}/software-versions
     * @secure
     */
    getAllModelVersions: (vid: number, pid: number, params: RequestParams = {}) =>
      this.request<
        {
          modelVersions: DclModelVersions;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}/products/${pid}/software-versions`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Return the detail software information from DCL for the given vid, pid, and software version
     *
     * @tags Matter
     * @name GetModelVersion
     * @summary Get detail software information
     * @request GET:/matter/vendors/{vid}/products/{pid}/software-versions/{softwareVersion}
     * @secure
     */
    getModelVersion: (vid: number, pid: number, softwareVersion: number, params: RequestParams = {}) =>
      this.request<
        {
          modelVersion?: DclModelVersion;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}/products/${pid}/software-versions/${softwareVersion}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Return the software compliance status from DCL for the given vid, pid, and software version
     *
     * @tags Matter
     * @name GetCompliance
     * @summary Get software compliance status
     * @request GET:/matter/vendors/{vid}/products/{pid}/software-versions/{softwareVersion}/compliance
     * @secure
     */
    getCompliance: (vid: number, pid: number, softwareVersion: number, params: RequestParams = {}) =>
      this.request<
        {
          /** vendor ID */
          vid: DclVendorId;
          /** product ID */
          pid: DclProductId;
          /** software version */
          softwareVersion: DclSoftwareVersion;
          /** matter or zigbee is the and the only supported values for now */
          certificationType: DclCertificationType;
          /** the software compliance status */
          status: DclComplianceStatus;
        },
        ErrorResponse
      >({
        path: `/matter/vendors/${vid}/products/${pid}/software-versions/${softwareVersion}/compliance`,
        method: 'GET',
        secure: true,
        ...params,
      }),
  };
  geoplaces = {
    /**
     * @description List all Linked Places currently available across all locations for the user, or provide ownerType and ownerId to list Linked Places relative to a given owner (i.e. Linked Places for a specific location). Note that this endpoint does not return linked places for MFU locations, see the v5 API for MFU support.
     *
     * @tags Geoplace
     * @name ListGeoplaces
     * @summary List Linked Places
     * @request GET:/geoplaces
     * @secure
     */
    listGeoplaces: (query: ListGeoplacesParams, params: RequestParams = {}) =>
      this.request<Geoplaces, ErrorResponse>({
        path: `/geoplaces`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a linked place for a given owner. Verification will be done to ensure the caller has write access to the owner. Currently, the owner must be a location.
     *
     * @tags Geoplace
     * @name CreateGeoplace
     * @summary Create a linked place
     * @request POST:/geoplaces
     * @secure
     */
    createGeoplace: (updateGeoplaceBody: CreateGeoplaceRequest, params: RequestParams = {}) =>
      this.request<Geoplace, ErrorResponse>({
        path: `/geoplaces`,
        method: 'POST',
        body: updateGeoplaceBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete all linked places for a specific owner. Verification will be done to ensure the caller has write access to the owner. Currently, the owner must be a location.
     *
     * @tags Geoplace
     * @name DeleteGeoplaces
     * @summary Delete all linked places
     * @request DELETE:/geoplaces
     * @secure
     */
    deleteGeoplaces: (query: DeleteGeoplacesParams, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/geoplaces`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Get a specific Linked Place by Id. Verification will be done to ensure the caller has read access to the owner.
     *
     * @tags Geoplace
     * @name GetGeoplace
     * @summary Get Linked Place
     * @request GET:/geoplaces/{geoplaceId}
     * @secure
     */
    getGeoplace: ({ geoplaceId, ...query }: GetGeoplaceParams, params: RequestParams = {}) =>
      this.request<Geoplace, ErrorResponse>({
        path: `/geoplaces/${geoplaceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description All the fields in the request body are optional except name which is required. Only the specified fields will be updated. Verification will be done to ensure the caller has write access to the owner.
     *
     * @tags Geoplace
     * @name UpdateGeoplace
     * @summary Update Linked Place
     * @request PUT:/geoplaces/{geoplaceId}
     * @secure
     */
    updateGeoplace: (geoplaceId: string, updateGeoplaceBody: UpdateGeoplaceRequest, params: RequestParams = {}) =>
      this.request<Geoplace, ErrorResponse>({
        path: `/geoplaces/${geoplaceId}`,
        method: 'PUT',
        body: updateGeoplaceBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete a specific Linked Place by Id. Verification will be done to ensure the caller has write access to the owner.
     *
     * @tags Geoplace
     * @name DeleteGeoplace
     * @summary Delete a Linked Place
     * @request DELETE:/geoplaces/{geoplaceId}
     * @secure
     */
    deleteGeoplace: (geoplaceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/geoplaces/${geoplaceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  essentials = {
    /**
     * @description Persist essential device information in SmartThings Cloud. This will be used during join phase of the onboarding process. There are two actors who are authorized to write this data 1. Device backends 2. Clients using auth token with scope `essentialinfo` and have write access to the Device One of `ocf/mqtt` type is mandatory. At this time, swagger definitions for other backend types is pending. If `macAddressHash` is included, one of the five entries is mandatory. If `serialNumber` is provided, then `hashedSerialNumber` and `partialSerialNumber` will be computed from it. If hashed and partial serial numbers are also provided, then the user-provided version will be used instead of the computed one.
     *
     * @tags essentials
     * @name CreateEssentialRecord
     * @summary Persist essential information
     * @request POST:/essentials
     * @secure
     */
    createEssentialRecord: (EssentialRequest: DeviceEssentialRequest, params: RequestParams = {}) =>
      this.request<DeviceEssentialResponse, ErrorResponse>({
        path: `/essentials`,
        method: 'POST',
        body: EssentialRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description A paginated list of essential data. Following query patterns are supported 1. `mnId` and `serialNumber` 2. `mnId` and `hashedSerialNumber` 3. macAddress type (one of `wifi/ble/p2p/bt/upnp`) and its value 4. locationId (returns EssentialData of those devices to which the user has access and which belong to that locationId) Data can be queried by 1. `r:essentialinfo` or `w:essentialinfo` scopes when querying by Location 2. `service:stdcp:backend` or `r:service:essentials.id` all other cases
     *
     * @tags essentials
     * @name ListEssentialData
     * @summary List essential data
     * @request GET:/essentials
     * @secure
     */
    listEssentialData: (query: ListEssentialDataParams, params: RequestParams = {}) =>
      this.request<DeviceEssentialsResponse, ErrorResponse>({
        path: `/essentials`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get essential data by deviceId. Data can be accessed by 1. Device backends 2. Clients using auth token with scope `essentialinfo` and have read access to the Device
     *
     * @tags essentials
     * @name GetEssentialData
     * @summary Get essential data by deviceId
     * @request GET:/essentials/{deviceId}
     * @secure
     */
    getEssentialData: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceEssentialResponse, ErrorResponse>({
        path: `/essentials/${deviceId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete essential data by deviceId. Data can be deleted by 1. Device backends 2. Clients whose auth token has scope `essentialinfo` and have write access to the Device
     *
     * @tags essentials
     * @name DeleteEssentialData
     * @summary Delete essential data by deviceId
     * @request DELETE:/essentials/{deviceId}
     * @secure
     */
    deleteEssentialData: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeleteDeviceResponse, ErrorResponse>({
        path: `/essentials/${deviceId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  hedge = {
    /**
     * @description Open the commissioning window for a second-ecosystem commissioner to onboard a Matter device.
     *
     * @tags hedge
     * @name CreateMatterCommissioningWindow
     * @request POST:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/commissioningWindow
     * @secure
     */
    createMatterCommissioningWindow: (
      hubDeviceId: string,
      deviceId: string,
      createMatterCommissioningWindowRequest: CreateMatterCommissioningWindowRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMatterCommissioningWindowResponse, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/commissioningWindow`,
        method: 'POST',
        body: createMatterCommissioningWindowRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Close the commissioning window in a Matter device.
     *
     * @tags hedge
     * @name DeleteMatterCommissioningWindow
     * @request DELETE:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/commissioningWindow
     * @secure
     */
    deleteMatterCommissioningWindow: (hubDeviceId: string, deviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/commissioningWindow`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Read the fabric information from a Matter device.
     *
     * @tags hedge
     * @name GetMatterFabrics
     * @request GET:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/fabrics
     * @secure
     */
    getMatterFabrics: (hubDeviceId: string, deviceId: string, params: RequestParams = {}) =>
      this.request<MatterFabricList, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/fabrics`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve information about the specified fabric from a Matter device.
     *
     * @tags hedge
     * @name GetMatterFabric
     * @request GET:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    getMatterFabric: (hubDeviceId: string, deviceId: string, fabricIndex: number, params: RequestParams = {}) =>
      this.request<FabricDescriptor, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Matter device's label for the selected fabric.  Only the hub-connected fabric is writable.
     *
     * @tags hedge
     * @name PartialUpdateMatterFabric
     * @request PATCH:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    partialUpdateMatterFabric: (
      hubDeviceId: string,
      deviceId: string,
      fabricIndex: number,
      partialUpdateMatterFabricRequest: PartialUpdateMatterFabricRequest,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'PATCH',
        body: partialUpdateMatterFabricRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove the specified fabric from a Matter device.  Removal of the hub-connected fabric is not permitted.
     *
     * @tags hedge
     * @name DeleteMatterFabric
     * @request DELETE:/hedge/request/{hubDeviceId}/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    deleteMatterFabric: (hubDeviceId: string, deviceId: string, fabricIndex: number, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the hub's Thread network information.
     *
     * @tags hedge
     * @name GetThreadNetworkInfo
     * @request GET:/hedge/request/{hubDeviceId}/thread/networkInfo
     * @secure
     */
    getThreadNetworkInfo: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ThreadNetworkInfo, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/thread/networkInfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Join the hub's border router to provided Thread network.
     *
     * @tags hedge
     * @name JoinThreadNetwork
     * @request POST:/hedge/request/{hubDeviceId}/thread/networkInfo
     * @secure
     */
    joinThreadNetwork: (
      hubDeviceId: string,
      ThreadNetworkJoinInfo: ThreadNetworkJoinInfo,
      params: RequestParams = {},
    ) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/thread/networkInfo`,
        method: 'POST',
        body: ThreadNetworkJoinInfo,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reset the hub's thread network information, which includes detaching from current network and forming a new one.
     *
     * @tags hedge
     * @name ResetThreadNetwork
     * @request DELETE:/hedge/request/{hubDeviceId}/thread/networkInfo
     * @secure
     */
    resetThreadNetwork: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<BleDeviceDetails, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/thread/networkInfo`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the active Thread operational data set from the hub.
     *
     * @tags hedge
     * @name GetThreadOperationalDataSet
     * @request GET:/hedge/request/{hubDeviceId}/thread/operationalDataSet
     * @secure
     */
    getThreadOperationalDataSet: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ThreadOperationalDataSet, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/thread/operationalDataSet`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate discovery of Thread border routers advertising the _meshcop._udp DNS-SD service.
     *
     * @tags hedge
     * @name GetThreadBorderRouterScan
     * @request GET:/hedge/request/{hubDeviceId}/thread/borderRouterScan
     * @secure
     */
    getThreadBorderRouterScan: (hubDeviceId: string, params: RequestParams = {}) =>
      this.request<ThreadBorderRouterScanResults, ErrorResponse>({
        path: `/hedge/request/${hubDeviceId}/thread/borderRouterScan`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  verificationcodes = {
    /**
     * @description Upsert a verification code for an InstalledAppId
     *
     * @tags verificationcodes
     * @name UpsertVerificationCode
     * @request POST:/verificationcodes
     */
    upsertVerificationCode: (postBody: CreateVerificationCodePostBody, params: RequestParams = {}) =>
      this.request<SuccessResponse, ErrorResponse>({
        path: `/verificationcodes`,
        method: 'POST',
        body: postBody,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Given a installedAppId, check if the verification codes is setup
     *
     * @tags verificationcodes
     * @name GetVerificationCodeByInstalledApp
     * @request GET:/verificationcodes/{installedAppId}
     */
    getVerificationCodeByInstalledApp: (installedAppId: string, params: RequestParams = {}) =>
      this.request<GetDevicesVerificationCodeDetailsResponse, ErrorResponse>({
        path: `/verificationcodes/${installedAppId}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete the verification code for all devices for an installedAppId
     *
     * @tags verificationcodes
     * @name DeleteVerificationCodeByInstalledApp
     * @request DELETE:/verificationcodes/{installedAppId}
     */
    deleteVerificationCodeByInstalledApp: (installedAppId: string, params: RequestParams = {}) =>
      this.request<SuccessResponse, ErrorResponse>({
        path: `/verificationcodes/${installedAppId}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),
  };
  clients = {
    /**
     * No description
     *
     * @tags Clients
     * @name CreateClient
     * @summary Create a new client
     * @request POST:/clients
     * @secure
     */
    createClient: (client: ClientCreateRequest, params: RequestParams = {}) =>
      this.request<CasperClientResponse, ErrorResponse>({
        path: `/clients`,
        method: 'POST',
        body: client,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name GetClients
     * @summary List clients
     * @request GET:/clients
     * @secure
     */
    getClients: (query: GetClientsParams, params: RequestParams = {}) =>
      this.request<PagedCasperClients, ErrorResponse>({
        path: `/clients`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name GetClient
     * @summary Get a client
     * @request GET:/clients/{clientId}
     * @secure
     */
    getClient: (clientId: string, params: RequestParams = {}) =>
      this.request<CasperClient, ErrorResponse>({
        path: `/clients/${clientId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name PatchClient
     * @summary Path an existing client
     * @request PATCH:/clients/{clientId}
     * @secure
     */
    patchClient: (clientId: string, client: ClientUpdateRequest, params: RequestParams = {}) =>
      this.request<CasperClientResponse, ErrorResponse>({
        path: `/clients/${clientId}`,
        method: 'PATCH',
        body: client,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clients
     * @name DeleteClient
     * @summary Delete a client
     * @request DELETE:/clients/{clientId}
     * @secure
     */
    deleteClient: (clientId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/clients/${clientId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  amigo = {
    /**
     * @description API returns the list of tariffs of the user defined by AUTHORIZATION header. ## **Service attributtes by partner** M : Mandatory O : Optional ### **Vodafone** | Name | Attribute                | Data Type | M/O | Default | Description                                            | | ---- | ------------------------ | --------- | --- | ------- | ------------------------------------------------------ | | HMVS | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |      | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | |      | maxNumCamera             | String   | M   | 0       | Number of cameras allowed to use this plan             | |      | maxStorageMB             | String   | M   | 10240   | Max cloud storage for this plan                        | |      | maxRetentionDays         | String   | M   | 14      | Video clip deleted after this valued days              | |      | maxRecodingSeconds       | String   | M   | 120     | Maximum selectable recording length                    | | VHM  | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |      | sharable                 | Boolean   | O   | ture    | True if this service can be shared with others         | | VAA  | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |      | sharable                 | Boolean   | O   | true    | True if this service can be shared with others         | | VBV  | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |      | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | | MAS  | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED/MISSING_CONFIG                         | |      | sharable                 | Boolean   | O   | true    | True if this service can be shared with others         | |      | serviceNumber            | String    |     |         | serviceNumber and assistanceUrl at least one Mandatory | |      | assistanceUrl            | String    |     |         |                                                        | |      | additionalServiceInfoUrl | String    | O   |         |                                                        | |      | nameToShow               | String    | M   |         | Name to show on the service card                       | ### **AMX** | Name                | Attribute                | Data Type | M/O | Default | Description                                            | | ------------------- | ------------------------ | --------- | --- | ------- | ------------------------------------------------------ | | HMVS_AMX_TELCEL     | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | |                     | maxNumber/maxNumCamera   | String   | M   | 0       | Number of cameras allowed to use this plan             | |                     | maxStorageMB             | String   | M   | 30720   | Max cloud storage for this plan                        | |                     | maxRetentionDays         | String   | M   | 30      | Video clip deleted after this valued days              | |                     | maxRecodingSeconds       | String   | M   | 120     | Maximum selectable recording length                    | | SHM_AMX_TELCEL      | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | true    | True if this service can be shared with others         | | PARTNER_AMX_TELCEL  | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | ### **Retail** | Name                | Attribute                | Data Type | M/O | Default | Description                                            | | ------------------- | ------------------------ | --------- | --- | ------- | ------------------------------------------------------ | | HMVS_RETAIL         | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | |                     | maxNumCamera             | String   | M   | 0       | Number of cameras allowed to use this plan             | |                     | maxStorageMB             | String   | M   | 5120    | Max cloud storage for this plan                        | |                     | maxRetentionDays         | String   | M   | 7       | Video clip deleted after this valued days              | |                     | maxRecodingSeconds       | String   | M   | 30      | Maximum selectable recording length                    | | SHM_RETAIL          | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | true    | True if this service can be shared with others         | ### **Singtel** | Name                | Attribute                | Data Type | M/O | Default | Description                                            | | ------------------- | ------------------------ | --------- | --- | ------- | ------------------------------------------------------ | | HMVS_SINGTEL        | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | |                     | maxNumCamera             | String   | M   | 0       | Number of cameras allowed to use this plan             | |                     | maxStorageMB             | String   | M   | 10240   | Max cloud storage for this plan                        | |                     | maxRetentionDays         | String   | M   | 14      | Video clip deleted after this valued days              | |                     | maxRecodingSeconds       | String   | M   | 120     | Maximum selectable recording length                    | | SHM_SINGTEL         | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | true    | True if this service can be shared with others         | | PARTNER_SINGTEL     | status                   | String    | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                     | sharable                 | Boolean   | O   | false   | True if this service can be shared with others         | ### **Open** | Name                  | Attribute                | Data Type      | M/O | Default | Description                                            | | --------------------- | ------------------------ | -------------- | --- | ------- | ------------------------------------------------------ | | HMVS_OPEN             | status                   | String         | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                       | sharable                 | Boolean        | O   | false   | True if this service can be shared with others         | |                       | maxNumCamera             | String        | M   | 2       | Number of cameras allowed to use this plan             | |                       | maxStorageMB             | String        | M   | 10240   | Max cloud storage for this plan                        | |                       | maxRetentionDays         | String        | M   | 7       | Video clip deleted after this valued days              | |                       | maxRecodingSeconds       | String        | M   | 120     | Maximum selectable recording length                    | |                       | maxNumPermClip           | String        | M   | 100     | Number of video clips can be st ored permanently       | | SHM                   | status                   | String         | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                       | sharable                 | Boolean        | O   | true    | True if this service can be shared with others         | | HMVS_OPEN_DEVICE_AUTH | status                   | String         | M   | ACTIVE  | ACTIVE/DISABLED                                        | |                       | sharable                 | Boolean        | O   | false   | True if this service can be shared with others         | |                       | cameraSerialNums         | List of String | M   | -       | List of device Serial Numbers                          | |                       | maxStorageMB             | String        | M   | 10240    | Max cloud storage for this plan                       | |                       | maxRetentionDays         | String        | M   | 7       | Video clip deleted after this valued days              | |                       | maxRecodingSeconds       | String        | M   | 120      | Maximum selectable recording length                   | |                       | maxNumPermClip           | String        | M   | 100     | Number of video clips can be st ored permanently       |
     *
     * @tags UserTariffController
     * @name GetTariffs
     * @summary "The list of tariffs of the user"
     * @request GET:/amigo/tariffs
     */
    getTariffs: (query: GetTariffsParams, params: RequestParams = {}) =>
      this.request<TariffResponse[], RestResponse>({
        path: `/amigo/tariffs`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description API returns the tariffs of the user defined by AUTHORIZATION header.
     *
     * @tags UserTariffController
     * @name GetTariffById
     * @summary getTariffById
     * @request GET:/amigo/tariffs/{tariff_id}
     */
    getTariffById: ({ tariffId, ...query }: GetTariffByIdParams, params: RequestParams = {}) =>
      this.request<TariffResponse[], RestResponse>({
        path: `/amigo/tariffs/${tariffId}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserServiceController
     * @name GetListOfServices
     * @summary getListOfServices
     * @request GET:/amigo/myservices
     */
    getListOfServices: (params: RequestParams = {}) =>
      this.request<GetLocationTariffResponse[], RestResponse>({
        path: `/amigo/myservices`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * @description You can check each partner policy(Need tariff, Check device/user centric) ### Query Parameter and Response values | Partner Name | DeviceType      | Tariff Needed | User Centric | | ------------ | --------------- | ------------- | ------------ | | open_us      | CAMERA          | FALSE         | TRUE         | |              | CAMERA_UNCONFIG | FALSE         | TRUE         | | vodafone     | HUB             | TRUE          | FALSE        | |              | CAMERA          | TRUE          | FALSE        | | amx          | HUB             | TRUE          | FALSE        | |              | CAMERA          | TRUE          | FALSE        | | upfront_mx   | HUB             | TRUE          | FALSE        | |              | CAMERA          | TRUE          | FALSE        | | singtel      | CAMERA          | TRUE          | FALSE        | | kt           | TAG             | TRUE          | FALSE        | | skt          | TAG             | TRUE          | FALSE        | | att          | TAG             | TRUE          | FALSE        | | vzw          | TAG             | TRUE          | FALSE        |
     *
     * @tags UserPolicyController
     * @name GetPolicy
     * @summary Check partner policy
     * @request GET:/amigo/partners/policy
     */
    getPolicy: (query: GetPolicyParams, params: RequestParams = {}) =>
      this.request<PolicyResponse, RestResponse>({
        path: `/amigo/partners/policy`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get activation url from partner for device activation ### Required response field by each partner and os. | Partner Name | OS      | web.method | web.url  | web.clientType | web.requriedPayload | web.accessibleUrls | | ------------ | ------- | ---------- | -------- | -------------- | ------------------- | ------------------ | | att          |         |            | required |                |                     |                    | | amx          |         |            | required |                |                     |                    | | kt           |         |            | required |                |                     |                    | | skt          |         |            | required |                |                     |                    | | vzw          | android | required   | required |                |                     |                    | |              | ios     | required   | required | required       |                     | required           | | open_us      |         |            | required | required       | requried            |                    |
     *
     * @tags PartnerController
     * @name GetActivationUrl
     * @summary Get activation url
     * @request POST:/amigo/partners/activationurl
     */
    getActivationUrl: (body: ActivationUrlRequest, params: RequestParams = {}) =>
      this.request<ActivationUrlResponse, RestResponse>({
        path: `/amigo/partners/activationurl`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get management url from partner ### Required response field by each partner and os. | Partner Name | OS      | web.method | web.url  | web.clientType | web.requriedPayload | web.accessibleUrls | | ------------ | ------- | ---------- | -------- | -------------- | ------------------- | ------------------ | | att          |         |            | required |                |                     |                    |
     *
     * @tags PartnerController
     * @name GetManagementUrl
     * @summary Get management url
     * @request POST:/amigo/partners/managementurl
     */
    getManagementUrl: (body: ActivationUrlRequest, params: RequestParams = {}) =>
      this.request<ActivationUrlResponse, RestResponse>({
        path: `/amigo/partners/managementurl`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeviceManagementController
     * @name DeleteDeviceFromTariff
     * @summary deleteDeviceFromTariff
     * @request DELETE:/amigo/tariffs/{id}/devices
     */
    deleteDeviceFromTariff: ({ id, ...query }: DeleteDeviceFromTariffParams, params: RequestParams = {}) =>
      this.request<DeleteTariffDeviceResponse, RestResponse>({
        path: `/amigo/tariffs/${id}/devices`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeviceManagementController
     * @name RegisterDeviceToTariff
     * @summary registerDeviceToTariff
     * @request PUT:/amigo/tariffs/{id}/devices
     */
    registerDeviceToTariff: (id: number, body: RegisterDeviceRequest, params: RequestParams = {}) =>
      this.request<void, RestResponse>({
        path: `/amigo/tariffs/${id}/devices`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags StRequestController
     * @name SearchTariffs
     * @summary searchTariffs
     * @request GET:/amigo/st/tariffs
     */
    searchTariffs: (query: SearchTariffsParams, params: RequestParams = {}) =>
      this.request<SearchTariffResponse[], RestResponse>({
        path: `/amigo/st/tariffs`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags KitsController
     * @name SaveKits
     * @summary saveKits
     * @request POST:/amigo/kits
     */
    saveKits: (body: PlanKit, params: RequestParams = {}) =>
      this.request<KitsResponse, RestResponse>({
        path: `/amigo/kits`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags KitsController
     * @name SelectKits
     * @summary selectKits
     * @request GET:/amigo/kits
     */
    selectKits: (query: SelectKitsParams, params: RequestParams = {}) =>
      this.request<GetKitsResponse, RestResponse>({
        path: `/amigo/kits`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags KitsController
     * @name DeleteKitsBySnAndType
     * @summary deleteKitsBySnAndType
     * @request DELETE:/amigo/kits
     */
    deleteKitsBySnAndType: (query: DeleteKitsBySnAndTypeParams, params: RequestParams = {}) =>
      this.request<KitsResponse, RestResponse>({
        path: `/amigo/kits`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags KitsController
     * @name SelectKitsById
     * @summary selectKitsById
     * @request GET:/amigo/kits/{id}
     */
    selectKitsById: (id: number, params: RequestParams = {}) =>
      this.request<GetKitsResponse, RestResponse>({
        path: `/amigo/kits/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags KitsController
     * @name DeleteKitsById
     * @summary deleteKitsById
     * @request DELETE:/amigo/kits/{id}
     */
    deleteKitsById: (id: number, params: RequestParams = {}) =>
      this.request<KitsResponse, RestResponse>({
        path: `/amigo/kits/${id}`,
        method: 'DELETE',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name CreatePlans
     * @summary createPlans
     * @request POST:/amigo/plans
     */
    createPlans: (query: CreatePlansParams, body: PlansRequest, params: RequestParams = {}) =>
      this.request<PlansResponse, RestResponse>({
        path: `/amigo/plans`,
        method: 'POST',
        query: query,
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name GetPlansByPlanId
     * @summary getPlansByPlanId
     * @request GET:/amigo/plans/{id}
     */
    getPlansByPlanId: (id: number, params: RequestParams = {}) =>
      this.request<GetNewPlansResponse, RestResponse>({
        path: `/amigo/plans/${id}`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name DeletePlans
     * @summary deletePlans
     * @request DELETE:/amigo/plans/{id}
     */
    deletePlans: ({ id, ...query }: DeletePlansParams, params: RequestParams = {}) =>
      this.request<RestResponse, RestResponse>({
        path: `/amigo/plans/${id}`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name UpdatePlans
     * @summary updatePlans
     * @request PUT:/amigo/plans/{id}
     */
    updatePlans: (id: number, body: PlansRequest, params: RequestParams = {}) =>
      this.request<RestResponse, RestResponse>({
        path: `/amigo/plans/${id}`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name UpdateStatusOfPlan
     * @summary updateStatusOfPlan
     * @request PUT:/amigo/plans/{id}/status
     */
    updateStatusOfPlan: (id: number, body: UpdatePlanStatusRequest, params: RequestParams = {}) =>
      this.request<RestResponse, RestResponse>({
        path: `/amigo/plans/${id}/status`,
        method: 'PUT',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name AddPlanService
     * @summary addPlanService
     * @request PUT:/amigo/plans/{id}/services/{name}
     */
    addPlanService: ({ name, id, ...query }: AddPlanServiceParams, body: Map, params: RequestParams = {}) =>
      this.request<RestResponse, RestResponse>({
        path: `/amigo/plans/${id}/services/${name}`,
        method: 'PUT',
        query: query,
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PlansController
     * @name DeletePlanService
     * @summary deletePlanService
     * @request DELETE:/amigo/plans/{id}/services
     */
    deletePlanService: ({ id, ...query }: DeletePlanServiceParams, params: RequestParams = {}) =>
      this.request<RestResponse, RestResponse>({
        path: `/amigo/plans/${id}/services`,
        method: 'DELETE',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ProxyController
     * @name SendAttNotification
     * @summary sendAttNotification
     * @request POST:/amigo/proxy/notification
     */
    sendAttNotification: (body: ProxyRequest, params: RequestParams = {}) =>
      this.request<ProxyResponse, RestResponse>({
        path: `/amigo/proxy/notification`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags InternalRequestController
     * @name DeleteDevices
     * @summary deleteDevices
     * @request POST:/amigo/internal/device/delete
     */
    deleteDevices: (body: DeleteDeviceRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/amigo/internal/device/delete`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags GdprController
     * @name UploadUserData
     * @summary uploadUserData
     * @request POST:/amigo/gdpr/user/information
     */
    uploadUserData: (body: GdprRequest, params: RequestParams = {}) =>
      this.request<RestResponse, any>({
        path: `/amigo/gdpr/user/information`,
        method: 'POST',
        body: body,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags HubController
     * @name GetSercommDevices
     * @summary getSercommDevices
     * @request GET:/amigo/identity/hub/devices
     */
    getSercommDevices: (query: GetSercommDevicesParams, params: RequestParams = {}) =>
      this.request<GetSercommDeviceResponse, RestResponse>({
        path: `/amigo/identity/hub/devices`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SercommController
     * @name GetSercommDevices2
     * @summary getSercommDevices
     * @request GET:/amigo/identity/sercomm/devices
     * @originalName getSercommDevices
     * @duplicate
     */
    getSercommDevices2: (query: GetSercommDevices2Params, params: RequestParams = {}) =>
      this.request<GetSercommDeviceResponse, RestResponse>({
        path: `/amigo/identity/sercomm/devices`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  gettingstarted = {
    /**
     * @description List HowToUse contents.
     *
     * @tags HowToUse
     * @name ListHowToUse
     * @summary List HowToUse
     * @request GET:/gettingstarted/howtouselist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listHowToUse: (
      { appVersion, countryId, lngId, device, ...query }: ListHowToUseParams,
      params: RequestParams = {},
    ) =>
      this.request<ListHowToUseResponse, ErrorResponse>({
        path: `/gettingstarted/howtouselist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Notification contents.
     *
     * @tags Notification
     * @name ListNotification
     * @summary List Notifications
     * @request GET:/gettingstarted/notificationslist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listNotification: (
      { appVersion, countryId, lngId, device, ...query }: ListNotificationParams,
      params: RequestParams = {},
    ) =>
      this.request<GSListNotificationResponse, ErrorResponse>({
        path: `/gettingstarted/notificationslist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List Video contents.
     *
     * @tags Video
     * @name ListVideo
     * @summary List Video
     * @request GET:/gettingstarted/videolist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listVideo: ({ appVersion, countryId, lngId, device, ...query }: ListVideoParams, params: RequestParams = {}) =>
      this.request<ListVideoResponse, ErrorResponse>({
        path: `/gettingstarted/videolist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * @description List HeroBanner contents.
     *
     * @tags HeroBanner
     * @name ListHeroBanner
     * @summary List HeroBanners
     * @request GET:/gettingstarted/herobannerlist/{appVersion}/{countryId}/{lngId}/{device}
     */
    listHeroBanner: (
      { appVersion, countryId, lngId, device, ...query }: ListHeroBannerParams,
      params: RequestParams = {},
    ) =>
      this.request<ListHeroBannerResponse, ErrorResponse>({
        path: `/gettingstarted/herobannerlist/${appVersion}/${countryId}/${lngId}/${device}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),
  };
  mfu = {
    /**
     * @description Retrieves the latest report for a property's onboarding tasks
     *
     * @tags onboardingReports
     * @name GetOnboardingReport
     * @summary Generate an onboarding report by property
     * @request GET:/mfu/locationgroups/{locationGroupId}/report
     * @secure
     */
    getOnboardingReport: (locationGroupId: string, params: RequestParams = {}) =>
      this.request<LocationGroupOnboardingReport, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/report`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the latest statistics for a properties onboarding statistics
     *
     * @tags onboardingStatistics
     * @name GetLocationGroupsOnboardingStatistics
     * @summary Get onboarding statistics for location groups
     * @request GET:/mfu/locationgroups/stats
     * @secure
     */
    getLocationGroupsOnboardingStatistics: (params: RequestParams = {}) =>
      this.request<PagedLocationGroupsOnboardingStatistics, ErrorResponse>({
        path: `/mfu/locationgroups/stats`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the latest statistics for a property's onboarding tasks
     *
     * @tags onboardingStatistics
     * @name GetLocationGroupOnboardingStatistics
     * @summary Get onboarding statistics for property
     * @request GET:/mfu/locationgroups/{locationGroupId}/stats
     * @secure
     */
    getLocationGroupOnboardingStatistics: (locationGroupId: string, params: RequestParams = {}) =>
      this.request<LocationGroupOnboardingStatistics, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/stats`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the latest statistics for a property's onboarding tasks broken down by locations
     *
     * @tags onboardingStatistics
     * @name GetLocationsOnboardingStatistics
     * @summary Get onboarding statistics for locations
     * @request GET:/mfu/locationgroups/{locationGroupId}/locations/stats
     * @secure
     */
    getLocationsOnboardingStatistics: (locationGroupId: string, params: RequestParams = {}) =>
      this.request<PagedLocationsOnboardingStatistics, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/stats`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * @description Retrieves the latest statistics for a property's onboarding tasks by Location
     *
     * @tags onboardingStatistics
     * @name GetLocationOnboardingStatistics
     * @summary Get onboarding statistics for a location
     * @request GET:/mfu/locationgroups/{locationGroupId}/locations/{locationId}/stats
     * @secure
     */
    getLocationOnboardingStatistics: (
      { locationGroupId, locationId, ...query }: GetLocationOnboardingStatisticsParams,
      params: RequestParams = {},
    ) =>
      this.request<LocationOnboardingStatistics, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/${locationId}/stats`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Gets an existing Location Group
     *
     * @tags onboarding
     * @name GetEphemeralDevices
     * @summary Get ephemeral devices
     * @request GET:/mfu/locationgroups/{locationGroupId}/devices
     * @secure
     */
    getEphemeralDevices: ({ locationGroupId, ...query }: GetEphemeralDevicesParams, params: RequestParams = {}) =>
      this.request<PagedEphemeralDevices, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/devices`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Gets an ephemeral device record. Once onboarded, ephemeral devices are retained for summary report generation and no longer map to canonical SmartThings Devices.
     *
     * @tags onboarding
     * @name GetEphemeralDevice
     * @summary Get an ephemeral device
     * @request GET:/mfu/locationgroups/{locationGroupId}/locations/{locationId}/devices/{ephemeralDeviceId}
     * @secure
     */
    getEphemeralDevice: (
      { locationGroupId, ephemeralDeviceId, locationId, ...query }: GetEphemeralDeviceParams,
      params: RequestParams = {},
    ) =>
      this.request<EphemeralDevice, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/${locationId}/devices/${ephemeralDeviceId}`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Creates or updates an ephemeral device record.
     *
     * @tags onboarding
     * @name UpsertEphemeralDevice
     * @summary Upsert an ephemeral device
     * @request PUT:/mfu/locationgroups/{locationGroupId}/locations/{locationId}/devices/{ephemeralDeviceId}
     * @secure
     */
    upsertEphemeralDevice: (
      { locationGroupId, ephemeralDeviceId, locationId, ...query }: UpsertEphemeralDeviceParams,
      UpsertEphemeralDeviceRequest: UpsertEphemeralDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<EphemeralDevice, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/${locationId}/devices/${ephemeralDeviceId}`,
        method: 'PUT',
        query: query,
        body: UpsertEphemeralDeviceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Perform a partial update to an ephemeral device record. Use when updating individual fields without disturbing the rest of the stored data.
     *
     * @tags onboarding
     * @name PartialUpdateEphemeralDevice
     * @summary Update an ephemeral device
     * @request PATCH:/mfu/locationgroups/{locationGroupId}/locations/{locationId}/devices/{ephemeralDeviceId}
     * @secure
     */
    partialUpdateEphemeralDevice: (
      { locationGroupId, ephemeralDeviceId, locationId, ...query }: PartialUpdateEphemeralDeviceParams,
      PartialUpdateEphemeralDeviceRequest: PartialUpdateEphemeralDeviceRequest,
      params: RequestParams = {},
    ) =>
      this.request<EphemeralDevice, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/${locationId}/devices/${ephemeralDeviceId}`,
        method: 'PATCH',
        query: query,
        body: PartialUpdateEphemeralDeviceRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Perform a partial update to an ephemeral device record. Use when updating individual fields without disturbing the rest of the stored data.
     *
     * @tags onboarding
     * @name DeleteEphemeralDevice
     * @summary Delete an ephemeral device
     * @request DELETE:/mfu/locationgroups/{locationGroupId}/locations/{locationId}/devices/{ephemeralDeviceId}
     * @secure
     */
    deleteEphemeralDevice: (
      { locationGroupId, ephemeralDeviceId, locationId, ...query }: DeleteEphemeralDeviceParams,
      params: RequestParams = {},
    ) =>
      this.request<EmptyObject, ErrorResponse>({
        path: `/mfu/locationgroups/${locationGroupId}/locations/${locationId}/devices/${ephemeralDeviceId}`,
        method: 'DELETE',
        query: query,
        secure: true,
        ...params,
      }),
  };
  petition = {
    /**
     * @description The caller is expected to be a hub principal associated with the location id or a user principal that is the owner of the location id. The endpoint accepts an optional body that can be used to set a product identifier, description for the petition, petition type and lifetime minutes.  The default petitionType is `STANDARD` and can be overridden with an optional field in the body.  The default lifetimeMinutes is 5 minutes for a `STANDARD` petition and 10080 (7 days) for a `LINKSHARE` petition and can be overridden with an optional field in the body. If provided, these free-form text values will be attached to any access request created from the petition.  The product identifier is used in some user notifications.  The description is considered opaque; petition service does not interpret the value.  Think of it as a generic mechanism to share data between a petitioner and a requestor.  The value can be a plain text string or some data encoded in a string (such as JSON). CALLERS MUST ENSURE THAT REQUESTORS ARE ALLOWED TO SEE ALL INFORMATION IN THE PRODUCT IDENTIFIER AND DESCRIPTION. For instance, the petitioner must never disclose the location name, location owner, etc.  The default grantType is `SHARE`. If a grantType is provided this will override the default value with this value.  Allowed grantTypes are `SHARE` and `RESTRICTEDSHARE`. If the petitioner is not allowed to create a petition for the location, then the result is a 400 error, and the reason code and message in the response body will explain why. Errors are `NO_RESOURCE_PERMISSION` (the petitioner does not have the required resource permissions), `PRODUCT_IDENTIFIER_TOO_LONG` (the product identifier exceeds the maximum allowed length), `DESCRIPTION_TOO_LONG` (the description exceeds the maximum allowed length), or `PETITION_LIMIT_REACHED` (the number of petitions of this type exceeds the maximum allowed for the resource).
     *
     * @tags Petition
     * @name CreatePetition
     * @summary Create a petition for sharing members to a particular location.
     * @request POST:/petition/location/{locationId}
     * @secure
     */
    createPetition: (locationId: string, body: CreatePetitionRequest, params: RequestParams = {}) =>
      this.request<PetitionResponse, ErrorResponse>({
        path: `/petition/location/${locationId}`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Only the resource administrator may retrieve this list.  Caller will receive an empty list if there are no active petitions.  You may pass an optional petition type as a query parameter
     *
     * @tags Petition
     * @name RetrieveResourcePetition
     * @summary Retrieve a list of petitions for a specific resource
     * @request GET:/petition/resource/{resourceType}/{resourceId}
     * @secure
     */
    retrieveResourcePetition: (
      { resourceType, resourceId, ...query }: RetrieveResourcePetitionParams,
      params: RequestParams = {},
    ) =>
      this.request<PagedPetitions, ErrorResponse>({
        path: `/petition/resource/${resourceType}/${resourceId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Only the user that originally submitted a petition may retrieve a standard petition.  An unknown petition id results in a 404 error.  Callers will also receive a 404 error if they attempt to retrieve a standard petition that they did not create.  Anyone with a valid scope and petitionId can retrieve the details of a linkshare petition.
     *
     * @tags Petition
     * @name RetrievePetition
     * @summary Retrieve details about a petition
     * @request GET:/petition/{petitionId}
     * @secure
     */
    retrievePetition: (petitionId: string, params: RequestParams = {}) =>
      this.request<PetitionResponse, ErrorResponse>({
        path: `/petition/${petitionId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Only the user that originally submitted a petition may delete the petition.  Deleting a petition does not change the status of any access requests that were previously created using the petition id. An unknown petition id results in a 404 error.  Callers will also receive a 404 error if they attempt to delete a petition that they did not create.
     *
     * @tags Petition
     * @name DeletePetition
     * @summary Delete a petition
     * @request DELETE:/petition/{petitionId}
     * @secure
     */
    deletePetition: (petitionId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/petition/${petitionId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint is deprecated.  Please use `/access-requests/{petitionId}/allowed`. An unknown petition id always results in a 404 error.  Otherwise, the 200 response body will explain whether the requestor is allowed to request access to the location.  If the requestor is not allowed, then the reason and description in the response body will explain why. Errors are `PETITION_ALREADY_USED` (the petition has already been used and cannot be re-used), `NO_GRANTORS_AVAILABLE` (no grantors exist to approve the request), `ALREADY_HAS_ACCESS` (the requestor already has access to the location), `ALREADY_HAS_PENDING` (the requestor already has a pending request for the location), `REQUEST_LIMIT_REACHED` (the requestor has reached the maximum number of pending requests), and `RESOURCE_REQUEST_LIMIT_REACHED` (the resource has reached the maximum number of pending requests).
     *
     * @tags Deprecated
     * @name AllowedPetitionDeprecated
     * @summary Deprecated: Determine whether a requestor is allowed to request access to a location
     * @request GET:/petition/location/{petitionId}/allowed
     * @secure
     */
    allowedPetitionDeprecated: (petitionId: string, params: RequestParams = {}) =>
      this.request<AllowedPetitionResponse, ErrorResponse>({
        path: `/petition/location/${petitionId}/allowed`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  accessRequests = {
    /**
     * @description The endpoint accepts an optional body that can be used to send a consent agreement to be stored in locksmith.  This is free-form text, but must be in valid JSON format.  If provided, it will be sent unaltered to locksmith.  The body is considered opaque; petition service does not interpret the value or validate the format.  BECAUSE PETITION SERVICE DOES NOT INTERPRET THIS VALUE, IT IS THE CALLER'S RESPONSIBILITY TO ENSURE THAT THE DATA IS VALID.  An unknown petition id always results in a 404 error.  If the requestor is not allowed to request access to the resource, then the result is a 400 error, and the reason code and message in the response body will explain why.  Errors are `PETITION_ALREADY_USED` (the petition has already been used and cannot be re-used), `NO_GRANTORS_AVAILABLE` (no grantors exist to approve the request), `ALREADY_HAS_ACCESS` (the requestor already has access to the resource), `ALREADY_HAS_PENDING` (the requestor already has a pending request for the resource), `REQUEST_LIMIT_REACHED` (the requestor has reached the maximum number of pending requests), `RESOURCE_REQUEST_LIMIT_REACHED` (the resource has reached the maximum number of pending requests) and `CONSENT_NOT_STORED` (there was an error storing the consent in locksmith). If the requestor is from a different region than the owner, a 422 error will be sent.
     *
     * @tags Access Requests
     * @name CreateAccessRequestFromPetition
     * @summary Create an access request from a petition
     * @request POST:/access-requests/{petitionId}
     * @secure
     */
    createAccessRequestFromPetition: (petitionId: string, body: ConsentAgreementBody, params: RequestParams = {}) =>
      this.request<MaskedAccessRequest, ErrorResponse>({
        path: `/access-requests/${petitionId}`,
        method: 'POST',
        body: body,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description An unknown petition id always results in a 404 error.  Otherwise, the 200 response body will explain whether the requestor is allowed to request access to the location.  If the requestor is not allowed, then the reason and description in the response body will explain why. Errors are `PETITION_ALREADY_USED` (the petition has already been used and cannot be re-used), `NO_GRANTORS_AVAILABLE` (no grantors exist to approve the request), `ALREADY_HAS_ACCESS` (the requestor already has access to the location), `ALREADY_HAS_PENDING` (the requestor already has a pending request for the location), `REQUEST_LIMIT_REACHED` (the requestor has reached the maximum number of pending requests), and `RESOURCE_REQUEST_LIMIT_REACHED` (the resource has reached the maximum number of pending requests).
     *
     * @tags Access Requests
     * @name AllowedPetition
     * @summary Determine whether a requestor is allowed to request access to a location
     * @request GET:/access-requests/{petitionId}/allowed
     * @secure
     */
    allowedPetition: (petitionId: string, params: RequestParams = {}) =>
      this.request<AllowedPetitionResponse, ErrorResponse>({
        path: `/access-requests/${petitionId}/allowed`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description This endpoint returns all non-expired `PENDING` requests, as well as all previous requests with status `APPROVED`, `REJECTED`, or `CANCELLED`.  If you want to see only `PENDING` requests, you must filter using the `status` query parameter.
     *
     * @tags Access Requests
     * @name ListAccessRequests
     * @summary List access requests a requestor has created
     * @request GET:/access-requests/requestor
     * @secure
     */
    listAccessRequests: (query: ListAccessRequestsParams, params: RequestParams = {}) =>
      this.request<PagedMaskedAccessRequests, ErrorResponse>({
        path: `/access-requests/requestor`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description This endpoint returns only non-expired requests with `PENDING` status, because these are the only requests a grantor may approve or reject. There is no way to query for expired, approved, or rejected requests by grantor.  When using the optional parameters in order to specify a resource you must provide both resourceType and resourceId.  When providing a petitionType you must include the resource parameters and the petitionId.
     *
     * @tags Access Requests
     * @name ListGrantorAccessRequests
     * @summary List access requests a grantor can approve or reject
     * @request GET:/access-requests/grantor
     * @secure
     */
    listGrantorAccessRequests: (query: ListGrantorAccessRequestsParams, params: RequestParams = {}) =>
      this.request<PagedAccessRequests, ErrorResponse>({
        path: `/access-requests/grantor`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description If the requestor already has access to the location by the time this approval is processed (due to some other invitation, approval by another approver, etc.), the existing grant will be left unchanged. The endpoint accepts an optional body that can be used to send a consent agreement to be stored in locksmith.  This is free-form text, but must be in valid JSON format.  If provided, it will be sent unaltered to locksmith.  The body is considered opaque; petition service does not interpret the value or validate the format. BECAUSE PETITION SERVICE DOES NOT INTERPRET THIS VALUE, IT IS THE CALLER'S RESPONSIBILITY TO ENSURE THAT THE DATA IS VALID.  An unknown access request id always results in a 404 error.  If the grantor is not allowed to approve the request, then the result is a 400 error, and the reason code and message in the response body will explain why.  Errors are `NO_RESOURCE_PERMISSION` (the grantor does not have the required resource permissions), `REQUEST_NOT_PENDING` (the access request is not pending, and can no longer be modified), `REQUEST_EXPIRED` (the access request is expired, and can no longer be modified), and `CONSENT_NOT_STORED` (there was an error storing the consent in locksmith).
     *
     * @tags Access Requests
     * @name ApproveAccessRequest
     * @summary Approve an access request
     * @request POST:/access-requests/{accessRequestId}/approve
     * @secure
     */
    approveAccessRequest: (
      { accessRequestId, ...query }: ApproveAccessRequestParams,
      body: ConsentAgreementBody,
      params: RequestParams = {},
    ) =>
      this.request<AccessRequest, ErrorResponse>({
        path: `/access-requests/${accessRequestId}/approve`,
        method: 'POST',
        query: query,
        body: body,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description An unknown access request id always results in a 404 error.  If the grantor is not allowed to reject the request, then the result is a 400 error, and the reason code and message in the response body will explain why.  Errors are `NO_RESOURCE_PERMISSION` (the grantor does not have the required resource permissions), `REQUEST_NOT_PENDING` (the access request is not pending, and can no longer be modified), and `REQUEST_EXPIRED` (the access request is expired, and can no longer be modified).
     *
     * @tags Access Requests
     * @name RejectAccessRequest
     * @summary Reject an access request
     * @request DELETE:/access-requests/{accessRequestId}/reject
     * @secure
     */
    rejectAccessRequest: (accessRequestId: string, params: RequestParams = {}) =>
      this.request<AccessRequest, ErrorResponse>({
        path: `/access-requests/${accessRequestId}/reject`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description An unknown access request id always results in a 404 error.  If the requestor is not allowed to cancel the request, then the result is a 400 error and the reason code and message in the response body will explain why.  Errors are `REQUEST_NOT_PENDING` (the access request is not pending, and can no longer be modified) and `REQUEST_EXPIRED` (the access request is expired, and can no longer be modified).
     *
     * @tags Access Requests
     * @name CancelAccessRequest
     * @summary Cancel an access request
     * @request POST:/access-requests/{accessRequestId}/cancel
     * @secure
     */
    cancelAccessRequest: (accessRequestId: string, params: RequestParams = {}) =>
      this.request<MaskedAccessRequest, ErrorResponse>({
        path: `/access-requests/${accessRequestId}/cancel`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  calmer = {
    /**
     * No description
     *
     * @tags Calmer
     * @name Devices
     * @summary Get all user devices
     * @request GET:/calmer/devices
     * @secure
     */
    devices: (params: RequestParams = {}) =>
      this.request<GetUserDeviceListResponse, ErrorResponse>({
        path: `/calmer/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calmer
     * @name Confirm
     * @summary Confirmed that this device belongs to this user
     * @request POST:/calmer/devices/{deviceId}/confirm
     * @secure
     */
    confirm: (deviceId: string, body: ConfirmDeviceRequest, params: RequestParams = {}) =>
      this.request<ConfirmDeviceResponse, ErrorResponse>({
        path: `/calmer/devices/${deviceId}/confirm`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Calmer
     * @name DeleteDevice
     * @summary Delete a device
     * @request DELETE:/calmer/devices/{deviceId}
     * @secure
     */
    deleteDevice: (deviceId: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/calmer/devices/${deviceId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  };
  blueprint = {
    /**
     * @description To query a list of information on addresses through the `keyword` or geolocation(`latitude`, `longitude`, `radius`) of the address. At least one of the keyword and geolocation should be required.
     *
     * @tags Addresses
     * @name ListAddresses
     * @summary List addresses
     * @request GET:/blueprint/addresses
     */
    listAddresses: (query: ListAddressesParams, params: RequestParams = {}) =>
      this.request<PagedAddresses, void>({
        path: `/blueprint/addresses`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Addresses
     * @name ListTypesOfIndoormapsForAddress
     * @summary List types of indoor maps for the given addressId
     * @request GET:/blueprint/addresses/{addressId}/types
     */
    listTypesOfIndoormapsForAddress: (addressId: string, params: RequestParams = {}) =>
      this.request<AddressTypes, void>({
        path: `/blueprint/addresses/${addressId}/types`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Indoormaps
     * @name GetAddressIndoormap
     * @summary Get an indoor map by indoormapId
     * @request GET:/blueprint/indoormaps/{indoormapId}
     */
    getAddressIndoormap: (indoormapId: string, params: RequestParams = {}) =>
      this.request<Indoormap, void>({
        path: `/blueprint/indoormaps/${indoormapId}`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Indoormaps
     * @name ListIndoormapIds
     * @summary List ids of indoor maps stored in locations
     * @request GET:/blueprint/indoormaps/locations
     */
    listIndoormapIds: (params: RequestParams = {}) =>
      this.request<PagedIndoormapIds, void>({
        path: `/blueprint/indoormaps/locations`,
        method: 'GET',
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Indoormaps
     * @name GetIndoormap
     * @summary Get an indoor map by locationId
     * @request GET:/blueprint/indoormaps/locations/{locationId}
     */
    getIndoormap: ({ locationId, ...query }: GetIndoormapParams, params: RequestParams = {}) =>
      this.request<Indoormap, void>({
        path: `/blueprint/indoormaps/locations/${locationId}`,
        method: 'GET',
        query: query,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Indoormaps
     * @name UpdateIndoormap
     * @summary Create or update an indoor map by locationId
     * @request PUT:/blueprint/indoormaps/locations/{locationId}
     */
    updateIndoormap: (
      { locationId, ...query }: UpdateIndoormapParams,
      jsonBody: IndoormapPUT,
      params: RequestParams = {},
    ) =>
      this.request<Indoormap, void>({
        path: `/blueprint/indoormaps/locations/${locationId}`,
        method: 'PUT',
        query: query,
        body: jsonBody,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Indoormaps
     * @name DeleteIndoormap
     * @summary Delete an indoor map by locationId
     * @request DELETE:/blueprint/indoormaps/locations/{locationId}
     */
    deleteIndoormap: ({ locationId, ...query }: DeleteIndoormapParams, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/blueprint/indoormaps/locations/${locationId}`,
        method: 'DELETE',
        query: query,
        type: ContentType.Json,
        ...params,
      }),
  };
  corvette = {
    /**
     * @description Get Clip records by `locationId` or `deviceId`. If `locationId` and `deviceId` are not specified, the api will return all clips that the principal (i.e `ownerId`) has access to
     *
     * @tags Corvette
     * @name GetClips
     * @summary Get clip records
     * @request GET:/corvette/clips
     * @secure
     */
    getClips: (query: GetClipsParams, params: RequestParams = {}) =>
      this.request<GetClipsResponse, ErrorResponse>({
        path: `/corvette/clips`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a clip record request
     *
     * @tags Corvette
     * @name CreateClips
     * @summary Create a clip record request
     * @request POST:/corvette/clips
     * @secure
     */
    createClips: (body: CreateClipRequest, params: RequestParams = {}) =>
      this.request<CreateClipResponse, ErrorResponse>({
        path: `/corvette/clips`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete clip by clipId
     *
     * @tags Corvette
     * @name DeleteClips
     * @summary Delete clip by clipId
     * @request DELETE:/corvette/clips/{clipId}
     * @secure
     */
    deleteClips: (clipId: string, params: RequestParams = {}) =>
      this.request<DeleteClipResponse, ErrorResponse>({
        path: `/corvette/clips/${clipId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get clip by clipId
     *
     * @tags Corvette
     * @name GetClipByClipId
     * @summary Get clip by clipId
     * @request GET:/corvette/clips/{clipId}
     * @secure
     */
    getClipByClipId: (clipId: string, params: RequestParams = {}) =>
      this.request<GetClipByClipIdResponse, ErrorResponse>({
        path: `/corvette/clips/${clipId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update clip
     *
     * @tags Corvette
     * @name UpdateClips
     * @summary Update clip
     * @request PUT:/corvette/clips/{clipId}
     * @secure
     */
    updateClips: (clipId: string, body: UpdateClipRequest, params: RequestParams = {}) =>
      this.request<GetClipByClipIdResponse, ErrorResponse>({
        path: `/corvette/clips/${clipId}`,
        method: 'PUT',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get latest clip by clipId
     *
     * @tags Corvette
     * @name GetLatestClipByDeviceId
     * @summary Get latest clip by deviceId
     * @request GET:/corvette/devices/{deviceId}/clips/latest
     * @secure
     */
    getLatestClipByDeviceId: ({ deviceId, ...query }: GetLatestClipByDeviceIdParams, params: RequestParams = {}) =>
      this.request<GetClipByClipIdResponse, ErrorResponse>({
        path: `/corvette/devices/${deviceId}/clips/latest`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get latest image by imageId
     *
     * @tags Corvette
     * @name GetLatestImageByDeviceId
     * @request GET:/corvette/devices/{deviceId}/images/latest
     * @secure
     */
    getLatestImageByDeviceId: ({ deviceId, ...query }: GetLatestImageByDeviceIdParams, params: RequestParams = {}) =>
      this.request<GetImageByImageIdResponse, ErrorResponse>({
        path: `/corvette/devices/${deviceId}/images/latest`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get image records by `locationId` or `deviceId`. If `locationId` and `deviceId` are not specified, the api will return all images that the principal (i.e `ownerId`) has access to
     *
     * @tags Corvette
     * @name GetImages
     * @summary Get image records
     * @request GET:/corvette/images
     * @secure
     */
    getImages: (query: GetImagesParams, params: RequestParams = {}) =>
      this.request<GetImagesResponse, ErrorResponse>({
        path: `/corvette/images`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a image record request
     *
     * @tags Corvette
     * @name CreateImages
     * @summary Create a image record request
     * @request POST:/corvette/images
     * @secure
     */
    createImages: (body: CreateImageRequest, params: RequestParams = {}) =>
      this.request<CreateImageResponse, ErrorResponse>({
        path: `/corvette/images`,
        method: 'POST',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Delete image
     *
     * @tags Corvette
     * @name DeleteImages
     * @summary Delete image
     * @request DELETE:/corvette/images/{imageId}
     * @secure
     */
    deleteImages: (imageId: string, params: RequestParams = {}) =>
      this.request<DeleteImageResponse, ErrorResponse>({
        path: `/corvette/images/${imageId}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get image by imageId
     *
     * @tags Corvette
     * @name GetImageByImageId
     * @summary Get image by imageId
     * @request GET:/corvette/images/{imageId}
     * @secure
     */
    getImageByImageId: (imageId: string, params: RequestParams = {}) =>
      this.request<GetImageByImageIdResponse, ErrorResponse>({
        path: `/corvette/images/${imageId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update image
     *
     * @tags Corvette
     * @name UpdateImages
     * @summary Update image
     * @request PUT:/corvette/images/{imageId}
     * @secure
     */
    updateImages: (imageId: string, body: UpdateImageRequest, params: RequestParams = {}) =>
      this.request<GetImageByImageIdResponse, ErrorResponse>({
        path: `/corvette/images/${imageId}`,
        method: 'PUT',
        body: body,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  invites = {
    /**
     * No description
     *
     * @tags qrInvites
     * @name CreateLocationQrInvite
     * @summary Create a QR code location invitation
     * @request POST:/invites/locationQR
     * @secure
     */
    createLocationQrInvite: (createQRInvitationBody: CreateLocationQRInviteRequest, params: RequestParams = {}) =>
      this.request<CreateLocationQRInviteResponse, ErrorResponse>({
        path: `/invites/locationQR`,
        method: 'POST',
        body: createQRInvitationBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags qrInvites
     * @name AcceptQrInvite
     * @summary Accept a QR code location invitation
     * @request PUT:/invites/locationQR/{longCode}/accept
     * @secure
     */
    acceptQrInvite: (longCode: string, acceptQRInviteBody: AcceptLocationQRInviteRequest, params: RequestParams = {}) =>
      this.request<AcceptLocationQRInviteResponse, ErrorResponse>({
        path: `/invites/locationQR/${longCode}/accept`,
        method: 'PUT',
        body: acceptQRInviteBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name CreateSchemaAppInvite
     * @summary Create an invitation for a schema app.
     * @request POST:/invites/schemaApp
     * @secure
     */
    createSchemaAppInvite: (createSchemaAppInvitationBody: CreateSchemaAppInviteRequest, params: RequestParams = {}) =>
      this.request<CreateSchemaAppInviteResponse, ErrorResponse>({
        path: `/invites/schemaApp`,
        method: 'POST',
        body: createSchemaAppInvitationBody,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name ListSchemaAppInvitations
     * @summary Get a list of invitations for a schema app.
     * @request GET:/invites/schemaApp
     * @secure
     */
    listSchemaAppInvitations: (query: ListSchemaAppInvitationsParams, params: RequestParams = {}) =>
      this.request<SchemaInvitePage, ErrorResponse>({
        path: `/invites/schemaApp`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name DeleteSchemaAppInvite
     * @summary Revoke an existing invitation
     * @request DELETE:/invites/schemaApp/{id}
     * @secure
     */
    deleteSchemaAppInvite: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/invites/schemaApp/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name SchemaAppCheckAcceptance
     * @summary Checks the acceptance status of a specific schema app invitation.
     * @request GET:/invites/schemaApp/checkAcceptance
     * @secure
     */
    schemaAppCheckAcceptance: (query: SchemaAppCheckAcceptanceParams, params: RequestParams = {}) =>
      this.request<CheckSchemaAppInviteAcceptanceResponse, ErrorResponse>({
        path: `/invites/schemaApp/checkAcceptance`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags schemaApp
     * @name AcceptSchemaAppInvite
     * @summary Accept a schema app invitation
     * @request PUT:/invites/schemaApp/{ShortCode}/accept
     * @secure
     */
    acceptSchemaAppInvite: (shortCode: string, params: RequestParams = {}) =>
      this.request<AcceptSchemaAppInviteResponse, ErrorResponse>({
        path: `/invites/schemaApp/${shortCode}/accept`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
